// Auto-generated catalog from latest CSV data
const defaultCatalog = [
  {
    "id": "csv-2221",
    "name": "Jus en poudre Mangue 2kg Ice",
    "price": 8.25,
    "purchasePrice": 7.819905,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-2221",
    "barcode": "2221",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2222",
    "name": "Fève Verte congelé 400gr Nesmah",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": -98,
    "category": "Accueil",
    "sku": "SKU-2222",
    "barcode": "2222",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2223",
    "name": "Gombo 400gr FOODICO",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -22,
    "category": "Accueil",
    "sku": "SKU-2223",
    "barcode": "2223",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2224",
    "name": "Petit Pois carotte 400gr Nesmah",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -38,
    "category": "Accueil",
    "sku": "SKU-2224",
    "barcode": "2224",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2225",
    "name": "Mloukhiya haché 400gr FOODICO",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -24,
    "category": "Accueil",
    "sku": "SKU-2225",
    "barcode": "2225",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2226",
    "name": "Falafel fève Congelé 400gr Nesmah",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2226",
    "barcode": "2226",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2227",
    "name": "Sirop de Mûre 600ml Al Dayaa",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-2227",
    "barcode": "2227",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2228",
    "name": "Sirop de Jallab 600ml Al Dayaa",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-2228",
    "barcode": "2228",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2229",
    "name": "CREME NESTLE 170 GR",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2229",
    "barcode": "2229",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2232",
    "name": "Baklava Alkhabaza 500gr",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2232",
    "barcode": "2232",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2233",
    "name": "Baklava Alkhabaza 500gr",
    "price": 14.5,
    "purchasePrice": 13.744076,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2233",
    "barcode": "2233",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2234",
    "name": "Maamoul Mad Dattes au kg",
    "price": 15.3,
    "purchasePrice": 14.50237,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2234",
    "barcode": "2234",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 15.3
  },
  {
    "id": "csv-2235",
    "name": "Concentré de tomate 635gr. Lio",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -102,
    "category": "Accueil",
    "sku": "SKU-2235",
    "barcode": "2235",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2236",
    "name": "Aubergines Imam Noyan",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-2236",
    "barcode": "2236",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2237",
    "name": "Dattes Rotab Al RAII 500gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2237",
    "barcode": "2237",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2238",
    "name": "Jello Cerise 85gr Domo",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": 12,
    "category": "Accueil",
    "sku": "SKU-2238",
    "barcode": "2238",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2239",
    "name": "Bouillon de poulet 600 gr Maggi",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-2239",
    "barcode": "2239",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2241",
    "name": "Indomie végétarien x 5",
    "price": 1.8,
    "purchasePrice": 1.706161,
    "stock": -727,
    "category": "Accueil",
    "sku": "SKU-2241",
    "barcode": "2241",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2242",
    "name": "Indomie Poulet x40",
    "price": 13.99,
    "purchasePrice": 13.260664,
    "stock": -14,
    "category": "Accueil",
    "sku": "SKU-2242",
    "barcode": "2242",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2243",
    "name": "Indomie Poulet x5",
    "price": 1.8,
    "purchasePrice": 1.706161,
    "stock": -224,
    "category": "Accueil",
    "sku": "SKU-2243",
    "barcode": "2243",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2244",
    "name": "Bamiya 350 gr Chtoura",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2244",
    "barcode": "2244",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2245",
    "name": "Aubergine 1kg",
    "price": 2.37,
    "purchasePrice": 2.246445,
    "stock": -366,
    "category": "Accueil",
    "sku": "SKU-2245",
    "barcode": "2245",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2246",
    "name": "Tomate Ronde au kg",
    "price": 2.37,
    "purchasePrice": 2.246445,
    "stock": -1458,
    "category": "Accueil",
    "sku": "SKU-2246",
    "barcode": "2246",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 2.37
  },
  {
    "id": "csv-2247",
    "name": "Maamoul dattes 500gr Khbazeh",
    "price": 8.5,
    "purchasePrice": 8.056872,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-2247",
    "barcode": "2247",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2248",
    "name": "Baklava 500gr Khbazeh",
    "price": 14.5,
    "purchasePrice": 13.744076,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-2248",
    "barcode": "2248",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2249",
    "name": "Nawashef 500gr khbazeh",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-2249",
    "barcode": "2249",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2250",
    "name": "Baklava Mabroume 500gr Khbazeh",
    "price": 16.5,
    "purchasePrice": 15.63981,
    "stock": -13,
    "category": "Accueil",
    "sku": "SKU-2250",
    "barcode": "2250",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2252",
    "name": "Jus de Citron 1L Cortas",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2252",
    "barcode": "2252",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2253",
    "name": "Pignons longs d'Espagne",
    "price": 19.85,
    "purchasePrice": 18.815166,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2253",
    "barcode": "2253",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2254",
    "name": "Haricots blancs 540 gr Samaya",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2254",
    "barcode": "2254",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2255",
    "name": "Raisins Aigres Marinés 70gr Récoltes Naturelles",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 24,
    "category": "Accueil",
    "sku": "SKU-2255",
    "barcode": "2255",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2256",
    "name": "Haricots blancs géants 540 gr Samaya",
    "price": 1.45,
    "purchasePrice": 1.374408,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2256",
    "barcode": "2256",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2257",
    "name": "Humus Kasih x4 135g",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": -144,
    "category": "Accueil",
    "sku": "SKU-2257",
    "barcode": "2257",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2260",
    "name": "Dattes Sukkari",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -18,
    "category": "Accueil",
    "sku": "SKU-2260",
    "barcode": "2260",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2262",
    "name": "Lentilles corail 900gr. Baladna",
    "price": 2.49,
    "purchasePrice": 2.36019,
    "stock": -11,
    "category": "Accueil",
    "sku": "SKU-2262",
    "barcode": "2262",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2263",
    "name": "Labneh Hajdu 1kg",
    "price": 6.95,
    "purchasePrice": 6.587678,
    "stock": -105,
    "category": "Accueil",
    "sku": "SKU-2263",
    "barcode": "2263",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2264",
    "name": "Piments marinés Alsaadah",
    "price": 1.89,
    "purchasePrice": 1.791469,
    "stock": -12,
    "category": "Accueil",
    "sku": "SKU-2264",
    "barcode": "2264",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2265",
    "name": "Soupe Poulet 66gr Al Sham Garden",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": -38,
    "category": "Accueil",
    "sku": "SKU-2265",
    "barcode": "2265",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2268",
    "name": "Crunch Aux amandes",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 26,
    "category": "Accueil",
    "sku": "SKU-2268",
    "barcode": "2268",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2269",
    "name": "Crunch aux Noisettes Sabrina 30gr",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 12,
    "category": "Accueil",
    "sku": "SKU-2269",
    "barcode": "2269",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2270",
    "name": "Crunch Aux Pistache 30gr",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 27,
    "category": "Accueil",
    "sku": "SKU-2270",
    "barcode": "2270",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2271",
    "name": "Crunch Aux cacahètes 30gr Sabrina",
    "price": 0.95,
    "purchasePrice": 0.900474,
    "stock": 12,
    "category": "Accueil",
    "sku": "SKU-2271",
    "barcode": "2271",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2272",
    "name": "Crunch Au sésames 30gr. Sabrina",
    "price": 0.75,
    "purchasePrice": 0.7109,
    "stock": -13,
    "category": "Accueil",
    "sku": "SKU-2272",
    "barcode": "2272",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.75
  },
  {
    "id": "csv-2273",
    "name": "Labneh 3.8 kg",
    "price": 17.5,
    "purchasePrice": 16.587678,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-2273",
    "barcode": "2273",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 17.5
  },
  {
    "id": "csv-2274",
    "name": "Pepite de tournesol par kg",
    "price": 5,
    "purchasePrice": 4.739336,
    "stock": -15,
    "category": "Accueil",
    "sku": "SKU-2274",
    "barcode": "2274",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 5
  },
  {
    "id": "csv-2275",
    "name": "Haricots blancs lingots 907gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2275",
    "barcode": "2275",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2281",
    "name": "Mahlab Chirag 50gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2281",
    "barcode": "2281",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2282",
    "name": "Riz égyptien  Aldoha 900 gr",
    "price": 2.49,
    "purchasePrice": 2.36019,
    "stock": 100,
    "category": "Accueil",
    "sku": "SKU-2282",
    "barcode": "2282",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2283",
    "name": "Mini concombre par kg",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-2283",
    "barcode": "2283",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 3.25
  },
  {
    "id": "csv-2284",
    "name": "Tzaziki Concombre 1kg",
    "price": 11.08,
    "purchasePrice": 10.50237,
    "stock": -16,
    "category": "Accueil",
    "sku": "SKU-2284",
    "barcode": "2284",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2285",
    "name": "Maamoul aux dattes moulin d'or 80gr",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": -22,
    "category": "Accueil",
    "sku": "SKU-2285",
    "barcode": "2285",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2286",
    "name": "Kaak au lait 250gr. Moulin d'or",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-2286",
    "barcode": "2286",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2287",
    "name": "Piment doux au kg",
    "price": 6,
    "purchasePrice": 5.687204,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2287",
    "barcode": "2287",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 6
  },
  {
    "id": "csv-2289",
    "name": "Thon Nature 160gr Durra",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2289",
    "barcode": "2289",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2290",
    "name": "Combi chtoura",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-2290",
    "barcode": "2290",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2291",
    "name": "Gingembre Moulu Espig 500gr",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -33,
    "category": "Accueil",
    "sku": "SKU-2291",
    "barcode": "2291",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2292",
    "name": "Curry Madras 500gr Espig",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": -96,
    "category": "Accueil",
    "sku": "SKU-2292",
    "barcode": "2292",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2293",
    "name": "Curcuma Moulu 500gr Espig",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": -50,
    "category": "Accueil",
    "sku": "SKU-2293",
    "barcode": "2293",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2294",
    "name": "Paprika Spico",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -20,
    "category": "Accueil",
    "sku": "SKU-2294",
    "barcode": "2294",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2295",
    "name": "Malban AU kg 14.9",
    "price": 0,
    "purchasePrice": 0,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2295",
    "barcode": "2295",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0
  },
  {
    "id": "csv-2296",
    "name": "Malban au Kg 17.5",
    "price": 0,
    "purchasePrice": 0,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2296",
    "barcode": "2296",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0
  },
  {
    "id": "csv-2298",
    "name": "Piments doux vrac 10 kg Saada",
    "price": 26.38,
    "purchasePrice": 25.004739,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-2298",
    "barcode": "2298",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 26.38
  },
  {
    "id": "csv-2299",
    "name": "Tasse de Café Moyen",
    "price": 14.5,
    "purchasePrice": 12.083333,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2299",
    "barcode": "2299",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2300",
    "name": "Tasse dorée grande",
    "price": 20,
    "purchasePrice": 16.666667,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2300",
    "barcode": "2300",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2301",
    "name": "Graines de nigelle Abido 500gr",
    "price": 6.86,
    "purchasePrice": 6.50237,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2301",
    "barcode": "2301",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2302",
    "name": "Foie de volaille par kg",
    "price": 3.06,
    "purchasePrice": 2.9,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-2302",
    "barcode": "2302",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 3.06
  },
  {
    "id": "csv-2303",
    "name": "Sept epices abido 500gr",
    "price": 16.5,
    "purchasePrice": 15.63981,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-2303",
    "barcode": "2303",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2304",
    "name": "Épice Soujouk ou sujuk ou sojok Abido 500gr",
    "price": 9.75,
    "purchasePrice": 9.241706,
    "stock": -13,
    "category": "Accueil",
    "sku": "SKU-2304",
    "barcode": "2304",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2305",
    "name": "Bourghol fin chtoura 800gr",
    "price": 1.89,
    "purchasePrice": 1.791469,
    "stock": -28,
    "category": "Accueil",
    "sku": "SKU-2305",
    "barcode": "2305",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2306",
    "name": "Tarboosh Ghandour 12 pieces",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-2306",
    "barcode": "2306",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2307",
    "name": "Tamarin sirop 75cl Dayaa",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-2307",
    "barcode": "2307",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2309",
    "name": "Graines de fenouil 250 Espig",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-2309",
    "barcode": "2309",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2310",
    "name": "Huile d'olive Italienne 5l",
    "price": 42.5,
    "purchasePrice": 40.28436,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2310",
    "barcode": "2310",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2312",
    "name": "Halva Arkan Nature 750gr",
    "price": 4.35,
    "purchasePrice": 4.123223,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2312",
    "barcode": "2312",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2313",
    "name": "Charbon encens",
    "price": 1,
    "purchasePrice": 0.833333,
    "stock": -34,
    "category": "Accueil",
    "sku": "SKU-2313",
    "barcode": "2313",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-2314",
    "name": "Pistaches d'Iran décortiquées 250 gr",
    "price": 8.95,
    "purchasePrice": 8.483412,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-2314",
    "barcode": "2314",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2315",
    "name": "Pistaches d'Iran décortiquées 500gr.",
    "price": 14.75,
    "purchasePrice": 13.981043,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-2315",
    "barcode": "2315",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2316",
    "name": "Pignons longs premium 100gr",
    "price": 9.99,
    "purchasePrice": 9.469194,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2316",
    "barcode": "2316",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2317",
    "name": "Pignons longs 50gr.",
    "price": 5.25,
    "purchasePrice": 4.976303,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2317",
    "barcode": "2317",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2318",
    "name": "Gaufres Cacao Diwani 400gr.",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": -19,
    "category": "Accueil",
    "sku": "SKU-2318",
    "barcode": "2318",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2319",
    "name": "Bière Al Arez Façon Libanaise",
    "price": 1.75,
    "purchasePrice": 1.458333,
    "stock": 9,
    "category": "Accueil",
    "sku": "SKU-2319",
    "barcode": "2319",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2320",
    "name": "Abricots séchés 500gr Arev",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-2320",
    "barcode": "2320",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2321",
    "name": "Infusion Cumin Citron 25 sachet 50gr",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-2321",
    "barcode": "2321",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2322",
    "name": "Infusion Zaatar 25 sachets 50gr",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-2322",
    "barcode": "2322",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2323",
    "name": "Infusion Herbe zhourat 25 sachet 50gr",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2323",
    "barcode": "2323",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2324",
    "name": "Tamer Diwani",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": -19,
    "category": "Accueil",
    "sku": "SKU-2324",
    "barcode": "2324",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2326",
    "name": "Fruits à Coque Acidulés Al Fakhr 500gr",
    "price": 8.99,
    "purchasePrice": 8.521327,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2326",
    "barcode": "2326",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2329",
    "name": "Chou fleur",
    "price": 1.85,
    "purchasePrice": 1.753555,
    "stock": -97,
    "category": "Accueil",
    "sku": "SKU-2329",
    "barcode": "2329",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2330",
    "name": "Aubergine",
    "price": 1.53,
    "purchasePrice": 1.450237,
    "stock": -417,
    "category": "Accueil",
    "sku": "SKU-2330",
    "barcode": "2330",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2338",
    "name": "Makdous Al dayaa 600G",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2338",
    "barcode": "2338",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2343",
    "name": "maggi 1 cube",
    "price": 0.25,
    "purchasePrice": 0.236967,
    "stock": -108,
    "category": "Accueil",
    "sku": "SKU-2343",
    "barcode": "2343",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.25
  },
  {
    "id": "csv-2345",
    "name": "Boite Plastique suchi 10x*13",
    "price": 7,
    "purchasePrice": 5.833333,
    "stock": -8,
    "category": "Accueil",
    "sku": "SKU-2345",
    "barcode": "2345",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2346",
    "name": "Huile d'olive grignon Monoz 5L",
    "price": 29.25,
    "purchasePrice": 27.725118,
    "stock": -14,
    "category": "Accueil",
    "sku": "SKU-2346",
    "barcode": "2346",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2347",
    "name": "Epice falafel Abido 500gr",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": -4,
    "category": "Gourmandises",
    "sku": "SKU-2347",
    "barcode": "2347",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2348",
    "name": "Janerek 500gr",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -15,
    "category": "Accueil",
    "sku": "SKU-2348",
    "barcode": "2348",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2351",
    "name": "Chou fleur congelé 2.5kg",
    "price": 5.93,
    "purchasePrice": 5.620853,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-2351",
    "barcode": "2351",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2362",
    "name": "Moule falafel 2.5",
    "price": 2.5,
    "purchasePrice": 2.083333,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-2362",
    "barcode": "2362",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2363",
    "name": "Baba Ghanouj 820gr Cortas",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2363",
    "barcode": "2363",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2364",
    "name": "Artichauts marinés à l'huile 940 gr",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2364",
    "barcode": "2364",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2365",
    "name": "Maamoul gardenia Douaihy",
    "price": 14.5,
    "purchasePrice": 13.744076,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2365",
    "barcode": "2365",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2366",
    "name": "Huile d'olive Munoz 5l",
    "price": 29.2,
    "purchasePrice": 27.677725,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2366",
    "barcode": "2366",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2368",
    "name": "Carvi 50 gr Gardenia",
    "price": 1.45,
    "purchasePrice": 1.374408,
    "stock": 0,
    "category": "pain et Kaak",
    "sku": "SKU-2368",
    "barcode": "2368",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2377",
    "name": "Indomie Spécial Poulet sachet",
    "price": 0.45,
    "purchasePrice": 0.42654,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2377",
    "barcode": "2377",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.45
  },
  {
    "id": "csv-2378",
    "name": "Indomie spécial poulet X5 375g",
    "price": 1.8,
    "purchasePrice": 1.706161,
    "stock": -22,
    "category": "Accueil",
    "sku": "SKU-2378",
    "barcode": "2378",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2379",
    "name": "Indomie spécial poulet carton 3kg",
    "price": 13.2,
    "purchasePrice": 12.511848,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2379",
    "barcode": "2379",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2384",
    "name": "vimto 33 cl",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 126,
    "category": "Accueil",
    "sku": "SKU-2384",
    "barcode": "2384",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2385",
    "name": "Pepite pastèques jaunes 250gr Al fakhr",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2385",
    "barcode": "2385",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2388",
    "name": "fanta mangue fruit du dragon 33cl",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -34,
    "category": "Accueil",
    "sku": "SKU-2388",
    "barcode": "2388",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-2389",
    "name": "oasis pomme cassis framboise",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -69,
    "category": "Accueil",
    "sku": "SKU-2389",
    "barcode": "2389",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-2394",
    "name": "7 up",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -20,
    "category": "Accueil",
    "sku": "SKU-2394",
    "barcode": "2394",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-2396",
    "name": "Cumin fine Abido 500gr",
    "price": 9.99,
    "purchasePrice": 9.469194,
    "stock": 9,
    "category": "Accueil",
    "sku": "SKU-2396",
    "barcode": "2396",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2398",
    "name": "Shankleesh al aseel 400gr",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": -8,
    "category": "Accueil",
    "sku": "SKU-2398",
    "barcode": "2398",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2403",
    "name": "Musanara 800gr",
    "price": 10.55,
    "purchasePrice": 10,
    "stock": -11,
    "category": "Accueil",
    "sku": "SKU-2403",
    "barcode": "2403",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2405",
    "name": "riz long parfumée 5 kg",
    "price": 12.49,
    "purchasePrice": 11.838863,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2405",
    "barcode": "2405",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 12.49
  },
  {
    "id": "csv-2410",
    "name": "feuilles d'olivier 100g",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 23,
    "category": "Accueil",
    "sku": "SKU-2410",
    "barcode": "2410",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2411",
    "name": "feuilles de jujubier 40 g",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-2411",
    "barcode": "2411",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2413",
    "name": "caroubier 100g",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 20,
    "category": "Accueil",
    "sku": "SKU-2413",
    "barcode": "2413",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2415",
    "name": "Tarama Espelette",
    "price": 38.77,
    "purchasePrice": 36.748815,
    "stock": -51,
    "category": "Accueil",
    "sku": "SKU-2415",
    "barcode": "2415",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2416",
    "name": "Tarama Saumon 3.5kg",
    "price": 38.77,
    "purchasePrice": 36.748815,
    "stock": -43,
    "category": "Accueil",
    "sku": "SKU-2416",
    "barcode": "2416",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2417",
    "name": "TZAZIKI 2.5 kg",
    "price": 11.08,
    "purchasePrice": 10.5,
    "stock": -48,
    "category": "Accueil",
    "sku": "SKU-2417",
    "barcode": "2417",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 11.08
  },
  {
    "id": "csv-2418",
    "name": "Tomate Belge",
    "price": 1.32,
    "purchasePrice": 1.251185,
    "stock": -1409,
    "category": "Accueil",
    "sku": "SKU-2418",
    "barcode": "2418",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2419",
    "name": "Acide citrique 1 kg Aoun",
    "price": 6.54,
    "purchasePrice": 5.45,
    "stock": -51,
    "category": "Accueil",
    "sku": "SKU-2419",
    "barcode": "2419",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 6.54
  },
  {
    "id": "csv-2420",
    "name": "Citron jaune",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -164,
    "category": "Accueil",
    "sku": "SKU-2420",
    "barcode": "2420",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2421",
    "name": "Coriandre Botte",
    "price": 0.58,
    "purchasePrice": 0.549763,
    "stock": -312,
    "category": "Accueil",
    "sku": "SKU-2421",
    "barcode": "2421",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.58
  },
  {
    "id": "csv-2422",
    "name": "ouvre boite",
    "price": 3.5,
    "purchasePrice": 2.916667,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-2422",
    "barcode": "2422",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2424",
    "name": "Labneh Chtoura 1kg",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": -54,
    "category": "Accueil",
    "sku": "SKU-2424",
    "barcode": "2424",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2428",
    "name": "ice caffee vanille",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -43,
    "category": "Accueil",
    "sku": "SKU-2428",
    "barcode": "2428",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-2429",
    "name": "ice caffee hazelnut",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -24,
    "category": "Accueil",
    "sku": "SKU-2429",
    "barcode": "2429",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-2430",
    "name": "ice caffee caramel",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -62,
    "category": "Accueil",
    "sku": "SKU-2430",
    "barcode": "2430",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-2431",
    "name": "grillee et salee 400g",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2431",
    "barcode": "2431",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2432",
    "name": "houmous classic 200g mille olives",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-2432",
    "barcode": "2432",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2433",
    "name": "Zaatar Arjaoui 3450gr",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -18,
    "category": "Accueil",
    "sku": "SKU-2433",
    "barcode": "2433",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2434",
    "name": "Pignon",
    "price": 0,
    "purchasePrice": 0,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2434",
    "barcode": "2434",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2438",
    "name": "Cricri au kg",
    "price": 9.85,
    "purchasePrice": 9.336493,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2438",
    "barcode": "2438",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 9.85
  },
  {
    "id": "csv-2443",
    "name": "Sablé Chocolat Moulin d'or",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2443",
    "barcode": "2443",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2444",
    "name": "Sablé Abricot",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-2444",
    "barcode": "2444",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2448",
    "name": "olive noir kalamata 405G",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2448",
    "barcode": "2448",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2449",
    "name": "Baklava Cajou rest. 1.5kg",
    "price": 28.5,
    "purchasePrice": 27.014218,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2449",
    "barcode": "2449",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2450",
    "name": "hummus flava 200G",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-2450",
    "barcode": "2450",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2451",
    "name": "Ghraybeh moulin d'or 350 G",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2451",
    "barcode": "2451",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2456",
    "name": "Kaak aux sesames",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2456",
    "barcode": "2456",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2457",
    "name": "Maamoul dates 70 g",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2457",
    "barcode": "2457",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2460",
    "name": "Labneh RONA 800 g",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-2460",
    "barcode": "2460",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2461",
    "name": "concombre sauvage marinés boulos 650 g",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": -12,
    "category": "Accueil",
    "sku": "SKU-2461",
    "barcode": "2461",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2462",
    "name": "Tahini Cortas 18kg",
    "price": 95,
    "purchasePrice": 90.047393,
    "stock": 11,
    "category": "Accueil",
    "sku": "SKU-2462",
    "barcode": "2462",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2464",
    "name": "Jus Ananas Maccaw 180ml",
    "price": 9.99,
    "purchasePrice": 9.469194,
    "stock": -12,
    "category": "Accueil",
    "sku": "SKU-2464",
    "barcode": "2464",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2466",
    "name": "Sirop de rose Al khudari",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -42,
    "category": "Accueil",
    "sku": "SKU-2466",
    "barcode": "2466",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2467",
    "name": "triangle Fady's food 500gr",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-2467",
    "barcode": "2467",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2468",
    "name": "kebbeh chausson 1 PIECES",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": -481,
    "category": "Accueil",
    "sku": "SKU-2468",
    "barcode": "2468",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2469",
    "name": "kebbeh chausson 1 PIECES",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": -271,
    "category": "Accueil",
    "sku": "SKU-2469",
    "barcode": "2469",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2472",
    "name": "Piment Al Saad 1kg",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": -8,
    "category": "Accueil",
    "sku": "SKU-2472",
    "barcode": "2472",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2473",
    "name": "Hibiscus",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -28,
    "category": "Accueil",
    "sku": "SKU-2473",
    "barcode": "2473",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2474",
    "name": "Bicarbonate Spico 500gr",
    "price": 5.25,
    "purchasePrice": 4.976303,
    "stock": -31,
    "category": "Accueil",
    "sku": "SKU-2474",
    "barcode": "2474",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2475",
    "name": "Baklava Pistache rest 4.8kg",
    "price": 94,
    "purchasePrice": 89.099526,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2475",
    "barcode": "2475",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2476",
    "name": "feves peles avec piments forts samaya",
    "price": 0.95,
    "purchasePrice": 0.900474,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-2476",
    "barcode": "2476",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2477",
    "name": "Boulgour fin blanc  900gr. Altunsa",
    "price": 3.15,
    "purchasePrice": 2.985782,
    "stock": -56,
    "category": "Accueil",
    "sku": "SKU-2477",
    "barcode": "2477",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2478",
    "name": "Noix de pecan 1kg",
    "price": 16.35,
    "purchasePrice": 15.49763,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2478",
    "barcode": "2478",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2479",
    "name": "Yaourt 2.25 kg",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-2479",
    "barcode": "2479",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 5.5
  },
  {
    "id": "csv-2480",
    "name": "Almaza Unfiltred",
    "price": 1.86,
    "purchasePrice": 1.55,
    "stock": 27,
    "category": "Accueil",
    "sku": "SKU-2480",
    "barcode": "2480",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2481",
    "name": "Homous cortas 850gr",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": -291,
    "category": "Accueil",
    "sku": "SKU-2481",
    "barcode": "2481",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2482",
    "name": "Aubergine 1.75",
    "price": 1.85,
    "purchasePrice": 1.75,
    "stock": -350,
    "category": "Accueil",
    "sku": "SKU-2482",
    "barcode": "2482",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2483",
    "name": "Colorant alimentaire Rouge 1000gr",
    "price": 93.6,
    "purchasePrice": 78,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2483",
    "barcode": "2483",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2484",
    "name": "Colorant Alimantaire rouge 500gr",
    "price": 48,
    "purchasePrice": 40,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-2484",
    "barcode": "2484",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2485",
    "name": "GIZA Frais 5Kg",
    "price": 16.34,
    "purchasePrice": 15.488152,
    "stock": -12,
    "category": "Accueil",
    "sku": "SKU-2485",
    "barcode": "2485",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2486",
    "name": "Quanta 164 gr",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": -8,
    "category": "Accueil",
    "sku": "SKU-2486",
    "barcode": "2486",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2487",
    "name": "Break Trio 164 gr",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": -11,
    "category": "Accueil",
    "sku": "SKU-2487",
    "barcode": "2487",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2488",
    "name": "Break 8 bar",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": -8,
    "category": "Accueil",
    "sku": "SKU-2488",
    "barcode": "2488",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2489",
    "name": "Yonquers 8 bar",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-2489",
    "barcode": "2489",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2490",
    "name": "Eclairs Bonbon Assortiment 350gr",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-2490",
    "barcode": "2490",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2491",
    "name": "Huile d'olive Pomo Rosso 5L",
    "price": 48.5,
    "purchasePrice": 45.971564,
    "stock": -16,
    "category": "Accueil",
    "sku": "SKU-2491",
    "barcode": "2491",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2492",
    "name": "Concombre mariné Hikayat",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -97,
    "category": "Accueil",
    "sku": "SKU-2492",
    "barcode": "2492",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2493",
    "name": "Lebanese receipe samaya 360",
    "price": 0.95,
    "purchasePrice": 0.900474,
    "stock": -24,
    "category": "Accueil",
    "sku": "SKU-2493",
    "barcode": "2493",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.95
  },
  {
    "id": "csv-2494",
    "name": "gombo",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -21,
    "category": "Accueil",
    "sku": "SKU-2494",
    "barcode": "2494",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2495",
    "name": "soleil gran",
    "price": 1.1,
    "purchasePrice": 1.042654,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2495",
    "barcode": "2495",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2496",
    "name": "Huile d'olive 4L Boulos",
    "price": 50,
    "purchasePrice": 47.393365,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-2496",
    "barcode": "2496",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2497",
    "name": "Pois chiche 400gr Cortas",
    "price": 0.89,
    "purchasePrice": 0.843602,
    "stock": 14,
    "category": "Accueil",
    "sku": "SKU-2497",
    "barcode": "2497",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2498",
    "name": "Huile d'olive Boulos 50cl long",
    "price": 8.25,
    "purchasePrice": 7.819905,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2498",
    "barcode": "2498",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2500",
    "name": "Foul libanaise 400gr Cortas",
    "price": 0.95,
    "purchasePrice": 0.900474,
    "stock": 78,
    "category": "Accueil",
    "sku": "SKU-2500",
    "barcode": "2500",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2501",
    "name": "hommous cortas 185gr",
    "price": 0.75,
    "purchasePrice": 0.7109,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-2501",
    "barcode": "2501",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2502",
    "name": "Amandes Carmel 250gr Oregal",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2502",
    "barcode": "2502",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2503",
    "name": "akkawi bocal 400gr",
    "price": 5.25,
    "purchasePrice": 4.976303,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-2503",
    "barcode": "2503",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2504",
    "name": "PDT agria lavée",
    "price": 0.9,
    "purchasePrice": 0.85,
    "stock": -239,
    "category": "Accueil",
    "sku": "SKU-2504",
    "barcode": "2504",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.9
  },
  {
    "id": "csv-2505",
    "name": "Melasse de datte durra 425gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2505",
    "barcode": "2505",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2506",
    "name": "Tomate pate 800gr Shahia",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2506",
    "barcode": "2506",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2507",
    "name": "Tomate belge 1.35",
    "price": 1.42,
    "purchasePrice": 1.345972,
    "stock": -335,
    "category": "Accueil",
    "sku": "SKU-2507",
    "barcode": "2507",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2508",
    "name": "Aubergine 5kg",
    "price": 2.1,
    "purchasePrice": 1.990521,
    "stock": -359,
    "category": "Accueil",
    "sku": "SKU-2508",
    "barcode": "2508",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2509",
    "name": "Lait demi",
    "price": 1.05,
    "purchasePrice": 0.995261,
    "stock": -349,
    "category": "Accueil",
    "sku": "SKU-2509",
    "barcode": "2509",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1.05
  },
  {
    "id": "csv-2510",
    "name": "Concombre mariné 10kg Wassim",
    "price": 22.15,
    "purchasePrice": 20.995261,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-2510",
    "barcode": "2510",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2511",
    "name": "Dingo banane 12 pieces",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2511",
    "barcode": "2511",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2512",
    "name": "Navet mechaalany 1000gr",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2512",
    "barcode": "2512",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2513",
    "name": "Charbon Hamada 1kg",
    "price": 4.54,
    "purchasePrice": 3.781991,
    "stock": -18,
    "category": "Accueil",
    "sku": "SKU-2513",
    "barcode": "2513",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2514",
    "name": "concentré de tomate 650gr",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": -54,
    "category": "Accueil",
    "sku": "SKU-2514",
    "barcode": "2514",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2515",
    "name": "Concentré de tomate 130 gr Kasih",
    "price": 0.75,
    "purchasePrice": 0.7109,
    "stock": 16,
    "category": "Accueil",
    "sku": "SKU-2515",
    "barcode": "2515",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2517",
    "name": "fava beans 500G haboba",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": -25,
    "category": "Accueil",
    "sku": "SKU-2517",
    "barcode": "2517",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2519",
    "name": "Jello spoon Fraise",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2519",
    "barcode": "2519",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.99
  },
  {
    "id": "csv-2520",
    "name": "jello cerise aruba",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-2520",
    "barcode": "2520",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2521",
    "name": "Cumin moulu 185gr  Blue Mill",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-2521",
    "barcode": "2521",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2522",
    "name": "Curcuma 210gr Blue Mill",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-2522",
    "barcode": "2522",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2523",
    "name": "Ails Moulu 180gr Blue Mill",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2523",
    "barcode": "2523",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2524",
    "name": "Origan 14gr. Bedros",
    "price": 1.6,
    "purchasePrice": 1.516588,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-2524",
    "barcode": "2524",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2525",
    "name": "Figue verte 2kg",
    "price": 14.9,
    "purchasePrice": 14.123223,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-2525",
    "barcode": "2525",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2527",
    "name": "concombre *12",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": -146,
    "category": "Accueil",
    "sku": "SKU-2527",
    "barcode": "2527",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2528",
    "name": "Datte Mejdoule *5kg",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": -16,
    "category": "Accueil",
    "sku": "SKU-2528",
    "barcode": "2528",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2529",
    "name": "Aubergine *5kg",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -359,
    "category": "Accueil",
    "sku": "SKU-2529",
    "barcode": "2529",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2530",
    "name": "Tomate 1.55",
    "price": 1.64,
    "purchasePrice": 1.554502,
    "stock": -359,
    "category": "Accueil",
    "sku": "SKU-2530",
    "barcode": "2530",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2531",
    "name": "Encens hexagonal",
    "price": 9,
    "purchasePrice": 7.5,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2531",
    "barcode": "2531",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2532",
    "name": "Citron mariné au kg",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2532",
    "barcode": "2532",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 2.99
  },
  {
    "id": "csv-2533",
    "name": "flava brezel piment",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2533",
    "barcode": "2533",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2534",
    "name": "Halloum 500G",
    "price": 5.25,
    "purchasePrice": 4.976303,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-2534",
    "barcode": "2534",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2535",
    "name": "Poivre Noir Spico 500gr.",
    "price": 6.92,
    "purchasePrice": 6.559242,
    "stock": -35,
    "category": "Accueil",
    "sku": "SKU-2535",
    "barcode": "2535",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2536",
    "name": "Huile de tourne sol friture",
    "price": 1.65,
    "purchasePrice": 1.563981,
    "stock": -121,
    "category": "Accueil",
    "sku": "SKU-2536",
    "barcode": "2536",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2537",
    "name": "Lupin Saladitos 600gr",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2537",
    "barcode": "2537",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2538",
    "name": "sumac blue mill 500 g",
    "price": 6.25,
    "purchasePrice": 5.924171,
    "stock": -15,
    "category": "Accueil",
    "sku": "SKU-2538",
    "barcode": "2538",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2539",
    "name": "Oeuf grand calibre",
    "price": 0.31,
    "purchasePrice": 0.29,
    "stock": -269,
    "category": "Accueil",
    "sku": "SKU-2539",
    "barcode": "2539",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.31
  },
  {
    "id": "csv-2540",
    "name": "pepite noir al fakhr 250 g",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -53,
    "category": "Accueil",
    "sku": "SKU-2540",
    "barcode": "2540",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2541",
    "name": "Arack Ghantous 75cl",
    "price": 31.5,
    "purchasePrice": 29.85782,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-2541",
    "barcode": "2541",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2542",
    "name": "zaatar khodari 5kg",
    "price": 24,
    "purchasePrice": 22.748815,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-2542",
    "barcode": "2542",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2543",
    "name": "vert zaatar 200 G divan garden",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": -15,
    "category": "Accueil",
    "sku": "SKU-2543",
    "barcode": "2543",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2544",
    "name": "falafel mix 200 G divan garden",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -22,
    "category": "Accueil",
    "sku": "SKU-2544",
    "barcode": "2544",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2545",
    "name": "Poivron cherry Farci",
    "price": 22,
    "purchasePrice": 20.853081,
    "stock": -74,
    "category": "Accueil",
    "sku": "SKU-2545",
    "barcode": "2545",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2546",
    "name": "Feta dodoni 2kg",
    "price": 16.41,
    "purchasePrice": 15.554502,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-2546",
    "barcode": "2546",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2547",
    "name": "labne fino 5kg",
    "price": 2.58,
    "purchasePrice": 2.445498,
    "stock": -134,
    "category": "Accueil",
    "sku": "SKU-2547",
    "barcode": "2547",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2548",
    "name": "maestro fromage grec 14kg",
    "price": 6.38,
    "purchasePrice": 6.047393,
    "stock": -41,
    "category": "Accueil",
    "sku": "SKU-2548",
    "barcode": "2548",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2549",
    "name": "menthe seche spico 500gr",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": -19,
    "category": "Accueil",
    "sku": "SKU-2549",
    "barcode": "2549",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2551",
    "name": "tapenade noir 3.5 kg",
    "price": 38.77,
    "purchasePrice": 36.748815,
    "stock": -17,
    "category": "Accueil",
    "sku": "SKU-2551",
    "barcode": "2551",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 38.77
  },
  {
    "id": "csv-2552",
    "name": "Piment d'espelette 40gr",
    "price": 5.8,
    "purchasePrice": 5.49763,
    "stock": -6,
    "category": "Produits",
    "sku": "SKU-2552",
    "barcode": "2552",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2553",
    "name": "maamoul noix",
    "price": 17.5,
    "purchasePrice": 16.587678,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-2553",
    "barcode": "2553",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2554",
    "name": "chou fleur",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -32,
    "category": "Produits",
    "sku": "SKU-2554",
    "barcode": "2554",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2555",
    "name": "labneh lailand 500 G",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -23,
    "category": "Accueil",
    "sku": "SKU-2555",
    "barcode": "2555",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2556",
    "name": "Concombre sauvage 600gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2556",
    "barcode": "2556",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2557",
    "name": "Beure golden plate",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2557",
    "barcode": "2557",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2558",
    "name": "keshke al ahlam 200ge",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -19,
    "category": "Accueil",
    "sku": "SKU-2558",
    "barcode": "2558",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2559",
    "name": "Tahini kanater 18kg",
    "price": 110.77,
    "purchasePrice": 104.995261,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-2559",
    "barcode": "2559",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2560",
    "name": "Vin Rouge breteche 37.5cl",
    "price": 5.27,
    "purchasePrice": 4.391667,
    "stock": -12,
    "category": "Accueil",
    "sku": "SKU-2560",
    "barcode": "2560",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2561",
    "name": "Halawa Alburj premium 350",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2561",
    "barcode": "2561",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2562",
    "name": "Galanga seché 100gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 24,
    "category": "Accueil",
    "sku": "SKU-2562",
    "barcode": "2562",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2563",
    "name": "Pignon Libanais 1 kg",
    "price": 100,
    "purchasePrice": 94.78673,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2563",
    "barcode": "2563",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 100
  },
  {
    "id": "csv-2564",
    "name": "Maamoul avec datte 500G",
    "price": 10,
    "purchasePrice": 9.478673,
    "stock": -18,
    "category": "Accueil",
    "sku": "SKU-2564",
    "barcode": "2564",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2565",
    "name": "Olive vert mechaalany 600gr",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2565",
    "barcode": "2565",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2566",
    "name": "Makdous Al RABIH 550gr",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": -18,
    "category": "Accueil",
    "sku": "SKU-2566",
    "barcode": "2566",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2570",
    "name": "Mélange fruit sec grillé cocktail 250gr Rifai",
    "price": 2.85,
    "purchasePrice": 2.701422,
    "stock": 15,
    "category": "Accueil",
    "sku": "SKU-2570",
    "barcode": "2570",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2571",
    "name": "Mélange classic 250 gr RIfai",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -12,
    "category": "Accueil",
    "sku": "SKU-2571",
    "barcode": "2571",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2572",
    "name": "zwan poulet Piment 800gr",
    "price": 6.25,
    "purchasePrice": 5.924171,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2572",
    "barcode": "2572",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2573",
    "name": "Maamoul avec noix 500 G",
    "price": 10,
    "purchasePrice": 9.478673,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2573",
    "barcode": "2573",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2574",
    "name": "Petale de rose 60gr",
    "price": 8.97,
    "purchasePrice": 8.50237,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2574",
    "barcode": "2574",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2575",
    "name": "Tomate Ronde",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -65,
    "category": "Accueil",
    "sku": "SKU-2575",
    "barcode": "2575",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2577",
    "name": "Safran d'Iran qualité premium",
    "price": 6.6,
    "purchasePrice": 6.255924,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2577",
    "barcode": "2577",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2578",
    "name": "Semoule grosse Le renard 1kg",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-2578",
    "barcode": "2578",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2579",
    "name": "Semoule extra fine le renard",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2579",
    "barcode": "2579",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2580",
    "name": "Semoule moyen Le renard 1kg",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2580",
    "barcode": "2580",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2581",
    "name": "Safran d'iran premium AZAFRAN",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 27,
    "category": "Épices",
    "sku": "SKU-2581",
    "barcode": "2581",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2582",
    "name": "garlic sauce durra 380g",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": -37,
    "category": "Accueil",
    "sku": "SKU-2582",
    "barcode": "2582",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2583",
    "name": "jalapeno durra 450G",
    "price": 1.95,
    "purchasePrice": 1.848341,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2583",
    "barcode": "2583",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2586",
    "name": "Hallab baklava kg",
    "price": 24,
    "purchasePrice": 22.748815,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2586",
    "barcode": "2586",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 24
  },
  {
    "id": "csv-2587",
    "name": "Maamoul hallab Pistache 70gr",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 12,
    "category": "Accueil",
    "sku": "SKU-2587",
    "barcode": "2587",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2588",
    "name": "Maamoul hallab Noix 70gr",
    "price": 2.24,
    "purchasePrice": 2.123223,
    "stock": 26,
    "category": "Accueil",
    "sku": "SKU-2588",
    "barcode": "2588",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2589",
    "name": "Maamoul Hallab dattes 70gr",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 15,
    "category": "Accueil",
    "sku": "SKU-2589",
    "barcode": "2589",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2590",
    "name": "Yogurt sutdiyari 1000G",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2590",
    "barcode": "2590",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2591",
    "name": "Baklava Hallab cajou 500gr",
    "price": 14.75,
    "purchasePrice": 13.981043,
    "stock": -19,
    "category": "Accueil",
    "sku": "SKU-2591",
    "barcode": "2591",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2592",
    "name": "Harissa boite 4/4",
    "price": 3.45,
    "purchasePrice": 3.270142,
    "stock": -75,
    "category": "Accueil",
    "sku": "SKU-2592",
    "barcode": "2592",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2593",
    "name": "Olive noir DenoYauter 5/1 5kg",
    "price": 11.15,
    "purchasePrice": 10.56872,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2593",
    "barcode": "2593",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2594",
    "name": "Piment sucette 7kg",
    "price": 21.09,
    "purchasePrice": 19.99,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2594",
    "barcode": "2594",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2595",
    "name": "Grenade Frais gros Calibre colis",
    "price": 27.43,
    "purchasePrice": 26,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-2595",
    "barcode": "2595",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2596",
    "name": "olive vert 4200G",
    "price": 13.5,
    "purchasePrice": 12.796209,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2596",
    "barcode": "2596",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2597",
    "name": "Origano",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-2597",
    "barcode": "2597",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2598",
    "name": "oignon en vrac par kg",
    "price": 0.75,
    "purchasePrice": 0.7109,
    "stock": -1245,
    "category": "Accueil",
    "sku": "SKU-2598",
    "barcode": "2598",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.75
  },
  {
    "id": "csv-2599",
    "name": "Menthe Fraiche",
    "price": 0.75,
    "purchasePrice": 0.7109,
    "stock": -39,
    "category": "Accueil",
    "sku": "SKU-2599",
    "barcode": "2599",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.75
  },
  {
    "id": "csv-2600",
    "name": "Huile grignon 5L",
    "price": 27.5,
    "purchasePrice": 26.066351,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2600",
    "barcode": "2600",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2603",
    "name": "Encen loubane nahil 150G",
    "price": 3.5,
    "purchasePrice": 2.916667,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2603",
    "barcode": "2603",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2604",
    "name": "aubergine frais 1kg",
    "price": 2.9,
    "purchasePrice": 2.748815,
    "stock": -99,
    "category": "Accueil",
    "sku": "SKU-2604",
    "barcode": "2604",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2605",
    "name": "Vinaigre Blanc 1L yamama",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2605",
    "barcode": "2605",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2606",
    "name": "Vinaigre de raison 1L Yamama",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-2606",
    "barcode": "2606",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2607",
    "name": "Pierre d'Alun 200gr",
    "price": 2.26,
    "purchasePrice": 1.886256,
    "stock": 17,
    "category": "Accueil",
    "sku": "SKU-2607",
    "barcode": "2607",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2608",
    "name": "Olive 2kg Ahlam",
    "price": 14.5,
    "purchasePrice": 13.744076,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-2608",
    "barcode": "2608",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2613",
    "name": "Starbucks Blonde",
    "price": 5,
    "purchasePrice": 4.739336,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-2613",
    "barcode": "2613",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2614",
    "name": "Starbucks House Blend",
    "price": 5,
    "purchasePrice": 4.739336,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-2614",
    "barcode": "2614",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2615",
    "name": "Starbucks espresso Roasted",
    "price": 5,
    "purchasePrice": 4.739336,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2615",
    "barcode": "2615",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2617",
    "name": "Concentré de tomate TAK 800gr",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": -159,
    "category": "Accueil",
    "sku": "SKU-2617",
    "barcode": "2617",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2618",
    "name": "Betterave au kg",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-2618",
    "barcode": "2618",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 2.25
  },
  {
    "id": "csv-2619",
    "name": "Bulgur avec vermicelle 900G",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2619",
    "barcode": "2619",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2621",
    "name": "Labneh kolios 900gr",
    "price": 6.75,
    "purchasePrice": 6.398104,
    "stock": -32,
    "category": "Accueil",
    "sku": "SKU-2621",
    "barcode": "2621",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2622",
    "name": "Champignon frais 1kg",
    "price": 3.43,
    "purchasePrice": 3.251185,
    "stock": -5,
    "category": "Produits",
    "sku": "SKU-2622",
    "barcode": "2622",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2623",
    "name": "Pignon de Siberie 1kg",
    "price": 40,
    "purchasePrice": 37.914692,
    "stock": -1,
    "category": "Produits",
    "sku": "SKU-2623",
    "barcode": "2623",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2624",
    "name": "Chou Rouge",
    "price": 1.42,
    "purchasePrice": 1.345972,
    "stock": -19,
    "category": "Produits",
    "sku": "SKU-2624",
    "barcode": "2624",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2625",
    "name": "soudjouk et makanek halal rest.",
    "price": 16.19,
    "purchasePrice": 15.35,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-2625",
    "barcode": "2625",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2626",
    "name": "Salade grec 3.5kg",
    "price": 38.77,
    "purchasePrice": 36.748815,
    "stock": -1,
    "category": "Produits",
    "sku": "SKU-2626",
    "barcode": "2626",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2627",
    "name": "TRIO d'olive bella cerignola 3.5kg",
    "price": 36.92,
    "purchasePrice": 34.995261,
    "stock": -2,
    "category": "Produits",
    "sku": "SKU-2627",
    "barcode": "2627",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2629",
    "name": "Sumac blue mill 1KG",
    "price": 9.99,
    "purchasePrice": 9.469194,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-2629",
    "barcode": "2629",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2630",
    "name": "Falafel chtoura 200G",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2630",
    "barcode": "2630",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2631",
    "name": "Markouk oat avoine",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -29,
    "category": "Accueil",
    "sku": "SKU-2631",
    "barcode": "2631",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2634",
    "name": "Mélange classique 250gr Beyrouti",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": -31,
    "category": "Accueil",
    "sku": "SKU-2634",
    "barcode": "2634",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2635",
    "name": "Melange delux salé Beyrouti 250gr",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -17,
    "category": "Accueil",
    "sku": "SKU-2635",
    "barcode": "2635",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2636",
    "name": "Melange supérieur Beyrouti 250gr",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2636",
    "barcode": "2636",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2637",
    "name": "feves bajela Diwan 400G",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": -18,
    "category": "Accueil",
    "sku": "SKU-2637",
    "barcode": "2637",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2638",
    "name": "Sibon kol w chkor",
    "price": 17.93,
    "purchasePrice": 16.995261,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2638",
    "barcode": "2638",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2639",
    "name": "ail en poudre espig",
    "price": 7.3,
    "purchasePrice": 6.919431,
    "stock": -18,
    "category": "Accueil",
    "sku": "SKU-2639",
    "barcode": "2639",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2640",
    "name": "hallab rest",
    "price": 9.5,
    "purchasePrice": 9.004739,
    "stock": -51,
    "category": "Accueil",
    "sku": "SKU-2640",
    "barcode": "2640",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2641",
    "name": "hallab rest 400gr",
    "price": 7.6,
    "purchasePrice": 7.203791,
    "stock": -12,
    "category": "Accueil",
    "sku": "SKU-2641",
    "barcode": "2641",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2642",
    "name": "Hallab Maamoul pistache 500gr",
    "price": 13,
    "purchasePrice": 12.322275,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-2642",
    "barcode": "2642",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2643",
    "name": "Namoura Hallab 550gr",
    "price": 9.95,
    "purchasePrice": 9.43128,
    "stock": -57,
    "category": "Accueil",
    "sku": "SKU-2643",
    "barcode": "2643",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2644",
    "name": "Hallab maamoul mad noix 600gr",
    "price": 15,
    "purchasePrice": 14.218009,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-2644",
    "barcode": "2644",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2645",
    "name": "hallab maamoul noix 500gr",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-2645",
    "barcode": "2645",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2646",
    "name": "Hallab Maamoul Datte 500gr",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-2646",
    "barcode": "2646",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2647",
    "name": "Knafe 170gr",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -97,
    "category": "Accueil",
    "sku": "SKU-2647",
    "barcode": "2647",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2649",
    "name": "Concentré de tomate ROSSO 800gr",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -13,
    "category": "Accueil",
    "sku": "SKU-2649",
    "barcode": "2649",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2653",
    "name": "kasih creamy 540g",
    "price": 3.9,
    "purchasePrice": 3.696682,
    "stock": -103,
    "category": "Accueil",
    "sku": "SKU-2653",
    "barcode": "2653",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2655",
    "name": "Falafel congelé 400gr jardin vert",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": -20,
    "category": "Accueil",
    "sku": "SKU-2655",
    "barcode": "2655",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2656",
    "name": "tarama brut 3kg",
    "price": 31.5,
    "purchasePrice": 29.85782,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2656",
    "barcode": "2656",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2657",
    "name": "Pistache hallab kg",
    "price": 30,
    "purchasePrice": 28.436019,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2657",
    "barcode": "2657",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 30
  },
  {
    "id": "csv-2658",
    "name": "Canard au kg",
    "price": 8.4,
    "purchasePrice": 7.962085,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2658",
    "barcode": "2658",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 8.4
  },
  {
    "id": "csv-2659",
    "name": "Aile de Poulet 2 flg 1kg",
    "price": 3.53,
    "purchasePrice": 3.35,
    "stock": -34,
    "category": "Accueil",
    "sku": "SKU-2659",
    "barcode": "2659",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2660",
    "name": "Pilon de Poulet 1kg",
    "price": 3.45,
    "purchasePrice": 3.270142,
    "stock": -49,
    "category": "Accueil",
    "sku": "SKU-2660",
    "barcode": "2660",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2661",
    "name": "Caille pièce kg",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": -59,
    "category": "Accueil",
    "sku": "SKU-2661",
    "barcode": "2661",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 2.25
  },
  {
    "id": "csv-2662",
    "name": "Tomate ronde marocaine",
    "price": 1.05,
    "purchasePrice": 0.995261,
    "stock": -113,
    "category": "Accueil",
    "sku": "SKU-2662",
    "barcode": "2662",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1.05
  },
  {
    "id": "csv-2663",
    "name": "hallab barbe à papa 150gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -8,
    "category": "Accueil",
    "sku": "SKU-2663",
    "barcode": "2663",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2664",
    "name": "Amora moutard forte 430gr",
    "price": 7.49,
    "purchasePrice": 7.099526,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-2664",
    "barcode": "2664",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2665",
    "name": "Graibeh Hallab 200g",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-2665",
    "barcode": "2665",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2666",
    "name": "Burma pistache 250g",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2666",
    "barcode": "2666",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2667",
    "name": "Baking Powder Grand",
    "price": 8.97,
    "purchasePrice": 8.50237,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2667",
    "barcode": "2667",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2668",
    "name": "Kefta ou kafta Abido 500gr",
    "price": 9.5,
    "purchasePrice": 9.004739,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-2668",
    "barcode": "2668",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2669",
    "name": "Bobine Carte Bleu x5",
    "price": 5,
    "purchasePrice": 4.166667,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-2669",
    "barcode": "2669",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2670",
    "name": "Poulet desossé",
    "price": 5.8,
    "purchasePrice": 5.49763,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-2670",
    "barcode": "2670",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2671",
    "name": "Chou fleur",
    "price": 2.1,
    "purchasePrice": 1.990521,
    "stock": -59,
    "category": "Accueil",
    "sku": "SKU-2671",
    "barcode": "2671",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2672",
    "name": "Film aluminium 45cm",
    "price": 33,
    "purchasePrice": 27.5,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2672",
    "barcode": "2672",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2673",
    "name": "Labneh cri cri 5kg",
    "price": 18,
    "purchasePrice": 17.061611,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2673",
    "barcode": "2673",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2674",
    "name": "Batavia Colis",
    "price": 10.5,
    "purchasePrice": 9.952607,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-2674",
    "barcode": "2674",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2675",
    "name": "Epinard surgelé 1kg",
    "price": 2.35,
    "purchasePrice": 2.227488,
    "stock": -136,
    "category": "Accueil",
    "sku": "SKU-2675",
    "barcode": "2675",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2676",
    "name": "Film Aluminium 30cm",
    "price": 20.88,
    "purchasePrice": 17.4,
    "stock": -12,
    "category": "Accueil",
    "sku": "SKU-2676",
    "barcode": "2676",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2677",
    "name": "tasse cafe petit",
    "price": 1,
    "purchasePrice": 0.833333,
    "stock": -32,
    "category": "Accueil",
    "sku": "SKU-2677",
    "barcode": "2677",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-2678",
    "name": "tasse cafe grand",
    "price": 1.5,
    "purchasePrice": 1.25,
    "stock": -27,
    "category": "Accueil",
    "sku": "SKU-2678",
    "barcode": "2678",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2679",
    "name": "Huile d'olive Senioro 5L",
    "price": 50,
    "purchasePrice": 47.393365,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2679",
    "barcode": "2679",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2680",
    "name": "Nougat kamaredin ghrawi 250gr",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-2680",
    "barcode": "2680",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2681",
    "name": "Noix pecan 150gr",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2681",
    "barcode": "2681",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2682",
    "name": "Poivre doux piment de jamaique 500gr",
    "price": 8.5,
    "purchasePrice": 8.056872,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-2682",
    "barcode": "2682",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2683",
    "name": "Okra bamiya zero 400gr",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-2683",
    "barcode": "2683",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2684",
    "name": "Mloukhiya Nasmah feuille entier 400gr",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2684",
    "barcode": "2684",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2685",
    "name": "Riz Basmati HAMADA 4.5kg",
    "price": 13.99,
    "purchasePrice": 13.260664,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2685",
    "barcode": "2685",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2686",
    "name": "melasse de sucre de canne 200gr",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-2686",
    "barcode": "2686",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2688",
    "name": "Epices Kaak 50gr",
    "price": 1.9,
    "purchasePrice": 1.800948,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2688",
    "barcode": "2688",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2689",
    "name": "boyaux Halal 10m",
    "price": 15,
    "purchasePrice": 14.218009,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2689",
    "barcode": "2689",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2690",
    "name": "Vermicelles 1KG HABO",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": -8,
    "category": "Accueil",
    "sku": "SKU-2690",
    "barcode": "2690",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2691",
    "name": "Pépite tournesol 250gr Castania",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2691",
    "barcode": "2691",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2692",
    "name": "ELNOZHA Pépite pastèque 250gr",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 34,
    "category": "Accueil",
    "sku": "SKU-2692",
    "barcode": "2692",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2693",
    "name": "miel fleurs walima 1kg",
    "price": 6.75,
    "purchasePrice": 6.398104,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2693",
    "barcode": "2693",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2694",
    "name": "Makdous Alsaadah 1000gr",
    "price": 7.95,
    "purchasePrice": 7.535545,
    "stock": -26,
    "category": "Accueil",
    "sku": "SKU-2694",
    "barcode": "2694",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2695",
    "name": "Makdous Baladna 950gr",
    "price": 11.5,
    "purchasePrice": 10.900474,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-2695",
    "barcode": "2695",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2696",
    "name": "Makdous durra 1250gr",
    "price": 13.75,
    "purchasePrice": 13.033175,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2696",
    "barcode": "2696",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2697",
    "name": "Tahini Baladna 800gr",
    "price": 7.25,
    "purchasePrice": 6.872038,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2697",
    "barcode": "2697",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2699",
    "name": "Kaak ALSAAFAH 350gr",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -169,
    "category": "Accueil",
    "sku": "SKU-2699",
    "barcode": "2699",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2700",
    "name": "Pepite pasteque aslaadah 300gr",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 11,
    "category": "Accueil",
    "sku": "SKU-2700",
    "barcode": "2700",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2701",
    "name": "Huile de tournesol 810ml SHAHIA",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 20,
    "category": "Accueil",
    "sku": "SKU-2701",
    "barcode": "2701",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2702",
    "name": "Huile de tournesol 4.2L SHAHIA",
    "price": 8.75,
    "purchasePrice": 8.293839,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2702",
    "barcode": "2702",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2703",
    "name": "Loumi citron séché 130gr Alsaadah",
    "price": 2.55,
    "purchasePrice": 2.417062,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2703",
    "barcode": "2703",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2704",
    "name": "riz Khyber",
    "price": 8.5,
    "purchasePrice": 8.056872,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2704",
    "barcode": "2704",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2705",
    "name": "Riz Basmati DAYFI 5Kg",
    "price": 8.99,
    "purchasePrice": 8.521327,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2705",
    "barcode": "2705",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2706",
    "name": "Labneh hajdu 600gr",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 25,
    "category": "Accueil",
    "sku": "SKU-2706",
    "barcode": "2706",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2707",
    "name": "Fromage hajdu 225gr",
    "price": 2.95,
    "purchasePrice": 2.796209,
    "stock": -55,
    "category": "Accueil",
    "sku": "SKU-2707",
    "barcode": "2707",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2708",
    "name": "Labneh hajdu 500gr",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 12,
    "category": "Accueil",
    "sku": "SKU-2708",
    "barcode": "2708",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2709",
    "name": "Labneh hajdu 180gr",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 38,
    "category": "Accueil",
    "sku": "SKU-2709",
    "barcode": "2709",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2711",
    "name": "Riz basmati Boustan sella 4.5kg",
    "price": 14.25,
    "purchasePrice": 13.507109,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2711",
    "barcode": "2711",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2712",
    "name": "KETTLE COOKED sel 37gr",
    "price": 0.75,
    "purchasePrice": 0.7109,
    "stock": -25,
    "category": "Accueil",
    "sku": "SKU-2712",
    "barcode": "2712",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.75
  },
  {
    "id": "csv-2714",
    "name": "Kettle Master Chips 37 gr vinaigre",
    "price": 0.75,
    "purchasePrice": 0.7109,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2714",
    "barcode": "2714",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2717",
    "name": "Paprika Abido 500gr",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": -75,
    "category": "Accueil",
    "sku": "SKU-2717",
    "barcode": "2717",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2718",
    "name": "Piment paillette 400gr Sofram",
    "price": 4.8,
    "purchasePrice": 4.549763,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2718",
    "barcode": "2718",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2719",
    "name": "Colorant alimentaire Jaune 250gr",
    "price": 24,
    "purchasePrice": 20,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2719",
    "barcode": "2719",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2723",
    "name": "Oasis Tropical",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 24,
    "category": "Accueil",
    "sku": "SKU-2723",
    "barcode": "2723",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2724",
    "name": "Oasis pomme cassis Framboise",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2724",
    "barcode": "2724",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2725",
    "name": "Pepsi zéro sucre",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -21,
    "category": "Accueil",
    "sku": "SKU-2725",
    "barcode": "2725",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-2726",
    "name": "7UP Saveur Majito",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-2726",
    "barcode": "2726",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2728",
    "name": "Huile d'olive vierge grec 5L",
    "price": 50,
    "purchasePrice": 47.393365,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2728",
    "barcode": "2728",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2730",
    "name": "Melasse de grenade Alsaada 700gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2730",
    "barcode": "2730",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2731",
    "name": "Ketchup louis martin",
    "price": 12,
    "purchasePrice": 11.374408,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2731",
    "barcode": "2731",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2734",
    "name": "Feuille de vigne farcie 280gr",
    "price": 3.85,
    "purchasePrice": 3.649289,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-2734",
    "barcode": "2734",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2735",
    "name": "Kadaeif 500gr",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": -16,
    "category": "Accueil",
    "sku": "SKU-2735",
    "barcode": "2735",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2736",
    "name": "AHMAD TEA 250gr CEYLON Tea",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2736",
    "barcode": "2736",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2737",
    "name": "Graines de chia 100gr",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2737",
    "barcode": "2737",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2738",
    "name": "Sauge Sage asiin maryamiye 50gr",
    "price": 2.95,
    "purchasePrice": 2.796209,
    "stock": -19,
    "category": "Accueil",
    "sku": "SKU-2738",
    "barcode": "2738",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2739",
    "name": "Neo vanille cream Deemah 30gr x 16",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-2739",
    "barcode": "2739",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2740",
    "name": "Piment  marinée Mexicain 1050gr Hikayat 2",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2740",
    "barcode": "2740",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2741",
    "name": "Variante de légume 1050gr Hikayat 2",
    "price": 2.95,
    "purchasePrice": 2.796209,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2741",
    "barcode": "2741",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2742",
    "name": "The Alwazah 400gr 100% pure Ceylon",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2742",
    "barcode": "2742",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2743",
    "name": "Jalapeno 710gr CICEK",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2743",
    "barcode": "2743",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2745",
    "name": "Dattes d'Algérie fraiche 1kg",
    "price": 5.95,
    "purchasePrice": 5.63981,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-2745",
    "barcode": "2745",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2746",
    "name": "Riz Egypcien Rihana 5kg",
    "price": 10.55,
    "purchasePrice": 10,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-2746",
    "barcode": "2746",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2748",
    "name": "DUBAI Chocolate KUBBANI 200gr",
    "price": 10.5,
    "purchasePrice": 9.952607,
    "stock": -20,
    "category": "Accueil",
    "sku": "SKU-2748",
    "barcode": "2748",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2749",
    "name": "Bablly Bonbon fruits 800g",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-2749",
    "barcode": "2749",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2750",
    "name": "Bonbon Chocolat Turque cadeau 560gr",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-2750",
    "barcode": "2750",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2752",
    "name": "Yaourt naturel beqaa",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-2752",
    "barcode": "2752",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2753",
    "name": "Kechek artisanal 200gr",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2753",
    "barcode": "2753",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2756",
    "name": "Plateau oeuf grand Calibre 30",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-2756",
    "barcode": "2756",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2757",
    "name": "Piment Marinés 600gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -11,
    "category": "Produits",
    "sku": "SKU-2757",
    "barcode": "2757",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2758",
    "name": "Noix de cajou 18.5 au kg",
    "price": 18.5,
    "purchasePrice": 17.535545,
    "stock": -1,
    "category": "Produits",
    "sku": "SKU-2758",
    "barcode": "2758",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 18.5
  },
  {
    "id": "csv-2759",
    "name": "pistache grillé d'iran 18.5 kg",
    "price": 18.5,
    "purchasePrice": 17.535545,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-2759",
    "barcode": "2759",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 18.5
  },
  {
    "id": "csv-2760",
    "name": "Aubergine grillé Al Saada 620gr",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-2760",
    "barcode": "2760",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2761",
    "name": "Kaak salé fenouil Tarallini 220gr",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-2761",
    "barcode": "2761",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2762",
    "name": "Café Glacé luna original",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2762",
    "barcode": "2762",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2764",
    "name": "Oeuf petit calibre 30 oeufs",
    "price": 5.99,
    "purchasePrice": 5.677725,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-2764",
    "barcode": "2764",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2765",
    "name": "Mini pain Ammo x20 pieces",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-2765",
    "barcode": "2765",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2766",
    "name": "lentille corail chtoura",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2766",
    "barcode": "2766",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2767",
    "name": "Aubergine ++ kg",
    "price": 4.01,
    "purchasePrice": 3.8,
    "stock": -156,
    "category": "Accueil",
    "sku": "SKU-2767",
    "barcode": "2767",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 4.01
  },
  {
    "id": "csv-2768",
    "name": "Mures sechees Selcuk 200g",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 11,
    "category": "Accueil",
    "sku": "SKU-2768",
    "barcode": "2768",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2769",
    "name": "Loukoum Biscuit Selcuk 300g",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-2769",
    "barcode": "2769",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2770",
    "name": "Saucisse de noix Selcuk 300",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-2770",
    "barcode": "2770",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2771",
    "name": "Acide citrique  kg",
    "price": 6.9,
    "purchasePrice": 5.75,
    "stock": -136,
    "category": "Accueil",
    "sku": "SKU-2771",
    "barcode": "2771",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 6.9
  },
  {
    "id": "csv-2772",
    "name": "Navet frais kg",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -69,
    "category": "Accueil",
    "sku": "SKU-2772",
    "barcode": "2772",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1.75
  },
  {
    "id": "csv-2775",
    "name": "Poitrine d'agneau",
    "price": 8.15,
    "purchasePrice": 7.725118,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2775",
    "barcode": "2775",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2776",
    "name": "Kefraya bretèche rouge 37.5cl",
    "price": 5.22,
    "purchasePrice": 4.35,
    "stock": -23,
    "category": "Accueil",
    "sku": "SKU-2776",
    "barcode": "2776",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2777",
    "name": "kashkaval 800gr",
    "price": 8.23,
    "purchasePrice": 7.800948,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2777",
    "barcode": "2777",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2778",
    "name": "Chou blanc Libanais",
    "price": 2.9,
    "purchasePrice": 2.748815,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2778",
    "barcode": "2778",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2779",
    "name": "Cannelle 500gr moulu",
    "price": 4.62,
    "purchasePrice": 4.379147,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2779",
    "barcode": "2779",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2780",
    "name": "piment fort moulu 500gr",
    "price": 3.88,
    "purchasePrice": 3.677725,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-2780",
    "barcode": "2780",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2781",
    "name": "Charbon Fan 1 kg",
    "price": 4.55,
    "purchasePrice": 3.791667,
    "stock": -40,
    "category": "Accueil",
    "sku": "SKU-2781",
    "barcode": "2781",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 4.55
  },
  {
    "id": "csv-2782",
    "name": "Baklava al sultan 200gr",
    "price": 8.5,
    "purchasePrice": 8.056872,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-2782",
    "barcode": "2782",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2783",
    "name": "sac bretelle 2000 pieces",
    "price": 43.2,
    "purchasePrice": 36,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-2783",
    "barcode": "2783",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2784",
    "name": "Msanara HaJdu Naboulsi 400gr",
    "price": 5.99,
    "purchasePrice": 5.677725,
    "stock": -38,
    "category": "Accueil",
    "sku": "SKU-2784",
    "barcode": "2784",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2785",
    "name": "Naboulsi hajdu 220gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": -35,
    "category": "Accueil",
    "sku": "SKU-2785",
    "barcode": "2785",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2786",
    "name": "Kashkaval hajdu 350gr brebis",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 9,
    "category": "Accueil",
    "sku": "SKU-2786",
    "barcode": "2786",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2787",
    "name": "Falafel boustani 400gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": -20,
    "category": "Accueil",
    "sku": "SKU-2787",
    "barcode": "2787",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2791",
    "name": "Tuna Chunk Chili Tayba 160 gr",
    "price": 1.65,
    "purchasePrice": 1.563981,
    "stock": -66,
    "category": "Accueil",
    "sku": "SKU-2791",
    "barcode": "2791",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2792",
    "name": "Tuna Chunk Tayba 160 gr",
    "price": 1.65,
    "purchasePrice": 1.563981,
    "stock": -112,
    "category": "Accueil",
    "sku": "SKU-2792",
    "barcode": "2792",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2793",
    "name": "Creamy White Hajdu 400 gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -8,
    "category": "Accueil",
    "sku": "SKU-2793",
    "barcode": "2793",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2794",
    "name": "Hallab Maamoul mix 600 gr",
    "price": 15,
    "purchasePrice": 14.218009,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2794",
    "barcode": "2794",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2795",
    "name": "Concombre Mariné Durra 2.7 kg",
    "price": 7.75,
    "purchasePrice": 7.345972,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-2795",
    "barcode": "2795",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 7.75
  },
  {
    "id": "csv-2796",
    "name": "Pignon de siberie 500gr",
    "price": 17.5,
    "purchasePrice": 16.587678,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2796",
    "barcode": "2796",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2797",
    "name": "Feuille de brique",
    "price": 1.05,
    "purchasePrice": 0.995261,
    "stock": -49,
    "category": "Accueil",
    "sku": "SKU-2797",
    "barcode": "2797",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1.05
  },
  {
    "id": "csv-2798",
    "name": "Feve secs Shahia 700 gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-2798",
    "barcode": "2798",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2799",
    "name": "Labne jaune 5kg",
    "price": 18.5,
    "purchasePrice": 17.535545,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-2799",
    "barcode": "2799",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2800",
    "name": "datte ajwa madina 600gr",
    "price": 10.5,
    "purchasePrice": 9.952607,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2800",
    "barcode": "2800",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2801",
    "name": "kashkaval 700gr",
    "price": 8.95,
    "purchasePrice": 8.483412,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-2801",
    "barcode": "2801",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2802",
    "name": "Zaatar Shami Alraii 500 gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2802",
    "barcode": "2802",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2804",
    "name": "Taj elmolouk 900g",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-2804",
    "barcode": "2804",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2805",
    "name": "soupe vegetale al sham garden",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": -21,
    "category": "Accueil",
    "sku": "SKU-2805",
    "barcode": "2805",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2806",
    "name": "sukari al nakhil 500gr",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-2806",
    "barcode": "2806",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2807",
    "name": "Ajwa al madina 450gr",
    "price": 10,
    "purchasePrice": 9.478673,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2807",
    "barcode": "2807",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2808",
    "name": "Datte Nader 700 gr",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2808",
    "barcode": "2808",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2809",
    "name": "Juc en poudre Orage - Ice Refreshing 12 sac",
    "price": 4.5,
    "purchasePrice": 3.75,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-2809",
    "barcode": "2809",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2810",
    "name": "Huile d'Olive Olivia 5 Litre",
    "price": 50,
    "purchasePrice": 47.393365,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-2810",
    "barcode": "2810",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2811",
    "name": "Jus Fraise Mama africa 1.5 Litre",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2811",
    "barcode": "2811",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2812",
    "name": "Jus Pomme Mama africa 1.5 Litre",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2812",
    "barcode": "2812",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2813",
    "name": "Jus Tutti Frutti Mama africa1.5 Litre",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2813",
    "barcode": "2813",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2814",
    "name": "Jus Tropical Mama africa 1.5 Litre",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2814",
    "barcode": "2814",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2815",
    "name": "Jus Pina Coco Mama africa 1.5 Litre",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2815",
    "barcode": "2815",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2816",
    "name": "Amidon 500 g",
    "price": 2,
    "purchasePrice": 1.895,
    "stock": 9,
    "category": "Accueil",
    "sku": "SKU-2816",
    "barcode": "2816",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2817",
    "name": "Syrup Jallab Khudari 600 ml",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2817",
    "barcode": "2817",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2818",
    "name": "Rouleau carte bleu sgma x20",
    "price": 14.28,
    "purchasePrice": 11.9,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2818",
    "barcode": "2818",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2819",
    "name": "GUILLEN huile d'olive 5L",
    "price": 45,
    "purchasePrice": 42.654028,
    "stock": -17,
    "category": "Accueil",
    "sku": "SKU-2819",
    "barcode": "2819",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2820",
    "name": "Nocille Chocomix 60gr",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2820",
    "barcode": "2820",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2821",
    "name": "Nocilla Original 60gr",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2821",
    "barcode": "2821",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2822",
    "name": "Vinaigre blanc durra 1L",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2822",
    "barcode": "2822",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2823",
    "name": "Navet Mariné saada 600 gr",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2823",
    "barcode": "2823",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2825",
    "name": "City café Mocha 180ml",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2825",
    "barcode": "2825",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2826",
    "name": "City Café 180ml Original",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2826",
    "barcode": "2826",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2828",
    "name": "Epice burger Abido 50gr",
    "price": 1.9,
    "purchasePrice": 1.800948,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-2828",
    "barcode": "2828",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2829",
    "name": "Graines de Pastéque 250 gr",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2829",
    "barcode": "2829",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2830",
    "name": "pistache haché 250gr oregal",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2830",
    "barcode": "2830",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2831",
    "name": "vimto 2litre",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": -8,
    "category": "Accueil",
    "sku": "SKU-2831",
    "barcode": "2831",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2832",
    "name": "Labne dodoni 5kg",
    "price": 21.05,
    "purchasePrice": 19.952607,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-2832",
    "barcode": "2832",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2833",
    "name": "Piment doux al saada 4kg",
    "price": 5.59,
    "purchasePrice": 5.298578,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-2833",
    "barcode": "2833",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2835",
    "name": "Graine de courge Beyrouti 250gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2835",
    "barcode": "2835",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2836",
    "name": "concentré de lait sucré Nestlé 397gr",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": -15,
    "category": "Accueil",
    "sku": "SKU-2836",
    "barcode": "2836",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2837",
    "name": "huile d'olive vierge boulos 2.75L",
    "price": 35,
    "purchasePrice": 33.175355,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2837",
    "barcode": "2837",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2840",
    "name": "falafel Nasmah",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": -21,
    "category": "Accueil",
    "sku": "SKU-2840",
    "barcode": "2840",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2841",
    "name": "custard Poudre Aruba originale 200 gr",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 24,
    "category": "Accueil",
    "sku": "SKU-2841",
    "barcode": "2841",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2843",
    "name": "poivre noir entière",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-2843",
    "barcode": "2843",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2844",
    "name": "Riz Rounde kg",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2844",
    "barcode": "2844",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 2
  },
  {
    "id": "csv-2845",
    "name": "Concombres marinés rabih 500gr",
    "price": 2.9,
    "purchasePrice": 2.748815,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2845",
    "barcode": "2845",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2846",
    "name": "Dattes mejdoul 900 gr",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2846",
    "barcode": "2846",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2847",
    "name": "Graines de citrouille Samir 300 g",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-2847",
    "barcode": "2847",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2850",
    "name": "Chapellure brune 1kg",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-2850",
    "barcode": "2850",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2851",
    "name": "Jus Naranja mama Africa 1.5 l",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2851",
    "barcode": "2851",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2852",
    "name": "Datte Mejdoul NADATY 450 GR",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2852",
    "barcode": "2852",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2855",
    "name": "Carvi Moulu Espig 250 gr",
    "price": 5,
    "purchasePrice": 4.739336,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-2855",
    "barcode": "2855",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2856",
    "name": "Ghreybe aghati 500gr",
    "price": 16.5,
    "purchasePrice": 15.63981,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2856",
    "barcode": "2856",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2857",
    "name": "Maamoul aghati noix 500Gr",
    "price": 15.5,
    "purchasePrice": 14.691943,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-2857",
    "barcode": "2857",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2858",
    "name": "Petit Four Aghati 1kg",
    "price": 21.5,
    "purchasePrice": 20.379147,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-2858",
    "barcode": "2858",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2859",
    "name": "Baklava aghati premium 750gr",
    "price": 31.5,
    "purchasePrice": 29.85782,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2859",
    "barcode": "2859",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2862",
    "name": "baklava Casti 250gr",
    "price": 6,
    "purchasePrice": 5.687204,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-2862",
    "barcode": "2862",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2863",
    "name": "Concombre Chtoura 600gr",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2863",
    "barcode": "2863",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2865",
    "name": "Jello Forest fruit Jelly 85gr",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-2865",
    "barcode": "2865",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-2866",
    "name": "Baklava deluxe pistache",
    "price": 45,
    "purchasePrice": 42.654028,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-2866",
    "barcode": "2866",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2867",
    "name": "Zaatar SHP 500 gr",
    "price": 7.25,
    "purchasePrice": 6.872038,
    "stock": -5,
    "category": "Promo",
    "sku": "SKU-2867",
    "barcode": "2867",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2868",
    "name": "Zafran d'Iran 0.25 gr",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-2868",
    "barcode": "2868",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2869",
    "name": "Mohalabia Aruba 200 gr",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-2869",
    "barcode": "2869",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2870",
    "name": "Ghee Alsaad Végétale 2L",
    "price": 11.75,
    "purchasePrice": 11.137441,
    "stock": -20,
    "category": "Accueil",
    "sku": "SKU-2870",
    "barcode": "2870",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2871",
    "name": "oasis orange",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -15,
    "category": "Accueil",
    "sku": "SKU-2871",
    "barcode": "2871",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-2872",
    "name": "Maamoul noix douhaihi",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": -27,
    "category": "Accueil",
    "sku": "SKU-2872",
    "barcode": "2872",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2873",
    "name": "Buffies Chips Master 60 gr",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-2873",
    "barcode": "2873",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2874",
    "name": "Chips tuile",
    "price": 0.55,
    "purchasePrice": 0.521327,
    "stock": -31,
    "category": "Accueil",
    "sku": "SKU-2874",
    "barcode": "2874",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.55
  },
  {
    "id": "csv-2875",
    "name": "Msanaracheese 800gr",
    "price": 10.95,
    "purchasePrice": 10.379147,
    "stock": -23,
    "category": "Accueil",
    "sku": "SKU-2875",
    "barcode": "2875",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2876",
    "name": "Fil d'or 800gr shahia",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": -18,
    "category": "Accueil",
    "sku": "SKU-2876",
    "barcode": "2876",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2877",
    "name": "megachips lemon chili 50gr",
    "price": 0.55,
    "purchasePrice": 0.521327,
    "stock": -15,
    "category": "Accueil",
    "sku": "SKU-2877",
    "barcode": "2877",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.55
  },
  {
    "id": "csv-2878",
    "name": "mega chips poulet 50gr",
    "price": 0.55,
    "purchasePrice": 0.521327,
    "stock": -48,
    "category": "Accueil",
    "sku": "SKU-2878",
    "barcode": "2878",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.55
  },
  {
    "id": "csv-2879",
    "name": "Mega chips pizza  50gr",
    "price": 0.55,
    "purchasePrice": 0.521327,
    "stock": -39,
    "category": "Accueil",
    "sku": "SKU-2879",
    "barcode": "2879",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.55
  },
  {
    "id": "csv-2880",
    "name": "concentré de tomate saada 850 gr",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -61,
    "category": "Accueil",
    "sku": "SKU-2880",
    "barcode": "2880",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2881",
    "name": "Hamwi cardamon Classic 450g",
    "price": 11.75,
    "purchasePrice": 11.137441,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2881",
    "barcode": "2881",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2882",
    "name": "bouillon poulet 432 gr 24 pc",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 17,
    "category": "Accueil",
    "sku": "SKU-2882",
    "barcode": "2882",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2883",
    "name": "Mega chips fromage 50gr",
    "price": 0.55,
    "purchasePrice": 0.521327,
    "stock": -21,
    "category": "Accueil",
    "sku": "SKU-2883",
    "barcode": "2883",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.55
  },
  {
    "id": "csv-2884",
    "name": "Tea shop Thikrayat 456gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -11,
    "category": "Accueil",
    "sku": "SKU-2884",
    "barcode": "2884",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2885",
    "name": "Vimto fizzy",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 9,
    "category": "Accueil",
    "sku": "SKU-2885",
    "barcode": "2885",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2886",
    "name": "Vida pop citron",
    "price": 0.75,
    "purchasePrice": 0.7109,
    "stock": -74,
    "category": "Accueil",
    "sku": "SKU-2886",
    "barcode": "2886",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.75
  },
  {
    "id": "csv-2887",
    "name": "zwan 340gr",
    "price": 2.45,
    "purchasePrice": 2.322275,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2887",
    "barcode": "2887",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2888",
    "name": "freekeh Baladna kasih",
    "price": 6.25,
    "purchasePrice": 5.924171,
    "stock": -12,
    "category": "Accueil",
    "sku": "SKU-2888",
    "barcode": "2888",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2889",
    "name": "kaak chtoura fields",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2889",
    "barcode": "2889",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2890",
    "name": "lentille vert al tunsa",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2890",
    "barcode": "2890",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2891",
    "name": "cardamone moulu Abido 500gr",
    "price": 37.5,
    "purchasePrice": 35.545024,
    "stock": -14,
    "category": "Accueil",
    "sku": "SKU-2891",
    "barcode": "2891",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2892",
    "name": "Cannelle Abido 500gr",
    "price": 9.2,
    "purchasePrice": 8.720379,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2892",
    "barcode": "2892",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2894",
    "name": "Origano Abido 50gr",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2894",
    "barcode": "2894",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2895",
    "name": "Sumac abido 50gr",
    "price": 1.85,
    "purchasePrice": 1.753555,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-2895",
    "barcode": "2895",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2896",
    "name": "Piment for chili abido 50gr",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2896",
    "barcode": "2896",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2897",
    "name": "Poulet entier 1.2",
    "price": 4.62,
    "purchasePrice": 4.379147,
    "stock": -82,
    "category": "Accueil",
    "sku": "SKU-2897",
    "barcode": "2897",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2898",
    "name": "Maamoul casti Pistache 1kg",
    "price": 30,
    "purchasePrice": 28.436019,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2898",
    "barcode": "2898",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2899",
    "name": "Moghrabie Chtoura 900gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -16,
    "category": "Accueil",
    "sku": "SKU-2899",
    "barcode": "2899",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2900",
    "name": "Blé Pelé Altunsa 900 gr",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2900",
    "barcode": "2900",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2902",
    "name": "Kibbeh au boeuf 480gr Tabya",
    "price": 7.99,
    "purchasePrice": 7.57346,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-2902",
    "barcode": "2902",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2903",
    "name": "Fromage Puck mois sel 240gr",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": -8,
    "category": "Accueil",
    "sku": "SKU-2903",
    "barcode": "2903",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2904",
    "name": "Fruit à coque grillé salé 200gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2904",
    "barcode": "2904",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2905",
    "name": "Fruit à coque grillé salé 200gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2905",
    "barcode": "2905",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2906",
    "name": "fruit à coque en vrac grillé salé",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-2906",
    "barcode": "2906",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 3.5
  },
  {
    "id": "csv-2907",
    "name": "fruit à coque grillé fumé",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-2907",
    "barcode": "2907",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2908",
    "name": "kaak baton en sachet de 200gr",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -14,
    "category": "Accueil",
    "sku": "SKU-2908",
    "barcode": "2908",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2909",
    "name": "Kashkaval 250 gr HAjdu",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 13,
    "category": "Accueil",
    "sku": "SKU-2909",
    "barcode": "2909",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2910",
    "name": "bavette Boeuf 10kg",
    "price": 158.76,
    "purchasePrice": 150.483412,
    "stock": -17,
    "category": "Accueil",
    "sku": "SKU-2910",
    "barcode": "2910",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2911",
    "name": "Labneh Vedoura rest",
    "price": 2.9,
    "purchasePrice": 2.748815,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2911",
    "barcode": "2911",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2912",
    "name": "Labneh Vedoura rest",
    "price": 2.9,
    "purchasePrice": 2.748815,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2912",
    "barcode": "2912",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2913",
    "name": "Labneh vedura",
    "price": 2.9,
    "purchasePrice": 2.748815,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-2913",
    "barcode": "2913",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2914",
    "name": "riz Basmati Tilda 10kg",
    "price": 4.48,
    "purchasePrice": 4.246445,
    "stock": -49,
    "category": "Accueil",
    "sku": "SKU-2914",
    "barcode": "2914",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2915",
    "name": "Fromage Grillé 200 g HALLOUMI",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": -17,
    "category": "Produits",
    "sku": "SKU-2915",
    "barcode": "2915",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2916",
    "name": "Grains de Tournesol Pelés Grillées 250 gr",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": -29,
    "category": "Produits",
    "sku": "SKU-2916",
    "barcode": "2916",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2917",
    "name": "Falafel alsham 650gr",
    "price": 6,
    "purchasePrice": 5.687204,
    "stock": -31,
    "category": "Produits",
    "sku": "SKU-2917",
    "barcode": "2917",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2918",
    "name": "Jello Fraise Aruba 85 gr",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": 16,
    "category": "Accueil",
    "sku": "SKU-2918",
    "barcode": "2918",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2919",
    "name": "maamoul noix sultane 500gr",
    "price": 8.25,
    "purchasePrice": 7.819905,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-2919",
    "barcode": "2919",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2920",
    "name": "Curry Fort Abido 50 gr",
    "price": 1.95,
    "purchasePrice": 1.848341,
    "stock": 13,
    "category": "Accueil",
    "sku": "SKU-2920",
    "barcode": "2920",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2922",
    "name": "Zwan poulet épicé",
    "price": 2.45,
    "purchasePrice": 2.322275,
    "stock": 1,
    "category": "Produits",
    "sku": "SKU-2922",
    "barcode": "2922",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2923",
    "name": "Baklava Douaihy 850gr",
    "price": 34.5,
    "purchasePrice": 32.701422,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2923",
    "barcode": "2923",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2924",
    "name": "Eich el belbol 1kg",
    "price": 39.9,
    "purchasePrice": 37.819905,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2924",
    "barcode": "2924",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2925",
    "name": "Miel arev 500gr",
    "price": 3.85,
    "purchasePrice": 3.649289,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-2925",
    "barcode": "2925",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2928",
    "name": "Huile d'olive Boulos 250 ML squeez",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2928",
    "barcode": "2928",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2931",
    "name": "Noix de Pecan 1.5kg",
    "price": 32.18,
    "purchasePrice": 30.50237,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-2931",
    "barcode": "2931",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2933",
    "name": "janerek finik 250gr",
    "price": 4.95,
    "purchasePrice": 4.691943,
    "stock": -8,
    "category": "Accueil",
    "sku": "SKU-2933",
    "barcode": "2933",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2935",
    "name": "sucre 20 kg saint louis P50",
    "price": 26.5,
    "purchasePrice": 25.118483,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-2935",
    "barcode": "2935",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 26.5
  },
  {
    "id": "csv-2936",
    "name": "Amande batonnet 1kg",
    "price": 9.5,
    "purchasePrice": 9.004739,
    "stock": -13,
    "category": "Accueil",
    "sku": "SKU-2936",
    "barcode": "2936",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2937",
    "name": "frais de livraison",
    "price": 5,
    "purchasePrice": 4.166667,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2937",
    "barcode": "2937",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2938",
    "name": "Divers 20%",
    "price": 0,
    "purchasePrice": 0,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-2938",
    "barcode": "2938",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2939",
    "name": "Maamoul Casti noix ou dattes 1kg",
    "price": 24,
    "purchasePrice": 22.748815,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-2939",
    "barcode": "2939",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2940",
    "name": "Huile de tournesol Sakoil 1L",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2940",
    "barcode": "2940",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2941",
    "name": "Abido Kebbeh epices 500gr",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2941",
    "barcode": "2941",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2943",
    "name": "Sucre St. Louis 20kg",
    "price": 26.38,
    "purchasePrice": 25.004739,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2943",
    "barcode": "2943",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2944",
    "name": "seven up 33cl",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -54,
    "category": "Accueil",
    "sku": "SKU-2944",
    "barcode": "2944",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-2945",
    "name": "Boulos olive vert ou noir 10kg",
    "price": 60,
    "purchasePrice": 56.872038,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2945",
    "barcode": "2945",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2946",
    "name": "Nestcafé pièce 30gr",
    "price": 0.4,
    "purchasePrice": 0.379147,
    "stock": -49,
    "category": "Accueil",
    "sku": "SKU-2946",
    "barcode": "2946",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.4
  },
  {
    "id": "csv-2947",
    "name": "Tofi LUK 396gr.",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": -11,
    "category": "Accueil",
    "sku": "SKU-2947",
    "barcode": "2947",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2949",
    "name": "Feuille de vigne Chtoura citron 450gr",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-2949",
    "barcode": "2949",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2951",
    "name": "Gombo zero",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-2951",
    "barcode": "2951",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2953",
    "name": "Halloumi Simos 225gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-2953",
    "barcode": "2953",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2954",
    "name": "Barazek Sabah 475gr",
    "price": 11.99,
    "purchasePrice": 11.364929,
    "stock": -35,
    "category": "Accueil",
    "sku": "SKU-2954",
    "barcode": "2954",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2955",
    "name": "Maamoul datte Sabah 475gr",
    "price": 11.99,
    "purchasePrice": 11.364929,
    "stock": -13,
    "category": "Accueil",
    "sku": "SKU-2955",
    "barcode": "2955",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2956",
    "name": "Pistachio GHARIBA",
    "price": 11.99,
    "purchasePrice": 11.364929,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-2956",
    "barcode": "2956",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2962",
    "name": "Feve Verte Diwan",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -5,
    "category": "Produits",
    "sku": "SKU-2962",
    "barcode": "2962",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2963",
    "name": "Tahini Anjar 908gr",
    "price": 6.85,
    "purchasePrice": 6.492891,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-2963",
    "barcode": "2963",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2964",
    "name": "Baba Ghannouj Diwan 400gr",
    "price": 2.15,
    "purchasePrice": 2.037915,
    "stock": -1,
    "category": "Produits",
    "sku": "SKU-2964",
    "barcode": "2964",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2965",
    "name": "Charbon enscen",
    "price": 1,
    "purchasePrice": 0.833333,
    "stock": 12,
    "category": "Accueil",
    "sku": "SKU-2965",
    "barcode": "2965",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2966",
    "name": "Sukar nabat ou bonbon au sucre naturelle 400gr Abido",
    "price": 4.49,
    "purchasePrice": 4.255924,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2966",
    "barcode": "2966",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2968",
    "name": "Tartina plein soleil 100gr",
    "price": 1.85,
    "purchasePrice": 1.753555,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-2968",
    "barcode": "2968",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2969",
    "name": "Halawa à la Noix de Pecan 500gr Arkan",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2969",
    "barcode": "2969",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2970",
    "name": "halawa pistache extra 500gr",
    "price": 8.5,
    "purchasePrice": 8.056872,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-2970",
    "barcode": "2970",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2971",
    "name": "café glacé caramel",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -12,
    "category": "Accueil",
    "sku": "SKU-2971",
    "barcode": "2971",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-2972",
    "name": "Café glacé louna capucino",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -14,
    "category": "Accueil",
    "sku": "0.69",
    "barcode": "2972",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-2974",
    "name": "Théiere 1.5 LTEA KETTLE",
    "price": 10.8,
    "purchasePrice": 9,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2974",
    "barcode": "2974",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2975",
    "name": "Theiere 3L TEA KETTLE",
    "price": 13.2,
    "purchasePrice": 11,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2975",
    "barcode": "2975",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2976",
    "name": "Theiere 1L Kettle TEA",
    "price": 9.12,
    "purchasePrice": 7.6,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2976",
    "barcode": "2976",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2977",
    "name": "Theiere 0.75L TEA KETTLE",
    "price": 8.16,
    "purchasePrice": 6.8,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2977",
    "barcode": "2977",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2979",
    "name": "Feve decortiqué Barco",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2979",
    "barcode": "2979",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2981",
    "name": "kaak hamdan Hamdan",
    "price": 2.4,
    "purchasePrice": 2.274882,
    "stock": -41,
    "category": "Accueil",
    "sku": "SKU-2981",
    "barcode": "2981",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2982",
    "name": "Miel de fleurs AREV 500g",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-2982",
    "barcode": "2982",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2983",
    "name": "Trio sesame coco arachide gateau",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-2983",
    "barcode": "2983",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2986",
    "name": "Dome Choco",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": 2,
    "category": "Accueil",
    "sku": "6253502202401",
    "barcode": "2986",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2987",
    "name": "Tahini kasih 18kg",
    "price": 94.84,
    "purchasePrice": 89.895735,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-2987",
    "barcode": "2987",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2994",
    "name": "Pack d'eau Petite pouteille",
    "price": 6,
    "purchasePrice": 5.687204,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2994",
    "barcode": "2994",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2995",
    "name": "Jellab kassatly Chtoura 3L",
    "price": 13.5,
    "purchasePrice": 12.796209,
    "stock": -13,
    "category": "Accueil",
    "sku": "SKU-2995",
    "barcode": "2995",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2996",
    "name": "Huile de sésame 500ml",
    "price": 8.97,
    "purchasePrice": 8.50237,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2996",
    "barcode": "2996",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2997",
    "name": "Citron confit 2.5kg",
    "price": 9.23,
    "purchasePrice": 8.748815,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2997",
    "barcode": "2997",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2998",
    "name": "Pate d'arachide DAKATNE 4/4",
    "price": 9.92,
    "purchasePrice": 9.402844,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2998",
    "barcode": "2998",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2999",
    "name": "Bavette boeuf Kg",
    "price": 15.72,
    "purchasePrice": 14.900474,
    "stock": -67,
    "category": "Accueil",
    "sku": "SKU-2999",
    "barcode": "2999",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 15.72
  },
  {
    "id": "csv-3001",
    "name": "nougat test",
    "price": 18,
    "purchasePrice": 17.061611,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3001",
    "barcode": "3001",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3002",
    "name": "Poivre doux moulu de Jamaïque 50g",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-3002",
    "barcode": "3002",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3003",
    "name": "Ghee khanum 1kg",
    "price": 18.5,
    "purchasePrice": 17.535545,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-3003",
    "barcode": "3003",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3004",
    "name": "Keshk ou Keshek Al Raii 500gr",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3004",
    "barcode": "3004",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3005",
    "name": "Barazek mini 300gr",
    "price": 9.99,
    "purchasePrice": 9.469194,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-3005",
    "barcode": "3005",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3006",
    "name": "Kaak caroub 370 gr",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3006",
    "barcode": "3006",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3007",
    "name": "Vermicelle 400gr baharoglu",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-3007",
    "barcode": "3007",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-3009",
    "name": "Homos chtoura 310 gr",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3009",
    "barcode": "3009",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3011",
    "name": "Epice de Cajun 30gr",
    "price": 1.7,
    "purchasePrice": 1.611374,
    "stock": 9,
    "category": "Accueil",
    "sku": "SKU-3011",
    "barcode": "3011",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3012",
    "name": "Piment très fort rouge en poudre 25gr",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-3012",
    "barcode": "3012",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-3013",
    "name": "pistache moulu iranien 100gr",
    "price": 3.15,
    "purchasePrice": 2.985782,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3013",
    "barcode": "3013",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3014",
    "name": "Olive Kalamata Dénoyautées 400g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3014",
    "barcode": "3014",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3015",
    "name": "Baklava Mix Douaihy 250gr",
    "price": 7.99,
    "purchasePrice": 7.57346,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-3015",
    "barcode": "3015",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3016",
    "name": "Fanta Citron 33cl",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3016",
    "barcode": "3016",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3017",
    "name": "Manne et sucrerises",
    "price": 33.99,
    "purchasePrice": 32.218009,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3017",
    "barcode": "3017",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3020",
    "name": "Mouloukhia Gardenia 200gr",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 2,
    "category": "Promo",
    "sku": "SKU-3020",
    "barcode": "3020",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3021",
    "name": "Aubergine makdouss",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-3021",
    "barcode": "3021",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3023",
    "name": "Gari 500g",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 2,
    "category": "Accueil",
    "sku": "Made in Togo",
    "barcode": "3023",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3024",
    "name": "Beurre de karité 200g",
    "price": 4.95,
    "purchasePrice": 4.691943,
    "stock": 7,
    "category": "Accueil",
    "sku": "Origine Togolaise",
    "barcode": "3024",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3027",
    "name": "Huile D'olive Vierge 5L",
    "price": 50,
    "purchasePrice": 47.393365,
    "stock": 2,
    "category": "Accueil",
    "sku": "Origine Grècque",
    "barcode": "3027",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3028",
    "name": "cilal deem 400gr",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3028",
    "barcode": "3028",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3029",
    "name": "Nabulsi 1Kg Al rai",
    "price": 14.75,
    "purchasePrice": 13.981043,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-3029",
    "barcode": "3029",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3030",
    "name": "okra gombo 450 gr Patrigel",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": -11,
    "category": "Accueil",
    "sku": "SKU-3030",
    "barcode": "3030",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3032",
    "name": "Alsaadah chicken stock spices 18g",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": -12,
    "category": "Accueil",
    "sku": "SKU-3032",
    "barcode": "3032",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.5
  },
  {
    "id": "csv-3033",
    "name": "Datte majdoule alaqsa",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-3033",
    "barcode": "3033",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3034",
    "name": "Pate d'arachide 4kg",
    "price": 26.38,
    "purchasePrice": 25.004739,
    "stock": -20,
    "category": "Accueil",
    "sku": "SKU-3034",
    "barcode": "3034",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3035",
    "name": "Tuna Chtoura avec piment 160GR",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-3035",
    "barcode": "3035",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3037",
    "name": "Miette de thon à la tomate 160gr",
    "price": 1.65,
    "purchasePrice": 1.563981,
    "stock": 11,
    "category": "Accueil",
    "sku": "SKU-3037",
    "barcode": "3037",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3038",
    "name": "Harissa 70gr",
    "price": 0.75,
    "purchasePrice": 0.7109,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3038",
    "barcode": "3038",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3041",
    "name": "Cumin Moulu Bedros 250gr",
    "price": 4.95,
    "purchasePrice": 4.691943,
    "stock": -27,
    "category": "Accueil",
    "sku": "SKU-3041",
    "barcode": "3041",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3042",
    "name": "Graine de Chia noir Bio en vrac 250gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-3042",
    "barcode": "3042",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 3.5
  },
  {
    "id": "csv-3043",
    "name": "Thon Albacore entier au naturel",
    "price": 1.65,
    "purchasePrice": 1.563981,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-3043",
    "barcode": "3043",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3045",
    "name": "Huile d'olive  AlKOUdos 1L",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-3045",
    "barcode": "3045",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3046",
    "name": "oat bread moulin d'or avoine",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -29,
    "category": "Accueil",
    "sku": "SKU-3046",
    "barcode": "3046",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3048",
    "name": "Sirop de rose Ashatly Chtoura 600 ml",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-3048",
    "barcode": "3048",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3049",
    "name": "Epices Tawouk blanc Abido 50gr",
    "price": 1.6,
    "purchasePrice": 1.516588,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3049",
    "barcode": "3049",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3050",
    "name": "Riz Basmati Al RAI 5kg",
    "price": 14.5,
    "purchasePrice": 13.744076,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-3050",
    "barcode": "3050",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3055",
    "name": "Concentré de piment doux Oncu 4kg",
    "price": 29.01,
    "purchasePrice": 27.49763,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3055",
    "barcode": "3055",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3056",
    "name": "Unica Barre 34g",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": 196,
    "category": "Accueil",
    "sku": "SKU-3056",
    "barcode": "3056",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3057",
    "name": "Pousse d'epinard 1kg",
    "price": 5.98,
    "purchasePrice": 5.668246,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-3057",
    "barcode": "3057",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3058",
    "name": "kaak round moulin d'or 210gr",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -15,
    "category": "Accueil",
    "sku": "SKU-3058",
    "barcode": "3058",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3059",
    "name": "Petit four Moulin 300gr",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-3059",
    "barcode": "3059",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3062",
    "name": "Makdous Shamiate 2800gr",
    "price": 22.75,
    "purchasePrice": 21.563981,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-3062",
    "barcode": "3062",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3063",
    "name": "Makdos Shamiate 650 gr",
    "price": 6.25,
    "purchasePrice": 5.924171,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-3063",
    "barcode": "3063",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3065",
    "name": "Café hamwi classic 450",
    "price": 9.75,
    "purchasePrice": 9.241706,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3065",
    "barcode": "3065",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3066",
    "name": "Riz Basmati Abu Kass 900 g",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": -1,
    "category": "Accueil",
    "sku": "Long Grains",
    "barcode": "3066",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3067",
    "name": "realmix premium energy drink",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 18,
    "category": "Accueil",
    "sku": "SKU-3067",
    "barcode": "3067",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3068",
    "name": "liquid vaisselle fairy 320ml",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3068",
    "barcode": "3068",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3069",
    "name": "shampoing H&S 250ml",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-3069",
    "barcode": "3069",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3070",
    "name": "pantene pro 300 ml",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3070",
    "barcode": "3070",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3071",
    "name": "Barazek Shamiate 500 gr",
    "price": 14.99,
    "purchasePrice": 14.208531,
    "stock": -11,
    "category": "Accueil",
    "sku": "SKU-3071",
    "barcode": "3071",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3072",
    "name": "shamiate concentre de piment doux 650 gm",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -34,
    "category": "Accueil",
    "sku": "SKU-3072",
    "barcode": "3072",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3073",
    "name": "Bouillon de poulet altunsa 10 gm",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-3073",
    "barcode": "3073",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3076",
    "name": "Eau de Rose 250 ml Durra",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Accueil",
    "sku": "2494",
    "barcode": "3076",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3077",
    "name": "Hrisseh douaihy vrac 2.2 kg",
    "price": 40.7,
    "purchasePrice": 38.578199,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3077",
    "barcode": "3077",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 40.7
  },
  {
    "id": "csv-3078",
    "name": "Cortas eau de Rose 500ml",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3078",
    "barcode": "3078",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3079",
    "name": "Sumac 800gr",
    "price": 8.5,
    "purchasePrice": 8.056872,
    "stock": -16,
    "category": "Accueil",
    "sku": "SKU-3079",
    "barcode": "3079",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3080",
    "name": "concombres marines shamiate",
    "price": 8.5,
    "purchasePrice": 8.056872,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3080",
    "barcode": "3080",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3081",
    "name": "riz doha 5kg",
    "price": 10.55,
    "purchasePrice": 10,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-3081",
    "barcode": "3081",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3082",
    "name": "Antiseptic Dr. Johnson'S",
    "price": 3.5,
    "purchasePrice": 2.916667,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3082",
    "barcode": "3082",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3083",
    "name": "Msanara Hana 900gr",
    "price": 11.55,
    "purchasePrice": 10.947867,
    "stock": -39,
    "category": "Accueil",
    "sku": "SKU-3083",
    "barcode": "3083",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3084",
    "name": "Tomate concassé 850gr Louis martin",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -59,
    "category": "Accueil",
    "sku": "SKU-3084",
    "barcode": "3084",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3088",
    "name": "graine dr courge 500gr",
    "price": 4.21,
    "purchasePrice": 3.990521,
    "stock": -21,
    "category": "Produits",
    "sku": "SKU-3088",
    "barcode": "3088",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3092",
    "name": "feves et pois chiches cuites 400g",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-3092",
    "barcode": "3092",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3094",
    "name": "Lavash Marko's 220 gr",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3094",
    "barcode": "3094",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3095",
    "name": "Patte d'apricot",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": 4,
    "category": "Produits",
    "sku": "SKU-3095",
    "barcode": "3095",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3096",
    "name": "baking powder gardenia 907 G",
    "price": 9.8,
    "purchasePrice": 9.2891,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3096",
    "barcode": "3096",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3098",
    "name": "Loukoum plain al kanater 500g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-3098",
    "barcode": "3098",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3099",
    "name": "tropico fraise",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -34,
    "category": "Accueil",
    "sku": "SKU-3099",
    "barcode": "3099",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-3100",
    "name": "fanta citron",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 20,
    "category": "Accueil",
    "sku": "SKU-3100",
    "barcode": "3100",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3101",
    "name": "tropicico orange ananas",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 12,
    "category": "Accueil",
    "sku": "SKU-3101",
    "barcode": "3101",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3102",
    "name": "fuze tea",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -13,
    "category": "Accueil",
    "sku": "SKU-3102",
    "barcode": "3102",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-3103",
    "name": "pepsi cherry",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-3103",
    "barcode": "3103",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3104",
    "name": "Bonbons fini mellows 80gr",
    "price": 1.25,
    "purchasePrice": 1.041667,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3104",
    "barcode": "3104",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3105",
    "name": "Thon entier petit navire 112gr huile d'olive",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3105",
    "barcode": "3105",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3106",
    "name": "fruit coque mélange AL KAZZI 450gr",
    "price": 8.49,
    "purchasePrice": 8.047393,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-3106",
    "barcode": "3106",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3107",
    "name": "Adida Cumin 50 gr",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 6,
    "category": "Accueil",
    "sku": "Avant 06/08/2028",
    "barcode": "3107",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3108",
    "name": "Mure et framboise fini",
    "price": 1.25,
    "purchasePrice": 1.041667,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-3108",
    "barcode": "3108",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3109",
    "name": "ourson fini 90gr",
    "price": 1.25,
    "purchasePrice": 1.041667,
    "stock": -8,
    "category": "Accueil",
    "sku": "SKU-3109",
    "barcode": "3109",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3110",
    "name": "Sour Little Mix 80gr fini",
    "price": 1.25,
    "purchasePrice": 1.041667,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3110",
    "barcode": "3110",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3111",
    "name": "Tapis Magiques Fini 80 gr",
    "price": 1.25,
    "purchasePrice": 1.041667,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-3111",
    "barcode": "3111",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3112",
    "name": "Jelly Cherries fini 80gr",
    "price": 1.25,
    "purchasePrice": 1.041667,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3112",
    "barcode": "3112",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3113",
    "name": "Bonbon oeuf au plat 80gr",
    "price": 1.25,
    "purchasePrice": 1.041667,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3113",
    "barcode": "3113",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3114",
    "name": "Tranche pastèque fini 80gr",
    "price": 1.25,
    "purchasePrice": 1.041667,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3114",
    "barcode": "3114",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3115",
    "name": "Melon bubble gum fini",
    "price": 1.25,
    "purchasePrice": 1.041667,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-3115",
    "barcode": "3115",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3116",
    "name": "Bisous Fraise 80gr fini",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3116",
    "barcode": "3116",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3117",
    "name": "Coeur de Pêche 80gr Fini",
    "price": 1.25,
    "purchasePrice": 1.041667,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3117",
    "barcode": "3117",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3118",
    "name": "Jelly BANANAS",
    "price": 1,
    "purchasePrice": 0.833333,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3118",
    "barcode": "3118",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3119",
    "name": "Thon Msc 185hr",
    "price": 1.65,
    "purchasePrice": 1.563981,
    "stock": 51,
    "category": "Accueil",
    "sku": "SKU-3119",
    "barcode": "3119",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3120",
    "name": "Thon huile d'olive extra vierge 160gr",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 62,
    "category": "Accueil",
    "sku": "SKU-3120",
    "barcode": "3120",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3122",
    "name": "Chips Ails et olive 120",
    "price": 1.49,
    "purchasePrice": 1.412322,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-3122",
    "barcode": "3122",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3124",
    "name": "Acide citrique adida 1kg",
    "price": 7.5,
    "purchasePrice": 6.25,
    "stock": -38,
    "category": "Accueil",
    "sku": "SKU-3124",
    "barcode": "3124",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3125",
    "name": "sirop de grenade oncu",
    "price": 4.7,
    "purchasePrice": 4.454976,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-3125",
    "barcode": "3125",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3126",
    "name": "chilal hana 900 G",
    "price": 14,
    "purchasePrice": 13.270142,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3126",
    "barcode": "3126",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3127",
    "name": "Essuie Tout x1 Sandra",
    "price": 2.99,
    "purchasePrice": 2.491667,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-3127",
    "barcode": "3127",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3128",
    "name": "Iceberg",
    "price": 11.75,
    "purchasePrice": 11.137441,
    "stock": -25,
    "category": "Accueil",
    "sku": "SKU-3128",
    "barcode": "3128",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3129",
    "name": "Piment de jamaique 500gr spico",
    "price": 14.5,
    "purchasePrice": 13.744076,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-3129",
    "barcode": "3129",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3130",
    "name": "sumac abido 500gr",
    "price": 9.25,
    "purchasePrice": 8.767773,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-3130",
    "barcode": "3130",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3131",
    "name": "harrissa par kg",
    "price": 5,
    "purchasePrice": 4.739336,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3131",
    "barcode": "3131",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 5
  },
  {
    "id": "csv-3132",
    "name": "limonade gazeuse",
    "price": 0.68,
    "purchasePrice": 0.64455,
    "stock": 23,
    "category": "Accueil",
    "sku": "SKU-3132",
    "barcode": "3132",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3133",
    "name": "Arrangement cadeau Noel 2025",
    "price": 42.5,
    "purchasePrice": 40.28436,
    "stock": -12,
    "category": "Accueil",
    "sku": "SKU-3133",
    "barcode": "3133",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3134",
    "name": "hayda savon dalep 4% 180 g",
    "price": 4,
    "purchasePrice": 3.333333,
    "stock": 1,
    "category": "Fruits secs",
    "sku": "SKU-3134",
    "barcode": "3134",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3136",
    "name": "savon d alep 16% 125G",
    "price": 5,
    "purchasePrice": 4.166667,
    "stock": 1,
    "category": "Fruits secs",
    "sku": "SKU-3136",
    "barcode": "3136",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3138",
    "name": "parfums d'alep 4% 100G",
    "price": 5,
    "purchasePrice": 4.166667,
    "stock": 1,
    "category": "Fruits secs",
    "sku": "SKU-3138",
    "barcode": "3138",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3139",
    "name": "coffret hayda 4%   v",
    "price": 12,
    "purchasePrice": 10,
    "stock": 1,
    "category": "Fruits secs",
    "sku": "SKU-3139",
    "barcode": "3139",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3140",
    "name": "hayda 16% 3PIECE",
    "price": 12,
    "purchasePrice": 10,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-3140",
    "barcode": "3140",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3141",
    "name": "hayda coffret",
    "price": 12,
    "purchasePrice": 10,
    "stock": 1,
    "category": "Fruits secs",
    "sku": "SKU-3141",
    "barcode": "3141",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3142",
    "name": "hayda 3 savonnettes 100G",
    "price": 4,
    "purchasePrice": 3.333333,
    "stock": -2,
    "category": "Fruits secs",
    "sku": "SKU-3142",
    "barcode": "3142",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3143",
    "name": "parfums dalep coffret   c",
    "price": 16,
    "purchasePrice": 13.333333,
    "stock": 1,
    "category": "Fruits secs",
    "sku": "SKU-3143",
    "barcode": "3143",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3145",
    "name": "gants gommage parfumes dalep",
    "price": 5,
    "purchasePrice": 4.166667,
    "stock": 1,
    "category": "Fruits secs",
    "sku": "SKU-3145",
    "barcode": "3145",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3146",
    "name": "parfums d alep 4 boules -",
    "price": 12,
    "purchasePrice": 11.374408,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-3146",
    "barcode": "3146",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3147",
    "name": "hayda 6 savonnettes",
    "price": 5,
    "purchasePrice": 4.166667,
    "stock": 1,
    "category": "Fruits secs",
    "sku": "SKU-3147",
    "barcode": "3147",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3148",
    "name": "savon alep 4% 180G",
    "price": 5,
    "purchasePrice": 4.166667,
    "stock": 2,
    "category": "Fruits secs",
    "sku": "SKU-3148",
    "barcode": "3148",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3150",
    "name": "parfum pierre ponce noire 150G",
    "price": 5,
    "purchasePrice": 4.166667,
    "stock": 1,
    "category": "Fruits secs",
    "sku": "SKU-3150",
    "barcode": "3150",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3151",
    "name": "hayda petite jarres 2piece",
    "price": 4,
    "purchasePrice": 3.333333,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-3151",
    "barcode": "3151",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3152",
    "name": "2 jarres naturelles",
    "price": 5,
    "purchasePrice": 4.166667,
    "stock": 1,
    "category": "Fruits secs",
    "sku": "SKU-3152",
    "barcode": "3152",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3153",
    "name": "coffret alep D",
    "price": 16,
    "purchasePrice": 13.333333,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-3153",
    "barcode": "3153",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3154",
    "name": "hayda pelote de sisal cousue lifa",
    "price": 4,
    "purchasePrice": 3.333333,
    "stock": 1,
    "category": "Fruits secs",
    "sku": "SKU-3154",
    "barcode": "3154",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3155",
    "name": "pilote de sisal lifa crochetee",
    "price": 5,
    "purchasePrice": 4.166667,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-3155",
    "barcode": "3155",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3156",
    "name": "pilote de sisal lifa cousue",
    "price": 5,
    "purchasePrice": 4.166667,
    "stock": 1,
    "category": "Fruits secs",
    "sku": "SKU-3156",
    "barcode": "3156",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3157",
    "name": "porte savon argile emaille",
    "price": 5,
    "purchasePrice": 4.166667,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-3157",
    "barcode": "3157",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3158",
    "name": "coffret hayda R",
    "price": 12,
    "purchasePrice": 10,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-3158",
    "barcode": "3158",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3159",
    "name": "coffret hayda T",
    "price": 12,
    "purchasePrice": 10,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-3159",
    "barcode": "3159",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3160",
    "name": "6 savonnettes alep 200% 4%",
    "price": 6,
    "purchasePrice": 5,
    "stock": 1,
    "category": "Fruits secs",
    "sku": "SKU-3160",
    "barcode": "3160",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3163",
    "name": "jus best",
    "price": 0.75,
    "purchasePrice": 0.7109,
    "stock": -104,
    "category": "Fruits secs",
    "sku": "SKU-3163",
    "barcode": "3163",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.75
  },
  {
    "id": "csv-3170",
    "name": "sel  750G",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-3170",
    "barcode": "3170",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3171",
    "name": "amandes decortiques 200g",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3171",
    "barcode": "3171",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3172",
    "name": "sucre glace poudre 1kg",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-3172",
    "barcode": "3172",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3173",
    "name": "chips lion",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": -100,
    "category": "Accueil",
    "sku": "SKU-3173",
    "barcode": "3173",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3174",
    "name": "Chips lion Ketchup",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-3174",
    "barcode": "3174",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3175",
    "name": "Chips lion Paprika",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-3175",
    "barcode": "3175",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3176",
    "name": "Chips lion Vinègre",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 8,
    "category": "Apéritifs et pain",
    "sku": "SKU-3176",
    "barcode": "3176",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3177",
    "name": "Tomate concentrée BEST 850 gr",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 13,
    "category": "Apéritifs et pain",
    "sku": "SKU-3177",
    "barcode": "3177",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3178",
    "name": "confiture best",
    "price": 1.9,
    "purchasePrice": 1.800948,
    "stock": 1,
    "category": "Apéritifs et pain",
    "sku": "SKU-3178",
    "barcode": "3178",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3182",
    "name": "zaatar dehni 400g",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-3182",
    "barcode": "3182",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3183",
    "name": "tahini baraa 800G",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-3183",
    "barcode": "3183",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3184",
    "name": "fromage jasmeen",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-3184",
    "barcode": "3184",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3185",
    "name": "labneh shamiate 500g",
    "price": 4,
    "purchasePrice": 3.791469,
    "stock": -58,
    "category": "Apéritifs et pain",
    "sku": "SKU-3185",
    "barcode": "3185",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3186",
    "name": "pain beiruti 340G",
    "price": 0.85,
    "purchasePrice": 0.805687,
    "stock": -932,
    "category": "Apéritifs et pain",
    "sku": "SKU-3186",
    "barcode": "3186",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.85
  },
  {
    "id": "csv-3187",
    "name": "Feuilles d'aluminium 50 pces",
    "price": 2.95,
    "purchasePrice": 2.458333,
    "stock": 45,
    "category": "Apéritifs et pain",
    "sku": "SKU-3187",
    "barcode": "3187",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3188",
    "name": "chorba frik 500 g shamiate",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 28,
    "category": "Apéritifs et pain",
    "sku": "SKU-3188",
    "barcode": "3188",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3190",
    "name": "charbon cocogold 1KG",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": -2,
    "category": "Apéritifs et pain",
    "sku": "SKU-3190",
    "barcode": "3190",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3191",
    "name": "samaya mais doux",
    "price": 0.85,
    "purchasePrice": 0.805687,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3191",
    "barcode": "3191",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3192",
    "name": "samaya recette palestinienne",
    "price": 0.85,
    "purchasePrice": 0.805687,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-3192",
    "barcode": "3192",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.85
  },
  {
    "id": "csv-3193",
    "name": "Epinard haché",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": -16,
    "category": "Accueil",
    "sku": "SKU-3193",
    "barcode": "3193",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3194",
    "name": "farine complete 1 KG",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-3194",
    "barcode": "3194",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-3195",
    "name": "feuilles de vignes shamiate 400G",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": -11,
    "category": "Accueil",
    "sku": "SKU-3195",
    "barcode": "3195",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3196",
    "name": "Kunafa turkish deem 160gr",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -31,
    "category": "Accueil",
    "sku": "SKU-3196",
    "barcode": "3196",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3198",
    "name": "Ghee vache Khanum 500gr",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-3198",
    "barcode": "3198",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3201",
    "name": "Maamoul  dattes 480gr Al Basha",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3201",
    "barcode": "3201",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3203",
    "name": "pois chiche 1600gr",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3203",
    "barcode": "3203",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3204",
    "name": "huile de tournesol 1L IMEX",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3204",
    "barcode": "3204",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3205",
    "name": "Vinaigre blanc shamiate 850 ml",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3205",
    "barcode": "3205",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3206",
    "name": "Bouillon poulet",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-3206",
    "barcode": "3206",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3208",
    "name": "Feverole Konouz 750 gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-3208",
    "barcode": "3208",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3210",
    "name": "kozat piment 10kg",
    "price": 45,
    "purchasePrice": 42.654028,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3210",
    "barcode": "3210",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3211",
    "name": "pain tendre au fromage",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 2,
    "category": "Produits",
    "sku": "SKU-3211",
    "barcode": "3211",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3212",
    "name": "Submarine 310gr",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": -46,
    "category": "Produits",
    "sku": "SKU-3212",
    "barcode": "3212",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3213",
    "name": "Akawi bocal 1kg",
    "price": 14,
    "purchasePrice": 13.270142,
    "stock": -1,
    "category": "Produits",
    "sku": "SKU-3213",
    "barcode": "3213",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3214",
    "name": "galettes aux dattes moulin d'or",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": -9,
    "category": "Produits",
    "sku": "SKU-3214",
    "barcode": "3214",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3215",
    "name": "galettes aux dattes moulin d'or",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": -26,
    "category": "Produits",
    "sku": "SKU-3215",
    "barcode": "3215",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3217",
    "name": "Mastic menthe",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": -1,
    "category": "Produits",
    "sku": "SKU-3217",
    "barcode": "3217",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3218",
    "name": "Mastic menthe",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 1,
    "category": "Produits",
    "sku": "SKU-3218",
    "barcode": "3218",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3219",
    "name": "Dorad royal 500/700 gr",
    "price": 33.5,
    "purchasePrice": 31.753555,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3219",
    "barcode": "3219",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3220",
    "name": "pickled peppers 550 g cortas",
    "price": 3.6,
    "purchasePrice": 3.412322,
    "stock": 3,
    "category": "Produits",
    "sku": "SKU-3220",
    "barcode": "3220",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3221",
    "name": "pasta spaghetti savino 500 g",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -23,
    "category": "Produits",
    "sku": "SKU-3221",
    "barcode": "3221",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-3222",
    "name": "pasta savino 500 g",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -34,
    "category": "Produits",
    "sku": "SKU-3222",
    "barcode": "3222",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-3223",
    "name": "dates al assalah 1 kg",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": -1,
    "category": "Produits",
    "sku": "SKU-3223",
    "barcode": "3223",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 4.99
  },
  {
    "id": "csv-3224",
    "name": "Farine de Pois-chiches 1kg",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 4,
    "category": "Produits",
    "sku": "SKU-3224",
    "barcode": "3224",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3225",
    "name": "Lamar jus 200 ml",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": -8,
    "category": "Produits",
    "sku": "SKU-3225",
    "barcode": "3225",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.5
  },
  {
    "id": "csv-3226",
    "name": "Lamar jus 200 ml",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": 38,
    "category": "Produits",
    "sku": "SKU-3226",
    "barcode": "3226",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3227",
    "name": "Lamar jus 200ml",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": 27,
    "category": "Produits",
    "sku": "SKU-3227",
    "barcode": "3227",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3228",
    "name": "Lamar jus 200 ml",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": 15,
    "category": "Produits",
    "sku": "SKU-3228",
    "barcode": "3228",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3230",
    "name": "huile d'olive algerie",
    "price": 5,
    "purchasePrice": 4.739336,
    "stock": -6,
    "category": "Produits",
    "sku": "SKU-3230",
    "barcode": "3230",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3232",
    "name": "halawa al kanater 900 g",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3232",
    "barcode": "3232",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3234",
    "name": "Tahina beit el safa 18kg",
    "price": 55,
    "purchasePrice": 52.132701,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-3234",
    "barcode": "3234",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3241",
    "name": "Makdous Al Rai 2,8 kg",
    "price": 23.5,
    "purchasePrice": 22.274882,
    "stock": 2,
    "category": "Produits",
    "sku": "SKU-3241",
    "barcode": "3241",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 23.5
  },
  {
    "id": "csv-3243",
    "name": "Laurier Entier 500gr",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3243",
    "barcode": "3243",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3244",
    "name": "pain promo",
    "price": 0.37,
    "purchasePrice": 0.350711,
    "stock": -604,
    "category": "Accueil",
    "sku": "SKU-3244",
    "barcode": "3244",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.37
  },
  {
    "id": "csv-3245",
    "name": "Tahini baraa 18kg",
    "price": 89,
    "purchasePrice": 84.36019,
    "stock": -11,
    "category": "Accueil",
    "sku": "SKU-3245",
    "barcode": "3245",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3246",
    "name": "ghee aseel 16kg",
    "price": 79.13,
    "purchasePrice": 75.004739,
    "stock": -24,
    "category": "Accueil",
    "sku": "SKU-3246",
    "barcode": "3246",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3247",
    "name": "tahini beit el safa promo 18kg",
    "price": 58.02,
    "purchasePrice": 54.995261,
    "stock": -22,
    "category": "Accueil",
    "sku": "SKU-3247",
    "barcode": "3247",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3248",
    "name": "Vin Cana",
    "price": 4.56,
    "purchasePrice": 3.8,
    "stock": -107,
    "category": "Accueil",
    "sku": "SKU-3248",
    "barcode": "3248",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3249",
    "name": "dorade 5kg",
    "price": 33.5,
    "purchasePrice": 31.753555,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-3249",
    "barcode": "3249",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3250",
    "name": "Tilapia 3.2 kg",
    "price": 9.85,
    "purchasePrice": 9.336493,
    "stock": -80,
    "category": "Accueil",
    "sku": "SKU-3250",
    "barcode": "3250",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 9.85
  },
  {
    "id": "csv-3251",
    "name": "Concombre Mariné 10kg",
    "price": 25,
    "purchasePrice": 23.696682,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-3251",
    "barcode": "3251",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3252",
    "name": "bokaj rest 1.2 kg cajou",
    "price": 22.79,
    "purchasePrice": 21.601896,
    "stock": -14,
    "category": "Accueil",
    "sku": "SKU-3252",
    "barcode": "3252",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 22.79
  },
  {
    "id": "csv-3253",
    "name": "Fanta orange 1.25 L",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-3253",
    "barcode": "3253",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3255",
    "name": "Formule traiteur repas staff midi",
    "price": 22.75,
    "purchasePrice": 21.563981,
    "stock": -34,
    "category": "Accueil",
    "sku": "SKU-3255",
    "barcode": "3255",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3256",
    "name": "Maggi 21 GR",
    "price": 0.55,
    "purchasePrice": 0.521327,
    "stock": 48,
    "category": "Produits",
    "sku": "SKU-3256",
    "barcode": "3256",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3257",
    "name": "huile d'olive gardenia 2.8L",
    "price": 22,
    "purchasePrice": 20.853081,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-3257",
    "barcode": "3257",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3258",
    "name": "olive boulos farcie piment",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -8,
    "category": "Produits",
    "sku": "SKU-3258",
    "barcode": "3258",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3259",
    "name": "Olive farcie au  boulos noix",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -10,
    "category": "Produits",
    "sku": "SKU-3259",
    "barcode": "3259",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3260",
    "name": "Olive boulos farcie amande",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -50,
    "category": "Produits",
    "sku": "SKU-3260",
    "barcode": "3260",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3268",
    "name": "Savon Alep 16% Laurier",
    "price": 5.12,
    "purchasePrice": 4.265403,
    "stock": 48,
    "category": "Promo",
    "sku": "SKU-3268",
    "barcode": "3268",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3270",
    "name": "Msanara Jasmeen 900gr",
    "price": 10.75,
    "purchasePrice": 10.189573,
    "stock": -32,
    "category": "Promo",
    "sku": "SKU-3270",
    "barcode": "3270",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3271",
    "name": "fromage cecile 1K",
    "price": 14,
    "purchasePrice": 13.270142,
    "stock": 0,
    "category": "Promo",
    "sku": "SKU-3271",
    "barcode": "3271",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3274",
    "name": "Nougat Mélange kg",
    "price": 20,
    "purchasePrice": 18.957346,
    "stock": 1000,
    "category": "Accueil",
    "sku": "SKU-3274",
    "barcode": "3274",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 20
  },
  {
    "id": "csv-3275",
    "name": "Capri-sun 330 ml",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-3275",
    "barcode": "3275",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3276",
    "name": "Capri-sun 200 ml",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": 17,
    "category": "Accueil",
    "sku": "SKU-3276",
    "barcode": "3276",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3278",
    "name": "Piment mexicains mariné 650 gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 1,
    "category": "Produits",
    "sku": "SKU-3278",
    "barcode": "3278",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3279",
    "name": "7 UP 1.5 L",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 6,
    "category": "Produits",
    "sku": "SKU-3279",
    "barcode": "3279",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3280",
    "name": "Fanta orange 1.25  L",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 5,
    "category": "Produits",
    "sku": "SKU-3280",
    "barcode": "3280",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3281",
    "name": "Fanta Orange",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-3281",
    "barcode": "3281",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3282",
    "name": "Pepsi 1.5  L",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-3282",
    "barcode": "3282",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3283",
    "name": "Lipton fraiche 1.25  L",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 2,
    "category": "Produits",
    "sku": "SKU-3283",
    "barcode": "3283",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3284",
    "name": "Oasis Framboise 2 L",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 5,
    "category": "Produits",
    "sku": "SKU-3284",
    "barcode": "3284",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3285",
    "name": "Oasis Tropical 2 L",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 1,
    "category": "Produits",
    "sku": "SKU-3285",
    "barcode": "3285",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3286",
    "name": "Orangina 1.5  L",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-3286",
    "barcode": "3286",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3287",
    "name": "tahini al safa 800gr",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -60,
    "category": "Accueil",
    "sku": "SKU-3287",
    "barcode": "3287",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3288",
    "name": "Popcorne Maïs 1kg",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-3288",
    "barcode": "3288",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3289",
    "name": "Gaufrettes fourré à la crème 400gr",
    "price": 3.85,
    "purchasePrice": 3.649289,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-3289",
    "barcode": "3289",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3290",
    "name": "cornichon mariné boulos",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -11,
    "category": "Accueil",
    "sku": "SKU-3290",
    "barcode": "3290",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3295",
    "name": "Chateau cana 2007",
    "price": 13.5,
    "purchasePrice": 11.25,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3295",
    "barcode": "3295",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3296",
    "name": "Feve cortas pelé",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": -20,
    "category": "Accueil",
    "sku": "SKU-3296",
    "barcode": "3296",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.5
  },
  {
    "id": "csv-3297",
    "name": "gardenia haricot sauce tomate",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -9,
    "category": "Boissons",
    "sku": "SKU-3297",
    "barcode": "3297",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3298",
    "name": "laziza",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 2,
    "category": "Boissons",
    "sku": "SKU-3298",
    "barcode": "3298",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3300",
    "name": "Buche de noel chocolat ou vanille",
    "price": 45,
    "purchasePrice": 42.654028,
    "stock": -3,
    "category": "Boissons",
    "sku": "SKU-3300",
    "barcode": "3300",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3301",
    "name": "De Capua huile d'olive",
    "price": 8.5,
    "purchasePrice": 8.056872,
    "stock": 5,
    "category": "Boissons",
    "sku": "SKU-3301",
    "barcode": "3301",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3303",
    "name": "rehana feves premium quality",
    "price": 2.35,
    "purchasePrice": 2.227488,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-3303",
    "barcode": "3303",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3304",
    "name": "Indomie crevette x5 350gr",
    "price": 1.8,
    "purchasePrice": 1.706161,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-3304",
    "barcode": "3304",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3306",
    "name": "Tropico",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -13,
    "category": "Accueil",
    "sku": "SKU-3306",
    "barcode": "3306",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-3308",
    "name": "cannelle 50g",
    "price": 2.2,
    "purchasePrice": 2.085308,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-3308",
    "barcode": "3308",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3312",
    "name": "Fenouille Nahil 100gr",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 15,
    "category": "Accueil",
    "sku": "SKU-3312",
    "barcode": "3312",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3313",
    "name": "Fenugrec Moulu 100gr Nahil",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3313",
    "barcode": "3313",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3314",
    "name": "Epices Qeima 50gr Abido",
    "price": 1.95,
    "purchasePrice": 1.848341,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3314",
    "barcode": "3314",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3316",
    "name": "moulin d or 500G",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3316",
    "barcode": "3316",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3317",
    "name": "Kaak sésame 400gr Al RAII",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -38,
    "category": "Accueil",
    "sku": "SKU-3317",
    "barcode": "3317",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3318",
    "name": "Patte FUSILLI 500gr",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-3318",
    "barcode": "3318",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-3321",
    "name": "Pate de dattes SANA 1kg",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-3321",
    "barcode": "3321",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3322",
    "name": "Medjool egyptian 800gr",
    "price": 6.75,
    "purchasePrice": 6.398104,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-3322",
    "barcode": "3322",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3323",
    "name": "Mussannara Jasmeen 450gr msanara",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": -74,
    "category": "Accueil",
    "sku": "SKU-3323",
    "barcode": "3323",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3324",
    "name": "AJWA al madina 250 gr",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-3324",
    "barcode": "3324",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3325",
    "name": "Datte rotab 550gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-3325",
    "barcode": "3325",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3326",
    "name": "Halloume Jasmeen 250gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -35,
    "category": "Accueil",
    "sku": "SKU-3326",
    "barcode": "3326",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3327",
    "name": "Konafetto ROSHEN Noisette 140gr",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 15,
    "category": "Accueil",
    "sku": "SKU-3327",
    "barcode": "3327",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3328",
    "name": "Konafetto ROSHEN Lait 140gr",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 29,
    "category": "Accueil",
    "sku": "SKU-3328",
    "barcode": "3328",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3329",
    "name": "Konafetto ROSHEN Noix Coco 140gr",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 35,
    "category": "Accueil",
    "sku": "SKU-3329",
    "barcode": "3329",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3330",
    "name": "Konafetto ROSHEN cacao 140gr",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -11,
    "category": "Accueil",
    "sku": "SKU-3330",
    "barcode": "3330",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3331",
    "name": "Custard Blue Mill 350gr",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3331",
    "barcode": "3331",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3332",
    "name": "Sardine Shahia 125gr",
    "price": 1.15,
    "purchasePrice": 1.090047,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-3332",
    "barcode": "3332",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3335",
    "name": "Chips tiger 90gr chili et limon",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 34,
    "category": "Accueil",
    "sku": "SKU-3335",
    "barcode": "3335",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3338",
    "name": "Ail Moulu Nahil 400gr",
    "price": 4.95,
    "purchasePrice": 4.691943,
    "stock": -74,
    "category": "Produits",
    "sku": "SKU-3338",
    "barcode": "3338",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3339",
    "name": "pepite pastèque 1Kg",
    "price": 9.5,
    "purchasePrice": 9.004739,
    "stock": -2,
    "category": "Produits",
    "sku": "SKU-3339",
    "barcode": "3339",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3342",
    "name": "Couscous DARI 2kg",
    "price": 5.25,
    "purchasePrice": 4.976303,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-3342",
    "barcode": "3342",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3343",
    "name": "Couscous Fin DARI 1kg",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 9,
    "category": "Accueil",
    "sku": "SKU-3343",
    "barcode": "3343",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3347",
    "name": "fruit farci noix 450gr",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3347",
    "barcode": "3347",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3348",
    "name": "Dattes Algérie 1kg",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-3348",
    "barcode": "3348",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3350",
    "name": "Savon fadie food 4pces",
    "price": 6,
    "purchasePrice": 5.687204,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3350",
    "barcode": "3350",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3351",
    "name": "Sirop de rose Kassatly",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -23,
    "category": "Accueil",
    "sku": "SKU-3351",
    "barcode": "3351",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3352",
    "name": "Dattes d'algerie 1kg",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-3352",
    "barcode": "3352",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3353",
    "name": "Raisins secs golden 500 gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-3353",
    "barcode": "3353",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3354",
    "name": "Pistaches décortiquées 200 gr",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3354",
    "barcode": "3354",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3356",
    "name": "Amandes décortiquées800 gr",
    "price": 7.99,
    "purchasePrice": 7.57346,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3356",
    "barcode": "3356",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3357",
    "name": "Arachide en poudre 500 gr",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-3357",
    "barcode": "3357",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3358",
    "name": "Kassatly jellab 600 mL",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3358",
    "barcode": "3358",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3359",
    "name": "Dattes sukari 600gr",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-3359",
    "barcode": "3359",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3360",
    "name": "Rotab",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": -17,
    "category": "Accueil",
    "sku": "SKU-3360",
    "barcode": "3360",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3364",
    "name": "SABAH",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 0,
    "category": "Boissons",
    "sku": "SKU-3364",
    "barcode": "3364",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3365",
    "name": "Majdoul boustan 900gr",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": -24,
    "category": "Boissons",
    "sku": "SKU-3365",
    "barcode": "3365",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3366",
    "name": "Puck fromage creme 200gr",
    "price": 1.39,
    "purchasePrice": 1.317536,
    "stock": -34,
    "category": "Boissons",
    "sku": "SKU-3366",
    "barcode": "3366",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3368",
    "name": "Date crown lulu 1kg",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -10,
    "category": "Boissons",
    "sku": "SKU-3368",
    "barcode": "3368",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3369",
    "name": "Date Crown KHENAIZI 1kg",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -9,
    "category": "Boissons",
    "sku": "SKU-3369",
    "barcode": "3369",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3370",
    "name": "Concombre chtoura 3kg",
    "price": 8.5,
    "purchasePrice": 8.056872,
    "stock": 1,
    "category": "Boissons",
    "sku": "SKU-3370",
    "barcode": "3370",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3371",
    "name": "Chanklish à oil Al-Raii 425 GR",
    "price": 9.25,
    "purchasePrice": 8.767773,
    "stock": 2,
    "category": "Boissons",
    "sku": "SKU-3371",
    "barcode": "3371",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3372",
    "name": "labne rai",
    "price": 7.76,
    "purchasePrice": 7.35545,
    "stock": -13,
    "category": "Accueil",
    "sku": "SKU-3372",
    "barcode": "3372",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3376",
    "name": "Al RAI poulet 390 gr",
    "price": 2.55,
    "purchasePrice": 2.417062,
    "stock": -21,
    "category": "Accueil",
    "sku": "SKU-3376",
    "barcode": "3376",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3383",
    "name": "Datte Crown 500gr Lulu",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -15,
    "category": "Accueil",
    "sku": "SKU-3383",
    "barcode": "3383",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3384",
    "name": "Date Crown khalas 1kg",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-3384",
    "barcode": "3384",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3385",
    "name": "Sardine Tayba 125gr",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -47,
    "category": "Accueil",
    "sku": "SKU-3385",
    "barcode": "3385",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-3395",
    "name": "SAFAWI Dattes 400gr",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3395",
    "barcode": "3395",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3396",
    "name": "Jello Aruba citron 85gr",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-3396",
    "barcode": "3396",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-3397",
    "name": "Jello Aruba Orange 85gr",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -8,
    "category": "Accueil",
    "sku": "SKU-3397",
    "barcode": "3397",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-3398",
    "name": "SUKKARY SAIFA",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-3398",
    "barcode": "3398",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3400",
    "name": "Maamoul aghati Dattes 500gr",
    "price": 13.5,
    "purchasePrice": 12.796209,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-3400",
    "barcode": "3400",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3402",
    "name": "Labneh huile piment Al RAI",
    "price": 7.76,
    "purchasePrice": 7.35545,
    "stock": -8,
    "category": "Accueil",
    "sku": "SKU-3402",
    "barcode": "3402",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3403",
    "name": "Falafel Boustan 800gr palestine",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-3403",
    "barcode": "3403",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3404",
    "name": "Si bon Baklava 1kg",
    "price": 27.5,
    "purchasePrice": 26.066351,
    "stock": -13,
    "category": "Accueil",
    "sku": "SKU-3404",
    "barcode": "3404",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3405",
    "name": "Indomie x5 frites",
    "price": 1.8,
    "purchasePrice": 1.706161,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-3405",
    "barcode": "3405",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3406",
    "name": "Maggi soupe végétale 50gr",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3406",
    "barcode": "3406",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3407",
    "name": "Maggi poulet 50gr soupe",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -11,
    "category": "Accueil",
    "sku": "SKU-3407",
    "barcode": "3407",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3408",
    "name": "Tamarin 400gr",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-3408",
    "barcode": "3408",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3409",
    "name": "Aruba 30 g",
    "price": 0.75,
    "purchasePrice": 0.7109,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-3409",
    "barcode": "3409",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3411",
    "name": "pistaches crues 250 G",
    "price": 8.95,
    "purchasePrice": 8.483412,
    "stock": -13,
    "category": "Accueil",
    "sku": "SKU-3411",
    "barcode": "3411",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3412",
    "name": "Sablé Chocolat Douaihy 70gr",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -8,
    "category": "Accueil",
    "sku": "SKU-3412",
    "barcode": "3412",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3413",
    "name": "Sablé Vanille Douaihy 70gr",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-3413",
    "barcode": "3413",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3414",
    "name": "Vimto 33cl X6",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-3414",
    "barcode": "3414",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3417",
    "name": "Raisin Sec Golden  500gr",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-3417",
    "barcode": "3417",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3418",
    "name": "chanklish al raii 200 g",
    "price": 4.29,
    "purchasePrice": 4.066351,
    "stock": -20,
    "category": "Accueil",
    "sku": "SKU-3418",
    "barcode": "3418",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3419",
    "name": "Cumin 500gr Jasmin",
    "price": 9.99,
    "purchasePrice": 9.469194,
    "stock": -45,
    "category": "Accueil",
    "sku": "SKU-3419",
    "barcode": "3419",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3421",
    "name": "Kebbeh Epices Gardenia 50 gr",
    "price": 2.1,
    "purchasePrice": 1.990521,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-3421",
    "barcode": "3421",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3422",
    "name": "Anis Grains Gardenia 50 gr",
    "price": 1.82,
    "purchasePrice": 1.725118,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3422",
    "barcode": "3422",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3423",
    "name": "Chawarma Viande Epices Gardenia 50 gr",
    "price": 2.1,
    "purchasePrice": 1.990521,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-3423",
    "barcode": "3423",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3427",
    "name": "Arrangement Ramadan",
    "price": 45,
    "purchasePrice": 42.654028,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-3427",
    "barcode": "3427",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3428",
    "name": "Combi KIRKEBY 16kg",
    "price": 3.17,
    "purchasePrice": 3.004739,
    "stock": -16,
    "category": "Accueil",
    "sku": "SKU-3428",
    "barcode": "3428",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3429",
    "name": "menthe seche 400gr",
    "price": 4.01,
    "purchasePrice": 3.800948,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-3429",
    "barcode": "3429",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3430",
    "name": "Paprika fumé 1kg",
    "price": 17.5,
    "purchasePrice": 16.587678,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-3430",
    "barcode": "3430",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3431",
    "name": "pruneau dénoyauté 1kg",
    "price": 13.19,
    "purchasePrice": 12.50237,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3431",
    "barcode": "3431",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3432",
    "name": "Maamoul Mix Sibon 500gr",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": -30,
    "category": "Accueil",
    "sku": "SKU-3432",
    "barcode": "3432",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3434",
    "name": "Baklava Ramadan kareem 700 gr",
    "price": 32.5,
    "purchasePrice": 30.805687,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-3434",
    "barcode": "3434",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3435",
    "name": "Kaak b halib 470gr",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-3435",
    "barcode": "3435",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3436",
    "name": "Le renard semoule",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-3436",
    "barcode": "3436",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3438",
    "name": "eau mineral",
    "price": 1.7,
    "purchasePrice": 1.611374,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3438",
    "barcode": "3438",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3442",
    "name": "pain egyptien 400gr",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-3442",
    "barcode": "3442",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3443",
    "name": "Keshta 500gr",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3443",
    "barcode": "3443",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3448",
    "name": "bonbon Roshen",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 9,
    "category": "Accueil",
    "sku": "SKU-3448",
    "barcode": "3448",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3450",
    "name": "nesmah variante legumes",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-3450",
    "barcode": "3450",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3451",
    "name": "Arrangement cadeaux de paques Gateau",
    "price": 35,
    "purchasePrice": 33.175355,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3451",
    "barcode": "3451",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3452",
    "name": "humberger pain moulin d'or",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-3452",
    "barcode": "3452",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3453",
    "name": "pain complet moulin d'or",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-3453",
    "barcode": "3453",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3454",
    "name": "jus",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -13,
    "category": "Accueil",
    "sku": "SKU-3454",
    "barcode": "3454",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3455",
    "name": "Pois chiche 4.2 kg bouilli",
    "price": 7.4,
    "purchasePrice": 7.014218,
    "stock": -17,
    "category": "Accueil",
    "sku": "SKU-3455",
    "barcode": "3455",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 7.4
  },
  {
    "id": "csv-3456",
    "name": "Tomate concassé 5/1",
    "price": 10.44,
    "purchasePrice": 9.895735,
    "stock": -71,
    "category": "Accueil",
    "sku": "SKU-3456",
    "barcode": "3456",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3457",
    "name": "tomate ronde 3.5",
    "price": 3.69,
    "purchasePrice": 3.49763,
    "stock": -47,
    "category": "Accueil",
    "sku": "SKU-3457",
    "barcode": "3457",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3458",
    "name": "Cornichon Boulos lamelle 10kg",
    "price": 25,
    "purchasePrice": 23.696682,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-3458",
    "barcode": "3458",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3459",
    "name": "Tomate 6 kg",
    "price": 6,
    "purchasePrice": 5.687204,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-3459",
    "barcode": "3459",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 6
  },
  {
    "id": "csv-3460",
    "name": "Courgette farcie 2 kg",
    "price": 9.5,
    "purchasePrice": 9.004739,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-3460",
    "barcode": "3460",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 9.5
  },
  {
    "id": "csv-3461",
    "name": "Jus Maccaw Mango 250 ml",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3461",
    "barcode": "3461",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3462",
    "name": "Fromage grillé",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-3462",
    "barcode": "3462",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3463",
    "name": "Topinambour taro en cube 400gr",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 14,
    "category": "Condiments",
    "sku": "SKU-3463",
    "barcode": "3463",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3465",
    "name": "Feta TZAFETTAS 200gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-3465",
    "barcode": "3465",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3466",
    "name": "Halloume 200gr Petrou",
    "price": 2.95,
    "purchasePrice": 2.796209,
    "stock": -12,
    "category": "Accueil",
    "sku": "SKU-3466",
    "barcode": "3466",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3467",
    "name": "Feta TZAFETTAS 400gr",
    "price": 6.75,
    "purchasePrice": 6.398104,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-3467",
    "barcode": "3467",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3471",
    "name": "Jello domo fraise banane",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": -14,
    "category": "Accueil",
    "sku": "SKU-3471",
    "barcode": "3471",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.99
  },
  {
    "id": "csv-3475",
    "name": "Zaatar vert durra 6kg",
    "price": 35.75,
    "purchasePrice": 33.886256,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3475",
    "barcode": "3475",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3476",
    "name": "Labneh piment bocal golden plate",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-3476",
    "barcode": "3476",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3477",
    "name": "Labne bocal golden plate thym",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-3477",
    "barcode": "3477",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3479",
    "name": "Tahini Anti gaspi 400gr beit Al safa",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -693,
    "category": "Accueil",
    "sku": "SKU-3479",
    "barcode": "3479",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3490",
    "name": "grissini thyme",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3490",
    "barcode": "3490",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3491",
    "name": "Pois chiche Kaymo",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": -86,
    "category": "Accueil",
    "sku": "SKU-3491",
    "barcode": "3491",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3492",
    "name": "Ail moulu Sofram 500gr",
    "price": 5.85,
    "purchasePrice": 5.545024,
    "stock": -8,
    "category": "Accueil",
    "sku": "SKU-3492",
    "barcode": "3492",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3493",
    "name": "Feta 16kg arev",
    "price": 4.91,
    "purchasePrice": 4.654028,
    "stock": -31,
    "category": "Accueil",
    "sku": "SKU-3493",
    "barcode": "3493",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3503",
    "name": "Nabulsi 460gr Al Rai",
    "price": 6.75,
    "purchasePrice": 6.398104,
    "stock": 27,
    "category": "Accueil",
    "sku": "SKU-3503",
    "barcode": "3503",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3504",
    "name": "Chilal Alrai 225gr",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-3504",
    "barcode": "3504",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3505",
    "name": "Akkawi 460gr Al rai",
    "price": 6.75,
    "purchasePrice": 6.398104,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-3505",
    "barcode": "3505",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3508",
    "name": "buffies pop corn",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-3508",
    "barcode": "3508",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3514",
    "name": "noix de muscade entier",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3514",
    "barcode": "3514",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3519",
    "name": "uno ananas 30cl",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-3519",
    "barcode": "3519",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3520",
    "name": "Derbi",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-3520",
    "barcode": "3520",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3521",
    "name": "Sésame doré Abido",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": 17,
    "category": "Accueil",
    "sku": "SKU-3521",
    "barcode": "3521",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3522",
    "name": "Persil Bottes petit",
    "price": 0.55,
    "purchasePrice": 0.521327,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-3522",
    "barcode": "3522",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.55
  },
  {
    "id": "csv-3525",
    "name": "Graines de citrouille - Krikita 220 g",
    "price": 4.49,
    "purchasePrice": 4.255924,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-3525",
    "barcode": "3525",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3532",
    "name": "Aruba Fraise 12 saches",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-3532",
    "barcode": "3532",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3534",
    "name": "Al Raii Beuf 200 gr",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-3534",
    "barcode": "3534",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3535",
    "name": "Fromage à griller kaval 1kg",
    "price": 9.87,
    "purchasePrice": 9.35545,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3535",
    "barcode": "3535",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3539",
    "name": "Junet Orange Carrot 250 ml",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 19,
    "category": "Accueil",
    "sku": "SKU-3539",
    "barcode": "3539",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3541",
    "name": "Soujook en tranche Guven 200GR",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3541",
    "barcode": "3541",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3546",
    "name": "falafel durra kg",
    "price": 8.75,
    "purchasePrice": 8.293839,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-3546",
    "barcode": "3546",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 8.75
  },
  {
    "id": "csv-3548",
    "name": "Jello ou gelée fraise halal - Aruba 85 gr",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": 22,
    "category": "Accueil",
    "sku": "SKU-3548",
    "barcode": "3548",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3551",
    "name": "Concombre Mariné Jana 10kg",
    "price": 25,
    "purchasePrice": 23.696682,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-3551",
    "barcode": "3551",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3552",
    "name": "baklava soultan 220gr",
    "price": 9.99,
    "purchasePrice": 9.469194,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-3552",
    "barcode": "3552",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3554",
    "name": "feuille de curry 100gr",
    "price": 9.95,
    "purchasePrice": 9.43128,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-3554",
    "barcode": "3554",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3555",
    "name": "Ras el Hanout yellow 50gr",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 9,
    "category": "Accueil",
    "sku": "SKU-3555",
    "barcode": "3555",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3556",
    "name": "Redbull sans sucres",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": 18,
    "category": "Accueil",
    "sku": "SKU-3556",
    "barcode": "3556",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3557",
    "name": "Mansaf Epices 50 Abido",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 9,
    "category": "Accueil",
    "sku": "SKU-3557",
    "barcode": "3557",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3559",
    "name": "Pilon en bois de lotus",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 19,
    "category": "Accueil",
    "sku": "SKU-3559",
    "barcode": "3559",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3560",
    "name": "Presse citron en bois",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": 16,
    "category": "Accueil",
    "sku": "SKU-3560",
    "barcode": "3560",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3561",
    "name": "Riz Duru 1kg",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-3561",
    "barcode": "3561",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3563",
    "name": "chilal Sefa 800gr",
    "price": 15.5,
    "purchasePrice": 14.691943,
    "stock": 13,
    "category": "Accueil",
    "sku": "SKU-3563",
    "barcode": "3563",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3564",
    "name": "Msennara sefa 800gr",
    "price": 11.5,
    "purchasePrice": 10.900474,
    "stock": 52,
    "category": "Accueil",
    "sku": "SKU-3564",
    "barcode": "3564",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3565",
    "name": "Shishbarak le bon gout 400gr",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-3565",
    "barcode": "3565",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3566",
    "name": "Tahina shamiate 750gr",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3566",
    "barcode": "3566",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3567",
    "name": "Ghee vegetal Aseel 1000g",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 12,
    "category": "Accueil",
    "sku": "SKU-3567",
    "barcode": "3567",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3568",
    "name": "Ghee Vegetal Alssad 1L",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 12,
    "category": "Accueil",
    "sku": "SKU-3568",
    "barcode": "3568",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-184",
    "name": "Labneh Milky's 500 g",
    "price": 4.29,
    "purchasePrice": 4.0645,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-184",
    "barcode": "184",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-401",
    "name": "olives vertes dénoyautée",
    "price": 0,
    "purchasePrice": 0,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-401",
    "barcode": "401",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-402",
    "name": "Frais de livraison",
    "price": 12.8,
    "purchasePrice": 10.666667,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-402",
    "barcode": "402",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-403",
    "name": "Frais de livraison inf à 49 euros",
    "price": 5.83,
    "purchasePrice": 5.83,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-403",
    "barcode": "403",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-404",
    "name": "Frais de Livraison",
    "price": 6,
    "purchasePrice": 5,
    "stock": -17,
    "category": "Accueil",
    "sku": "SKU-404",
    "barcode": "404",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-405",
    "name": "Livraison à domicile inf à 49 euros",
    "price": 10.54,
    "purchasePrice": 10.54,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-405",
    "barcode": "405",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-435",
    "name": "transport slovaquie",
    "price": 30.71,
    "purchasePrice": 30.71,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-435",
    "barcode": "435",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-449",
    "name": "Haricots Blancs Géants",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 1,
    "category": "Légumineuses et grains",
    "sku": "SKU-449",
    "barcode": "449",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-570",
    "name": "Pistaches décortiqué d'Iran 1kg",
    "price": 31.99,
    "purchasePrice": 30.322275,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-570",
    "barcode": "570",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-574",
    "name": "Purée de Tomates",
    "price": 1.55,
    "purchasePrice": 1.469194,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-574",
    "barcode": "574",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-575",
    "name": "Ketchup Heinz 300mL",
    "price": 1.55,
    "purchasePrice": 1.469194,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-575",
    "barcode": "575",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-576",
    "name": "Mayonnaise 235 gr",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-576",
    "barcode": "576",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-577",
    "name": "Moutarde Amora 440 gr",
    "price": 0.75,
    "purchasePrice": 0.7109,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-577",
    "barcode": "577",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-578",
    "name": "Pulpe de Tomates en morceaux",
    "price": 0.85,
    "purchasePrice": 0.805687,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-578",
    "barcode": "578",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-579",
    "name": "Eau de source Roche des écrins 33cl",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": -86,
    "category": "Accueil",
    "sku": "SKU-579",
    "barcode": "579",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.5
  },
  {
    "id": "csv-580",
    "name": "Eau Cristaline 1,5 L",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-580",
    "barcode": "580",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-581",
    "name": "Cristaline Pack x6",
    "price": 1.15,
    "purchasePrice": 1.090047,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-581",
    "barcode": "581",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-583",
    "name": "Yaourt Yayla 1Kg 3,5% MG",
    "price": 3.42,
    "purchasePrice": 3.241706,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-583",
    "barcode": "583",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-584",
    "name": "Beurre DOUX Bridel",
    "price": 1.85,
    "purchasePrice": 1.753555,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-584",
    "barcode": "584",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-585",
    "name": "Beurre demi sel 250gr",
    "price": 1.85,
    "purchasePrice": 1.753555,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-585",
    "barcode": "585",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-587",
    "name": "Crème fraiche entière 20cL",
    "price": 0.75,
    "purchasePrice": 0.7109,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-587",
    "barcode": "587",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-588",
    "name": "Crème fraiche Légère 20cL",
    "price": 0.75,
    "purchasePrice": 0.7109,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-588",
    "barcode": "588",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-589",
    "name": "Sorbert oasis tropical",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -30,
    "category": "Accueil",
    "sku": "SKU-589",
    "barcode": "589",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-590",
    "name": "Sorbet Oasice pèche",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-590",
    "barcode": "590",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-591",
    "name": "Glace magnum classic",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-591",
    "barcode": "591",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-592",
    "name": "Minicup favorite selection",
    "price": 5.99,
    "purchasePrice": 5.677725,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-592",
    "barcode": "592",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-593",
    "name": "Glace cornet fraise vanille",
    "price": 0.75,
    "purchasePrice": 0.7109,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-593",
    "barcode": "593",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-594",
    "name": "Sel La baleine 50% 350gr",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-594",
    "barcode": "594",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-626",
    "name": "Ail 40gr",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-626",
    "barcode": "626",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-628",
    "name": "Moule petit Maamoul",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-628",
    "barcode": "628",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-630",
    "name": "Red Bull Sans Sucre Energy 250 ml",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 17,
    "category": "Accueil",
    "sku": "SKU-630",
    "barcode": "630",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-631",
    "name": "Sprite",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 11,
    "category": "Boissons",
    "sku": "SKU-631",
    "barcode": "631",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-632",
    "name": "Pepsi Regular 33cl",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -123,
    "category": "Boissons",
    "sku": "SKU-632",
    "barcode": "632",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-633",
    "name": "Cristaline eau pack",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-633",
    "barcode": "633",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-635",
    "name": "Boite d'allumette",
    "price": 0.25,
    "purchasePrice": 0.208333,
    "stock": 46,
    "category": "Accueil",
    "sku": "SKU-635",
    "barcode": "635",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-636",
    "name": "Tarator",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -12,
    "category": "Accueil",
    "sku": "SKU-636",
    "barcode": "636",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-638",
    "name": "Chausson salé",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 441,
    "category": "Accueil",
    "sku": "SKU-638",
    "barcode": "638",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-639",
    "name": "Ail grand",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-639",
    "barcode": "639",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-640",
    "name": "Maamoul de Qualité paquet de 5 pièces",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-640",
    "barcode": "640",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-642",
    "name": "kebbe",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": -22,
    "category": "Accueil",
    "sku": "SKU-642",
    "barcode": "642",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-643",
    "name": "Pain Libanais 20 sachets de 5 pains",
    "price": 15.99,
    "purchasePrice": 15.156398,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-643",
    "barcode": "643",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-652",
    "name": "Nougat petit",
    "price": 6.25,
    "purchasePrice": 5.924171,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-652",
    "barcode": "652",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-653",
    "name": "FREEZ",
    "price": 5.3,
    "purchasePrice": 5.023697,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-653",
    "barcode": "653",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-657",
    "name": "Pignon bio",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-657",
    "barcode": "657",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-680",
    "name": "charbon",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -13,
    "category": "Accueil",
    "sku": "SKU-680",
    "barcode": "680",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-688",
    "name": "Tasse Mate",
    "price": 4,
    "purchasePrice": 3.791469,
    "stock": 2,
    "category": "Yerba Maté",
    "sku": "SKU-688",
    "barcode": "688",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-691",
    "name": "Charbon chicha",
    "price": 16,
    "purchasePrice": 15.165877,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-691",
    "barcode": "691",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-693",
    "name": "Tahini Extra Syrienne Malakeh 900gr",
    "price": 2.48,
    "purchasePrice": 4.691943,
    "stock": 0,
    "category": "Tahini",
    "sku": "SKU-693",
    "barcode": "693",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-696",
    "name": "Savon d'alep cadeau",
    "price": 21,
    "purchasePrice": 17.5,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-696",
    "barcode": "696",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-702",
    "name": "Olives vertes Grec à la Libanaise 250gr",
    "price": 1.12,
    "purchasePrice": 1.184834,
    "stock": 0,
    "category": "Accueil",
    "sku": "Conseillé par Almouné",
    "barcode": "702",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-706",
    "name": "Aromatique fresh",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-706",
    "barcode": "706",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-708",
    "name": "Namoura",
    "price": 12,
    "purchasePrice": 11.374408,
    "stock": -18,
    "category": "Accueil",
    "sku": "SKU-708",
    "barcode": "708",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-709",
    "name": "Moule",
    "price": 8.5,
    "purchasePrice": 7.083333,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-709",
    "barcode": "709",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-710",
    "name": "DIVERS 5.5%",
    "price": 0,
    "purchasePrice": 0,
    "stock": 127,
    "category": "Accueil",
    "sku": "SKU-710",
    "barcode": "710",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-717",
    "name": "Concombres Marinés Cortas 625 gr.",
    "price": 3.91,
    "purchasePrice": 3.706161,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-717",
    "barcode": "717",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-719",
    "name": "Biscuits à la noix de coco Haylayf Ulker 4*64g",
    "price": 1.85,
    "purchasePrice": 1.753555,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-719",
    "barcode": "719",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-720",
    "name": "Petit four Beybaba 320 g",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Patisseries",
    "sku": "SKU-720",
    "barcode": "720",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-721",
    "name": "Ghreybe turque beybaba",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-721",
    "barcode": "721",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-729",
    "name": "Chips Ringo boules de fromage 22gr",
    "price": 0.35,
    "purchasePrice": 0.331754,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-729",
    "barcode": "729",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-730",
    "name": "Chips Ringo pizza 22gr",
    "price": 0.35,
    "purchasePrice": 0.331754,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-730",
    "barcode": "730",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-731",
    "name": "Chips Ringo saveur arachide 22gr",
    "price": 0.35,
    "purchasePrice": 0.331754,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-731",
    "barcode": "731",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-739",
    "name": "Pain Markouk traditionel Libanais 240g",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-739",
    "barcode": "739",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-740",
    "name": "Kaak Asrouni Libanais 240gr",
    "price": 4,
    "purchasePrice": 3.791469,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-740",
    "barcode": "740",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-741",
    "name": "Riz long il rosotino",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-741",
    "barcode": "741",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-743",
    "name": "Concombres Marinés 10 kg Al Dayaa",
    "price": 25,
    "purchasePrice": 23.696682,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-743",
    "barcode": "743",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 25
  },
  {
    "id": "csv-749",
    "name": "Al dayaa Grenade 3.5kg",
    "price": 13.5,
    "purchasePrice": 12.796209,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-749",
    "barcode": "749",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-752",
    "name": "Huile de tournesol 1L Bingoil",
    "price": 1.86,
    "purchasePrice": 1.763033,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-752",
    "barcode": "752",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-753",
    "name": "Lait demi Ecrémé 1L",
    "price": 1.15,
    "purchasePrice": 1.090047,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-753",
    "barcode": "753",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-754",
    "name": "Mloukhiya",
    "price": 2.1,
    "purchasePrice": 1.990521,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-754",
    "barcode": "754",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-756",
    "name": "Lait entier",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-756",
    "barcode": "756",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-758",
    "name": "Baklava Al sultan 750gr",
    "price": 16,
    "purchasePrice": 15.165877,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-758",
    "barcode": "758",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-759",
    "name": "kasih Tahini 18kg",
    "price": 73.85,
    "purchasePrice": 70,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-759",
    "barcode": "759",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-761",
    "name": "Tropico",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-761",
    "barcode": "761",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-762",
    "name": "Fanta Orange 33cl",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-762",
    "barcode": "762",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-763",
    "name": "coca cola",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-763",
    "barcode": "763",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-764",
    "name": "coca cola zero",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-764",
    "barcode": "764",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-769",
    "name": "Acide citrique aruba",
    "price": 7.5,
    "purchasePrice": 6.25,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-769",
    "barcode": "769",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-773",
    "name": "Piment",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-773",
    "barcode": "773",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-777",
    "name": "gaufrette Unica Noir Sac Mini 170gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-777",
    "barcode": "777",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-780",
    "name": "Salami boeuf 700 gr",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-780",
    "barcode": "780",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-784",
    "name": "Acide Citrique 500gr",
    "price": 3.27,
    "purchasePrice": 3.099526,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-784",
    "barcode": "784",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-787",
    "name": "Zwan pâté de boeuf Halal 850gr",
    "price": 7.99,
    "purchasePrice": 7.57346,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-787",
    "barcode": "787",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-788",
    "name": "Pepite pasteque rohana",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-788",
    "barcode": "788",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-789",
    "name": "oignons 2 5kg",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-789",
    "barcode": "789",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-790",
    "name": "Pomme de terre",
    "price": 2.1,
    "purchasePrice": 1.990521,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-790",
    "barcode": "790",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-791",
    "name": "Tamarin",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-791",
    "barcode": "791",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-792",
    "name": "Aubergine 1kg",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-792",
    "barcode": "792",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-793",
    "name": "Carotte 1kg",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-793",
    "barcode": "793",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-794",
    "name": "Beurre de cacahuète 500gr",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-794",
    "barcode": "794",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-798",
    "name": "Lait demi-Ecreme x6",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-798",
    "barcode": "798",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-799",
    "name": "Jus de Citron et menthe Junet",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-799",
    "barcode": "799",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-800",
    "name": "bhar falafel",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-800",
    "barcode": "800",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-802",
    "name": "freez granade",
    "price": 1.1,
    "purchasePrice": 1.042654,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-802",
    "barcode": "802",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-803",
    "name": "Mélange fruit à coque Samir 300gr.",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-803",
    "barcode": "803",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-804",
    "name": "Falafel en Poudre Baytouti 8kg",
    "price": 28.48,
    "purchasePrice": 26.995261,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-804",
    "barcode": "804",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-809",
    "name": "Riz Basmati Al-RAII 1kg",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-809",
    "barcode": "809",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-812",
    "name": "Vimto",
    "price": 2.65,
    "purchasePrice": 2.511848,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-812",
    "barcode": "812",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-838",
    "name": "Pain TOFAHA",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-838",
    "barcode": "838",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-850",
    "name": "makanek rungis",
    "price": 14.5,
    "purchasePrice": 13.744076,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-850",
    "barcode": "850",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-856",
    "name": "P. soleil",
    "price": 0.85,
    "purchasePrice": 0.805687,
    "stock": 2288,
    "category": "Accueil",
    "sku": "SKU-856",
    "barcode": "856",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-857",
    "name": "Baklava premium HALLAB 450gr.",
    "price": 18.5,
    "purchasePrice": 17.535545,
    "stock": -16,
    "category": "Accueil",
    "sku": "SKU-857",
    "barcode": "857",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-863",
    "name": "film aliment",
    "price": 8.25,
    "purchasePrice": 6.875,
    "stock": -205,
    "category": "Accueil",
    "sku": "SKU-863",
    "barcode": "863",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-864",
    "name": "P. Soleil Grand",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 3311,
    "category": "Accueil",
    "sku": "SKU-864",
    "barcode": "864",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-872",
    "name": "Houmous Baladna 400gr",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 1,
    "category": "Produits",
    "sku": "SKU-872",
    "barcode": "872",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-873",
    "name": "Fromage Combi beyaz Sofram 800gr",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": -77,
    "category": "Accueil",
    "sku": "SKU-873",
    "barcode": "873",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-874",
    "name": "Amidon de Mais 1kg",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": -204,
    "category": "Accueil",
    "sku": "SKU-874",
    "barcode": "874",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-875",
    "name": "Barquette 500g.",
    "price": 6,
    "purchasePrice": 5,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-875",
    "barcode": "875",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-876",
    "name": "Mozzarella 2 kg",
    "price": 17,
    "purchasePrice": 16.113744,
    "stock": -500,
    "category": "Accueil",
    "sku": "SKU-876",
    "barcode": "876",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 17
  },
  {
    "id": "csv-877",
    "name": "Tarama rose",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-877",
    "barcode": "877",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-881",
    "name": "Labneh Rona 2.750 kg",
    "price": 14.51,
    "purchasePrice": 13.753555,
    "stock": -26,
    "category": "Accueil",
    "sku": "SKU-881",
    "barcode": "881",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 14.51
  },
  {
    "id": "csv-884",
    "name": "Acide Citrique socofram 5kg",
    "price": 12,
    "purchasePrice": 10,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-884",
    "barcode": "884",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-885",
    "name": "Ricotta 250 gr",
    "price": 1.95,
    "purchasePrice": 1.848341,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-885",
    "barcode": "885",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-888",
    "name": "Epices soujok Adida 500gr",
    "price": 5.8,
    "purchasePrice": 5.5,
    "stock": -7,
    "category": "Épices",
    "sku": "SKU-888",
    "barcode": "888",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-889",
    "name": "Cannelle bâtonnets Adida 500gr",
    "price": 6,
    "purchasePrice": 5.687204,
    "stock": -8,
    "category": "5",
    "sku": "SKU-889",
    "barcode": "889",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-890",
    "name": "Pois Chiche 1600gr.",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "5",
    "sku": "SKU-890",
    "barcode": "890",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-891",
    "name": "Pois cassés 5kg",
    "price": 1.16,
    "purchasePrice": 1.099526,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-891",
    "barcode": "891",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-892",
    "name": "Curry 500g.",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -3,
    "category": "Épices",
    "sku": "SKU-892",
    "barcode": "892",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-894",
    "name": "ayran 250ml",
    "price": 0.75,
    "purchasePrice": 0.7109,
    "stock": -209,
    "category": "Accueil",
    "sku": "SKU-894",
    "barcode": "894",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.75
  },
  {
    "id": "csv-897",
    "name": "Concentré de tomates France",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-897",
    "barcode": "897",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-898",
    "name": "zaatar brut 500gr",
    "price": 6.33,
    "purchasePrice": 6,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-898",
    "barcode": "898",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-899",
    "name": "Bouillon poulet extra",
    "price": 6.86,
    "purchasePrice": 6.50237,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-899",
    "barcode": "899",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-902",
    "name": "Ghee samne la vache de paris 1.6 kg",
    "price": 23.5,
    "purchasePrice": 22.274882,
    "stock": 0,
    "category": "Produits laitiers",
    "sku": "SKU-902",
    "barcode": "902",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 23.5
  },
  {
    "id": "csv-907",
    "name": "Barazek Al sharek 375 gr",
    "price": 6,
    "purchasePrice": 5.687204,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-907",
    "barcode": "907",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-908",
    "name": "Barazek Al sharek 375 gr",
    "price": 6,
    "purchasePrice": 5.687204,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-908",
    "barcode": "908",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-913",
    "name": "Savon de visage",
    "price": 4.75,
    "purchasePrice": 3.958333,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-913",
    "barcode": "913",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-915",
    "name": "Pistaches décortiquées",
    "price": 13,
    "purchasePrice": 12.322275,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-915",
    "barcode": "915",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-917",
    "name": "Acide citrique aruba 4 kg",
    "price": 24,
    "purchasePrice": 20,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-917",
    "barcode": "917",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 24
  },
  {
    "id": "csv-918",
    "name": "Courgette",
    "price": 7.91,
    "purchasePrice": 7.49763,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-918",
    "barcode": "918",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-920",
    "name": "kaak au sésame",
    "price": 5,
    "purchasePrice": 4.739336,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-920",
    "barcode": "920",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-922",
    "name": "Combi Yasilova 800gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-922",
    "barcode": "922",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-923",
    "name": "Mloukhiya 200gr. sèche premium",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-923",
    "barcode": "923",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-925",
    "name": "Coriandre Adida 500gr.",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 6,
    "category": "Épices",
    "sku": "SKU-925",
    "barcode": "925",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-931",
    "name": "Cave Kouroum Rosé",
    "price": 4.68,
    "purchasePrice": 3.9,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-931",
    "barcode": "931",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-932",
    "name": "Cave Kouroum Rouge 37cl",
    "price": 3.36,
    "purchasePrice": 2.8,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-932",
    "barcode": "932",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-933",
    "name": "Cave Kouroum Rosé 37cl",
    "price": 3.36,
    "purchasePrice": 2.8,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-933",
    "barcode": "933",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-941",
    "name": "Bicarbonate 4 kg",
    "price": 10,
    "purchasePrice": 8.333333,
    "stock": 1,
    "category": "Produits",
    "sku": "SKU-941",
    "barcode": "941",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 10
  },
  {
    "id": "csv-943",
    "name": "Halloume Rona",
    "price": 2.95,
    "purchasePrice": 2.796209,
    "stock": -429,
    "category": "Fromages libanais",
    "sku": "SKU-943",
    "barcode": "943",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-944",
    "name": "Epice Adida 1 euros",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-944",
    "barcode": "944",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-945",
    "name": "Purée tomate bio 720 ml",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": 0,
    "category": "Concentrés",
    "sku": "SKU-945",
    "barcode": "945",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-951",
    "name": "Meghli",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 6,
    "category": "Gourmandises",
    "sku": "SKU-951",
    "barcode": "951",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-954",
    "name": "Graines de tournesol (pépites) salées  250gr.",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-954",
    "barcode": "954",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-955",
    "name": "Mloukhiya Boustani 400gr.",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-955",
    "barcode": "955",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-957",
    "name": "Pistaches émondées 200gr",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -3,
    "category": "Fruits secs",
    "sku": "SKU-957",
    "barcode": "957",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-962",
    "name": "Pépites de tournesol 500gr O'regal",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -1,
    "category": "Fruits secs",
    "sku": "SKU-962",
    "barcode": "962",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-965",
    "name": "Lipton Pastèque Menthe",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-965",
    "barcode": "965",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-966",
    "name": "Schweppes Indian tonic",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 18,
    "category": "Accueil",
    "sku": "SKU-966",
    "barcode": "966",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-967",
    "name": "Oasis Fraise framboise",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -25,
    "category": "Jus - Sirops",
    "sku": "SKU-967",
    "barcode": "967",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-968",
    "name": "Orangina et sa puple",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-968",
    "barcode": "968",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-969",
    "name": "Oasis tropical",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-969",
    "barcode": "969",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-970",
    "name": "kaak",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-970",
    "barcode": "970",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-973",
    "name": "Melasse de Grenade 600ml",
    "price": 4.95,
    "purchasePrice": 4.691943,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-973",
    "barcode": "973",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-974",
    "name": "Chair de tomate bio 400 gr.",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-974",
    "barcode": "974",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-979",
    "name": "pois chiche Grillés 100gr.",
    "price": 0.75,
    "purchasePrice": 0.7109,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-979",
    "barcode": "979",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-981",
    "name": "Adida Cumin 500gr.",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": -2,
    "category": "Épices",
    "sku": "SKU-981",
    "barcode": "981",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-982",
    "name": "Boulghour blanc",
    "price": 1.95,
    "purchasePrice": 1.848341,
    "stock": -29,
    "category": "Accueil",
    "sku": "SKU-982",
    "barcode": "982",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-983",
    "name": "Poivre blanc 500gr.",
    "price": 11.45,
    "purchasePrice": 10.853081,
    "stock": -26,
    "category": "Accueil",
    "sku": "SKU-983",
    "barcode": "983",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-984",
    "name": "Brochette Aluminium 2cm",
    "price": 2,
    "purchasePrice": 1.666667,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-984",
    "barcode": "984",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-985",
    "name": "Brochette en bois plat kefta",
    "price": 2,
    "purchasePrice": 1.666667,
    "stock": -15,
    "category": "Accueil",
    "sku": "SKU-985",
    "barcode": "985",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-989",
    "name": "Zaatar Abido 10kg",
    "price": 47.47,
    "purchasePrice": 44.995261,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-989",
    "barcode": "989",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-990",
    "name": "Gateau aghati knefe",
    "price": 9.5,
    "purchasePrice": 9.004739,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-990",
    "barcode": "990",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-992",
    "name": "Red Bull Energy 250 ml",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-992",
    "barcode": "992",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-993",
    "name": "Frais de port",
    "price": 15.78,
    "purchasePrice": 13.15,
    "stock": -4,
    "category": "Produits",
    "sku": "SKU-993",
    "barcode": "993",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-994",
    "name": "Twist Choco 24 pièces",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -3,
    "category": "Friandises",
    "sku": "SKU-994",
    "barcode": "994",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-995",
    "name": "Gaufrette choco 24 La vita",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-995",
    "barcode": "995",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-996",
    "name": "Twist untié",
    "price": 0.25,
    "purchasePrice": 0.236967,
    "stock": 8,
    "category": "Friandises",
    "sku": "SKU-996",
    "barcode": "996",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-998",
    "name": "soleil complet",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 3022,
    "category": "Accueil",
    "sku": "SKU-998",
    "barcode": "998",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1000",
    "name": "Graines de courge 250gr.",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 24,
    "category": "Accueil",
    "sku": "SKU-1000",
    "barcode": "1000",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1003",
    "name": "Moule toue",
    "price": 3,
    "purchasePrice": 2.5,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-1003",
    "barcode": "1003",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1005",
    "name": "Bretche Blanc 75cl",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1005",
    "barcode": "1005",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1006",
    "name": "Breteche 75cl blc",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1006",
    "barcode": "1006",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1007",
    "name": "Navet dayaa",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1007",
    "barcode": "1007",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1011",
    "name": "moutrade",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-1011",
    "barcode": "1011",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1014",
    "name": "Combi 16kg",
    "price": 3.85,
    "purchasePrice": 3.649289,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1014",
    "barcode": "1014",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1015",
    "name": "Feta combi 16kg",
    "price": 61.6,
    "purchasePrice": 58.388626,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-1015",
    "barcode": "1015",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1017",
    "name": "Pepsi Max 33cl",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-1017",
    "barcode": "1017",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-1020",
    "name": "Sirop de Jellab Al Dayaa 600ml",
    "price": 3.95,
    "purchasePrice": 3.744076,
    "stock": 0,
    "category": "Jus - Sirops",
    "sku": "SKU-1020",
    "barcode": "1020",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1021",
    "name": "Aubergine Paliria 4.2 kg",
    "price": 11.45,
    "purchasePrice": 10.853081,
    "stock": -87,
    "category": "Légumes Marinés",
    "sku": "SKU-1021",
    "barcode": "1021",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 11.45
  },
  {
    "id": "csv-1023",
    "name": "Douyhe Maamoul aux dattes 1 pièce grande",
    "price": 1.15,
    "purchasePrice": 1.090047,
    "stock": -517,
    "category": "Gâteaux - Biscuits orientaux",
    "sku": "SKU-1023",
    "barcode": "1023",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1024",
    "name": "Baklava douyhe assabeh 3kg",
    "price": 63.3,
    "purchasePrice": 60,
    "stock": -2,
    "category": "Baklava",
    "sku": "SKU-1024",
    "barcode": "1024",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1025",
    "name": "Huile de nigelle 60ml",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 1,
    "category": "Autres",
    "sku": "SKU-1025",
    "barcode": "1025",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1030",
    "name": "Moka classic",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 4,
    "category": "Cafés",
    "sku": "SKU-1030",
    "barcode": "1030",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1033",
    "name": "Halloum nature Artisanal 250gr.",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -149,
    "category": "Fromages libanais",
    "sku": "SKU-1033",
    "barcode": "1033",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1034",
    "name": "Halloume nij 250gr",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1034",
    "barcode": "1034",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1035",
    "name": "Halloum Nature artisanal 250gr.",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1035",
    "barcode": "1035",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1036",
    "name": "Akawi artisanal nature 260g",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": -80,
    "category": "Accueil",
    "sku": "SKU-1036",
    "barcode": "1036",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1037",
    "name": "Chancliche artisanal 160gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": -144,
    "category": "Accueil",
    "sku": "SKU-1037",
    "barcode": "1037",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1040",
    "name": "Labneh artisanal BEQAA 500gr.",
    "price": 4.95,
    "purchasePrice": 4.691943,
    "stock": 12,
    "category": "Accueil",
    "sku": "SKU-1040",
    "barcode": "1040",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1041",
    "name": "Laban artisanal 500gr.",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1041",
    "barcode": "1041",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1042",
    "name": "Artichauts Boustani 400gr",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": 0,
    "category": "Légumineuses et grains",
    "sku": "SKU-1042",
    "barcode": "1042",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1043",
    "name": "Bamiya okra Boustani 400gr",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": -35,
    "category": "Légumineuses et grains",
    "sku": "SKU-1043",
    "barcode": "1043",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1044",
    "name": "Petit pois nature boustani 400gr.",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 0,
    "category": "Légumineuses et grains",
    "sku": "SKU-1044",
    "barcode": "1044",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1045",
    "name": "Bamiya exta boustani 750 gr.",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 0,
    "category": "Légumineuses et grains",
    "sku": "SKU-1045",
    "barcode": "1045",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1046",
    "name": "Coriandre Boustani 200gr.",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 0,
    "category": "Légumineuses et grains",
    "sku": "SKU-1046",
    "barcode": "1046",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1050",
    "name": "Gombos tranché congelé",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-1050",
    "barcode": "1050",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1060",
    "name": "Pistaches moulues 500gr",
    "price": 16.5,
    "purchasePrice": 15.63981,
    "stock": -18,
    "category": "Accueil",
    "sku": "SKU-1060",
    "barcode": "1060",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1061",
    "name": "Thina Mira",
    "price": 86,
    "purchasePrice": 81.516588,
    "stock": 0,
    "category": "Tahini",
    "sku": "SKU-1061",
    "barcode": "1061",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1067",
    "name": "huile d'olive Mylos",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Huiles et vinaigres",
    "sku": "SKU-1067",
    "barcode": "1067",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1068",
    "name": "Cafetière steinliss 3 tasse",
    "price": 5,
    "purchasePrice": 4.166667,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-1068",
    "barcode": "1068",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1069",
    "name": "Jus de citron instantané 360gr.",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Jus - Sirops",
    "sku": "SKU-1069",
    "barcode": "1069",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1071",
    "name": "Chupa chups crazy dips",
    "price": 1,
    "purchasePrice": 0.833333,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1071",
    "barcode": "1071",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1072",
    "name": "Bonbon melon",
    "price": 1.25,
    "purchasePrice": 1.041667,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1072",
    "barcode": "1072",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1074",
    "name": "huile d'olive Al Dayaa 1L",
    "price": 9,
    "purchasePrice": 8.530806,
    "stock": 0,
    "category": "Huiles et vinaigres",
    "sku": "SKU-1074",
    "barcode": "1074",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1075",
    "name": "Essuie tout x8",
    "price": 15,
    "purchasePrice": 12.5,
    "stock": -82,
    "category": "Accueil",
    "sku": "SKU-1075",
    "barcode": "1075",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1076",
    "name": "Cappuccino sachet",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-1076",
    "barcode": "1076",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1103",
    "name": "Labneh Rona cond. 500g.",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": -15,
    "category": "Yaourt et Labneh",
    "sku": "SKU-1103",
    "barcode": "1103",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1104",
    "name": "Makdous Aubergines farcies Al Dayaa 3kg",
    "price": 16.75,
    "purchasePrice": 15.876777,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1104",
    "barcode": "1104",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1109",
    "name": "skitle",
    "price": 0.75,
    "purchasePrice": 0.625,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1109",
    "barcode": "1109",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1122",
    "name": "Baklava douyhe 500g.",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": -3,
    "category": "Patisseries",
    "sku": "SKU-1122",
    "barcode": "1122",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1123",
    "name": "Coriandre moulue Sofram 500gr",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": -5,
    "category": "Épices",
    "sku": "SKU-1123",
    "barcode": "1123",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1124",
    "name": "Epices kebbeh Adida 500g.",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": -2,
    "category": "Épices",
    "sku": "SKU-1124",
    "barcode": "1124",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1125",
    "name": "poulet 5kg",
    "price": 42.5,
    "purchasePrice": 40.28436,
    "stock": -1123,
    "category": "Accueil",
    "sku": "SKU-1125",
    "barcode": "1125",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1127",
    "name": "Hommus kash 1kg",
    "price": 5.54,
    "purchasePrice": 5.251185,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1127",
    "barcode": "1127",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1128",
    "name": "Riz Basmati Iranien 1kg",
    "price": 3.17,
    "purchasePrice": 3.004739,
    "stock": -25,
    "category": "Accueil",
    "sku": "SKU-1128",
    "barcode": "1128",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1130",
    "name": "Epices pour yaougrt ou concombre pour tzatziki ou mast o khyar 250gr",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": -7,
    "category": "Épices",
    "sku": "SKU-1130",
    "barcode": "1130",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1132",
    "name": "Eau de fleurs Samra",
    "price": 1.64,
    "purchasePrice": 1.554502,
    "stock": -12,
    "category": "Concentrés",
    "sku": "SKU-1132",
    "barcode": "1132",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1139",
    "name": "mchallaleh lailand 900gr.",
    "price": 13.5,
    "purchasePrice": 12.796209,
    "stock": 0,
    "category": "Fromages libanais",
    "sku": "SKU-1139",
    "barcode": "1139",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1140",
    "name": "Maamoul Gardenia 300g.",
    "price": 12,
    "purchasePrice": 11.374408,
    "stock": -1,
    "category": "Gâteaux - Biscuits orientaux",
    "sku": "SKU-1140",
    "barcode": "1140",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1141",
    "name": "Labneh Rona 2.75kg",
    "price": 18.5,
    "purchasePrice": 17.535545,
    "stock": -89,
    "category": "Yaourt et Labneh",
    "sku": "SKU-1141",
    "barcode": "1141",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1142",
    "name": "Savon D'Alep coffret bois",
    "price": 30.71,
    "purchasePrice": 25.592417,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1142",
    "barcode": "1142",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1143",
    "name": "O'regal pignon 1kg",
    "price": 36.4,
    "purchasePrice": 34.5,
    "stock": 0,
    "category": "Légumineuses et grains",
    "sku": "SKU-1143",
    "barcode": "1143",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1144",
    "name": "Taanayel, AKAWI 0.5",
    "price": 64.88,
    "purchasePrice": 61.49763,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1144",
    "barcode": "1144",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1146",
    "name": "Bourghol blanc beytouti",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Légumineuses et grains",
    "sku": "SKU-1146",
    "barcode": "1146",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1147",
    "name": "Curry Espig 250gr.",
    "price": 2.24,
    "purchasePrice": 2.123223,
    "stock": -5,
    "category": "Épices",
    "sku": "SKU-1147",
    "barcode": "1147",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1156",
    "name": "Top Jus carton",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -20,
    "category": "Jus - Sirops",
    "sku": "SKU-1156",
    "barcode": "1156",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1161",
    "name": "Tasse libanaise Traditionel (shaffe)",
    "price": 0.75,
    "purchasePrice": 0.625,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1161",
    "barcode": "1161",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1163",
    "name": "jus Limonade menthe Junet 250ml",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-1163",
    "barcode": "1163",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1164",
    "name": "Arak Galon 3 litre",
    "price": 48,
    "purchasePrice": 40,
    "stock": 2,
    "category": "Boissons",
    "sku": "SKU-1164",
    "barcode": "1164",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1184",
    "name": "Cardamome Adida 240 gr",
    "price": 13.67,
    "purchasePrice": 12.957346,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-1184",
    "barcode": "1184",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1185",
    "name": "Baklava mix Douaihy Au kg",
    "price": 20,
    "purchasePrice": 18.957346,
    "stock": 987,
    "category": "Baklava",
    "sku": "SKU-1185",
    "barcode": "1185",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 20
  },
  {
    "id": "csv-1186",
    "name": "BOURMA Douaihy Mix au kg",
    "price": 24,
    "purchasePrice": 22.748815,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1186",
    "barcode": "1186",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 24
  },
  {
    "id": "csv-1187",
    "name": "Bourma douahy pistache au kg",
    "price": 27,
    "purchasePrice": 25.592417,
    "stock": -3,
    "category": "Patisserie Douaihy",
    "sku": "SKU-1187",
    "barcode": "1187",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 27
  },
  {
    "id": "csv-1188",
    "name": "Olive Grec cassé au kg",
    "price": 0,
    "purchasePrice": 0,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1188",
    "barcode": "1188",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0
  },
  {
    "id": "csv-1189",
    "name": "Olive Vert Libanais au kg",
    "price": 0,
    "purchasePrice": 0,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1189",
    "barcode": "1189",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0
  },
  {
    "id": "csv-1190",
    "name": "Olive noir Libanais au kg",
    "price": 0,
    "purchasePrice": 0,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1190",
    "barcode": "1190",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0
  },
  {
    "id": "csv-1191",
    "name": "Olive vert dénoyauté pimenté au kg",
    "price": 0,
    "purchasePrice": 0,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1191",
    "barcode": "1191",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0
  },
  {
    "id": "csv-1199",
    "name": "fromage grille",
    "price": 2.95,
    "purchasePrice": 2.796209,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1199",
    "barcode": "1199",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1200",
    "name": "haricots giants",
    "price": 2.65,
    "purchasePrice": 2.511848,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1200",
    "barcode": "1200",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1201",
    "name": "UGO",
    "price": 0.75,
    "purchasePrice": 0.7109,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1201",
    "barcode": "1201",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1205",
    "name": "Fromage bulgarie 200gr.",
    "price": 2.95,
    "purchasePrice": 2.796209,
    "stock": -12,
    "category": "Accueil",
    "sku": "SKU-1205",
    "barcode": "1205",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1212",
    "name": "derby chips 18",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -76,
    "category": "Accueil",
    "sku": "SKU-1212",
    "barcode": "1212",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1214",
    "name": "navet mechaalani",
    "price": 12,
    "purchasePrice": 11.374408,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-1214",
    "barcode": "1214",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1218",
    "name": "Pistaches moulues 250gr",
    "price": 8.5,
    "purchasePrice": 8.056872,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-1218",
    "barcode": "1218",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1220",
    "name": "Noix de cajou au kg 14.5",
    "price": 15,
    "purchasePrice": 14.218009,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1220",
    "barcode": "1220",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 15
  },
  {
    "id": "csv-1221",
    "name": "Pistache grillé salé au kg (grec)",
    "price": 21.9,
    "purchasePrice": 20.758294,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1221",
    "barcode": "1221",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 21.9
  },
  {
    "id": "csv-1224",
    "name": "Akawi tchikiye Boustani 390 gr",
    "price": 5.25,
    "purchasePrice": 4.976303,
    "stock": 0,
    "category": "Produits laitiers",
    "sku": "SKU-1224",
    "barcode": "1224",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1229",
    "name": "Ras el hanout 500gr.",
    "price": 4.96,
    "purchasePrice": 4.7,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1229",
    "barcode": "1229",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1231",
    "name": "Mshallal Golden Plate 225g.",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -11,
    "category": "Produits",
    "sku": "SKU-1231",
    "barcode": "1231",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1233",
    "name": "Concombre au vinaigre Mechelany 430g. net",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": -89,
    "category": "Légumes Marinés",
    "sku": "SKU-1233",
    "barcode": "1233",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1237",
    "name": "Pignon Long 200g.",
    "price": 10,
    "purchasePrice": 9.478673,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-1237",
    "barcode": "1237",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1239",
    "name": "barazek douaihy 150gr.",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1239",
    "barcode": "1239",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1241",
    "name": "Lahm bi Ajin",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-1241",
    "barcode": "1241",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1243",
    "name": "Baklava Restaurant",
    "price": 16.35,
    "purchasePrice": 15.49763,
    "stock": 13,
    "category": "Accueil",
    "sku": "SKU-1243",
    "barcode": "1243",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1248",
    "name": "Huile de tournesol Maurel 10L",
    "price": 29.3,
    "purchasePrice": 27.772512,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-1248",
    "barcode": "1248",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1249",
    "name": "Poudre de Falafel Durra 8kg",
    "price": 54,
    "purchasePrice": 51.184834,
    "stock": 2,
    "category": "Produits",
    "sku": "SKU-1249",
    "barcode": "1249",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1250",
    "name": "Mouhallabiye",
    "price": 5,
    "purchasePrice": 4.739336,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-1250",
    "barcode": "1250",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1251",
    "name": "Halva pistache bsat 450g",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Halawa",
    "sku": "SKU-1251",
    "barcode": "1251",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1252",
    "name": "Foul mdamas California Garden 400gr",
    "price": 1.49,
    "purchasePrice": 1.412322,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1252",
    "barcode": "1252",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1253",
    "name": "Baklava cajou vrac 3.5 kg",
    "price": 16.35,
    "purchasePrice": 15.49763,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1253",
    "barcode": "1253",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 16.35
  },
  {
    "id": "csv-1254",
    "name": "Baklava vrac rest. cajou 3.5kg",
    "price": 57.23,
    "purchasePrice": 54.246445,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1254",
    "barcode": "1254",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 57.23
  },
  {
    "id": "csv-1255",
    "name": "baklava bokaj rest. Cajou 3kg",
    "price": 49.06,
    "purchasePrice": 46.50237,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-1255",
    "barcode": "1255",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1257",
    "name": "Bourma rest Cajou 5kg",
    "price": 84.4,
    "purchasePrice": 80,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1257",
    "barcode": "1257",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1258",
    "name": "Chwing gum",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1258",
    "barcode": "1258",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1260",
    "name": "Makdous",
    "price": 10,
    "purchasePrice": 9.478673,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1260",
    "barcode": "1260",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1261",
    "name": "halva nature Bissat 400gr.",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1261",
    "barcode": "1261",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1266",
    "name": "Concombre au Vinaigre en Tranches - Al Dayaa 500g",
    "price": 2,
    "purchasePrice": 1.9,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-1266",
    "barcode": "1266",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1267",
    "name": "baklava restaurant",
    "price": 7.91,
    "purchasePrice": 7.49763,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1267",
    "barcode": "1267",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1288",
    "name": "BASTERMA TUTUNJIAN 250gr.",
    "price": 15,
    "purchasePrice": 14.218009,
    "stock": 0,
    "category": "Viandes - Poissons",
    "sku": "SKU-1288",
    "barcode": "1288",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1290",
    "name": "Lavita box 24",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1290",
    "barcode": "1290",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1294",
    "name": "Maamoul Bawabet dimashq",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": 0,
    "category": "Patisseries",
    "sku": "SKU-1294",
    "barcode": "1294",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1295",
    "name": "Foie Gras de Canard Entier ID HALAL 180g.",
    "price": 23.95,
    "purchasePrice": 22.701422,
    "stock": 0,
    "category": "Viandes - Poissons",
    "sku": "SKU-1295",
    "barcode": "1295",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1296",
    "name": "Paprika 500g Adida",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -11,
    "category": "Accueil",
    "sku": "SKU-1296",
    "barcode": "1296",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1298",
    "name": "Feuille de vigne Al wadi 400gr.",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1298",
    "barcode": "1298",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1299",
    "name": "Baklava Pistache restaurent vrac 3.5 kg",
    "price": 79.39,
    "purchasePrice": 75.251185,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1299",
    "barcode": "1299",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 79.39
  },
  {
    "id": "csv-1300",
    "name": "Arak",
    "price": 20.4,
    "purchasePrice": 17,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1300",
    "barcode": "1300",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1301",
    "name": "Harrissa 5kg",
    "price": 20.84,
    "purchasePrice": 19.753555,
    "stock": -22,
    "category": "Accueil",
    "sku": "SKU-1301",
    "barcode": "1301",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1304",
    "name": "Feta en Saumure  200g. DODONI",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -1,
    "category": "Fromages libanais",
    "sku": "SKU-1304",
    "barcode": "1304",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1310",
    "name": "Cerneaux de noix Extra 1/4  - origine Chili - 1 kg",
    "price": 14.99,
    "purchasePrice": 14.208531,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1310",
    "barcode": "1310",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 14.99
  },
  {
    "id": "csv-1312",
    "name": "Pistache D'iran 200gr.",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1312",
    "barcode": "1312",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1315",
    "name": "Kashkaval Brebris 350 gr.",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1315",
    "barcode": "1315",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1316",
    "name": "Kashkaval Brebris 350 gr.",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-1316",
    "barcode": "1316",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1317",
    "name": "Yalya ayran 1L",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": -92,
    "category": "Accueil",
    "sku": "SKU-1317",
    "barcode": "1317",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1323",
    "name": "Foul (feve cuite) Mdamas Nature Samaya 400gr.",
    "price": 0.85,
    "purchasePrice": 0.805687,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1323",
    "barcode": "1323",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1326",
    "name": "Sumac Naturel",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-1326",
    "barcode": "1326",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1327",
    "name": "Mélange d'épices mandi - Abido 50gr",
    "price": 1.6,
    "purchasePrice": 1.516588,
    "stock": 6,
    "category": "Épices",
    "sku": "SKU-1327",
    "barcode": "1327",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1328",
    "name": "Tahini bissate 450g",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Tahini",
    "sku": "SKU-1328",
    "barcode": "1328",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1330",
    "name": "Raisin Sec Noir Jumbo Oral",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": -6,
    "category": "Fruits secs",
    "sku": "SKU-1330",
    "barcode": "1330",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1332",
    "name": "Pistaches moulues - O'Régal 250g",
    "price": 8.5,
    "purchasePrice": 8.056872,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-1332",
    "barcode": "1332",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1335",
    "name": "Bicarbonate Aruba 500gr.",
    "price": 1.75,
    "purchasePrice": 1.458333,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-1335",
    "barcode": "1335",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1345",
    "name": "Molokhia ou Mloukhiya Cortas Cuite 800g.",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1345",
    "barcode": "1345",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1350",
    "name": "Concombre Mariné Mechaalany 400g.",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": -21,
    "category": "Accueil",
    "sku": "SKU-1350",
    "barcode": "1350",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1352",
    "name": "Zaatar Akhdar Al ousra 400gr.",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": -20,
    "category": "Accueil",
    "sku": "SKU-1352",
    "barcode": "1352",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1353",
    "name": "Molokhia ou mloukhiya Durra 400gr.",
    "price": 6.25,
    "purchasePrice": 5.924171,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1353",
    "barcode": "1353",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1354",
    "name": "Molokhia séché Kheir w baraka 200gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1354",
    "barcode": "1354",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1356",
    "name": "Semoule Extra fin ( ferkha) 1kg",
    "price": 1.49,
    "purchasePrice": 1.412322,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1356",
    "barcode": "1356",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1357",
    "name": "Semoule Moyen Tosca 1kg",
    "price": 1.49,
    "purchasePrice": 1.412322,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1357",
    "barcode": "1357",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1358",
    "name": "Semoule Gros Zine 800g.",
    "price": 1.55,
    "purchasePrice": 1.469194,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1358",
    "barcode": "1358",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1359",
    "name": "Boulghour Fin Brun AS 900gr.",
    "price": 1.79,
    "purchasePrice": 1.696682,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1359",
    "barcode": "1359",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1364",
    "name": "Lait en poudre Nido 2.5KG",
    "price": 34.9,
    "purchasePrice": 33.080569,
    "stock": 0,
    "category": "Lait et Crème",
    "sku": "SKU-1364",
    "barcode": "1364",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1368",
    "name": "Feuille de vigne onassis",
    "price": 2.65,
    "purchasePrice": 2.511848,
    "stock": -1,
    "category": "Légumes Marinés",
    "sku": "SKU-1368",
    "barcode": "1368",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1369",
    "name": "Maamoul douaihy 70g.",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Patisseries Douaihy",
    "sku": "SKU-1369",
    "barcode": "1369",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1373",
    "name": "Sirop de fraise Anjar 600mL",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1373",
    "barcode": "1373",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1374",
    "name": "Oate d'abricot Anti gaspillage",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-1374",
    "barcode": "1374",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1375",
    "name": "Makdouss 2800 gr. Durra",
    "price": 21.9,
    "purchasePrice": 20.758294,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1375",
    "barcode": "1375",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1378",
    "name": "Aruba mandarine",
    "price": 0.4,
    "purchasePrice": 0.379147,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1378",
    "barcode": "1378",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1396",
    "name": "Hibiscus 30gr. Abido",
    "price": 0.75,
    "purchasePrice": 0.7109,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1396",
    "barcode": "1396",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1398",
    "name": "Falafel Gardenia 200gr.",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-1398",
    "barcode": "1398",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1400",
    "name": "Fruit sec Kazzi 300 gr Spécial mixed Nuts",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-1400",
    "barcode": "1400",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1407",
    "name": "Sucre Cristal saint Louis 1Kg",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-1407",
    "barcode": "1407",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1408",
    "name": "Alfakher",
    "price": 6.99,
    "purchasePrice": 6.625592,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-1408",
    "barcode": "1408",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1416",
    "name": "Amande effilé 500gr. Oregale",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": -7,
    "category": "Fruits secs",
    "sku": "SKU-1416",
    "barcode": "1416",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1417",
    "name": "Pépite de grain de tournessol Samire 300gr.",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-1417",
    "barcode": "1417",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1423",
    "name": "Shampoin d'Alep Au huile d'olive et de Laurier 400mL",
    "price": 4.9,
    "purchasePrice": 4.64455,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-1423",
    "barcode": "1423",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1425",
    "name": "Labneh Al Raï 500gr.",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -14,
    "category": "Produits laitiers",
    "sku": "SKU-1425",
    "barcode": "1425",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1426",
    "name": "Labneh Al RAï 1kg",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": -62,
    "category": "Yaourt et Labneh",
    "sku": "SKU-1426",
    "barcode": "1426",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1427",
    "name": "Yaourt Grec LYNOS 500gr.",
    "price": 2.85,
    "purchasePrice": 2.701422,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1427",
    "barcode": "1427",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1433",
    "name": "Graines de pastèque jaune au kg",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Chips et apéritifs",
    "sku": "SKU-1433",
    "barcode": "1433",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 7.5
  },
  {
    "id": "csv-1434",
    "name": "Mastic meské Mahmoud Chaalawi 100x2pc",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": -25,
    "category": "Friandises",
    "sku": "SKU-1434",
    "barcode": "1434",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1435",
    "name": "Mastic Chewing Gum Naturel Mahmoud Chaalawi 100x2pc",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1435",
    "barcode": "1435",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1437",
    "name": "Mechallale Fromage Alhalabi 900gr.",
    "price": 13.75,
    "purchasePrice": 13.033175,
    "stock": -11,
    "category": "Fromages libanais",
    "sku": "SKU-1437",
    "barcode": "1437",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1438",
    "name": "Eau de fleur Anjar 600ml",
    "price": 2.8,
    "purchasePrice": 2.654028,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1438",
    "barcode": "1438",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1439",
    "name": "Curcuma 500gr. Espeg",
    "price": 5.04,
    "purchasePrice": 4.78,
    "stock": -16,
    "category": "Épices",
    "sku": "SKU-1439",
    "barcode": "1439",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1440",
    "name": "Bokaj Pistache 1kg. Douaihy",
    "price": 28.68,
    "purchasePrice": 27.184834,
    "stock": -45,
    "category": "Accueil",
    "sku": "SKU-1440",
    "barcode": "1440",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1441",
    "name": "Namoura 5Kg. Douaihy rest.",
    "price": 52.75,
    "purchasePrice": 50,
    "stock": 0,
    "category": "Patisseries Douaihy",
    "sku": "SKU-1441",
    "barcode": "1441",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1442",
    "name": "Riz égyptien moyen rond Samaya",
    "price": 10,
    "purchasePrice": 9.478673,
    "stock": 9,
    "category": "Accueil",
    "sku": "SKU-1442",
    "barcode": "1442",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1443",
    "name": "Epice Kabse 500gr. Abido",
    "price": 8.75,
    "purchasePrice": 8.293839,
    "stock": 8,
    "category": "Épices",
    "sku": "SKU-1443",
    "barcode": "1443",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1446",
    "name": "Date bar 24x19 Zine Alsham",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-1446",
    "barcode": "1446",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1450",
    "name": "Loukoum today Mastic",
    "price": 2.45,
    "purchasePrice": 2.322275,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1450",
    "barcode": "1450",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1451",
    "name": "Rubby Noisette",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -8,
    "category": "Fruits secs",
    "sku": "SKU-1451",
    "barcode": "1451",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1452",
    "name": "Delitik milk lait",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -3,
    "category": "Lait et Crème",
    "sku": "SKU-1452",
    "barcode": "1452",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1453",
    "name": "Delikit Chocolat",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1453",
    "barcode": "1453",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1455",
    "name": "Basmati XXL Sella Kaalar 5kg",
    "price": 13.99,
    "purchasePrice": 13.260664,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1455",
    "barcode": "1455",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1458",
    "name": "Dingo chocolat 1 pièce",
    "price": 0.25,
    "purchasePrice": 0.236967,
    "stock": 24,
    "category": "Accueil",
    "sku": "SKU-1458",
    "barcode": "1458",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1459",
    "name": "Vimto Canette 33cL",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -11,
    "category": "Boissons",
    "sku": "SKU-1459",
    "barcode": "1459",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-1460",
    "name": "ketchup Rosen",
    "price": 0.75,
    "purchasePrice": 0.7109,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1460",
    "barcode": "1460",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1463",
    "name": "Fakher Croissant chocolat x5",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Patisseries",
    "sku": "SKU-1463",
    "barcode": "1463",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1464",
    "name": "Jellab Chtoura 600 ml",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Boissons",
    "sku": "SKU-1464",
    "barcode": "1464",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1465",
    "name": "Jellab Chtoura 3150 gr",
    "price": 10.55,
    "purchasePrice": 10,
    "stock": 7,
    "category": "Jus - Sirops",
    "sku": "SKU-1465",
    "barcode": "1465",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1467",
    "name": "Iced coffe Luna",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 29,
    "category": "Accueil",
    "sku": "SKU-1467",
    "barcode": "1467",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1474",
    "name": "Bourghol Fark Blanc fin 1kg",
    "price": 1.89,
    "purchasePrice": 1.791469,
    "stock": -15,
    "category": "Boulghour",
    "sku": "SKU-1474",
    "barcode": "1474",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1475",
    "name": "Boulghor gros brun Duru 1kg",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": -3,
    "category": "Légumineuses et grains",
    "sku": "SKU-1475",
    "barcode": "1475",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1481",
    "name": "Huile de tournesol Maurel 1L",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Huiles et vinaigres",
    "sku": "SKU-1481",
    "barcode": "1481",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1494",
    "name": "Baklava Al Sultane 750gr.",
    "price": 29.9,
    "purchasePrice": 28.341232,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1494",
    "barcode": "1494",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1495",
    "name": "Colorant alimentaire Idéal",
    "price": 2.4,
    "purchasePrice": 2.274882,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1495",
    "barcode": "1495",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1496",
    "name": "Sahlab 200gr. Cortas",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1496",
    "barcode": "1496",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1499",
    "name": "Pistaches d'Iran décortiquées 500gr.",
    "price": 14.95,
    "purchasePrice": 14.170616,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-1499",
    "barcode": "1499",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1501",
    "name": "Kebbe grillé congelé  6 pièces Le bon gout",
    "price": 14.99,
    "purchasePrice": 14.208531,
    "stock": 0,
    "category": "Viandes - Poissons",
    "sku": "SKU-1501",
    "barcode": "1501",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1502",
    "name": "Kebbé frit Congelé 10 pièces le bon gout",
    "price": 10.99,
    "purchasePrice": 10.417062,
    "stock": 0,
    "category": "Viandes - Poissons",
    "sku": "SKU-1502",
    "barcode": "1502",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1503",
    "name": "Rouleau fromage 10 pièces conglé fromage",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -2,
    "category": "Produits",
    "sku": "SKU-1503",
    "barcode": "1503",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1504",
    "name": "Kebbé Labaniye congelé 10 pièces",
    "price": 9.49,
    "purchasePrice": 8.995261,
    "stock": 0,
    "category": "Produits laitiers",
    "sku": "SKU-1504",
    "barcode": "1504",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1505",
    "name": "Citron séché ou Loumi Noir 150g. NAZ",
    "price": 2.65,
    "purchasePrice": 2.511848,
    "stock": 18,
    "category": "Fruits secs",
    "sku": "SKU-1505",
    "barcode": "1505",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1506",
    "name": "Citron séché ou loumi jaune 150gr.",
    "price": 2.65,
    "purchasePrice": 2.511848,
    "stock": 11,
    "category": "Fruits secs",
    "sku": "SKU-1506",
    "barcode": "1506",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1507",
    "name": "Fèves pelées congelées 400 gr. Basma",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": -26,
    "category": "Accueil",
    "sku": "SKU-1507",
    "barcode": "1507",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1508",
    "name": "Feuille de Vigne farcie - Chtoura Garden 2 kg",
    "price": 8.99,
    "purchasePrice": 8.521327,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1508",
    "barcode": "1508",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 8.99
  },
  {
    "id": "csv-1514",
    "name": "Feuilles de vigne Paliria à farcir 300gr.",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 0,
    "category": "Légumineuses",
    "sku": "SKU-1514",
    "barcode": "1514",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1516",
    "name": "Kaak au thym zaatar 250gr.",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -3,
    "category": "pain et Kaak",
    "sku": "SKU-1516",
    "barcode": "1516",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1517",
    "name": "Kaak termsiyeh petit Wooden Bakery 320gr",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "pain et Kaak",
    "sku": "SKU-1517",
    "barcode": "1517",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1518",
    "name": "Kaak Chamiyeh 400gr. Wooden Bakery",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "pain et Kaak",
    "sku": "SKU-1518",
    "barcode": "1518",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1525",
    "name": "Yaourt le petit grec 1kg",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Yaourt et Labneh",
    "sku": "SKU-1525",
    "barcode": "1525",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1531",
    "name": "Combi tendre 500gr.",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 21,
    "category": "Accueil",
    "sku": "SKU-1531",
    "barcode": "1531",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1533",
    "name": "Pistache Grillé salé",
    "price": 15.9,
    "purchasePrice": 15.07109,
    "stock": -3,
    "category": "Chips et apéritifs",
    "sku": "SKU-1533",
    "barcode": "1533",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1534",
    "name": "Huile",
    "price": 10.5,
    "purchasePrice": 9.952607,
    "stock": 0,
    "category": "Huiles et vinaigres",
    "sku": "SKU-1534",
    "barcode": "1534",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1535",
    "name": "Fruit à coque au kg 16.90",
    "price": 0,
    "purchasePrice": 0,
    "stock": 92,
    "category": "Accueil",
    "sku": "SKU-1535",
    "barcode": "1535",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0
  },
  {
    "id": "csv-1536",
    "name": "Kaak à la datte",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -4,
    "category": "pain et Kaak",
    "sku": "SKU-1536",
    "barcode": "1536",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1538",
    "name": "Sukkari Wassim 500 gr",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-1538",
    "barcode": "1538",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1541",
    "name": "Thym Sofram 500g.",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Zaatar",
    "sku": "SKU-1541",
    "barcode": "1541",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1542",
    "name": "Coriandre entier 250gr. vrac",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -4,
    "category": "Épices",
    "sku": "SKU-1542",
    "barcode": "1542",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 3.5
  },
  {
    "id": "csv-1543",
    "name": "Akawi Boustani  env 400gr",
    "price": 0,
    "purchasePrice": 0,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-1543",
    "barcode": "1543",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1544",
    "name": "Akawi Boustani  env 400gr",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": -55,
    "category": "Fromages libanais",
    "sku": "SKU-1544",
    "barcode": "1544",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1556",
    "name": "sofram fromage combi 800gr.",
    "price": 7,
    "purchasePrice": 6.635071,
    "stock": -2,
    "category": "Fromages libanais",
    "sku": "SKU-1556",
    "barcode": "1556",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1567",
    "name": "Petites Pepites Degypte 500 gr",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-1567",
    "barcode": "1567",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1568",
    "name": "Riz Rond Italie 5 kg",
    "price": 10,
    "purchasePrice": 9.478673,
    "stock": 0,
    "category": "Riz et vermicelles",
    "sku": "SKU-1568",
    "barcode": "1568",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 10
  },
  {
    "id": "csv-1569",
    "name": "Riz Basmati Tilda 5 kg",
    "price": 18.5,
    "purchasePrice": 17.535545,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1569",
    "barcode": "1569",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 18.5
  },
  {
    "id": "csv-1572",
    "name": "Houmous Chtoura sachet 1kg",
    "price": 4.48,
    "purchasePrice": 4.246445,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1572",
    "barcode": "1572",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1584",
    "name": "Huile d'olive Extra Loukakos 5 L",
    "price": 37.5,
    "purchasePrice": 35.545024,
    "stock": 0,
    "category": "Huiles et vinaigres",
    "sku": "SKU-1584",
    "barcode": "1584",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1589",
    "name": "Ail en poudre 500gr.",
    "price": 8.02,
    "purchasePrice": 7.6,
    "stock": -25,
    "category": "Accueil",
    "sku": "SKU-1589",
    "barcode": "1589",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1590",
    "name": "Arack Ajawari 1.5L",
    "price": 43.5,
    "purchasePrice": 36.25,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-1590",
    "barcode": "1590",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1591",
    "name": "Gombo Baby Okra Al Wadi",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Produits congelés",
    "sku": "SKU-1591",
    "barcode": "1591",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1594",
    "name": "Sept épice tanourine 1kg",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-1594",
    "barcode": "1594",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1595",
    "name": "Eau de rose Samra 50cL",
    "price": 1.15,
    "purchasePrice": 1.090047,
    "stock": -2,
    "category": "Boissons",
    "sku": "SKU-1595",
    "barcode": "1595",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1596",
    "name": "Riz khorshid",
    "price": 3.43,
    "purchasePrice": 3.251185,
    "stock": -40,
    "category": "Accueil",
    "sku": "SKU-1596",
    "barcode": "1596",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1599",
    "name": "Ail pelé frais 100 gr",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": 2,
    "category": "Épices",
    "sku": "SKU-1599",
    "barcode": "1599",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1601",
    "name": "levure fraîche l'hirondelle",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1601",
    "barcode": "1601",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1603",
    "name": "Persil botte",
    "price": 0.79,
    "purchasePrice": 0.748815,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1603",
    "barcode": "1603",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1604",
    "name": "methe botte",
    "price": 0.58,
    "purchasePrice": 0.549763,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1604",
    "barcode": "1604",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1605",
    "name": "P. Soleil Familiale",
    "price": 1.15,
    "purchasePrice": 1.090047,
    "stock": 1330,
    "category": "Accueil",
    "sku": "SKU-1605",
    "barcode": "1605",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1608",
    "name": "Bouillon De Poulet Jumbo",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-1608",
    "barcode": "1608",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1609",
    "name": "Bouillon De Poulet Ideal",
    "price": 6.25,
    "purchasePrice": 5.924171,
    "stock": -8,
    "category": "Accueil",
    "sku": "SKU-1609",
    "barcode": "1609",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1610",
    "name": "Dirbie",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -39,
    "category": "Accueil",
    "sku": "SKU-1610",
    "barcode": "1610",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1614",
    "name": "Ail",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1614",
    "barcode": "1614",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1647",
    "name": "Concombre entier Hikayat 9kg",
    "price": 20.84,
    "purchasePrice": 19.753555,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-1647",
    "barcode": "1647",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1661",
    "name": "Creme liquide 1L",
    "price": 4.2,
    "purchasePrice": 3.981043,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1661",
    "barcode": "1661",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1671",
    "name": "Arak Al jawari 1.5L",
    "price": 24.49,
    "purchasePrice": 20.408333,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-1671",
    "barcode": "1671",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1676",
    "name": "Ail pelé frais 1kg",
    "price": 7.95,
    "purchasePrice": 7.535545,
    "stock": -426,
    "category": "Accueil",
    "sku": "SKU-1676",
    "barcode": "1676",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1677",
    "name": "Labneh Le verger du Liban",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1677",
    "barcode": "1677",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1678",
    "name": "labneh en boule nature",
    "price": 7.85,
    "purchasePrice": 7.440758,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-1678",
    "barcode": "1678",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1682",
    "name": "Labneh kolios cream cheese",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -64,
    "category": "Accueil",
    "sku": "SKU-1682",
    "barcode": "1682",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1691",
    "name": "fruits secs grillés goût barbecue - Al Kazzi 220 gr",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-1691",
    "barcode": "1691",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1694",
    "name": "Pépites Al Fakr",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-1694",
    "barcode": "1694",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.99
  },
  {
    "id": "csv-1695",
    "name": "Thon à l'huile 185 gr",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -33,
    "category": "Accueil",
    "sku": "SKU-1695",
    "barcode": "1695",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1700",
    "name": "Baklava pistache 1.5kg",
    "price": 34,
    "purchasePrice": 32.227488,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1700",
    "barcode": "1700",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1701",
    "name": "Gingembre Moulu 500gr. Spico",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-1701",
    "barcode": "1701",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1721",
    "name": "Pistache grec décortiqué 1kg",
    "price": 37,
    "purchasePrice": 35.07109,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-1721",
    "barcode": "1721",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1734",
    "name": "Viande au kilo halal 11 euros/kg",
    "price": 11,
    "purchasePrice": 10.42654,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-1734",
    "barcode": "1734",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1736",
    "name": "Acide citrique Abido 1kg",
    "price": 5.46,
    "purchasePrice": 4.55,
    "stock": -13,
    "category": "Accueil",
    "sku": "SKU-1736",
    "barcode": "1736",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1737",
    "name": "Huile d'olive d'Espagne Segura 5 L",
    "price": 43,
    "purchasePrice": 40.758294,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-1737",
    "barcode": "1737",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1738",
    "name": "Boites Plastique 500gr.",
    "price": 14.4,
    "purchasePrice": 12,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-1738",
    "barcode": "1738",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1739",
    "name": "boite ovale bourma",
    "price": 7.8,
    "purchasePrice": 6.5,
    "stock": -37,
    "category": "Accueil",
    "sku": "SKU-1739",
    "barcode": "1739",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1740",
    "name": "Lentille 5kg",
    "price": 14.86,
    "purchasePrice": 14.085308,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-1740",
    "barcode": "1740",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1768",
    "name": "boulghour 900gr AS",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-1768",
    "barcode": "1768",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1769",
    "name": "Halva kanater 2.5 kilos",
    "price": 42,
    "purchasePrice": 35,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1769",
    "barcode": "1769",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1770",
    "name": "Pistache caramelisé Ghrawi 70gr",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1770",
    "barcode": "1770",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1771",
    "name": "Baklava pistache rest. 1.5kg",
    "price": 39.5,
    "purchasePrice": 37.440758,
    "stock": -42,
    "category": "Accueil",
    "sku": "SKU-1771",
    "barcode": "1771",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1772",
    "name": "Junet carton 21 pyramides",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1772",
    "barcode": "1772",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1775",
    "name": "Carton Junet mangue 21 pyramides",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1775",
    "barcode": "1775",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1776",
    "name": "Gigot d'Agneau Halal au kg",
    "price": 18.5,
    "purchasePrice": 17.535545,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1776",
    "barcode": "1776",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 18.5
  },
  {
    "id": "csv-1777",
    "name": "AL KAZZI mélange de noix 250 gr",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-1777",
    "barcode": "1777",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1778",
    "name": "Cuisse de Poulet Halal 10 kg",
    "price": 28.43,
    "purchasePrice": 26.947867,
    "stock": -20,
    "category": "Accueil",
    "sku": "SKU-1778",
    "barcode": "1778",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 28.43
  },
  {
    "id": "csv-1779",
    "name": "Etiqueteuse et rouleau",
    "price": 25,
    "purchasePrice": 20.833333,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1779",
    "barcode": "1779",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1780",
    "name": "Tahini arkan 3kg",
    "price": 22.5,
    "purchasePrice": 21.327014,
    "stock": 0,
    "category": "Tahini",
    "sku": "SKU-1780",
    "barcode": "1780",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1781",
    "name": "Baklava Cajou 18ht€/kg rest",
    "price": 18,
    "purchasePrice": 17.061611,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1781",
    "barcode": "1781",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1786",
    "name": "Houmous Restaurant 7.5 kg",
    "price": 39.56,
    "purchasePrice": 37.49763,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1786",
    "barcode": "1786",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 39.56
  },
  {
    "id": "csv-1788",
    "name": "Kol w chkor pistache restaurant 1.5 kg",
    "price": 35.61,
    "purchasePrice": 33.753555,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1788",
    "barcode": "1788",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 35.61
  },
  {
    "id": "csv-1791",
    "name": "Halloume  Rona",
    "price": 2.95,
    "purchasePrice": 2.796209,
    "stock": -76,
    "category": "Accueil",
    "sku": "SKU-1791",
    "barcode": "1791",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1792",
    "name": "kaak moulin d'or Vanille",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-1792",
    "barcode": "1792",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1793",
    "name": "Kaak anis moulin d'or",
    "price": 6.25,
    "purchasePrice": 5.924171,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1793",
    "barcode": "1793",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1794",
    "name": "Offre Aruba Custard",
    "price": 5,
    "purchasePrice": 4.739336,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1794",
    "barcode": "1794",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1799",
    "name": "Amande Frites 250 gr Grec",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1799",
    "barcode": "1799",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1800",
    "name": "Halloume Golden Plate 400gr.",
    "price": 5.22,
    "purchasePrice": 4.947867,
    "stock": -35,
    "category": "Accueil",
    "sku": "SKU-1800",
    "barcode": "1800",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1801",
    "name": "Labne Golden Plate 500gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -236,
    "category": "Accueil",
    "sku": "SKU-1801",
    "barcode": "1801",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1802",
    "name": "Labne 1kg Golden Plate",
    "price": 6.25,
    "purchasePrice": 5.924171,
    "stock": -55,
    "category": "Accueil",
    "sku": "SKU-1802",
    "barcode": "1802",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1803",
    "name": "dry okra algota 400gr",
    "price": 9.5,
    "purchasePrice": 9.004739,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-1803",
    "barcode": "1803",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1805",
    "name": "Gombo Okra au naturel - Chtoura Garden 840 gr.",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 9,
    "category": "Conserves",
    "sku": "SKU-1805",
    "barcode": "1805",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1806",
    "name": "fromage nabulsi golden plate",
    "price": 5.45,
    "purchasePrice": 5.165877,
    "stock": -24,
    "category": "Accueil",
    "sku": "SKU-1806",
    "barcode": "1806",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1807",
    "name": "Dingo Chocolat 24 pièces",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1807",
    "barcode": "1807",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1808",
    "name": "Concombre mariné 12 Kg Mechaalani",
    "price": 25,
    "purchasePrice": 23.696682,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-1808",
    "barcode": "1808",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 25
  },
  {
    "id": "csv-1812",
    "name": "Pistaches fraîches du Liban - 250 gr.",
    "price": 5,
    "purchasePrice": 4.739336,
    "stock": 2,
    "category": "Apéritifs et pain",
    "sku": "SKU-1812",
    "barcode": "1812",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1813",
    "name": "Epices shawarma viande Abido 500 gr",
    "price": 16.99,
    "purchasePrice": 16.104265,
    "stock": -56,
    "category": "Accueil",
    "sku": "SKU-1813",
    "barcode": "1813",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1820",
    "name": "Raisins secs noirs Jumbo  en vrac 500 gr",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-1820",
    "barcode": "1820",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 3.99
  },
  {
    "id": "csv-1821",
    "name": "Baklava pistache douaihy au kilo",
    "price": 27,
    "purchasePrice": 25.592417,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1821",
    "barcode": "1821",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1823",
    "name": "Filets de poulet label rouge halal",
    "price": 17.4,
    "purchasePrice": 16.492891,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1823",
    "barcode": "1823",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1824",
    "name": "Bonbons acidulés cola halal 90 g",
    "price": 1.25,
    "purchasePrice": 1.041667,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1824",
    "barcode": "1824",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1835",
    "name": "Farine de blé Fleur du JuraT.55 1kg",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": -546,
    "category": "Accueil",
    "sku": "SKU-1835",
    "barcode": "1835",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.99
  },
  {
    "id": "csv-1841",
    "name": "Nabulsi golden plate sous vide 460 g",
    "price": 4.85,
    "purchasePrice": 4.597156,
    "stock": -16,
    "category": "Accueil",
    "sku": "SKU-1841",
    "barcode": "1841",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1842",
    "name": "Blanc d'oeuf liquide 1L",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-1842",
    "barcode": "1842",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1843",
    "name": "Figues fraîches 1.8 kg",
    "price": 10.99,
    "purchasePrice": 10.417062,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1843",
    "barcode": "1843",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 10.99
  },
  {
    "id": "csv-1846",
    "name": "Tasse café",
    "price": 8,
    "purchasePrice": 6.666667,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-1846",
    "barcode": "1846",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1847",
    "name": "Arak galon Mijana 3 litres",
    "price": 75,
    "purchasePrice": 62.5,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-1847",
    "barcode": "1847",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1850",
    "name": "alarjawi",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-1850",
    "barcode": "1850",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1854",
    "name": "Bamiya Algota 200gr.",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-1854",
    "barcode": "1854",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1855",
    "name": "Pain Golden Village",
    "price": 0.85,
    "purchasePrice": 0.805687,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1855",
    "barcode": "1855",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1856",
    "name": "RAISIN MUSCAT BIO KG",
    "price": 4.95,
    "purchasePrice": 4.691943,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1856",
    "barcode": "1856",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 4.95
  },
  {
    "id": "csv-1857",
    "name": "POMMES ELSTAR BIO KG",
    "price": 1.85,
    "purchasePrice": 1.753555,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1857",
    "barcode": "1857",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1.85
  },
  {
    "id": "csv-1858",
    "name": "NOISETTES OREGAL 1 KG",
    "price": 15.46,
    "purchasePrice": 14.65,
    "stock": -26,
    "category": "Accueil",
    "sku": "SKU-1858",
    "barcode": "1858",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 15.46
  },
  {
    "id": "csv-1859",
    "name": "Phenicia Tahini 18kg",
    "price": 96,
    "purchasePrice": 90.995261,
    "stock": -28,
    "category": "Accueil",
    "sku": "SKU-1859",
    "barcode": "1859",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1863",
    "name": "Karalis feta 200gr.",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -18,
    "category": "Accueil",
    "sku": "SKU-1863",
    "barcode": "1863",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1864",
    "name": "kaak vanille 200gr",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-1864",
    "barcode": "1864",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1865",
    "name": "Vermicelles (cheveux d'ange) Val Fleuri 250 g",
    "price": 2.15,
    "purchasePrice": 2.037915,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1865",
    "barcode": "1865",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1868",
    "name": "Cruche Petit 500ml",
    "price": 7.5,
    "purchasePrice": 6.25,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1868",
    "barcode": "1868",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1869",
    "name": "Cruche grand 1000ml",
    "price": 12,
    "purchasePrice": 10,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-1869",
    "barcode": "1869",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1871",
    "name": "Cruche petit peinture 500ml",
    "price": 40,
    "purchasePrice": 33.333333,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-1871",
    "barcode": "1871",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1872",
    "name": "Cruche Grand peinture 1000ml",
    "price": 45,
    "purchasePrice": 37.5,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-1872",
    "barcode": "1872",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1879",
    "name": "Dattes d'Iran Rotab - Mazafati 550 gr",
    "price": 2.65,
    "purchasePrice": 2.511848,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-1879",
    "barcode": "1879",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1881",
    "name": "Pierre à Aiguiser",
    "price": 45,
    "purchasePrice": 37.5,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1881",
    "barcode": "1881",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1882",
    "name": "persil 20 bottes",
    "price": 17.33,
    "purchasePrice": 16.42654,
    "stock": -686,
    "category": "Accueil",
    "sku": "SKU-1882",
    "barcode": "1882",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1883",
    "name": "Tarama Cabillaut Rose 3.5 kg",
    "price": 43.9,
    "purchasePrice": 41.611374,
    "stock": -204,
    "category": "Produits",
    "sku": "SKU-1883",
    "barcode": "1883",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 43.9
  },
  {
    "id": "csv-1885",
    "name": "Kashkaval Golden plate 320 gr.",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -11,
    "category": "Accueil",
    "sku": "SKU-1885",
    "barcode": "1885",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1886",
    "name": "Fromage de chèvre 400 gr Golden Plate",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": -33,
    "category": "Accueil",
    "sku": "SKU-1886",
    "barcode": "1886",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1887",
    "name": "Cecile Golden Plate 400gr",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": -17,
    "category": "Accueil",
    "sku": "SKU-1887",
    "barcode": "1887",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1888",
    "name": "Confiture de figues entières - Al Asil 450gr.",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1888",
    "barcode": "1888",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1889",
    "name": "Huile d'olive Munoz",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-1889",
    "barcode": "1889",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1892",
    "name": "Jujube 500gr",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1892",
    "barcode": "1892",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1893",
    "name": "Huile de tournesol 900ml",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-1893",
    "barcode": "1893",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1895",
    "name": "Café Amer ou kahwa morra Hamwi 1L",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1895",
    "barcode": "1895",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1896",
    "name": "Pate à tartinet noisette MASTELLA 200gr",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1896",
    "barcode": "1896",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1897",
    "name": "Petit beure Dingo 400gr",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1897",
    "barcode": "1897",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1898",
    "name": "Maamoul au dates dingo 256gr.",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1898",
    "barcode": "1898",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1902",
    "name": "Charbon Al-Mani coconut 1Kg",
    "price": 4.75,
    "purchasePrice": 3.958333,
    "stock": -91,
    "category": "Accueil",
    "sku": "SKU-1902",
    "barcode": "1902",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1903",
    "name": "fromage puck 500gr.",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": -11,
    "category": "Accueil",
    "sku": "SKU-1903",
    "barcode": "1903",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1904",
    "name": "Charbon Naturel batonnet pour chicha 1Kg",
    "price": 3.99,
    "purchasePrice": 3.325,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-1904",
    "barcode": "1904",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1905",
    "name": "PUCK 910GR",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-1905",
    "barcode": "1905",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1908",
    "name": "Navet marine Durra 710gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-1908",
    "barcode": "1908",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1909",
    "name": "Navet mariné durra 2.75 kg",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1909",
    "barcode": "1909",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 6.5
  },
  {
    "id": "csv-1910",
    "name": "Houmous tahini Chtoura 2.1 kg",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1910",
    "barcode": "1910",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 4.5
  },
  {
    "id": "csv-1919",
    "name": "Purée de piment fort - Altunsa 650g",
    "price": 3.55,
    "purchasePrice": 3.364929,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1919",
    "barcode": "1919",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1920",
    "name": "Concentré de piment doux - Altunsa 650g",
    "price": 3.55,
    "purchasePrice": 3.364929,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1920",
    "barcode": "1920",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1931",
    "name": "Adida Acide Citrique 1kg",
    "price": 8.5,
    "purchasePrice": 7.083333,
    "stock": 24,
    "category": "Accueil",
    "sku": "SKU-1931",
    "barcode": "1931",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1933",
    "name": "Cardamone spico 500gr",
    "price": 34,
    "purchasePrice": 32.227488,
    "stock": -30,
    "category": "Accueil",
    "sku": "SKU-1933",
    "barcode": "1933",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1934",
    "name": "Cardamone en grain 500 gr",
    "price": 19.51,
    "purchasePrice": 18.492891,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-1934",
    "barcode": "1934",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1935",
    "name": "Cardamone en grain 500 gr",
    "price": 19.51,
    "purchasePrice": 18.492891,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-1935",
    "barcode": "1935",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1936",
    "name": "Mahlab Abido 500gr.",
    "price": 15.18,
    "purchasePrice": 14.388626,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1936",
    "barcode": "1936",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1937",
    "name": "Tomate 6kg 1.85",
    "price": 11.71,
    "purchasePrice": 11.099526,
    "stock": -92,
    "category": "Accueil",
    "sku": "SKU-1937",
    "barcode": "1937",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1938",
    "name": "AMMO",
    "price": 0.8,
    "purchasePrice": 0.758294,
    "stock": -12822,
    "category": "Accueil",
    "sku": "SKU-1938",
    "barcode": "1938",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.8
  },
  {
    "id": "csv-1940",
    "name": "Smeds 400gr",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1940",
    "barcode": "1940",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1941",
    "name": "Smeds triangle 8 portions",
    "price": 0.75,
    "purchasePrice": 0.7109,
    "stock": 33,
    "category": "Accueil",
    "sku": "SKU-1941",
    "barcode": "1941",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1947",
    "name": "FIGUES SECHEES 260G",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -16,
    "category": "Accueil",
    "sku": "SKU-1947",
    "barcode": "1947",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1951",
    "name": "Dragée Today 500 gr",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1951",
    "barcode": "1951",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1955",
    "name": "Mohalabieh SHP 200gr",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1955",
    "barcode": "1955",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1957",
    "name": "Loukoum libanais aux framboises - Shahin 500g",
    "price": 9.85,
    "purchasePrice": 9.336493,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1957",
    "barcode": "1957",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1965",
    "name": "Boulghour blanc gros Chtoura 900g",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1965",
    "barcode": "1965",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1970",
    "name": "Concombre Hikayat 3kg",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -13,
    "category": "Accueil",
    "sku": "SKU-1970",
    "barcode": "1970",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1981",
    "name": "Pistaches grillées salées Chirag 500g",
    "price": 10.9,
    "purchasePrice": 10.331754,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-1981",
    "barcode": "1981",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1983",
    "name": "Navet mariné 3kg Cortas",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-1983",
    "barcode": "1983",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1985",
    "name": "Arkan Tahini 10kg",
    "price": 48.53,
    "purchasePrice": 46,
    "stock": -25,
    "category": "Accueil",
    "sku": "SKU-1985",
    "barcode": "1985",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1986",
    "name": "Bokaj Cajou restaurant 1kg",
    "price": 18.99,
    "purchasePrice": 18,
    "stock": -105,
    "category": "Accueil",
    "sku": "SKU-1986",
    "barcode": "1986",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1987",
    "name": "Farine Mais 1kg",
    "price": 1.85,
    "purchasePrice": 1.753555,
    "stock": -17,
    "category": "Accueil",
    "sku": "SKU-1987",
    "barcode": "1987",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1988",
    "name": "Tomate concassees 5/1",
    "price": 7.91,
    "purchasePrice": 7.49763,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-1988",
    "barcode": "1988",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1989",
    "name": "Oignon Grand Calibre",
    "price": 1.05,
    "purchasePrice": 0.995261,
    "stock": -135,
    "category": "Accueil",
    "sku": "SKU-1989",
    "barcode": "1989",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1.05
  },
  {
    "id": "csv-1990",
    "name": "Concombre par pièce grand calibre",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-1990",
    "barcode": "1990",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1991",
    "name": "Radis rose 1kg",
    "price": 4.01,
    "purchasePrice": 3.800948,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-1991",
    "barcode": "1991",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1992",
    "name": "Haricot rouge 3/1 Bonduelle 2.5kg",
    "price": 7.91,
    "purchasePrice": 7.49763,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-1992",
    "barcode": "1992",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1993",
    "name": "Baklava mix 500gr.",
    "price": 10.9,
    "purchasePrice": 10.331754,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-1993",
    "barcode": "1993",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1994",
    "name": "Arkan Tahini 5kg",
    "price": 30,
    "purchasePrice": 28.436019,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-1994",
    "barcode": "1994",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2000",
    "name": "Menthe seche abido 500gr",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": -66,
    "category": "Accueil",
    "sku": "SKU-2000",
    "barcode": "2000",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2001",
    "name": "Indomie boeuf 40 pcs",
    "price": 13.19,
    "purchasePrice": 12.5,
    "stock": -89,
    "category": "Accueil",
    "sku": "SKU-2001",
    "barcode": "2001",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2010",
    "name": "Hommos Chtoura 2.1kg",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -108,
    "category": "Accueil",
    "sku": "SKU-2010",
    "barcode": "2010",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2011",
    "name": "ammo kaak dates ou simit",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 72,
    "category": "Accueil",
    "sku": "SKU-2011",
    "barcode": "2011",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2012",
    "name": "Pain al Basha",
    "price": 0.85,
    "purchasePrice": 0.805687,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2012",
    "barcode": "2012",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2013",
    "name": "Feuille de vigne Milos",
    "price": 8.5,
    "purchasePrice": 8.056872,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-2013",
    "barcode": "2013",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2014",
    "name": "Maamoul mad Pistache au kg",
    "price": 27,
    "purchasePrice": 25.592417,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2014",
    "barcode": "2014",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 27
  },
  {
    "id": "csv-2015",
    "name": "Bourma Cajou au Kg",
    "price": 24,
    "purchasePrice": 22.748815,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2015",
    "barcode": "2015",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 24
  },
  {
    "id": "csv-2016",
    "name": "Baklava cajou au kg",
    "price": 20,
    "purchasePrice": 18.957346,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2016",
    "barcode": "2016",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 20
  },
  {
    "id": "csv-2017",
    "name": "levure fraiche L'hirondelle 12 cubes",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -15,
    "category": "Accueil",
    "sku": "SKU-2017",
    "barcode": "2017",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2018",
    "name": "Fois gras Id halal 180g.",
    "price": 21,
    "purchasePrice": 19.905213,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2018",
    "barcode": "2018",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2019",
    "name": "Bloc de fois gras id Halal 250gr.",
    "price": 21,
    "purchasePrice": 19.905213,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2019",
    "barcode": "2019",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2020",
    "name": "Cumin 150gr",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2020",
    "barcode": "2020",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2022",
    "name": "Halloume 750 gr",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": -367,
    "category": "Accueil",
    "sku": "SKU-2022",
    "barcode": "2022",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2028",
    "name": "MALBAN PIECE",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": -153,
    "category": "Accueil",
    "sku": "SKU-2028",
    "barcode": "2028",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.5
  },
  {
    "id": "csv-2029",
    "name": "MALBAN POIDS",
    "price": 20,
    "purchasePrice": 18.957346,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2029",
    "barcode": "2029",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2039",
    "name": "Pistache d'Iran restaurant 2.5kg",
    "price": 67.5,
    "purchasePrice": 63.981043,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2039",
    "barcode": "2039",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2043",
    "name": "Aubergine grillé Chtoura 600gr.",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2043",
    "barcode": "2043",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2044",
    "name": "msanara 800gr fdl",
    "price": 10.9,
    "purchasePrice": 10.331754,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-2044",
    "barcode": "2044",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2054",
    "name": "Légumes marinés - Chtoura Garden 1kg",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2054",
    "barcode": "2054",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2055",
    "name": "Sac cadeaux",
    "price": 1,
    "purchasePrice": 0.833333,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2055",
    "barcode": "2055",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2058",
    "name": "tarama blanc 2kg",
    "price": 7.9,
    "purchasePrice": 7.488152,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2058",
    "barcode": "2058",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2059",
    "name": "Bache pour marché 2x2m",
    "price": 100.56,
    "purchasePrice": 83.8,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2059",
    "barcode": "2059",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2073",
    "name": "huile olive Italien 5L",
    "price": 45,
    "purchasePrice": 42.654028,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2073",
    "barcode": "2073",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2074",
    "name": "Boulghour duru gros brun 1kg",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": -22,
    "category": "Accueil",
    "sku": "SKU-2074",
    "barcode": "2074",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2078",
    "name": "Paprika spico 500gr",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": -38,
    "category": "Accueil",
    "sku": "SKU-2078",
    "barcode": "2078",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2079",
    "name": "Coriandre moulue 500gr spigo",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -52,
    "category": "Accueil",
    "sku": "SKU-2079",
    "barcode": "2079",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2081",
    "name": "gigot d'agneau 8.5kg 12.5euros/kg",
    "price": 106.25,
    "purchasePrice": 100.7109,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2081",
    "barcode": "2081",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2083",
    "name": "Pois chiches cuits - Cortas 3,2 kg",
    "price": 6.25,
    "purchasePrice": 5.924171,
    "stock": -14,
    "category": "Conserves",
    "sku": "SKU-2083",
    "barcode": "2083",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 6.25
  },
  {
    "id": "csv-2090",
    "name": "Huile d'olive Grignon tunisie",
    "price": 5.8,
    "purchasePrice": 5.49763,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2090",
    "barcode": "2090",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2092",
    "name": "Sel Fin 1kg",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": -117,
    "category": "Accueil",
    "sku": "SKU-2092",
    "barcode": "2092",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.99
  },
  {
    "id": "csv-2093",
    "name": "Mloukhiya congelé Nesmah",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -72,
    "category": "Accueil",
    "sku": "SKU-2093",
    "barcode": "2093",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2094",
    "name": "huile d'olive grignon tunisie 1L",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": -29,
    "category": "Accueil",
    "sku": "SKU-2094",
    "barcode": "2094",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2095",
    "name": "Estragon  séché 20 gr Espig",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-2095",
    "barcode": "2095",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2096",
    "name": "Tahini Shamiyat 18kg",
    "price": 89.67,
    "purchasePrice": 84.995261,
    "stock": -18,
    "category": "Accueil",
    "sku": "SKU-2096",
    "barcode": "2096",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2098",
    "name": "Sucette Pierrot Gourmand 1 unité",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": 9,
    "category": "Friandises",
    "sku": "SKU-2098",
    "barcode": "2098",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2100",
    "name": "pepite tournesol 1kg",
    "price": 5,
    "purchasePrice": 4.739336,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2100",
    "barcode": "2100",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2105",
    "name": "Anari Baladi 250gr",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-2105",
    "barcode": "2105",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2110",
    "name": "tomate",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -620,
    "category": "Accueil",
    "sku": "SKU-2110",
    "barcode": "2110",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2111",
    "name": "Rouleau Aluminium 45cm",
    "price": 36,
    "purchasePrice": 30,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2111",
    "barcode": "2111",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2112",
    "name": "Rouleau Aluminium 30cm",
    "price": 25.2,
    "purchasePrice": 21,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-2112",
    "barcode": "2112",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2113",
    "name": "Tomate 2",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": -1623,
    "category": "Accueil",
    "sku": "SKU-2113",
    "barcode": "2113",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2114",
    "name": "Couteau chef spéciale Persil",
    "price": 72,
    "purchasePrice": 60,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2114",
    "barcode": "2114",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2115",
    "name": "tomate 1.5",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -397,
    "category": "Accueil",
    "sku": "SKU-2115",
    "barcode": "2115",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2116",
    "name": "tomate 1.5",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -287,
    "category": "Accueil",
    "sku": "SKU-2116",
    "barcode": "2116",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2117",
    "name": "Fromage puck 240gr",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": -96,
    "category": "Accueil",
    "sku": "SKU-2117",
    "barcode": "2117",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2130",
    "name": "Cecil Golden PLate 225gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -50,
    "category": "Accueil",
    "sku": "SKU-2130",
    "barcode": "2130",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2131",
    "name": "Falafel congelé pois chiche 400gr",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": -76,
    "category": "Accueil",
    "sku": "SKU-2131",
    "barcode": "2131",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2132",
    "name": "Pistaches grecques salées au kg",
    "price": 21.9,
    "purchasePrice": 20.758294,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2132",
    "barcode": "2132",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 21.9
  },
  {
    "id": "csv-2145",
    "name": "Pistache décortiqué Jordanien 500gr.",
    "price": 16,
    "purchasePrice": 15.165877,
    "stock": -28,
    "category": "Accueil",
    "sku": "SKU-2145",
    "barcode": "2145",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2146",
    "name": "Hummus libanais classique et authentique - Flavva 200g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 1,
    "category": "Entrées-Mezzé",
    "sku": "SKU-2146",
    "barcode": "2146",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2166",
    "name": "Feve décortiqué 1kg",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": -276,
    "category": "Accueil",
    "sku": "SKU-2166",
    "barcode": "2166",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2167",
    "name": "Mejhoul Dates 900gr.",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": -7,
    "category": "Accueil",
    "sku": "SKU-2167",
    "barcode": "2167",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2168",
    "name": "Cumin entier espig 250 gr.",
    "price": 5.25,
    "purchasePrice": 4.98,
    "stock": -23,
    "category": "Accueil",
    "sku": "SKU-2168",
    "barcode": "2168",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2169",
    "name": "Lentille blond petit 4mm",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": -13,
    "category": "Accueil",
    "sku": "SKU-2169",
    "barcode": "2169",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2170",
    "name": "kamar el din abricot 400gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -19,
    "category": "Accueil",
    "sku": "SKU-2170",
    "barcode": "2170",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2172",
    "name": "pois chiche sec petit calibre",
    "price": 1.89,
    "purchasePrice": 1.791469,
    "stock": -3,
    "category": "Gourmandises",
    "sku": "SKU-2172",
    "barcode": "2172",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2173",
    "name": "pois chiche sec petit calibre",
    "price": 1.89,
    "purchasePrice": 1.791469,
    "stock": -42,
    "category": "Gourmandises",
    "sku": "SKU-2173",
    "barcode": "2173",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2174",
    "name": "baklava",
    "price": 13.4,
    "purchasePrice": 12.701422,
    "stock": -60,
    "category": "Gourmandises",
    "sku": "SKU-2174",
    "barcode": "2174",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2175",
    "name": "Aneth 500gr.",
    "price": 11.08,
    "purchasePrice": 10.50237,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2175",
    "barcode": "2175",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2176",
    "name": "Bicarbonate de sodium 1kg",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -55,
    "category": "Accueil",
    "sku": "SKU-2176",
    "barcode": "2176",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2177",
    "name": "tahini shahin 5kg",
    "price": 33.23,
    "purchasePrice": 31.49763,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-2177",
    "barcode": "2177",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2178",
    "name": "Tahini arkan 18kg",
    "price": 89.68,
    "purchasePrice": 85,
    "stock": -128,
    "category": "Accueil",
    "sku": "SKU-2178",
    "barcode": "2178",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2179",
    "name": "mahlab gardenia 500gr.",
    "price": 30,
    "purchasePrice": 28.436019,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2179",
    "barcode": "2179",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2180",
    "name": "Fromage vache en saumure le kg",
    "price": 7.38,
    "purchasePrice": 6.995261,
    "stock": -13,
    "category": "Accueil",
    "sku": "SKU-2180",
    "barcode": "2180",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 7.38
  },
  {
    "id": "csv-2181",
    "name": "Tomate 1.75/kg",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -384,
    "category": "Accueil",
    "sku": "SKU-2181",
    "barcode": "2181",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2182",
    "name": "Tomate Maroc kg",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -1421,
    "category": "Accueil",
    "sku": "SKU-2182",
    "barcode": "2182",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 1.75
  },
  {
    "id": "csv-2183",
    "name": "Malban egypte 1 kg",
    "price": 15.5,
    "purchasePrice": 14.691943,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2183",
    "barcode": "2183",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 15.5
  },
  {
    "id": "csv-2184",
    "name": "malban egypte man w salwa",
    "price": 13.5,
    "purchasePrice": 12.796209,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2184",
    "barcode": "2184",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2185",
    "name": "riz kaalar bleu xxl",
    "price": 16.5,
    "purchasePrice": 15.63981,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-2185",
    "barcode": "2185",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2188",
    "name": "Halloumi 200gr Golden Plate",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -21,
    "category": "Accueil",
    "sku": "SKU-2188",
    "barcode": "2188",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2189",
    "name": "Barbe à papa 200gr. pistache",
    "price": 6.5,
    "purchasePrice": 5.416667,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2189",
    "barcode": "2189",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2192",
    "name": "Halawa a tartinée 300gr. Arkan",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-2192",
    "barcode": "2192",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2193",
    "name": "barazek Shamsine 420gr",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-2193",
    "barcode": "2193",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2194",
    "name": "Aubergine Espagnol",
    "price": 2.06,
    "purchasePrice": 1.952607,
    "stock": -669,
    "category": "Accueil",
    "sku": "SKU-2194",
    "barcode": "2194",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2195",
    "name": "Tomate ronde Maroc",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": -821,
    "category": "Accueil",
    "sku": "SKU-2195",
    "barcode": "2195",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2196",
    "name": "Oignon Grand calibre",
    "price": 0.9,
    "purchasePrice": 0.853081,
    "stock": -539,
    "category": "Accueil",
    "sku": "SKU-2196",
    "barcode": "2196",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.9
  },
  {
    "id": "csv-2197",
    "name": "Poivron Rouge et vert",
    "price": 3.35,
    "purchasePrice": 3.175355,
    "stock": -389,
    "category": "Accueil",
    "sku": "SKU-2197",
    "barcode": "2197",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2198",
    "name": "Épinard Frais",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": -506,
    "category": "Accueil",
    "sku": "SKU-2198",
    "barcode": "2198",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2199",
    "name": "olive durra vert 660 gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-2199",
    "barcode": "2199",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2200",
    "name": "Makdous 600gr. La",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-2200",
    "barcode": "2200",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2201",
    "name": "Raisin aigre mariné 70gr Recoltes naturelles",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 12,
    "category": "Accueil",
    "sku": "SKU-2201",
    "barcode": "2201",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2202",
    "name": "Confiture d'abricot Naturelle 700gr Les récoltes Naturelles",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2202",
    "barcode": "2202",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2203",
    "name": "Confit d’écorce d’orange amère - MyMouné 240 g",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-2203",
    "barcode": "2203",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2204",
    "name": "Pois chiche 400gr. Diwan",
    "price": 0.89,
    "purchasePrice": 0.843602,
    "stock": -21,
    "category": "Accueil",
    "sku": "SKU-2204",
    "barcode": "2204",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.89
  },
  {
    "id": "csv-2205",
    "name": "Feve pois chiche 400gr. Diwan",
    "price": 0.89,
    "purchasePrice": 0.843602,
    "stock": -46,
    "category": "Accueil",
    "sku": "SKU-2205",
    "barcode": "2205",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 0.89
  },
  {
    "id": "csv-2206",
    "name": "Mamoul Noix 500gr Alsultan",
    "price": 18.5,
    "purchasePrice": 17.535545,
    "stock": 11,
    "category": "Accueil",
    "sku": "SKU-2206",
    "barcode": "2206",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2207",
    "name": "Maamoul dattes 800gr. Alsultan",
    "price": 18.5,
    "purchasePrice": 17.535545,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-2207",
    "barcode": "2207",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2208",
    "name": "Shawarma poulet Gardenia",
    "price": 1.9,
    "purchasePrice": 1.800948,
    "stock": -17,
    "category": "Accueil",
    "sku": "SKU-2208",
    "barcode": "2208",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2209",
    "name": "Gants Nitrile S, M , L",
    "price": 7.5,
    "purchasePrice": 6.25,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-2209",
    "barcode": "2209",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2210",
    "name": "Feta rona vrac",
    "price": 4.35,
    "purchasePrice": 4.123223,
    "stock": -440,
    "category": "Accueil",
    "sku": "SKU-2210",
    "barcode": "2210",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": 4.35
  },
  {
    "id": "csv-2211",
    "name": "Malban egypte 1er prix",
    "price": 7.38,
    "purchasePrice": 6.995261,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2211",
    "barcode": "2211",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2212",
    "name": "Pistache O'regale",
    "price": 32.5,
    "purchasePrice": 30.805687,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-2212",
    "barcode": "2212",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2213",
    "name": "Jus Cocktail Ice en poudre  400gr.",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2213",
    "barcode": "2213",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2214",
    "name": "Jus orange 400gr Ice",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 20,
    "category": "Accueil",
    "sku": "SKU-2214",
    "barcode": "2214",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2215",
    "name": "Mangue Jus en poudre 400gr Ice",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-2215",
    "barcode": "2215",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2216",
    "name": "Jus Hibiscus 400gr Ice",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-2216",
    "barcode": "2216",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2217",
    "name": "Jus en poudre Guyave 400gr. Ice",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 22,
    "category": "Accueil",
    "sku": "SKU-2217",
    "barcode": "2217",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2218",
    "name": "Jus en poudre fraise 400gr Ice",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 21,
    "category": "Accueil",
    "sku": "SKU-2218",
    "barcode": "2218",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2219",
    "name": "Jus en Poudre gingembre 400gr Ice",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 22,
    "category": "Accueil",
    "sku": "SKU-2219",
    "barcode": "2219",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2220",
    "name": "Jus en Poudre Anana 400gr Ice",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 20,
    "category": "Accueil",
    "sku": "SKU-2220",
    "barcode": "2220",
    "imageUrl": "http://almoune.fr/img/p/0.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1",
    "name": "Thé Noir Mahmood Ceylon 450g",
    "price": 4.58,
    "purchasePrice": 4.3406,
    "stock": 0,
    "category": "Thés",
    "sku": "SKU-1",
    "barcode": "1",
    "imageUrl": "http://almoune.fr/img/p/1/5/9/1/1591.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2",
    "name": "Boulghour Gros - Altunsa 900g",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 18,
    "category": "Aliments et Laitiers",
    "sku": "SKU-2",
    "barcode": "2",
    "imageUrl": "http://almoune.fr/img/p/1/5/9/2/1592.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3",
    "name": "Boulghour Gros- Altunsa 900g",
    "price": 1.98,
    "purchasePrice": 1.881,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-3",
    "barcode": "3",
    "imageUrl": "http://almoune.fr/img/p/1/5/9/3/1593.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-4",
    "name": "Boulghour Fin Blanc - Altunsa 900g",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 99,
    "category": "Aliments et Laitiers",
    "sku": "SKU-4",
    "barcode": "4",
    "imageUrl": "http://almoune.fr/img/p/1/5/9/4/1594.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-5",
    "name": "Boulghour avec vermicelles - Altunsa 900g",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-5",
    "barcode": "5",
    "imageUrl": "http://almoune.fr/img/p/1/5/9/5/1595.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-6",
    "name": "Vermicelles - Altunsa 450g",
    "price": 1.07,
    "purchasePrice": 1.012,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-6",
    "barcode": "6",
    "imageUrl": "http://almoune.fr/img/p/1/5/9/6/1596.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-7",
    "name": "Fèves Géantes - Altunsa 750g",
    "price": 4.85,
    "purchasePrice": 4.597156,
    "stock": 2,
    "category": "Aliments et Laitiers",
    "sku": "SKU-7",
    "barcode": "7",
    "imageUrl": "http://almoune.fr/img/p/1/5/9/7/1597.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-8",
    "name": "Maïs Popcorn - Altunsa 900g",
    "price": 3.35,
    "purchasePrice": 3.175355,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-8",
    "barcode": "8",
    "imageUrl": "http://almoune.fr/img/p/1/5/9/8/1598.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-9",
    "name": "Lentilles Corail Entières - Altunsa 900 g",
    "price": 2.44,
    "purchasePrice": 2.31,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-9",
    "barcode": "9",
    "imageUrl": "http://almoune.fr/img/p/1/5/9/9/1599.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-10",
    "name": "Infusion Mélange de plantes (Zhourat) - Algota 60g",
    "price": 2.2,
    "purchasePrice": 2.085308,
    "stock": 1,
    "category": "Aliments et Laitiers",
    "sku": "SKU-10",
    "barcode": "10",
    "imageUrl": "http://almoune.fr/img/p/1/6/0/0/1600.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-11",
    "name": "Gelée à la Fraise (Jello) 2+1- Algota 80g",
    "price": 1.2,
    "purchasePrice": 1.137441,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-11",
    "barcode": "11",
    "imageUrl": "http://almoune.fr/img/p/1/6/0/1/1601.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-12",
    "name": "Gelée à la Cerise (Jello) 2+1 - Algota 80g",
    "price": 1.2,
    "purchasePrice": 1.137441,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-12",
    "barcode": "12",
    "imageUrl": "http://almoune.fr/img/p/1/6/0/2/1602.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-13",
    "name": "Gelée à la Banane (Jello) 2+1 - Algota 80g",
    "price": 1.2,
    "purchasePrice": 1.137441,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-13",
    "barcode": "13",
    "imageUrl": "http://almoune.fr/img/p/1/6/0/3/1603.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-14",
    "name": "Concentré de Piment Fort - Algota 350g",
    "price": 1.6,
    "purchasePrice": 1.8117,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-14",
    "barcode": "14",
    "imageUrl": "http://almoune.fr/img/p/1/6/0/4/1604.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-15",
    "name": "Mélasse de Raisin - Algota 350g",
    "price": 3.2,
    "purchasePrice": 3.033175,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-15",
    "barcode": "15",
    "imageUrl": "http://almoune.fr/img/p/1/6/0/5/1605.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-16",
    "name": "Fèves Foul Medammas Recette Libanaise - Durra 400g",
    "price": 1.45,
    "purchasePrice": 1.374408,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-16",
    "barcode": "16",
    "imageUrl": "http://almoune.fr/img/p/1/6/0/6/1606.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-17",
    "name": "Fèves Foul Medammas au naturel - Durra 400g",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-17",
    "barcode": "17",
    "imageUrl": "http://almoune.fr/img/p/1/6/0/7/1607.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-18",
    "name": "Falafel en poudre - Algota 400g",
    "price": 2.27,
    "purchasePrice": 2.938389,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-18",
    "barcode": "18",
    "imageUrl": "http://almoune.fr/img/p/1/6/0/8/1608.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-19",
    "name": "Concentré de Piment Fort - Durra 650g",
    "price": 4.55,
    "purchasePrice": 4.312796,
    "stock": 12,
    "category": "Accueil",
    "sku": "SKU-19",
    "barcode": "19",
    "imageUrl": "http://almoune.fr/img/p/1/6/0/9/1609.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-20",
    "name": "Concentré de Piment Fort - Durra 375g",
    "price": 1.76,
    "purchasePrice": 1.6687,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-20",
    "barcode": "20",
    "imageUrl": "http://almoune.fr/img/p/1/6/1/0/1610.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-21",
    "name": "Houmous Tahina - Durra  370 gr",
    "price": 1.98,
    "purchasePrice": 1.876777,
    "stock": 31,
    "category": "Accueil",
    "sku": "SKU-21",
    "barcode": "21",
    "imageUrl": "http://almoune.fr/img/p/1/6/1/1/1611.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-22",
    "name": "Tahini (Crème de Sésame) - Durra 800g",
    "price": 7.25,
    "purchasePrice": 6.872038,
    "stock": 16,
    "category": "Accueil",
    "sku": "SKU-22",
    "barcode": "22",
    "imageUrl": "http://almoune.fr/img/p/1/6/1/2/1612.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-23",
    "name": "Tahini (crème de sésame) - Durra 400g",
    "price": 4.45,
    "purchasePrice": 4.218009,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-23",
    "barcode": "23",
    "imageUrl": "http://almoune.fr/img/p/1/6/1/3/1613.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-24",
    "name": "Halawa Pistaches - Durra 350g",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 24,
    "category": "Halawa",
    "sku": "SKU-24",
    "barcode": "24",
    "imageUrl": "http://almoune.fr/img/p/1/6/1/4/1614.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-25",
    "name": "Frikeh ( Blé Dur Vert) - Durra 450g",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-25",
    "barcode": "25",
    "imageUrl": "http://almoune.fr/img/p/1/6/1/5/1615.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-26",
    "name": "Confiture de Rose - Durra 430g",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": 10,
    "category": "Confitures",
    "sku": "SKU-26",
    "barcode": "26",
    "imageUrl": "http://almoune.fr/img/p/1/6/1/6/1616.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-27",
    "name": "Confiture de Figue et Noix - Durra 430g",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": 1,
    "category": "Confitures",
    "sku": "SKU-27",
    "barcode": "27",
    "imageUrl": "http://almoune.fr/img/p/1/6/1/7/1617.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-28",
    "name": "Pâte d'Abricots Secs  Kamardine -  400g",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": 24,
    "category": "Aliments et Laitiers",
    "sku": "SKU-28",
    "barcode": "28",
    "imageUrl": "http://almoune.fr/img/p/1/6/1/8/1618.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-29",
    "name": "Houmous Tahina - Durra 850g",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 11,
    "category": "Aliments et Laitiers",
    "sku": "SKU-29",
    "barcode": "29",
    "imageUrl": "http://almoune.fr/img/p/1/6/1/9/1619.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-30",
    "name": "Aubergines Marinées - Durra 720g",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-30",
    "barcode": "30",
    "imageUrl": "http://almoune.fr/img/p/1/6/2/0/1620.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-31",
    "name": "Halawa Pistaches - Durra 200g",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 0,
    "category": "Halawa",
    "sku": "SKU-31",
    "barcode": "31",
    "imageUrl": "http://almoune.fr/img/p/1/6/2/1/1621.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-32",
    "name": "Olives vertes Salkini - Durra 650g",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-32",
    "barcode": "32",
    "imageUrl": "http://almoune.fr/img/p/3/6/8/6/3686.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-33",
    "name": "Halawa Nature - Durra 200g",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 47,
    "category": "Halawa",
    "sku": "SKU-33",
    "barcode": "33",
    "imageUrl": "http://almoune.fr/img/p/1/6/2/3/1623.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-34",
    "name": "Lupins en  bocal - Ziné 540g",
    "price": 1.9,
    "purchasePrice": 1.800948,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-34",
    "barcode": "34",
    "imageUrl": "http://almoune.fr/img/p/1/6/2/4/1624.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-35",
    "name": "Fromage de Chèvre en saumure - Suntat 400g",
    "price": 5.83,
    "purchasePrice": 6.473934,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-35",
    "barcode": "35",
    "imageUrl": "http://almoune.fr/img/p/1/6/2/5/1625.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-36",
    "name": "Fromage Esma Gombi 20% Graisse 800g",
    "price": 3.75,
    "purchasePrice": 3.5585,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-36",
    "barcode": "36",
    "imageUrl": "http://almoune.fr/img/p/1/6/2/6/1626.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-37",
    "name": "Fromage Kashkaval - Suntat 400g",
    "price": 4.77,
    "purchasePrice": 4.7109,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-37",
    "barcode": "37",
    "imageUrl": "http://almoune.fr/img/p/1/6/2/7/1627.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-38",
    "name": "Cheveux d'ange frais pour patisserie 400g",
    "price": 2.94,
    "purchasePrice": 2.78673,
    "stock": 0,
    "category": "Pâtes",
    "sku": "SKU-38",
    "barcode": "38",
    "imageUrl": "http://almoune.fr/img/p/1/6/2/8/1628.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-39",
    "name": "Soujuk à l'Ail Doux Suntat 250g",
    "price": 3.45,
    "purchasePrice": 3.270142,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-39",
    "barcode": "39",
    "imageUrl": "http://almoune.fr/img/p/1/6/2/9/1629.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-40",
    "name": "Soujuk à l'Ail Fort Suntat 250g",
    "price": 3.45,
    "purchasePrice": 3.270142,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-40",
    "barcode": "40",
    "imageUrl": "http://almoune.fr/img/p/1/6/3/0/1630.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-41",
    "name": "Nido Lait Entier en Poudre - Nestlé 400g",
    "price": 6.99,
    "purchasePrice": 6.625592,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-41",
    "barcode": "41",
    "imageUrl": "http://almoune.fr/img/p/1/6/3/1/1631.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-42",
    "name": "Café Moulu Nature Mocha Hamwi 180g",
    "price": 4.45,
    "purchasePrice": 4.218009,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-42",
    "barcode": "42",
    "imageUrl": "http://almoune.fr/img/p/1/6/3/2/1632.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-43",
    "name": "Café Moulu à la Cardamome Najjar 200g",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Boissons",
    "sku": "SKU-43",
    "barcode": "43",
    "imageUrl": "http://almoune.fr/img/p/1/6/3/3/1633.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-44",
    "name": "Yerba Maté d'Argentine - Piporé 250g",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 20,
    "category": "Accueil",
    "sku": "SKU-44",
    "barcode": "44",
    "imageUrl": "http://almoune.fr/img/p/1/6/3/4/1634.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-45",
    "name": "Yerba Maté Blanc d'Argentine - Kharta 250g",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-45",
    "barcode": "45",
    "imageUrl": "http://almoune.fr/img/p/1/6/3/5/1635.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-46",
    "name": "Pistaches Décortiquées premium en vrac 200g",
    "price": 8.95,
    "purchasePrice": 8.483412,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-46",
    "barcode": "46",
    "imageUrl": "http://almoune.fr/img/p/1/6/3/6/1636.jpg",
    "price_per_kg": 8.95
  },
  {
    "id": "csv-47",
    "name": "AL KAZZI Offre (Extra-Mixed Nuts-Kanaker) 800g",
    "price": 6.72,
    "purchasePrice": 7.3205,
    "stock": 1,
    "category": "Apéritifs et pain",
    "sku": "SKU-47",
    "barcode": "47",
    "imageUrl": "http://almoune.fr/img/p/1/6/3/7/1637.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-48",
    "name": "Graines Salées Tournesol - Graines Blanches Sheki 170g",
    "price": 1.31,
    "purchasePrice": 1.2419,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-48",
    "barcode": "48",
    "imageUrl": "http://almoune.fr/img/p/1/6/3/8/1638.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-49",
    "name": "Graines Salées melon Sheki 200g",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-49",
    "barcode": "49",
    "imageUrl": "http://almoune.fr/img/p/1/6/3/9/1639.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-50",
    "name": "Cerneaux de Noix Sheki 200g",
    "price": 3.14,
    "purchasePrice": 2.9777,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-50",
    "barcode": "50",
    "imageUrl": "http://almoune.fr/img/p/1/6/4/0/1640.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-51",
    "name": "Graines de Tournesol Salées  - Sheki 180g",
    "price": 0.75,
    "purchasePrice": 1.374408,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-51",
    "barcode": "51",
    "imageUrl": "http://almoune.fr/img/p/1/6/4/1/1641.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-52",
    "name": "Maamoul aux Dattes - Teashop  480g",
    "price": 4.49,
    "purchasePrice": 4.255924,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-52",
    "barcode": "52",
    "imageUrl": "http://almoune.fr/img/p/1/6/4/2/1642.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-53",
    "name": "Biscuit Lahfa Cylindre Caco 8 pièces 180g",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-53",
    "barcode": "53",
    "imageUrl": "http://almoune.fr/img/p/1/6/4/3/1643.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-54",
    "name": "Ghraybeh Hamdan 330g",
    "price": 6.75,
    "purchasePrice": 6.398104,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-54",
    "barcode": "54",
    "imageUrl": "http://almoune.fr/img/p/1/6/4/4/1644.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-55",
    "name": "Epices Kebbeh Abido 50g",
    "price": 1.95,
    "purchasePrice": 1.848341,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-55",
    "barcode": "55",
    "imageUrl": "http://almoune.fr/img/p/1/6/4/5/1645.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-56",
    "name": "Epices Shawarma Poulet Abido 50g",
    "price": 2.1,
    "purchasePrice": 1.990521,
    "stock": 9,
    "category": "Accueil",
    "sku": "SKU-56",
    "barcode": "56",
    "imageUrl": "http://almoune.fr/img/p/1/6/4/6/1646.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-57",
    "name": "Epices pour Sojok - Abido 50g",
    "price": 1.8,
    "purchasePrice": 1.706161,
    "stock": 8,
    "category": "Épices",
    "sku": "SKU-57",
    "barcode": "57",
    "imageUrl": "http://almoune.fr/img/p/1/6/4/7/1647.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-58",
    "name": "Epices Chich Tawouk Abido 50gr",
    "price": 1.95,
    "purchasePrice": 1.848341,
    "stock": 7,
    "category": "Épices",
    "sku": "SKU-58",
    "barcode": "58",
    "imageUrl": "http://almoune.fr/img/p/1/6/4/8/1648.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-59",
    "name": "Anis Moulu - Abido  50g",
    "price": 1.49,
    "purchasePrice": 1.412322,
    "stock": 1,
    "category": "Épices",
    "sku": "SKU-59",
    "barcode": "59",
    "imageUrl": "http://almoune.fr/img/p/1/6/4/9/1649.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-60",
    "name": "Anis Entier - Abido 50g",
    "price": 1.8,
    "purchasePrice": 1.706161,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-60",
    "barcode": "60",
    "imageUrl": "http://almoune.fr/img/p/1/6/5/0/1650.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-61",
    "name": "Feuilles de Laurier Abido  50g",
    "price": 1.9,
    "purchasePrice": 1.800948,
    "stock": 1,
    "category": "Épices",
    "sku": "SKU-61",
    "barcode": "61",
    "imageUrl": "http://almoune.fr/img/p/1/6/5/1/1651.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-62",
    "name": "Carvi Moulu Abido  50g",
    "price": 1.4,
    "purchasePrice": 1.327014,
    "stock": 9,
    "category": "Épices",
    "sku": "SKU-62",
    "barcode": "62",
    "imageUrl": "http://almoune.fr/img/p/1/6/5/2/1652.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-63",
    "name": "Cardamome Entière en vrac 30g",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 6,
    "category": "Épices",
    "sku": "SKU-63",
    "barcode": "63",
    "imageUrl": "http://almoune.fr/img/p/3/7/8/0/3780.jpg",
    "price_per_kg": 2.99
  },
  {
    "id": "csv-64",
    "name": "Cannelle en Bâtons - Abido 100g",
    "price": 2.55,
    "purchasePrice": 2.417062,
    "stock": 5,
    "category": "Épices",
    "sku": "SKU-64",
    "barcode": "64",
    "imageUrl": "http://almoune.fr/img/p/1/6/5/4/1654.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-65",
    "name": "Clous de Girofle Moulus Abido 50g",
    "price": 2.15,
    "purchasePrice": 2.037915,
    "stock": 14,
    "category": "Épices",
    "sku": "SKU-65",
    "barcode": "65",
    "imageUrl": "http://almoune.fr/img/p/1/6/5/5/1655.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-66",
    "name": "Clous de Girofle Entiers Abido 30g",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-66",
    "barcode": "66",
    "imageUrl": "http://almoune.fr/img/p/1/6/5/6/1656.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-67",
    "name": "Coriandre Moulue - Abido 50g",
    "price": 1.3,
    "purchasePrice": 1.232227,
    "stock": 4,
    "category": "Épices",
    "sku": "SKU-67",
    "barcode": "67",
    "imageUrl": "http://almoune.fr/img/p/1/6/5/7/1657.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-68",
    "name": "Coriandre en graines en vrac 30g",
    "price": 0.99,
    "purchasePrice": 0.9384,
    "stock": 3,
    "category": "Épices",
    "sku": "SKU-68",
    "barcode": "68",
    "imageUrl": "http://almoune.fr/img/p/3/7/8/1/3781.jpg",
    "price_per_kg": 0.99
  },
  {
    "id": "csv-69",
    "name": "Cumin Moulu Abido 50g",
    "price": 1.85,
    "purchasePrice": 1.753555,
    "stock": 2,
    "category": "Épices",
    "sku": "SKU-69",
    "barcode": "69",
    "imageUrl": "http://almoune.fr/img/p/1/6/5/9/1659.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-70",
    "name": "Cumin En Grains Abido 50g",
    "price": 1.7,
    "purchasePrice": 1.611374,
    "stock": 12,
    "category": "Épices",
    "sku": "SKU-70",
    "barcode": "70",
    "imageUrl": "http://almoune.fr/img/p/1/6/6/0/1660.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-71",
    "name": "Epices Falafel Abido 50g",
    "price": 1.6,
    "purchasePrice": 1.516588,
    "stock": 4,
    "category": "Épices",
    "sku": "SKU-71",
    "barcode": "71",
    "imageUrl": "http://almoune.fr/img/p/1/6/6/1/1661.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-72",
    "name": "Fenugrec Moulu Abido 50g",
    "price": 1.7,
    "purchasePrice": 1.611374,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-72",
    "barcode": "72",
    "imageUrl": "http://almoune.fr/img/p/1/6/6/2/1662.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-73",
    "name": "Gingembre Moulu Abido  50g",
    "price": 1.85,
    "purchasePrice": 1.753555,
    "stock": 7,
    "category": "Épices",
    "sku": "SKU-73",
    "barcode": "73",
    "imageUrl": "http://almoune.fr/img/p/1/6/6/3/1663.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-74",
    "name": "Epices Kefta - Abido 50g",
    "price": 1.7,
    "purchasePrice": 1.611374,
    "stock": 2,
    "category": "Épices",
    "sku": "SKU-74",
    "barcode": "74",
    "imageUrl": "http://almoune.fr/img/p/1/6/6/4/1664.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-75",
    "name": "Mardakoush (Marjolaine) Abido 50g",
    "price": 0.99,
    "purchasePrice": 0.9384,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-75",
    "barcode": "75",
    "imageUrl": "http://almoune.fr/img/p/1/6/6/5/1665.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-76",
    "name": "Graines de cresson - Abido 50g",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-76",
    "barcode": "76",
    "imageUrl": "http://almoune.fr/img/p/1/6/6/6/1666.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-77",
    "name": "Curcuma en Poudre Abido 50g",
    "price": 1.45,
    "purchasePrice": 1.374408,
    "stock": 18,
    "category": "Épices",
    "sku": "SKU-77",
    "barcode": "77",
    "imageUrl": "http://almoune.fr/img/p/1/6/6/7/1667.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-78",
    "name": "Acide Citrique Abido 100g",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -3,
    "category": "Épices",
    "sku": "SKU-78",
    "barcode": "78",
    "imageUrl": "http://almoune.fr/img/p/1/6/6/8/1668.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-79",
    "name": "Citrons Séchés Blancs (Loumi) 150g",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-79",
    "barcode": "79",
    "imageUrl": "http://almoune.fr/img/p/1/6/6/9/1669.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-80",
    "name": "Noix de Muscade Moulues Abido 50g",
    "price": 2.85,
    "purchasePrice": 2.701422,
    "stock": -1,
    "category": "Épices",
    "sku": "SKU-80",
    "barcode": "80",
    "imageUrl": "http://almoune.fr/img/p/1/6/7/0/1670.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-81",
    "name": "Cardamone Moulue Abido 20g",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 7,
    "category": "Épices",
    "sku": "SKU-81",
    "barcode": "81",
    "imageUrl": "http://almoune.fr/img/p/1/6/7/1/1671.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-82",
    "name": "Cannelle Poudre Abido 50g",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-82",
    "barcode": "82",
    "imageUrl": "http://almoune.fr/img/p/1/6/7/2/1672.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-83",
    "name": "Fenouil Moulu Abido 50g",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 2,
    "category": "Épices",
    "sku": "SKU-83",
    "barcode": "83",
    "imageUrl": "http://almoune.fr/img/p/1/6/7/3/1673.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-84",
    "name": "Epices Makanek Abido 50g",
    "price": 1.9,
    "purchasePrice": 1.800948,
    "stock": 7,
    "category": "Épices",
    "sku": "SKU-84",
    "barcode": "84",
    "imageUrl": "http://almoune.fr/img/p/1/6/7/4/1674.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-85",
    "name": "Bonjus Mangue 180ml",
    "price": 1,
    "purchasePrice": 0.9479,
    "stock": 0,
    "category": "Boissons",
    "sku": "SKU-85",
    "barcode": "85",
    "imageUrl": "http://almoune.fr/img/p/1/6/7/5/1675.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-86",
    "name": "Bonjus Ananas 180ml",
    "price": 1,
    "purchasePrice": 0.9479,
    "stock": 0,
    "category": "Boissons",
    "sku": "SKU-86",
    "barcode": "86",
    "imageUrl": "http://almoune.fr/img/p/1/6/7/6/1676.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-87",
    "name": "Vide Courgette",
    "price": 2.5,
    "purchasePrice": 2.083333,
    "stock": 0,
    "category": "Autres",
    "sku": "SKU-87",
    "barcode": "87",
    "imageUrl": "http://almoune.fr/img/p/1/6/7/7/1677.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-88",
    "name": "Thym Mixte Alep (Zaatar Halabi Rouge)  - Ossraty 454g",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-88",
    "barcode": "88",
    "imageUrl": "http://almoune.fr/img/p/1/6/7/8/1678.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-89",
    "name": "Chips Derby 20g",
    "price": 0.35,
    "purchasePrice": 0.331754,
    "stock": 82,
    "category": "Chips et apéritifs",
    "sku": "SKU-89",
    "barcode": "89",
    "imageUrl": "http://almoune.fr/img/p/2/3/6/9/2369.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-90",
    "name": "Indomie (nouilles) Végétarien 75g",
    "price": 0.55,
    "purchasePrice": 0.521327,
    "stock": 80,
    "category": "Légumineuses et grains",
    "sku": "SKU-90",
    "barcode": "90",
    "imageUrl": "http://almoune.fr/img/p/1/6/8/0/1680.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-91",
    "name": "Indomie (nouilles) Poulet 70g",
    "price": 0.55,
    "purchasePrice": 0.521327,
    "stock": 32,
    "category": "Aliments et Laitiers",
    "sku": "SKU-91",
    "barcode": "91",
    "imageUrl": "http://almoune.fr/img/p/1/6/8/1/1681.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-92",
    "name": "Chewing Gum Mamon Sharawi Cannelle 200g",
    "price": 1.6,
    "purchasePrice": 2.843602,
    "stock": 1,
    "category": "Gourmandises",
    "sku": "SKU-92",
    "barcode": "92",
    "imageUrl": "http://almoune.fr/img/p/1/6/8/2/1682.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-93",
    "name": "Mim Cire épilatoire traditionelle Orientale",
    "price": 1.7,
    "purchasePrice": 1.416667,
    "stock": -5,
    "category": "Autres",
    "sku": "SKU-93",
    "barcode": "93",
    "imageUrl": "http://almoune.fr/img/p/3/6/9/6/3696.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-94",
    "name": "Lupins Secs Chtoura 450 g",
    "price": 2.2,
    "purchasePrice": 2.085308,
    "stock": 6,
    "category": "Aliments et Laitiers",
    "sku": "SKU-94",
    "barcode": "94",
    "imageUrl": "http://almoune.fr/img/p/1/6/8/4/1684.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-95",
    "name": "Pâte d'amande(pistache) - 500 g",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-95",
    "barcode": "95",
    "imageUrl": "http://almoune.fr/img/p/1/6/8/5/1685.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-96",
    "name": "Patisserie mahruse mixed 500 g",
    "price": 18.56,
    "purchasePrice": 17.589,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-96",
    "barcode": "96",
    "imageUrl": "http://almoune.fr/img/p/1/6/8/6/1686.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-97",
    "name": "Pâtisserie mahruse mixed 850 g",
    "price": 30.97,
    "purchasePrice": 29.359,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-97",
    "barcode": "97",
    "imageUrl": "http://almoune.fr/img/p/1/6/8/7/1687.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-98",
    "name": "Pâtisserie mahruse bourma 500 g",
    "price": 21.54,
    "purchasePrice": 20.416,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-98",
    "barcode": "98",
    "imageUrl": "http://almoune.fr/img/p/1/6/8/8/1688.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-99",
    "name": "Pâtisserie marhruse karabij 500 g",
    "price": 12,
    "purchasePrice": 14.795,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-99",
    "barcode": "99",
    "imageUrl": "http://almoune.fr/img/p/1/6/8/9/1689.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-101",
    "name": "Pâte d'amande en forme de fruits 500 g",
    "price": 11.5,
    "purchasePrice": 10.900474,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-101",
    "barcode": "101",
    "imageUrl": "http://almoune.fr/img/p/1/7/9/1/1791.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-102",
    "name": "Pâte de noix - Jelmalban 500 g",
    "price": 6.01,
    "purchasePrice": 5.6925,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-102",
    "barcode": "102",
    "imageUrl": "http://almoune.fr/img/p/1/7/9/2/1792.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-103",
    "name": "Arak Batta 0.70litre 0.50alc",
    "price": 23.18,
    "purchasePrice": 19.316,
    "stock": 0,
    "category": "Boissons",
    "sku": "SKU-103",
    "barcode": "103",
    "imageUrl": "http://almoune.fr/img/p/1/7/9/3/1793.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-104",
    "name": "Haricots blancs bouillis - Akdeniz 570g",
    "price": 1.54,
    "purchasePrice": 1.4619,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-104",
    "barcode": "104",
    "imageUrl": "http://almoune.fr/img/p/1/7/9/4/1794.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-105",
    "name": "Lentilles Blondes Bouillies - Akdeniz 570g",
    "price": 1.54,
    "purchasePrice": 1.4619,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-105",
    "barcode": "105",
    "imageUrl": "http://almoune.fr/img/p/1/7/9/5/1795.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-106",
    "name": "Pois Chiche Bouillis - Akdeniz 570g",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 2,
    "category": "Conserves",
    "sku": "SKU-106",
    "barcode": "106",
    "imageUrl": "http://almoune.fr/img/p/1/7/9/6/1796.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-107",
    "name": "Boulghour avec vermicelles- Akdeniz 900g",
    "price": 2.12,
    "purchasePrice": 2.0097,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-107",
    "barcode": "107",
    "imageUrl": "http://almoune.fr/img/p/1/7/9/7/1797.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-108",
    "name": "Lentilles Rouges ou corail - Al Tunsa 900g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-108",
    "barcode": "108",
    "imageUrl": "http://almoune.fr/img/p/4/0/0/7/4007.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-109",
    "name": "Aubergines Grillées Marinées - Baktat 620g",
    "price": 2,
    "purchasePrice": 2.2957,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-109",
    "barcode": "109",
    "imageUrl": "http://almoune.fr/img/p/1/7/9/9/1799.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-110",
    "name": "Pois Chiche grillé - Beybaba 200g",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-110",
    "barcode": "110",
    "imageUrl": "http://almoune.fr/img/p/1/8/0/0/1800.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-111",
    "name": "Gâteau Sec - Beybaba 320g",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 1,
    "category": "Gourmandises",
    "sku": "SKU-111",
    "barcode": "111",
    "imageUrl": "http://almoune.fr/img/p/1/8/0/1/1801.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-112",
    "name": "Pois chiche jaune - Beybaba 200g",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-112",
    "barcode": "112",
    "imageUrl": "http://almoune.fr/img/p/1/8/0/2/1802.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-113",
    "name": "Pois chiche sucré - Beybaba 200g",
    "price": 0.69,
    "purchasePrice": 1.1187,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-113",
    "barcode": "113",
    "imageUrl": "http://almoune.fr/img/p/1/8/0/3/1803.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-114",
    "name": "Cheveux d'ange - Dari 500g",
    "price": 1.99,
    "purchasePrice": 1.8887,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-114",
    "barcode": "114",
    "imageUrl": "http://almoune.fr/img/p/1/8/0/4/1804.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-115",
    "name": "Tortilla 20cm - Doydoy 240g",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-115",
    "barcode": "115",
    "imageUrl": "http://almoune.fr/img/p/1/8/0/5/1805.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-116",
    "name": "Crème Chantilly - Dr. Oetker 150g",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-116",
    "barcode": "116",
    "imageUrl": "http://almoune.fr/img/p/1/8/0/6/1806.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-117",
    "name": "Sahlab en poudre  80g",
    "price": 1.8,
    "purchasePrice": 1.706161,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-117",
    "barcode": "117",
    "imageUrl": "http://almoune.fr/img/p/1/8/0/7/1807.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-118",
    "name": "Blé pelé 1 kg",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-118",
    "barcode": "118",
    "imageUrl": "http://almoune.fr/img/p/1/8/0/8/1808.jpg",
    "price_per_kg": 2.99
  },
  {
    "id": "csv-119",
    "name": "Olives Vertes dénoyautées 250g",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-119",
    "barcode": "119",
    "imageUrl": "http://almoune.fr/img/p/1/8/0/9/1809.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-120",
    "name": "Boulghour Brun Gros - Duru 1kg",
    "price": 3.45,
    "purchasePrice": 3.270142,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-120",
    "barcode": "120",
    "imageUrl": "http://almoune.fr/img/p/1/8/1/0/1810.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-121",
    "name": "Haricots noirs - Duru 1kg",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-121",
    "barcode": "121",
    "imageUrl": "http://almoune.fr/img/p/1/8/1/1/1811.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-122",
    "name": "Barazek ghreybe Zeitoune 250 GR",
    "price": 7.45,
    "purchasePrice": 7.0631,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-122",
    "barcode": "122",
    "imageUrl": "http://almoune.fr/img/p/1/8/1/2/1812.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-123",
    "name": "Mahlab moulu Abido 50 g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-123",
    "barcode": "123",
    "imageUrl": "http://almoune.fr/img/p/3/7/8/7/3787.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-124",
    "name": "Amidon maïs - Firat 250g",
    "price": 1.39,
    "purchasePrice": 1.317536,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-124",
    "barcode": "124",
    "imageUrl": "http://almoune.fr/img/p/1/8/1/4/1814.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-125",
    "name": "Sumac - Firat 500g",
    "price": 3.15,
    "purchasePrice": 2.9898,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-125",
    "barcode": "125",
    "imageUrl": "http://almoune.fr/img/p/1/8/1/5/1815.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-126",
    "name": "Sirop de jallab - Rabih 50cL",
    "price": 6.75,
    "purchasePrice": 6.398104,
    "stock": 0,
    "category": "Boissons",
    "sku": "SKU-126",
    "barcode": "126",
    "imageUrl": "http://almoune.fr/img/p/1/8/1/6/1816.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-127",
    "name": "Saucisse de dinde - Fulya 400g",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-127",
    "barcode": "127",
    "imageUrl": "http://almoune.fr/img/p/1/8/1/7/1817.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-128",
    "name": "Chips tube Nature - Gusto 85g",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-128",
    "barcode": "128",
    "imageUrl": "http://almoune.fr/img/p/1/8/1/8/1818.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-129",
    "name": "Chips tube paprika - Gusto 100g",
    "price": 1.4,
    "purchasePrice": 1.327014,
    "stock": 0,
    "category": "Chips et apéritifs",
    "sku": "SKU-129",
    "barcode": "129",
    "imageUrl": "http://almoune.fr/img/p/1/8/1/9/1819.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-130",
    "name": "Salami de dinde  - Istanbul 500g",
    "price": 2.49,
    "purchasePrice": 2.36019,
    "stock": 13,
    "category": "Aliments et Laitiers",
    "sku": "SKU-130",
    "barcode": "130",
    "imageUrl": "http://almoune.fr/img/p/1/8/2/0/1820.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-131",
    "name": "Mil brick - 170g",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-131",
    "barcode": "131",
    "imageUrl": "http://almoune.fr/img/p/1/8/2/1/1821.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-132",
    "name": "Pâte à filo baklava, beurek et croustillant  - Yufka 500g",
    "price": 2.31,
    "purchasePrice": 2.189,
    "stock": -1,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-132",
    "barcode": "132",
    "imageUrl": "http://almoune.fr/img/p/1/8/2/2/1822.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-133",
    "name": "Pâte feuilleté triangle  - Yufka 400g",
    "price": 2.94,
    "purchasePrice": 2.78673,
    "stock": -80,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-133",
    "barcode": "133",
    "imageUrl": "http://almoune.fr/img/p/1/8/2/3/1823.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-134",
    "name": "Purée de poivron fort - Oncu 370g",
    "price": 2.6,
    "purchasePrice": 2.464455,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-134",
    "barcode": "134",
    "imageUrl": "http://almoune.fr/img/p/1/8/2/4/1824.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-135",
    "name": "Purée de poivron doux - Oncu 720g",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-135",
    "barcode": "135",
    "imageUrl": "http://almoune.fr/img/p/1/8/2/5/1825.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-136",
    "name": "Levure boulangère - Pakmaya 100g",
    "price": 0.99,
    "purchasePrice": 0.9384,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-136",
    "barcode": "136",
    "imageUrl": "http://almoune.fr/img/p/1/8/2/6/1826.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-137",
    "name": "Fromage kashkaval  - Pinar 400g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-137",
    "barcode": "137",
    "imageUrl": "http://almoune.fr/img/p/1/8/2/7/1827.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-138",
    "name": "Concentré de Piment Fort turc - Suntat 600g",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-138",
    "barcode": "138",
    "imageUrl": "http://almoune.fr/img/p/1/8/2/8/1828.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-139",
    "name": "Houmous Tahini - Al Rabih 850g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -12,
    "category": "Conserves",
    "sku": "SKU-139",
    "barcode": "139",
    "imageUrl": "http://almoune.fr/img/p/1/8/2/9/1829.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-140",
    "name": "Tahini - Rabih 200 g",
    "price": 2.07,
    "purchasePrice": 1.9613,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-140",
    "barcode": "140",
    "imageUrl": "http://almoune.fr/img/p/1/8/3/0/1830.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-141",
    "name": "Tahini - Rabih 454 g",
    "price": 3.81,
    "purchasePrice": 3.6124,
    "stock": 0,
    "category": "Tahini",
    "sku": "SKU-141",
    "barcode": "141",
    "imageUrl": "http://almoune.fr/img/p/1/8/3/1/1831.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-142",
    "name": "Pastirma  - Suntat 100g",
    "price": 3.72,
    "purchasePrice": 3.526066,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-142",
    "barcode": "142",
    "imageUrl": "http://almoune.fr/img/p/1/8/3/2/1832.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-143",
    "name": "Yaourt  - Suntat 1kg",
    "price": 3.3,
    "purchasePrice": 3.127962,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-143",
    "barcode": "143",
    "imageUrl": "http://almoune.fr/img/p/1/8/3/3/1833.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-144",
    "name": "Thé Ceylan nature  - Tanay 250g",
    "price": 2.27,
    "purchasePrice": 2.1527,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-144",
    "barcode": "144",
    "imageUrl": "http://almoune.fr/img/p/1/8/3/4/1834.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-145",
    "name": "Concentré de tomate  - Tukas 350g",
    "price": 1.66,
    "purchasePrice": 1.5752,
    "stock": 0,
    "category": "Concentrés",
    "sku": "SKU-145",
    "barcode": "145",
    "imageUrl": "http://almoune.fr/img/p/1/8/3/5/1835.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-146",
    "name": "Concentré de Piment Doux  - Tukas 700g",
    "price": 3.79,
    "purchasePrice": 3.592417,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-146",
    "barcode": "146",
    "imageUrl": "http://almoune.fr/img/p/1/8/3/6/1836.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-147",
    "name": "Biscuit chocolat albeni - Ulker 360g",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-147",
    "barcode": "147",
    "imageUrl": "http://almoune.fr/img/p/1/8/3/7/1837.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-148",
    "name": "Biscuit chocolat duo Biskrem  - Ulker 120g",
    "price": 1,
    "purchasePrice": 0.9479,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-148",
    "barcode": "148",
    "imageUrl": "http://almoune.fr/img/p/1/8/3/8/1838.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-149",
    "name": "Biscuit cacao Biskrem - Ulker 170g",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-149",
    "barcode": "149",
    "imageUrl": "http://almoune.fr/img/p/1/8/3/9/1839.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-150",
    "name": "Gaufrette Cikolatali  - Ulker 180g",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-150",
    "barcode": "150",
    "imageUrl": "http://almoune.fr/img/p/1/8/4/0/1840.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-151",
    "name": "Biscuit hally - Ulker 150g",
    "price": 1.14,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-151",
    "barcode": "151",
    "imageUrl": "http://almoune.fr/img/p/1/8/4/1/1841.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-152",
    "name": "Biscuit Kremali vanille - Ulker 300g",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-152",
    "barcode": "152",
    "imageUrl": "http://almoune.fr/img/p/1/8/4/2/1842.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-153",
    "name": "Biscuits Petit Beurre Cacao  - Ulker 450g",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-153",
    "barcode": "153",
    "imageUrl": "http://almoune.fr/img/p/1/8/4/3/1843.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-154",
    "name": "Biscuit Rouleau cacao - Ulker 150g",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-154",
    "barcode": "154",
    "imageUrl": "http://almoune.fr/img/p/1/8/4/4/1844.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-155",
    "name": "Salami dinde  - Yalya 80g",
    "price": 1.49,
    "purchasePrice": 1.412322,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-155",
    "barcode": "155",
    "imageUrl": "http://almoune.fr/img/p/1/8/4/5/1845.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-156",
    "name": "Sujuk fort  - Yalya 250g",
    "price": 2.5,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-156",
    "barcode": "156",
    "imageUrl": "http://almoune.fr/img/p/1/8/4/6/1846.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-157",
    "name": "Aubergine Grillée  - Yonca 510g",
    "price": 2.04,
    "purchasePrice": 1.9294,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-157",
    "barcode": "157",
    "imageUrl": "http://almoune.fr/img/p/1/8/4/7/1847.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-158",
    "name": "Fromage Msanara - 400g",
    "price": 6.25,
    "purchasePrice": 5.924171,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-158",
    "barcode": "158",
    "imageUrl": "http://almoune.fr/img/p/1/8/4/8/1848.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-159",
    "name": "Fromage Fil Sous Vide - 450g",
    "price": 6.75,
    "purchasePrice": 6.398104,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-159",
    "barcode": "159",
    "imageUrl": "http://almoune.fr/img/p/1/8/4/9/1849.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-160",
    "name": "Fromage Chilal - 450g",
    "price": 6.75,
    "purchasePrice": 6.398104,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-160",
    "barcode": "160",
    "imageUrl": "http://almoune.fr/img/p/1/8/5/0/1850.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-161",
    "name": "Olives vertes Salkini - 250g",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-161",
    "barcode": "161",
    "imageUrl": "http://almoune.fr/img/p/1/8/5/1/1851.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-162",
    "name": "Amandes Blanchies O'Régal - 250g",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-162",
    "barcode": "162",
    "imageUrl": "http://almoune.fr/img/p/1/8/5/2/1852.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-163",
    "name": "Amandes supremes crues O'Régal -400g",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-163",
    "barcode": "163",
    "imageUrl": "http://almoune.fr/img/p/1/8/5/3/1853.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-164",
    "name": "Maïs frit salé - O'Régal 250 g",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-164",
    "barcode": "164",
    "imageUrl": "http://almoune.fr/img/p/1/8/5/4/1854.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-165",
    "name": "Raisins secs Golden Jumbo Chilli - 250g",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-165",
    "barcode": "165",
    "imageUrl": "http://almoune.fr/img/p/1/8/5/5/1855.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-166",
    "name": "Raisins secs Golden Afrique du sud - 250g",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-166",
    "barcode": "166",
    "imageUrl": "http://almoune.fr/img/p/1/8/5/6/1856.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-167",
    "name": "Raisins secs noirs Jumbo - 250g",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-167",
    "barcode": "167",
    "imageUrl": "http://almoune.fr/img/p/1/8/5/7/1857.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-168",
    "name": "Sésame doré - 250 g",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-168",
    "barcode": "168",
    "imageUrl": "http://almoune.fr/img/p/1/8/5/8/1858.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-169",
    "name": "Baba Ghanouj Cortas - 430g",
    "price": 2.49,
    "purchasePrice": 2.3573,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-169",
    "barcode": "169",
    "imageUrl": "http://almoune.fr/img/p/1/8/5/9/1859.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-170",
    "name": "Café Super Brasil - 180g",
    "price": 6.25,
    "purchasePrice": 5.924171,
    "stock": 23,
    "category": "Cafés",
    "sku": "SKU-170",
    "barcode": "170",
    "imageUrl": "http://almoune.fr/img/p/1/8/6/0/1860.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-171",
    "name": "Confiture de coings - Cortas 370g",
    "price": 3.27,
    "purchasePrice": 3.0998,
    "stock": 0,
    "category": "Confitures",
    "sku": "SKU-171",
    "barcode": "171",
    "imageUrl": "http://almoune.fr/img/p/1/8/6/1/1861.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-172",
    "name": "Confiture de figues - Cortas 370g",
    "price": 3.27,
    "purchasePrice": 3.0998,
    "stock": 0,
    "category": "Confitures",
    "sku": "SKU-172",
    "barcode": "172",
    "imageUrl": "http://almoune.fr/img/p/1/8/6/2/1862.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-173",
    "name": "Concombres marinés - Cortas 625g",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-173",
    "barcode": "173",
    "imageUrl": "http://almoune.fr/img/p/1/8/6/3/1863.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-174",
    "name": "Foul Cortas - 400g",
    "price": 1.22,
    "purchasePrice": 1.156398,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-174",
    "barcode": "174",
    "imageUrl": "http://almoune.fr/img/p/3/8/1/8/3818.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-175",
    "name": "Fromage Akawi Milky's 250g",
    "price": 3.15,
    "purchasePrice": 2.98925,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-175",
    "barcode": "175",
    "imageUrl": "http://almoune.fr/img/p/1/8/6/5/1865.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-176",
    "name": "Fromage Feta Alexandre Protos 250 g",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-176",
    "barcode": "176",
    "imageUrl": "http://almoune.fr/img/p/1/8/6/6/1866.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-177",
    "name": "Fromage Halloumi Milky's 250 g.",
    "price": 3.15,
    "purchasePrice": 2.98925,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-177",
    "barcode": "177",
    "imageUrl": "http://almoune.fr/img/p/1/8/6/7/1867.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-178",
    "name": "Fromage Naboulsi Milky's 250 g",
    "price": 3.15,
    "purchasePrice": 2.98925,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-178",
    "barcode": "178",
    "imageUrl": "http://almoune.fr/img/p/1/8/6/8/1868.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-179",
    "name": "Halawa Chocolat - Kanater 450g",
    "price": 5.2,
    "purchasePrice": 4.334,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-179",
    "barcode": "179",
    "imageUrl": "http://almoune.fr/img/p/1/8/6/9/1869.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-180",
    "name": "Halawa Nature Diet - Kanater 450g",
    "price": 6.23,
    "purchasePrice": 5.192,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-180",
    "barcode": "180",
    "imageUrl": "http://almoune.fr/img/p/1/8/7/0/1870.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-181",
    "name": "Halawa Nature - Kanater 450g",
    "price": 4.85,
    "purchasePrice": 4.041667,
    "stock": 3,
    "category": "Halawa",
    "sku": "SKU-181",
    "barcode": "181",
    "imageUrl": "http://almoune.fr/img/p/1/8/7/1/1871.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-182",
    "name": "Halawa Pistaches - Kanater 450g",
    "price": 5.89,
    "purchasePrice": 4.906,
    "stock": 4,
    "category": "Halawa",
    "sku": "SKU-182",
    "barcode": "182",
    "imageUrl": "http://almoune.fr/img/p/1/8/7/2/1872.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-183",
    "name": "Houmous Tahina - Cortas 400g",
    "price": 1.51,
    "purchasePrice": 1.4278,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-183",
    "barcode": "183",
    "imageUrl": "http://almoune.fr/img/p/1/8/7/3/1873.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-185",
    "name": "Légumes marinés mixtes Cortas 625 g",
    "price": 3.19,
    "purchasePrice": 3.025,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-185",
    "barcode": "185",
    "imageUrl": "http://almoune.fr/img/p/1/8/7/5/1875.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-186",
    "name": "Loufa naturelle",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Autres",
    "sku": "SKU-186",
    "barcode": "186",
    "imageUrl": "http://almoune.fr/img/p/1/8/7/6/1876.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-187",
    "name": "Man w salwa Ghrawi 250 g",
    "price": 6.25,
    "purchasePrice": 5.208333,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-187",
    "barcode": "187",
    "imageUrl": "http://almoune.fr/img/p/1/8/7/7/1877.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-188",
    "name": "Mélasse de Caroube - Cortas 560g",
    "price": 5.55,
    "purchasePrice": 5.258,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-188",
    "barcode": "188",
    "imageUrl": "http://almoune.fr/img/p/1/8/7/8/1878.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-189",
    "name": "Mouloukhieh en feuilles cuites (Corète potagère) Cortas 775 g",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-189",
    "barcode": "189",
    "imageUrl": "http://almoune.fr/img/p/1/8/7/9/1879.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-190",
    "name": "Mélasse de Grenade - Cortas 300 ml",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-190",
    "barcode": "190",
    "imageUrl": "http://almoune.fr/img/p/1/8/8/0/1880.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-191",
    "name": "Makdous Cortas 625 g",
    "price": 6.48,
    "purchasePrice": 6.138,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-191",
    "barcode": "191",
    "imageUrl": "http://almoune.fr/img/p/1/8/8/1/1881.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-192",
    "name": "Concombre arménien sauvage Cortas 625 g",
    "price": 4.85,
    "purchasePrice": 4.597156,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-192",
    "barcode": "192",
    "imageUrl": "http://almoune.fr/img/p/1/8/8/2/1882.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-193",
    "name": "Mouhalabieh  - Cortas 200g",
    "price": 2.1,
    "purchasePrice": 1.990521,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-193",
    "barcode": "193",
    "imageUrl": "http://almoune.fr/img/p/1/8/8/3/1883.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-194",
    "name": "Moule Falafel 100 g",
    "price": 5,
    "purchasePrice": 4.166667,
    "stock": 0,
    "category": "Autres",
    "sku": "SKU-194",
    "barcode": "194",
    "imageUrl": "http://almoune.fr/img/p/1/8/8/4/1884.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-195",
    "name": "Moule Maamoul  datte grand",
    "price": 5.5,
    "purchasePrice": 4.583333,
    "stock": 0,
    "category": "Autres",
    "sku": "SKU-195",
    "barcode": "195",
    "imageUrl": "http://almoune.fr/img/p/1/8/8/5/1885.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-196",
    "name": "Moule Maamoul datte Petit",
    "price": 3.8,
    "purchasePrice": 3.166667,
    "stock": 0,
    "category": "Autres",
    "sku": "SKU-196",
    "barcode": "196",
    "imageUrl": "http://almoune.fr/img/p/1/8/8/6/1886.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-197",
    "name": "Moule Maamoul Noix grand",
    "price": 5.5,
    "purchasePrice": 4.583333,
    "stock": 0,
    "category": "Autres",
    "sku": "SKU-197",
    "barcode": "197",
    "imageUrl": "http://almoune.fr/img/p/1/8/8/7/1887.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-198",
    "name": "Moule Maamoul noix Petit",
    "price": 3.8,
    "purchasePrice": 3.166667,
    "stock": 0,
    "category": "Autres",
    "sku": "SKU-198",
    "barcode": "198",
    "imageUrl": "http://almoune.fr/img/p/1/8/8/8/1888.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-199",
    "name": "Moule Maamoul Pistaches grand 170 g",
    "price": 5.5,
    "purchasePrice": 4.583333,
    "stock": 0,
    "category": "Autres",
    "sku": "SKU-199",
    "barcode": "199",
    "imageUrl": "http://almoune.fr/img/p/1/8/8/9/1889.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-200",
    "name": "Moule Maamoul Pistaches Petit",
    "price": 3.8,
    "purchasePrice": 3.166667,
    "stock": 0,
    "category": "Autres",
    "sku": "SKU-200",
    "barcode": "200",
    "imageUrl": "http://almoune.fr/img/p/1/8/9/0/1890.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-201",
    "name": "Nougats Abricot  250 g",
    "price": 6.59,
    "purchasePrice": 5.49175,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-201",
    "barcode": "201",
    "imageUrl": "http://almoune.fr/img/p/1/8/9/1/1891.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-202",
    "name": "Olives noires Koura 500 g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 158,
    "category": "Olives",
    "sku": "SKU-202",
    "barcode": "202",
    "imageUrl": "http://almoune.fr/img/p/1/8/9/2/1892.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-204",
    "name": "Pâte de dattes d'Algérie - 1kg",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-204",
    "barcode": "204",
    "imageUrl": "http://almoune.fr/img/p/1/8/9/4/1894.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-205",
    "name": "Pois chiches secs Mexique 42/44 1kg",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-205",
    "barcode": "205",
    "imageUrl": "http://almoune.fr/img/p/1/8/9/5/1895.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-206",
    "name": "Pois chiches secs petit calibre 1kg",
    "price": 2.36,
    "purchasePrice": 2.233,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-206",
    "barcode": "206",
    "imageUrl": "http://almoune.fr/img/p/1/8/9/6/1896.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-207",
    "name": "Tahini (crème de sésame) - Al Kanater 900 g",
    "price": 7.99,
    "purchasePrice": 7.57346,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-207",
    "barcode": "207",
    "imageUrl": "http://almoune.fr/img/p/1/8/9/7/1897.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-208",
    "name": "Biscuits Unica x24 - Gandour 600g",
    "price": 7.99,
    "purchasePrice": 7.57346,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-208",
    "barcode": "208",
    "imageUrl": "http://almoune.fr/img/p/1/8/9/8/1898.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-209",
    "name": "Biscuit Unica - Gandour 25g",
    "price": 0.25,
    "purchasePrice": 0.236967,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-209",
    "barcode": "209",
    "imageUrl": "http://almoune.fr/img/p/1/8/9/9/1899.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-210",
    "name": "Légumes Marinés mixtes Yonca 250 gr",
    "price": 1,
    "purchasePrice": 0.9479,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-210",
    "barcode": "210",
    "imageUrl": "http://almoune.fr/img/p/1/9/0/0/1900.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-211",
    "name": "Yaourt Grec Kolios 1kg",
    "price": 4.15,
    "purchasePrice": 3.933649,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-211",
    "barcode": "211",
    "imageUrl": "http://almoune.fr/img/p/1/9/0/1/1901.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-212",
    "name": "Labneh Kolios 500 g",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": -41,
    "category": "Aliments et Laitiers",
    "sku": "SKU-212",
    "barcode": "212",
    "imageUrl": "http://almoune.fr/img/p/1/9/0/2/1902.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-213",
    "name": "Figues Séchées en sachet 500 g",
    "price": 9.5,
    "purchasePrice": 9.004739,
    "stock": 3,
    "category": "Fruits secs",
    "sku": "SKU-213",
    "barcode": "213",
    "imageUrl": "http://almoune.fr/img/p/1/9/0/3/1903.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-214",
    "name": "Figues Sechees Evias 250 g",
    "price": 3.49,
    "purchasePrice": 3.311,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-214",
    "barcode": "214",
    "imageUrl": "http://almoune.fr/img/p/1/9/0/4/1904.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-215",
    "name": "Kaak ou Gressini à l'ancienne - Cnossos 250g",
    "price": 2.45,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-215",
    "barcode": "215",
    "imageUrl": "http://almoune.fr/img/p/1/9/0/5/1905.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-216",
    "name": "Pignons Kernels dela Siberie 50 g",
    "price": 2.35,
    "purchasePrice": 2.227488,
    "stock": 7,
    "category": "Fruits secs",
    "sku": "SKU-216",
    "barcode": "216",
    "imageUrl": "http://almoune.fr/img/p/1/9/0/6/1906.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-217",
    "name": "Keshek végétal SHP 454g",
    "price": 14.99,
    "purchasePrice": 14.208531,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-217",
    "barcode": "217",
    "imageUrl": "http://almoune.fr/img/p/1/9/0/7/1907.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-218",
    "name": "Pain grillé Gressini A l'anis Cnossos 250g",
    "price": 2.45,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-218",
    "barcode": "218",
    "imageUrl": "http://almoune.fr/img/p/1/9/0/8/1908.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-219",
    "name": "Miel Grec - Attiki (1ère qualité) 500g",
    "price": 10.79,
    "purchasePrice": 10.2256,
    "stock": 0,
    "category": "Mélasses et miels",
    "sku": "SKU-219",
    "barcode": "219",
    "imageUrl": "http://almoune.fr/img/p/1/9/0/9/1909.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-220",
    "name": "Miel Toutes Fleurs 1kg",
    "price": 9.5,
    "purchasePrice": 9.004739,
    "stock": 3,
    "category": "Mélasses et miels",
    "sku": "SKU-220",
    "barcode": "220",
    "imageUrl": "http://almoune.fr/img/p/1/9/1/0/1910.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-221",
    "name": "Vin Rouge Reserve Du Couvent - 75 cl KSARA",
    "price": 10.9,
    "purchasePrice": 9.083333,
    "stock": -73,
    "category": "Accueil",
    "sku": "SKU-221",
    "barcode": "221",
    "imageUrl": "http://almoune.fr/img/p/3/6/0/1/3601.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-222",
    "name": "Arak Ksara 70 cl",
    "price": 36,
    "purchasePrice": 30,
    "stock": -1,
    "category": "Arack ou Arak Libanais",
    "sku": "SKU-222",
    "barcode": "222",
    "imageUrl": "http://almoune.fr/img/p/3/5/6/8/3568.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-223",
    "name": "Fromage crème Puck Tartinable 500g",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-223",
    "barcode": "223",
    "imageUrl": "http://almoune.fr/img/p/1/9/1/3/1913.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-224",
    "name": "Fromage Feta Kolios BIO 200g",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-224",
    "barcode": "224",
    "imageUrl": "http://almoune.fr/img/p/1/9/1/4/1914.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-225",
    "name": "Sirop de Mures  - Anjar 60cl",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 9,
    "category": "Accueil",
    "sku": "SKU-225",
    "barcode": "225",
    "imageUrl": "http://almoune.fr/img/p/1/9/1/5/1915.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-226",
    "name": "Mélasse de Raisin - Anjar 800g",
    "price": 5.51,
    "purchasePrice": 5.2206,
    "stock": 1,
    "category": "Mélasses et miels",
    "sku": "SKU-226",
    "barcode": "226",
    "imageUrl": "http://almoune.fr/img/p/1/9/1/6/1916.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-227",
    "name": "Thym Mariné - Mechelany 600g",
    "price": 4.75,
    "purchasePrice": 6.398104,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-227",
    "barcode": "227",
    "imageUrl": "http://almoune.fr/img/p/1/9/1/7/1917.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-228",
    "name": "Sirop de Tamarin - Anjar 60cl",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-228",
    "barcode": "228",
    "imageUrl": "http://almoune.fr/img/p/1/9/1/8/1918.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-229",
    "name": "Concombres sauvages Marinés Mekté Dewan 600 gr",
    "price": 3.66,
    "purchasePrice": 3.4705,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-229",
    "barcode": "229",
    "imageUrl": "http://almoune.fr/img/p/1/9/1/9/1919.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-230",
    "name": "Gombo Bamia Tamek 800g",
    "price": 2.91,
    "purchasePrice": 2.7555,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-230",
    "barcode": "230",
    "imageUrl": "http://almoune.fr/img/p/1/9/2/0/1920.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-231",
    "name": "Purée d'aubergines grillées - Paliria 680g",
    "price": 4.49,
    "purchasePrice": 4.255924,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-231",
    "barcode": "231",
    "imageUrl": "http://almoune.fr/img/p/1/9/2/1/1921.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-232",
    "name": "Feuille de vigne chirag 280g",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-232",
    "barcode": "232",
    "imageUrl": "http://almoune.fr/img/p/1/9/2/2/1922.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-233",
    "name": "Piments Forts marinés Anjar 600g",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-233",
    "barcode": "233",
    "imageUrl": "http://almoune.fr/img/p/1/9/2/3/1923.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-234",
    "name": "Piments Verts marinés en vrac - KOZAT 500 g. net",
    "price": 2.95,
    "purchasePrice": 2.796209,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-234",
    "barcode": "234",
    "imageUrl": "http://almoune.fr/img/p/1/9/2/4/1924.jpg",
    "price_per_kg": 2.95
  },
  {
    "id": "csv-235",
    "name": "Arome De rose Anjar 300 ml",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 1,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-235",
    "barcode": "235",
    "imageUrl": "http://almoune.fr/img/p/1/9/2/5/1925.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-236",
    "name": "Arôme de fleur d'oranger - Anjar 300 ml",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-236",
    "barcode": "236",
    "imageUrl": "http://almoune.fr/img/p/1/9/2/6/1926.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-237",
    "name": "Café Najjar Nature 220g",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 47,
    "category": "Accueil",
    "sku": "SKU-237",
    "barcode": "237",
    "imageUrl": "http://almoune.fr/img/p/1/9/2/7/1927.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-238",
    "name": "Loukoum Assortis Rahat - Bolero 300g",
    "price": 2.71,
    "purchasePrice": 3.0943,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-238",
    "barcode": "238",
    "imageUrl": "http://almoune.fr/img/p/1/9/2/8/1928.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-239",
    "name": "Baklava Triangle 1 piece (140g)",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-239",
    "barcode": "239",
    "imageUrl": "http://almoune.fr/img/p/1/9/2/9/1929.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-240",
    "name": "Kadaif 1 Piece  (140g)",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-240",
    "barcode": "240",
    "imageUrl": "http://almoune.fr/img/p/1/9/3/0/1930.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-241",
    "name": "Dattes D'Iran Nazila env 500g",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-241",
    "barcode": "241",
    "imageUrl": "http://almoune.fr/img/p/1/9/3/1/1931.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-242",
    "name": "Sucette Chupa Chups ( Une pièce parfun aléatoire)",
    "price": 0.5,
    "purchasePrice": 0.4167,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-242",
    "barcode": "242",
    "imageUrl": "http://almoune.fr/img/p/1/9/3/2/1932.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-243",
    "name": "HUILE de TOURNESOL Roch  1L",
    "price": 3.17,
    "purchasePrice": 3.0085,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-243",
    "barcode": "243",
    "imageUrl": "http://almoune.fr/img/p/1/9/3/3/1933.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-244",
    "name": "FARINE DE BLE ARO T55 1KG",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-244",
    "barcode": "244",
    "imageUrl": "http://almoune.fr/img/p/1/9/3/4/1934.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-245",
    "name": "SUCRE EN Poudre  Roch1 KG",
    "price": 1.92,
    "purchasePrice": 1.81544,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-245",
    "barcode": "245",
    "imageUrl": "http://almoune.fr/img/p/1/9/3/5/1935.jpg",
    "price_per_kg": 1.92
  },
  {
    "id": "csv-246",
    "name": "LEVURE boulangère fraiche FALA 42G",
    "price": 0.5,
    "purchasePrice": 0.4739,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-246",
    "barcode": "246",
    "imageUrl": "http://almoune.fr/img/p/1/9/3/6/1936.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-247",
    "name": "Castania Super Extra mixte 450g.",
    "price": 12.75,
    "purchasePrice": 12.085308,
    "stock": 12,
    "category": "Fruits à coques grillés",
    "sku": "SKU-247",
    "barcode": "247",
    "imageUrl": "http://almoune.fr/img/p/4/0/3/4/4034.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-248",
    "name": "Castania EXTRA 300g",
    "price": 5.99,
    "purchasePrice": 5.677725,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-248",
    "barcode": "248",
    "imageUrl": "http://almoune.fr/img/p/1/9/3/8/1938.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-249",
    "name": "Castania cacahuètes frites 100g.",
    "price": 1.5,
    "purchasePrice": 1.800948,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-249",
    "barcode": "249",
    "imageUrl": "http://almoune.fr/img/p/1/9/3/9/1939.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-250",
    "name": "Castania Cacahuetes krikri BBQ 100 g.",
    "price": 1.5,
    "purchasePrice": 1.800948,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-250",
    "barcode": "250",
    "imageUrl": "http://almoune.fr/img/p/1/9/4/0/1940.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-251",
    "name": "Paté de boeuf Halal ZWAN  340 g",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": -1,
    "category": "Aliments et Laitiers",
    "sku": "SKU-251",
    "barcode": "251",
    "imageUrl": "http://almoune.fr/img/p/1/9/4/1/1941.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-252",
    "name": "Thym Libanais (Zaatar) - Abido 500g",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 53,
    "category": "Accueil",
    "sku": "SKU-252",
    "barcode": "252",
    "imageUrl": "http://almoune.fr/img/p/1/9/4/2/1942.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-253",
    "name": "Sardines Au piment et à l'huile de tournesol 125g",
    "price": 1.1,
    "purchasePrice": 1.042654,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-253",
    "barcode": "253",
    "imageUrl": "http://almoune.fr/img/p/1/9/4/3/1943.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-254",
    "name": "Hot dog Poulet- Al RAII 400g",
    "price": 2.06,
    "purchasePrice": 1.952607,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-254",
    "barcode": "254",
    "imageUrl": "http://almoune.fr/img/p/1/9/4/4/1944.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-255",
    "name": "Halawa Super Fruits secs KASIH 400g",
    "price": 4.8,
    "purchasePrice": 4.549763,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-255",
    "barcode": "255",
    "imageUrl": "http://almoune.fr/img/p/1/9/4/5/1945.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-256",
    "name": "Salade d'olives Durra 325g",
    "price": 3.17,
    "purchasePrice": 3.0085,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-256",
    "barcode": "256",
    "imageUrl": "http://almoune.fr/img/p/1/9/4/6/1946.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-257",
    "name": "Confiture de Cerises Durra 430g",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Confitures",
    "sku": "SKU-257",
    "barcode": "257",
    "imageUrl": "http://almoune.fr/img/p/1/9/4/7/1947.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-258",
    "name": "Maggi Bouillon Cube poulet 21g",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-258",
    "barcode": "258",
    "imageUrl": "http://almoune.fr/img/p/1/9/4/8/1948.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-259",
    "name": "Sel- 1 kg",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": -37,
    "category": "Condiments",
    "sku": "SKU-259",
    "barcode": "259",
    "imageUrl": "http://almoune.fr/img/p/1/9/4/9/1949.jpg",
    "price_per_kg": 0.99
  },
  {
    "id": "csv-260",
    "name": "NavetsMarinés Chtoura Garden-1kg",
    "price": 4.01,
    "purchasePrice": 3.8027,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-260",
    "barcode": "260",
    "imageUrl": "http://almoune.fr/img/p/1/9/5/0/1950.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-261",
    "name": "Fèves Grandes - Durra- 400g",
    "price": 1.49,
    "purchasePrice": 1.412322,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-261",
    "barcode": "261",
    "imageUrl": "http://almoune.fr/img/p/1/9/5/1/1951.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-262",
    "name": "Concombres sauvages marinés Mekte Chtoura- 1kg",
    "price": 4.33,
    "purchasePrice": 4.103,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-262",
    "barcode": "262",
    "imageUrl": "http://almoune.fr/img/p/1/9/5/2/1952.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-263",
    "name": "Vinaigre Blanc  Chtoura Garden 1L",
    "price": 2.26,
    "purchasePrice": 2.1417,
    "stock": 0,
    "category": "Huiles et vinaigres",
    "sku": "SKU-263",
    "barcode": "263",
    "imageUrl": "http://almoune.fr/img/p/1/9/5/3/1953.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-264",
    "name": "Makdous à l'huile  (Aubergines farcies) Durra 600g",
    "price": 6.75,
    "purchasePrice": 6.398104,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-264",
    "barcode": "264",
    "imageUrl": "http://almoune.fr/img/p/1/9/5/4/1954.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-265",
    "name": "Feuilles de vigne à farcir  400G",
    "price": 3.9,
    "purchasePrice": 3.696,
    "stock": 1,
    "category": "Aliments et Laitiers",
    "sku": "SKU-265",
    "barcode": "265",
    "imageUrl": "http://almoune.fr/img/p/1/9/5/5/1955.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-266",
    "name": "Riz rond Egyptien - 900g",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-266",
    "barcode": "266",
    "imageUrl": "http://almoune.fr/img/p/4/0/2/3/4023.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-267",
    "name": "Infusion Mélange de plantes (Zhourat) - Abido 100 g",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-267",
    "barcode": "267",
    "imageUrl": "http://almoune.fr/img/p/1/9/5/7/1957.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-269",
    "name": "Savon dettol antibactérien original 65g",
    "price": 1,
    "purchasePrice": 0.8333,
    "stock": 0,
    "category": "Autres",
    "sku": "SKU-269",
    "barcode": "269",
    "imageUrl": "http://almoune.fr/img/p/1/9/5/9/1959.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-270",
    "name": "Dattes Deglet Nour Algérie- 1kg",
    "price": 7.52,
    "purchasePrice": 7.128,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-270",
    "barcode": "270",
    "imageUrl": "http://almoune.fr/img/p/1/9/6/0/1960.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-271",
    "name": "Dattes Deglet Nour Algérie-400g",
    "price": 3.57,
    "purchasePrice": 3.383886,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-271",
    "barcode": "271",
    "imageUrl": "http://almoune.fr/img/p/1/9/6/1/1961.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-272",
    "name": "Loukoum Mastic  (Raha) - 400g",
    "price": 1.9,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-272",
    "barcode": "272",
    "imageUrl": "http://almoune.fr/img/p/1/9/6/2/1962.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-273",
    "name": "Pois chiche bouillis Nahil 540gr",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-273",
    "barcode": "273",
    "imageUrl": "http://almoune.fr/img/p/1/9/6/3/1963.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-274",
    "name": "Huile d'olive Extra vierge Chtoura Garden 500mL",
    "price": 6.56,
    "purchasePrice": 6.2161,
    "stock": 0,
    "category": "Huiles et vinaigres",
    "sku": "SKU-274",
    "barcode": "274",
    "imageUrl": "http://almoune.fr/img/p/1/9/6/4/1964.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-275",
    "name": "Pois chiche Gros Calibre Prizma 1kg",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-275",
    "barcode": "275",
    "imageUrl": "http://almoune.fr/img/p/1/9/6/5/1965.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-276",
    "name": "Boulghour Fin Brun - Prizma 1kg",
    "price": 2.19,
    "purchasePrice": 2.0757,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-276",
    "barcode": "276",
    "imageUrl": "http://almoune.fr/img/p/1/9/6/6/1966.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-277",
    "name": "Mograbieh (Pates) - Chtoura Garden 900 g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-277",
    "barcode": "277",
    "imageUrl": "http://almoune.fr/img/p/1/9/6/7/1967.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-278",
    "name": "Haricots Cornille en vrac - 1kg",
    "price": 3.4,
    "purchasePrice": 3.2197,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-278",
    "barcode": "278",
    "imageUrl": "http://almoune.fr/img/p/3/6/8/7/3687.jpg",
    "price_per_kg": 3.4
  },
  {
    "id": "csv-279",
    "name": "Boulghour Gros Brun - Chtoura Garden  900g",
    "price": 2.36,
    "purchasePrice": 2.2385,
    "stock": 6,
    "category": "Aliments et Laitiers",
    "sku": "SKU-279",
    "barcode": "279",
    "imageUrl": "http://almoune.fr/img/p/1/9/6/9/1969.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-280",
    "name": "Fèves Vertes Grandes Surgelées - Basma 400gr",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-280",
    "barcode": "280",
    "imageUrl": "http://almoune.fr/img/p/1/9/7/0/1970.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-281",
    "name": "Mouloukhia feuilles entières Basma 400gr",
    "price": 2.01,
    "purchasePrice": 1.9085,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-281",
    "barcode": "281",
    "imageUrl": "http://almoune.fr/img/p/1/9/7/1/1971.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-282",
    "name": "Mouloukhiye feuilles hachées Basma- 400g",
    "price": 2.01,
    "purchasePrice": 1.9085,
    "stock": -11,
    "category": "Accueil",
    "sku": "SKU-282",
    "barcode": "282",
    "imageUrl": "http://almoune.fr/img/p/1/9/7/2/1972.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-283",
    "name": "Basma Gombo Extra 400gr",
    "price": 2.68,
    "purchasePrice": 2.5377,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-283",
    "barcode": "283",
    "imageUrl": "http://almoune.fr/img/p/1/9/7/3/1973.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-284",
    "name": "Basma Gombo Classique Excellent 400gr",
    "price": 2.01,
    "purchasePrice": 1.9085,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-284",
    "barcode": "284",
    "imageUrl": "http://almoune.fr/img/p/1/9/7/4/1974.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-285",
    "name": "Falafel 12 pièces - Mr. Falafel 400g",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-285",
    "barcode": "285",
    "imageUrl": "http://almoune.fr/img/p/1/9/7/5/1975.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-286",
    "name": "Crème à dessert Puck 170 gr",
    "price": 1.87,
    "purchasePrice": 2.36019,
    "stock": 1,
    "category": "Aliments et Laitiers",
    "sku": "SKU-286",
    "barcode": "286",
    "imageUrl": "http://almoune.fr/img/p/1/9/7/6/1976.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-287",
    "name": "Poudre de Cacao - 200gr",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 1,
    "category": "Condiments",
    "sku": "SKU-287",
    "barcode": "287",
    "imageUrl": "http://almoune.fr/img/p/1/9/7/7/1977.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-288",
    "name": "Bonbons pâte d'abricot - SAHHA 400g",
    "price": 3.22,
    "purchasePrice": 3.0525,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-288",
    "barcode": "288",
    "imageUrl": "http://almoune.fr/img/p/1/9/7/8/1978.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-289",
    "name": "Ghee vegetal (samneh) Aseel  500gr",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 5,
    "category": "Aliments et Laitiers",
    "sku": "SKU-289",
    "barcode": "289",
    "imageUrl": "http://almoune.fr/img/p/1/9/7/9/1979.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-290",
    "name": "Patisserie Ouch BOULBOUL Rashid 475g",
    "price": 12.39,
    "purchasePrice": 11.7414,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-290",
    "barcode": "290",
    "imageUrl": "http://almoune.fr/img/p/1/9/8/0/1980.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-291",
    "name": "Baklava Rashid 400g",
    "price": 12.07,
    "purchasePrice": 11.4389,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-291",
    "barcode": "291",
    "imageUrl": "http://almoune.fr/img/p/1/9/8/1/1981.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-292",
    "name": "Huile d'olive al kheir 1l",
    "price": 8.14,
    "purchasePrice": 7.711,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-292",
    "barcode": "292",
    "imageUrl": "http://almoune.fr/img/p/1/9/8/2/1982.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-293",
    "name": "Cuillère ou paille à Maté (bombilla)",
    "price": 2,
    "purchasePrice": 1.666667,
    "stock": 20,
    "category": "Accueil",
    "sku": "SKU-293",
    "barcode": "293",
    "imageUrl": "http://almoune.fr/img/p/1/9/8/3/1983.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-294",
    "name": "Noix de coco rapée 300 gr",
    "price": 2.35,
    "purchasePrice": 2.227488,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-294",
    "barcode": "294",
    "imageUrl": "http://almoune.fr/img/p/1/9/8/4/1984.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-295",
    "name": "Sirop d'abricot - Anjar 60cl",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-295",
    "barcode": "295",
    "imageUrl": "http://almoune.fr/img/p/1/9/8/5/1985.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-296",
    "name": "Pruneaux d'Agen 500gr",
    "price": 3.35,
    "purchasePrice": 3.175355,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-296",
    "barcode": "296",
    "imageUrl": "http://almoune.fr/img/p/1/9/8/6/1986.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-298",
    "name": "Baklava Mixte Fraiche du Liban - Al Bohsali 500g",
    "price": 13,
    "purchasePrice": 14.652,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-298",
    "barcode": "298",
    "imageUrl": "http://almoune.fr/img/p/1/9/8/8/1988.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-299",
    "name": "Baklava Mixte Fraiche du Liban - Al Bohsali 1 kg",
    "price": 22,
    "purchasePrice": 25.5924,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-299",
    "barcode": "299",
    "imageUrl": "http://almoune.fr/img/p/1/9/8/9/1989.jpg",
    "price_per_kg": 22
  },
  {
    "id": "csv-300",
    "name": "Sirop de rose - Al Rabih 50 cL",
    "price": 6.75,
    "purchasePrice": 5.625,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-300",
    "barcode": "300",
    "imageUrl": "http://almoune.fr/img/p/1/9/9/0/1990.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-301",
    "name": "Castania graines de courge salées 250gr",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-301",
    "barcode": "301",
    "imageUrl": "http://almoune.fr/img/p/1/9/9/1/1991.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-302",
    "name": "Mélasse de Grenade - Al Rabih 250ml",
    "price": 3.5,
    "purchasePrice": 3.3175,
    "stock": 0,
    "category": "Mélasses et miels",
    "sku": "SKU-302",
    "barcode": "302",
    "imageUrl": "http://almoune.fr/img/p/1/9/9/2/1992.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-303",
    "name": "Feuilles de vigne à farcir en bocal- 650g",
    "price": 3.97,
    "purchasePrice": 3.7587,
    "stock": 1,
    "category": "Aliments et Laitiers",
    "sku": "SKU-303",
    "barcode": "303",
    "imageUrl": "http://almoune.fr/img/p/1/9/9/3/1993.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-304",
    "name": "Halawa Pistache - Rabih 907g",
    "price": 7.53,
    "purchasePrice": 7.1335,
    "stock": 0,
    "category": "Halawa",
    "sku": "SKU-304",
    "barcode": "304",
    "imageUrl": "http://almoune.fr/img/p/1/9/9/4/1994.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-305",
    "name": "Foul mdammas Rabih 800g",
    "price": 2.85,
    "purchasePrice": 2.701422,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-305",
    "barcode": "305",
    "imageUrl": "http://almoune.fr/img/p/1/9/9/5/1995.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-306",
    "name": "Boisson instantanee orange  (12 sachets) Aruba 360g",
    "price": 3.71,
    "purchasePrice": 3.5123,
    "stock": 0,
    "category": "Jus en poudre instantanée",
    "sku": "SKU-306",
    "barcode": "306",
    "imageUrl": "http://almoune.fr/img/p/1/9/9/6/1996.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-307",
    "name": "Boisson instantanee citron  (12 sachets) Aruba 360g",
    "price": 3.71,
    "purchasePrice": 3.5123,
    "stock": 0,
    "category": "Jus en poudre instantanée",
    "sku": "SKU-307",
    "barcode": "307",
    "imageUrl": "http://almoune.fr/img/p/1/9/9/7/1997.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-308",
    "name": "Café Najjar Beirut blend - 200gr",
    "price": 3.73,
    "purchasePrice": 3.5354,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-308",
    "barcode": "308",
    "imageUrl": "http://almoune.fr/img/p/3/6/1/8/3618.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-309",
    "name": "VERJUS de Raisin Durra 250g",
    "price": 3.94,
    "purchasePrice": 3.7308,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-309",
    "barcode": "309",
    "imageUrl": "http://almoune.fr/img/p/1/9/9/9/1999.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-310",
    "name": "Riz Basmati Durra-1 Kg",
    "price": 3.35,
    "purchasePrice": 3.1768,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-310",
    "barcode": "310",
    "imageUrl": "http://almoune.fr/img/p/2/0/0/0/2000.jpg",
    "price_per_kg": 3.35
  },
  {
    "id": "csv-311",
    "name": "Poudre Custard Original  - Aruba 200g",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-311",
    "barcode": "311",
    "imageUrl": "http://almoune.fr/img/p/2/0/0/1/2001.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-312",
    "name": "Olives vertes Salkini Cassées - vrac 500 g",
    "price": 3.9,
    "purchasePrice": 3.696682,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-312",
    "barcode": "312",
    "imageUrl": "http://almoune.fr/img/p/2/0/0/2/2002.jpg",
    "price_per_kg": 3.9
  },
  {
    "id": "csv-313",
    "name": "Falafel préparation Instantanée Rabih - 200g",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-313",
    "barcode": "313",
    "imageUrl": "http://almoune.fr/img/p/2/0/0/3/2003.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-314",
    "name": "Vinaigre de Pomme Durra 50cl",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 4,
    "category": "Aliments et Laitiers",
    "sku": "SKU-314",
    "barcode": "314",
    "imageUrl": "http://almoune.fr/img/p/2/0/0/4/2004.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-315",
    "name": "Piments marinés 550g Rabih",
    "price": 3.2,
    "purchasePrice": 3.0338,
    "stock": -2,
    "category": "Aliments et Laitiers",
    "sku": "SKU-315",
    "barcode": "315",
    "imageUrl": "http://almoune.fr/img/p/2/0/0/5/2005.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-316",
    "name": "Zaatar Vert Durra - 400g",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 11,
    "category": "Accueil",
    "sku": "SKU-316",
    "barcode": "316",
    "imageUrl": "http://almoune.fr/img/p/2/0/0/6/2006.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-317",
    "name": "Caviar d'aubergine Baba ghannouj Rabih 375g",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 11,
    "category": "Aliments et Laitiers",
    "sku": "SKU-317",
    "barcode": "317",
    "imageUrl": "http://almoune.fr/img/p/2/0/0/7/2007.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-318",
    "name": "Fromage Combi LEZZET - 800g",
    "price": 4.12,
    "purchasePrice": 3.9017,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-318",
    "barcode": "318",
    "imageUrl": "http://almoune.fr/img/p/2/0/0/8/2008.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-319",
    "name": "Caviar d' Aubergines-SAM-HAR-440G",
    "price": 3.5,
    "purchasePrice": 3.3209,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-319",
    "barcode": "319",
    "imageUrl": "http://almoune.fr/img/p/2/0/6/9/2069.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-320",
    "name": "ABRICOT JUMBO SECHE en vrac 250 g",
    "price": 2.5,
    "purchasePrice": 2.3697,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-320",
    "barcode": "320",
    "imageUrl": "http://almoune.fr/img/p/2/0/9/7/2097.jpg",
    "price_per_kg": 2.5
  },
  {
    "id": "csv-321",
    "name": "Butter ghee (samneh) - VACHE DE PARIS 400g",
    "price": 8.5,
    "purchasePrice": 8.056872,
    "stock": 5,
    "category": "Aliments et Laitiers",
    "sku": "SKU-321",
    "barcode": "321",
    "imageUrl": "http://almoune.fr/img/p/2/0/9/8/2098.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-322",
    "name": "Ail en poudre - Espig 100g",
    "price": 2,
    "purchasePrice": 1.8957,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-322",
    "barcode": "322",
    "imageUrl": "http://almoune.fr/img/p/2/0/9/9/2099.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-323",
    "name": "Sept Epices Abido 50 g",
    "price": 2.1,
    "purchasePrice": 1.990521,
    "stock": -4,
    "category": "Épices",
    "sku": "SKU-323",
    "barcode": "323",
    "imageUrl": "http://almoune.fr/img/p/2/1/0/0/2100.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-324",
    "name": "Epices Shawarma Boeuf Abido 50 g",
    "price": 1.9,
    "purchasePrice": 1.800948,
    "stock": 16,
    "category": "Épices",
    "sku": "SKU-324",
    "barcode": "324",
    "imageUrl": "http://almoune.fr/img/p/2/1/0/1/2101.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-325",
    "name": "Graines de Nigelle en vrac 50 g",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 2,
    "category": "Épices",
    "sku": "SKU-325",
    "barcode": "325",
    "imageUrl": "http://almoune.fr/img/p/3/7/8/2/3782.jpg",
    "price_per_kg": 1.75
  },
  {
    "id": "csv-326",
    "name": "Olives vertes Salkini - Durra 2.9 Kg",
    "price": 17.5,
    "purchasePrice": 16.587678,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-326",
    "barcode": "326",
    "imageUrl": "http://almoune.fr/img/p/2/1/0/3/2103.jpg",
    "price_per_kg": 17.5
  },
  {
    "id": "csv-327",
    "name": "Boisson instantané en poudre Ananas - Aruba 750g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Jus en poudre instantanée",
    "sku": "SKU-327",
    "barcode": "327",
    "imageUrl": "http://almoune.fr/img/p/2/1/0/4/2104.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-328",
    "name": "Fromage Chilal al halabi - 450g",
    "price": 8.99,
    "purchasePrice": 8.521327,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-328",
    "barcode": "328",
    "imageUrl": "http://almoune.fr/img/p/2/1/0/5/2105.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-329",
    "name": "Concentré de tomates Durra 650g",
    "price": 4.4,
    "purchasePrice": 4.170616,
    "stock": 13,
    "category": "Concentrés",
    "sku": "SKU-329",
    "barcode": "329",
    "imageUrl": "http://almoune.fr/img/p/2/1/0/6/2106.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-330",
    "name": "Fromage Chanklish Lailand 125 g",
    "price": 2.58,
    "purchasePrice": 2.442,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-330",
    "barcode": "330",
    "imageUrl": "http://almoune.fr/img/p/2/1/0/7/2107.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-331",
    "name": "Papier pour Sandwich et tartines ≈ 40 feuilles",
    "price": 1.25,
    "purchasePrice": 1.041667,
    "stock": 51,
    "category": "Autres",
    "sku": "SKU-331",
    "barcode": "331",
    "imageUrl": "http://almoune.fr/img/p/2/1/0/8/2108.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-332",
    "name": "Sana Maki infusion 40g",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 29,
    "category": "Infusions",
    "sku": "SKU-332",
    "barcode": "332",
    "imageUrl": "http://almoune.fr/img/p/2/1/0/9/2109.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-333",
    "name": "Pâté de poulet Halal Zwan - 340g",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 3,
    "category": "Aliments et Laitiers",
    "sku": "SKU-333",
    "barcode": "333",
    "imageUrl": "http://almoune.fr/img/p/2/1/1/0/2110.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-334",
    "name": "Fromage double creme Lailand 250g",
    "price": 2.75,
    "purchasePrice": 2.6066,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-334",
    "barcode": "334",
    "imageUrl": "http://almoune.fr/img/p/2/1/1/1/2111.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-335",
    "name": "Labneh yaourt egoute Lailand - 200g",
    "price": 2.84,
    "purchasePrice": 2.6917,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-335",
    "barcode": "335",
    "imageUrl": "http://almoune.fr/img/p/2/1/1/2/2112.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-336",
    "name": "Labneh vache avec huille 200g",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-336",
    "barcode": "336",
    "imageUrl": "http://almoune.fr/img/p/2/1/1/3/2113.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-337",
    "name": "Haricots Lingots Blancs 1kg",
    "price": 3.55,
    "purchasePrice": 3.3627,
    "stock": 3,
    "category": "Aliments et Laitiers",
    "sku": "SKU-337",
    "barcode": "337",
    "imageUrl": "http://almoune.fr/img/p/3/6/8/9/3689.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-338",
    "name": "Légumes Frits marinés Msakaa-SAM-HAR-440G",
    "price": 3.5,
    "purchasePrice": 3.3175,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-338",
    "barcode": "338",
    "imageUrl": "http://almoune.fr/img/p/2/1/1/5/2115.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-339",
    "name": "Menthe Séchée - ABIDO 30g",
    "price": 1.2,
    "purchasePrice": 1.137441,
    "stock": -1,
    "category": "Épices",
    "sku": "SKU-339",
    "barcode": "339",
    "imageUrl": "http://almoune.fr/img/p/2/1/1/6/2116.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-340",
    "name": "Semoule grosse Nahil 1kg",
    "price": 2.05,
    "purchasePrice": 1.947,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-340",
    "barcode": "340",
    "imageUrl": "http://almoune.fr/img/p/2/1/1/7/2117.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-341",
    "name": "Semoule Fine Altamora 1kg",
    "price": 2.05,
    "purchasePrice": 1.947,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-341",
    "barcode": "341",
    "imageUrl": "http://almoune.fr/img/p/2/1/1/8/2118.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-342",
    "name": "Fèveroles ou petites fèves 800 g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 28,
    "category": "Aliments et Laitiers",
    "sku": "SKU-342",
    "barcode": "342",
    "imageUrl": "http://almoune.fr/img/p/3/7/1/0/3710.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-343",
    "name": "Thym Zaatar  - Nahil 50g",
    "price": 0.78,
    "purchasePrice": 1.4487,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-343",
    "barcode": "343",
    "imageUrl": "http://almoune.fr/img/p/2/1/2/0/2120.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-344",
    "name": "Semoule Moyenne Halima 5kg",
    "price": 9.5,
    "purchasePrice": 9.0057,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-344",
    "barcode": "344",
    "imageUrl": "http://almoune.fr/img/p/2/1/2/1/2121.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-345",
    "name": "Piment Fort moulu 50g",
    "price": 1.6,
    "purchasePrice": 1.516588,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-345",
    "barcode": "345",
    "imageUrl": "http://almoune.fr/img/p/2/1/2/2/2122.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-346",
    "name": "Paprika Moulu Doux Abido 50g",
    "price": 1.7,
    "purchasePrice": 1.611374,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-346",
    "barcode": "346",
    "imageUrl": "http://almoune.fr/img/p/2/1/2/3/2123.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-347",
    "name": "Aubergines Séchées - Durra 75g",
    "price": 3.5,
    "purchasePrice": 3.982,
    "stock": 1,
    "category": "Aliments et Laitiers",
    "sku": "SKU-347",
    "barcode": "347",
    "imageUrl": "http://almoune.fr/img/p/2/1/2/4/2124.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-348",
    "name": "Feuilles de vigne farcies Durra- 400g",
    "price": 3.95,
    "purchasePrice": 3.744076,
    "stock": 9,
    "category": "Conserves",
    "sku": "SKU-348",
    "barcode": "348",
    "imageUrl": "http://almoune.fr/img/p/2/1/2/5/2125.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-349",
    "name": "Concentré de tomates en vrac - 250 g",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-349",
    "barcode": "349",
    "imageUrl": "http://almoune.fr/img/p/2/1/2/6/2126.jpg",
    "price_per_kg": 2
  },
  {
    "id": "csv-350",
    "name": "Concentré de Piments forts en vrac - 250 g",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-350",
    "barcode": "350",
    "imageUrl": "http://almoune.fr/img/p/2/1/2/7/2127.jpg",
    "price_per_kg": 2.5
  },
  {
    "id": "csv-352",
    "name": "Graines pépite Salées melon Samir 300g",
    "price": 3.85,
    "purchasePrice": 3.649289,
    "stock": 50,
    "category": "Fruits à coques grillés",
    "sku": "SKU-352",
    "barcode": "352",
    "imageUrl": "http://almoune.fr/img/p/2/1/2/9/2129.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-353",
    "name": "Graines de pastèque blanchies Salées  Samir 300g",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 14,
    "category": "Fruits à coques grillés",
    "sku": "SKU-353",
    "barcode": "353",
    "imageUrl": "http://almoune.fr/img/p/2/1/3/0/2130.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-354",
    "name": "Graines Salées Pasteque Noires Samir 300g",
    "price": 2.76,
    "purchasePrice": 2.6147,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-354",
    "barcode": "354",
    "imageUrl": "http://almoune.fr/img/p/2/1/3/1/2131.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-355",
    "name": "Corned Beef - 340g",
    "price": 7.49,
    "purchasePrice": 7.099526,
    "stock": 43,
    "category": "Aliments et Laitiers",
    "sku": "SKU-355",
    "barcode": "355",
    "imageUrl": "http://almoune.fr/img/p/2/1/3/2/2132.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-356",
    "name": "Haricots Blancs Géants - Akdeniz 570 g",
    "price": 1.74,
    "purchasePrice": 1.6511,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-356",
    "barcode": "356",
    "imageUrl": "http://almoune.fr/img/p/2/1/3/3/2133.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-357",
    "name": "Olives Noires Desséchées Grand Calibre 250 g",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-357",
    "barcode": "357",
    "imageUrl": "http://almoune.fr/img/p/2/1/3/4/2134.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-358",
    "name": "Pépites de tournesol salées - Beybaba 200g",
    "price": 0.93,
    "purchasePrice": 1.1187,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-358",
    "barcode": "358",
    "imageUrl": "http://almoune.fr/img/p/2/1/3/5/2135.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-359",
    "name": "Boulghour Fin Brun - Duru 1kg",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-359",
    "barcode": "359",
    "imageUrl": "http://almoune.fr/img/p/2/1/3/6/2136.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-360",
    "name": "Ble dur complet Duru 1 kg",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-360",
    "barcode": "360",
    "imageUrl": "http://almoune.fr/img/p/2/1/3/7/2137.jpg",
    "price_per_kg": 2.99
  },
  {
    "id": "csv-361",
    "name": "Fromage Combi Feta 60% Mg - SUTDIYARI  1Kg",
    "price": 11.74,
    "purchasePrice": 11.127962,
    "stock": 0,
    "category": "Fromages libanais",
    "sku": "SKU-361",
    "barcode": "361",
    "imageUrl": "http://almoune.fr/img/p/2/1/3/8/2138.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-362",
    "name": "Piment fort en paillettes - Firat 250g",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-362",
    "barcode": "362",
    "imageUrl": "http://almoune.fr/img/p/2/1/3/9/2139.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-363",
    "name": "Boulghour Fin Brun - Altunsa 900g",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 100,
    "category": "Boulghour",
    "sku": "SKU-363",
    "barcode": "363",
    "imageUrl": "http://almoune.fr/img/p/2/1/4/0/2140.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-364",
    "name": "Menthe firat 250g",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Epices",
    "sku": "SKU-364",
    "barcode": "364",
    "imageUrl": "http://almoune.fr/img/p/2/1/4/1/2141.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-365",
    "name": "Barbe à papa traditionnelle blanche - Beyaz 150g",
    "price": 1.5,
    "purchasePrice": 1.895735,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-365",
    "barcode": "365",
    "imageUrl": "http://almoune.fr/img/p/2/1/4/2/2142.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-366",
    "name": "Yaourt Yayla 10% 1kg",
    "price": 3.42,
    "purchasePrice": 3.2461,
    "stock": 0,
    "category": "Produits laitiers",
    "sku": "SKU-366",
    "barcode": "366",
    "imageUrl": "http://almoune.fr/img/p/2/1/4/3/2143.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-367",
    "name": "Barbe à papa traditionelle pistache beyaz 250g",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": 0,
    "category": "Patisseries",
    "sku": "SKU-367",
    "barcode": "367",
    "imageUrl": "http://almoune.fr/img/p/2/1/4/4/2144.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-368",
    "name": "Graines de courge decortiquées crues 250",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-368",
    "barcode": "368",
    "imageUrl": "http://almoune.fr/img/p/2/1/4/5/2145.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-369",
    "name": "Graines de courge grillées sans sel 500gr",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 4,
    "category": "Fruits à coques grillés",
    "sku": "SKU-369",
    "barcode": "369",
    "imageUrl": "http://almoune.fr/img/p/2/1/4/6/2146.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-370",
    "name": "Pasterma Miran tranches 100 g",
    "price": 4.14,
    "purchasePrice": 3.927,
    "stock": 0,
    "category": "Viandes - Poissons",
    "sku": "SKU-370",
    "barcode": "370",
    "imageUrl": "http://almoune.fr/img/p/2/1/4/7/2147.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-371",
    "name": "Graines de tournesol grillées sans sel 250 g",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-371",
    "barcode": "371",
    "imageUrl": "http://almoune.fr/img/p/2/1/4/8/2148.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-372",
    "name": "Fromage Haloum Milky 250g",
    "price": 3,
    "purchasePrice": 2.84625,
    "stock": 0,
    "category": "Fromages libanais",
    "sku": "SKU-372",
    "barcode": "372",
    "imageUrl": "http://almoune.fr/img/p/2/1/4/9/2149.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-373",
    "name": "Chanklish Golden Plate 250g",
    "price": 3.95,
    "purchasePrice": 3.744076,
    "stock": -5,
    "category": "Fromages libanais",
    "sku": "SKU-373",
    "barcode": "373",
    "imageUrl": "http://almoune.fr/img/p/2/1/5/0/2150.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-374",
    "name": "Haricots Lingots Rouges 1kg",
    "price": 3.55,
    "purchasePrice": 3.3627,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-374",
    "barcode": "374",
    "imageUrl": "http://almoune.fr/img/p/3/6/9/2/3692.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-375",
    "name": "Pâté de poulet Halal ZWAN 200gr",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-375",
    "barcode": "375",
    "imageUrl": "http://almoune.fr/img/p/2/1/5/2/2152.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-376",
    "name": "Lentilles Rouges - Akdeniz 900 g",
    "price": 2.26,
    "purchasePrice": 2.1384,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-376",
    "barcode": "376",
    "imageUrl": "http://almoune.fr/img/p/2/1/5/3/2153.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-377",
    "name": "Purée d'Aubergines grillées Suntat 590g",
    "price": 2.27,
    "purchasePrice": 2.156,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-377",
    "barcode": "377",
    "imageUrl": "http://almoune.fr/img/p/2/1/5/4/2154.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-378",
    "name": "Eau de fleur d'oranger 100%  naturelle mymoune 25cl",
    "price": 9.9,
    "purchasePrice": 9.383886,
    "stock": 2,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-378",
    "barcode": "378",
    "imageUrl": "http://almoune.fr/img/p/2/1/5/5/2155.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-379",
    "name": "Huile D'olive Vierge Extra Al-Wazir-1L",
    "price": 15.99,
    "purchasePrice": 15.156398,
    "stock": 0,
    "category": "Huiles et vinaigres",
    "sku": "SKU-379",
    "barcode": "379",
    "imageUrl": "http://almoune.fr/img/p/2/1/5/6/2156.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-380",
    "name": "Eau de Rose Chtoura 25 cL",
    "price": 2.15,
    "purchasePrice": 2.0379,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-380",
    "barcode": "380",
    "imageUrl": "http://almoune.fr/img/p/2/1/5/7/2157.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-381",
    "name": "Thon au piment - Durra 112g",
    "price": 1.75,
    "purchasePrice": 1.6588,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-381",
    "barcode": "381",
    "imageUrl": "http://almoune.fr/img/p/2/1/5/8/2158.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-382",
    "name": "Origan firat 250g",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-382",
    "barcode": "382",
    "imageUrl": "http://almoune.fr/img/p/2/1/5/9/2159.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-383",
    "name": "Vinaigre de raisin Durra 50cl",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 3,
    "category": "Aliments et Laitiers",
    "sku": "SKU-383",
    "barcode": "383",
    "imageUrl": "http://almoune.fr/img/p/2/1/6/0/2160.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-384",
    "name": "Aubergines Frites Tamek (Moussaka) 380g",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-384",
    "barcode": "384",
    "imageUrl": "http://almoune.fr/img/p/2/1/6/1/2161.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-385",
    "name": "Fromage Msanara - 900 g",
    "price": 11.43,
    "purchasePrice": 10.834123,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-385",
    "barcode": "385",
    "imageUrl": "http://almoune.fr/img/p/2/1/6/2/2162.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-386",
    "name": "Cumin Qualité suppérieur 100gr",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 28,
    "category": "Aliments et Laitiers",
    "sku": "SKU-386",
    "barcode": "386",
    "imageUrl": "http://almoune.fr/img/p/2/1/6/3/2163.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-387",
    "name": "Boisson instantanée orange  (30g) Aruba",
    "price": 0.4,
    "purchasePrice": 0.3791,
    "stock": 0,
    "category": "Jus en poudre instantanée",
    "sku": "SKU-387",
    "barcode": "387",
    "imageUrl": "http://almoune.fr/img/p/2/1/6/4/2164.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-388",
    "name": "Boisson instantanée citron  (30g) Aruba",
    "price": 0.4,
    "purchasePrice": 0.3791,
    "stock": 0,
    "category": "Jus en poudre instantanée",
    "sku": "SKU-388",
    "barcode": "388",
    "imageUrl": "http://almoune.fr/img/p/2/1/6/5/2165.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-389",
    "name": "Graines de tournesol décortiquées grillées salées 250g",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-389",
    "barcode": "389",
    "imageUrl": "http://almoune.fr/img/p/2/1/6/6/2166.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-390",
    "name": "Boisson instantanée en poudre Mangue - Aruba 750g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Infusions",
    "sku": "SKU-390",
    "barcode": "390",
    "imageUrl": "http://almoune.fr/img/p/2/1/6/7/2167.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-391",
    "name": "Pois chiche jaunes grillés 400g",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 22,
    "category": "Fruits à coques grillés",
    "sku": "SKU-391",
    "barcode": "391",
    "imageUrl": "http://almoune.fr/img/p/2/1/6/8/2168.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-392",
    "name": "Kechek Abido 500g",
    "price": 4.57,
    "purchasePrice": 4.334,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-392",
    "barcode": "392",
    "imageUrl": "http://almoune.fr/img/p/2/1/6/9/2169.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-393",
    "name": "Narjile Grand format",
    "price": 55,
    "purchasePrice": 45.833333,
    "stock": 0,
    "category": "Autres",
    "sku": "SKU-393",
    "barcode": "393",
    "imageUrl": "http://almoune.fr/img/p/2/1/7/0/2170.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-394",
    "name": "Pain Libanais - 5 pièces 220~240 gr",
    "price": 1.15,
    "purchasePrice": 1.090047,
    "stock": 7769,
    "category": "Accueil",
    "sku": "SKU-394",
    "barcode": "394",
    "imageUrl": "http://almoune.fr/img/p/2/4/9/0/2490.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-395",
    "name": "Pain Lavash env.360 g",
    "price": 3.57,
    "purchasePrice": 3.3836,
    "stock": 0,
    "category": "pain et Kaak",
    "sku": "SKU-395",
    "barcode": "395",
    "imageUrl": "http://almoune.fr/img/p/2/1/7/2/2172.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-396",
    "name": "Gombos Sechés 200g",
    "price": 6.5,
    "purchasePrice": 6.1644,
    "stock": 0,
    "category": "Légumineuses",
    "sku": "SKU-396",
    "barcode": "396",
    "imageUrl": "http://almoune.fr/img/p/2/1/7/3/2173.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-397",
    "name": "Piment de la Jamaique Moulu ( Bhar helo) - Abido50g",
    "price": 1.85,
    "purchasePrice": 1.753555,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-397",
    "barcode": "397",
    "imageUrl": "http://almoune.fr/img/p/2/1/7/4/2174.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-398",
    "name": "pâte d'amande pistache 300g",
    "price": 6.55,
    "purchasePrice": 6.204,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-398",
    "barcode": "398",
    "imageUrl": "http://almoune.fr/img/p/2/1/7/5/2175.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-399",
    "name": "pate d'amande forme de fruit 300g",
    "price": 5.95,
    "purchasePrice": 5.63981,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-399",
    "barcode": "399",
    "imageUrl": "http://almoune.fr/img/p/2/0/1/0/2010.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-406",
    "name": "Concentré Piments moyens - 250 g",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-406",
    "barcode": "406",
    "imageUrl": "http://almoune.fr/img/p/2/0/1/1/2011.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-407",
    "name": "Foul mdammas Rabih 400g",
    "price": 1.45,
    "purchasePrice": 1.374408,
    "stock": 3,
    "category": "Conserves",
    "sku": "SKU-407",
    "barcode": "407",
    "imageUrl": "http://almoune.fr/img/p/2/0/1/2/2012.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-408",
    "name": "Molokheya Moulue 100g",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 0,
    "category": "Légumineuses et grains",
    "sku": "SKU-408",
    "barcode": "408",
    "imageUrl": "http://almoune.fr/img/p/2/0/1/3/2013.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-409",
    "name": "Abricots secs 250 g",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 1,
    "category": "Fruits secs",
    "sku": "SKU-409",
    "barcode": "409",
    "imageUrl": "http://almoune.fr/img/p/2/0/1/4/2014.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-410",
    "name": "Boulghour Gros Blanc - 1 kg",
    "price": 3.55,
    "purchasePrice": 3.364929,
    "stock": 0,
    "category": "Boulghour",
    "sku": "SKU-410",
    "barcode": "410",
    "imageUrl": "http://almoune.fr/img/p/2/0/1/5/2015.jpg",
    "price_per_kg": 3.55
  },
  {
    "id": "csv-411",
    "name": "Lentilles Blondes 1kg",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": -8,
    "category": "Légumineuses",
    "sku": "SKU-411",
    "barcode": "411",
    "imageUrl": "http://almoune.fr/img/p/3/6/9/3/3693.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-412",
    "name": "Mouloukhieh Libanais Seché 100g",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Légumineuses",
    "sku": "SKU-412",
    "barcode": "412",
    "imageUrl": "http://almoune.fr/img/p/2/0/1/7/2017.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-413",
    "name": "Fromages du Liban Double cream 230g",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Fromages libanais",
    "sku": "SKU-413",
    "barcode": "413",
    "imageUrl": "http://almoune.fr/img/p/2/0/1/8/2018.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-414",
    "name": "Fromages du Liban Double Cream 175g",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Produits laitiers",
    "sku": "SKU-414",
    "barcode": "414",
    "imageUrl": "http://almoune.fr/img/p/2/0/1/9/2019.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-415",
    "name": "Fromages du Liban Naboulsi 230 g",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 2,
    "category": "Fromages libanais",
    "sku": "SKU-415",
    "barcode": "415",
    "imageUrl": "http://almoune.fr/img/p/2/0/2/0/2020.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-416",
    "name": "labneh Fromage du Liban 500g",
    "price": 6.99,
    "purchasePrice": 6.625592,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-416",
    "barcode": "416",
    "imageUrl": "http://almoune.fr/img/p/2/0/2/1/2021.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-417",
    "name": "Fromages du Liban Naboulsi 290 g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 1,
    "category": "Fromages libanais",
    "sku": "SKU-417",
    "barcode": "417",
    "imageUrl": "http://almoune.fr/img/p/2/0/2/2/2022.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-418",
    "name": "Fromages du Liban Naboulsi 190 g",
    "price": 3.01,
    "purchasePrice": 2.853081,
    "stock": 0,
    "category": "Fromages libanais",
    "sku": "SKU-418",
    "barcode": "418",
    "imageUrl": "http://almoune.fr/img/p/2/0/2/3/2023.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-419",
    "name": "Baking powder (levure chimique) Aruba 100g",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-419",
    "barcode": "419",
    "imageUrl": "http://almoune.fr/img/p/2/0/2/4/2024.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-420",
    "name": "Baklava du Liban Sadaka 300gr",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 1,
    "category": "Gourmandises",
    "sku": "SKU-420",
    "barcode": "420",
    "imageUrl": "http://almoune.fr/img/p/2/0/2/5/2025.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-421",
    "name": "Chocolats Tutti Frutti - Gandour Boite (12)",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-421",
    "barcode": "421",
    "imageUrl": "http://almoune.fr/img/p/2/0/2/6/2026.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-422",
    "name": "Chocolat Tuti frutti - Gandour",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-422",
    "barcode": "422",
    "imageUrl": "http://almoune.fr/img/p/2/0/2/7/2027.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-423",
    "name": "Farine de riz en vrac 1kg",
    "price": 2.18,
    "purchasePrice": 2.445498,
    "stock": 3,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-423",
    "barcode": "423",
    "imageUrl": "http://almoune.fr/img/p/3/6/9/4/3694.jpg",
    "price_per_kg": 2.18
  },
  {
    "id": "csv-424",
    "name": "Farine Mais Jaune en vrac 1kg",
    "price": 1.06,
    "purchasePrice": 2.445498,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-424",
    "barcode": "424",
    "imageUrl": "http://almoune.fr/img/p/3/6/9/5/3695.jpg",
    "price_per_kg": 1.06
  },
  {
    "id": "csv-425",
    "name": "Cheveux d'Ange Yufka 500 g",
    "price": 2.8,
    "purchasePrice": 2.654028,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-425",
    "barcode": "425",
    "imageUrl": "http://almoune.fr/img/p/2/0/3/0/2030.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-426",
    "name": "Pain Libanais Complet  - 5 pièces 240 g",
    "price": 1.49,
    "purchasePrice": 1.412322,
    "stock": 175,
    "category": "Accueil",
    "sku": "SKU-426",
    "barcode": "426",
    "imageUrl": "http://almoune.fr/img/p/2/0/3/1/2031.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-427",
    "name": "Chips Barbecue Master 40g",
    "price": 0.65,
    "purchasePrice": 0.616114,
    "stock": 0,
    "category": "Chips et apéritifs",
    "sku": "SKU-427",
    "barcode": "427",
    "imageUrl": "http://almoune.fr/img/p/2/0/3/2/2032.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-428",
    "name": "Chips Ketchup Master 40g",
    "price": 0.65,
    "purchasePrice": 0.616114,
    "stock": 0,
    "category": "Chips et apéritifs",
    "sku": "SKU-428",
    "barcode": "428",
    "imageUrl": "http://almoune.fr/img/p/2/0/3/3/2033.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-429",
    "name": "Chips sel et Vingare Master 40g",
    "price": 0.65,
    "purchasePrice": 0.616114,
    "stock": 0,
    "category": "Chips et apéritifs",
    "sku": "SKU-429",
    "barcode": "429",
    "imageUrl": "http://almoune.fr/img/p/2/0/3/4/2034.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-430",
    "name": "Chips Fromage Francais Master 40g",
    "price": 0.65,
    "purchasePrice": 0.616114,
    "stock": 0,
    "category": "Chips et apéritifs",
    "sku": "SKU-430",
    "barcode": "430",
    "imageUrl": "http://almoune.fr/img/p/2/0/3/5/2035.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-431",
    "name": "Chips Hot Chili Master 40g",
    "price": 0.65,
    "purchasePrice": 0.616114,
    "stock": 0,
    "category": "Chips et apéritifs",
    "sku": "SKU-431",
    "barcode": "431",
    "imageUrl": "http://almoune.fr/img/p/2/0/3/6/2036.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-432",
    "name": "Makanek Cocktail 250g Tutunjian",
    "price": 6,
    "purchasePrice": 5.687204,
    "stock": 0,
    "category": "Viandes - Poissons",
    "sku": "SKU-432",
    "barcode": "432",
    "imageUrl": "http://almoune.fr/img/p/2/0/3/7/2037.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-433",
    "name": "Soudjouk Cocktail 250g Tutunjian",
    "price": 6,
    "purchasePrice": 5.687204,
    "stock": 0,
    "category": "Viandes - Poissons",
    "sku": "SKU-433",
    "barcode": "433",
    "imageUrl": "http://almoune.fr/img/p/2/0/3/8/2038.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-434",
    "name": "Pasterma 100g Tutunjian",
    "price": 5.2,
    "purchasePrice": 4.92891,
    "stock": 0,
    "category": "Viandes - Poissons",
    "sku": "SKU-434",
    "barcode": "434",
    "imageUrl": "http://almoune.fr/img/p/2/0/3/9/2039.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-436",
    "name": "Eau Cristaline 50cl",
    "price": 0.57,
    "purchasePrice": 0.540284,
    "stock": -69,
    "category": "Boissons",
    "sku": "SKU-436",
    "barcode": "436",
    "imageUrl": "http://almoune.fr/img/p/2/0/4/0/2040.jpg",
    "price_per_kg": 0.57
  },
  {
    "id": "csv-437",
    "name": "Epices De Curry",
    "price": 1.85,
    "purchasePrice": 1.753555,
    "stock": 4,
    "category": "Épices",
    "sku": "SKU-437",
    "barcode": "437",
    "imageUrl": "http://almoune.fr/img/p/2/0/4/1/2041.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-438",
    "name": "Maamoul mixte 12 pièces Pistache Noix et dattes - 750g",
    "price": 16,
    "purchasePrice": 15.165877,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-438",
    "barcode": "438",
    "imageUrl": "http://almoune.fr/img/p/2/0/4/2/2042.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-439",
    "name": "Maamoul petits pistache 14 pièces",
    "price": 10,
    "purchasePrice": 9.478673,
    "stock": 0,
    "category": "Gâteaux - Biscuits orientaux",
    "sku": "SKU-439",
    "barcode": "439",
    "imageUrl": "http://almoune.fr/img/p/2/0/4/3/2043.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-440",
    "name": "Maamoul petits noix14 pièces",
    "price": 10,
    "purchasePrice": 9.478673,
    "stock": 2,
    "category": "Aliments et Laitiers",
    "sku": "SKU-440",
    "barcode": "440",
    "imageUrl": "http://almoune.fr/img/p/2/0/4/4/2044.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-441",
    "name": "Maamoul petits datte14 pièces",
    "price": 8,
    "purchasePrice": 7.582938,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-441",
    "barcode": "441",
    "imageUrl": "http://almoune.fr/img/p/2/0/4/5/2045.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-442",
    "name": "Namoura 8 pièces - Bouchée Dorée 600g",
    "price": 12,
    "purchasePrice": 11.374408,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-442",
    "barcode": "442",
    "imageUrl": "http://almoune.fr/img/p/2/0/4/6/2046.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-443",
    "name": "Sanioura 300g",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-443",
    "barcode": "443",
    "imageUrl": "http://almoune.fr/img/p/2/0/4/7/2047.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-444",
    "name": "Hummus Kasih135 gr",
    "price": 1.45,
    "purchasePrice": 1.374408,
    "stock": -8,
    "category": "Aliments et Laitiers",
    "sku": "SKU-444",
    "barcode": "444",
    "imageUrl": "http://almoune.fr/img/p/2/0/4/8/2048.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-445",
    "name": "Concombre Sauvage Mekte Chtoura 600gr",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-445",
    "barcode": "445",
    "imageUrl": "http://almoune.fr/img/p/2/0/4/9/2049.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-446",
    "name": "Tamarin sans graines 400 gr",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-446",
    "barcode": "446",
    "imageUrl": "http://almoune.fr/img/p/7/3/7/737.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-447",
    "name": "Olives Vertes Dénoyautées Marinées et pimentées - 500 g",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-447",
    "barcode": "447",
    "imageUrl": "http://almoune.fr/img/p/2/0/5/0/2050.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-448",
    "name": "Semoule Extra Fine 1kg",
    "price": 2.35,
    "purchasePrice": 2.227488,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-448",
    "barcode": "448",
    "imageUrl": "http://almoune.fr/img/p/2/0/5/1/2051.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-450",
    "name": "Makdous Anjar 1kg",
    "price": 9.99,
    "purchasePrice": 9.469194,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-450",
    "barcode": "450",
    "imageUrl": "http://almoune.fr/img/p/2/0/5/2/2052.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-451",
    "name": "Tahina (crème de Sésame) - Bissat 900g",
    "price": 6.7,
    "purchasePrice": 6.35,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-451",
    "barcode": "451",
    "imageUrl": "http://almoune.fr/img/p/2/3/1/1/2311.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-452",
    "name": "Tahina (crème de Sésame) - Al Sanabel 800g",
    "price": 5.49,
    "purchasePrice": 5.203791,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-452",
    "barcode": "452",
    "imageUrl": "http://almoune.fr/img/p/2/3/1/2/2312.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-453",
    "name": "Halawa Pistaches Bissat 900g",
    "price": 5.99,
    "purchasePrice": 7.39,
    "stock": 0,
    "category": "Halawa",
    "sku": "SKU-453",
    "barcode": "453",
    "imageUrl": "http://almoune.fr/img/p/2/3/1/3/2313.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-454",
    "name": "Turksih Delights Miskeh - Bissat",
    "price": 4.71,
    "purchasePrice": 4.46,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-454",
    "barcode": "454",
    "imageUrl": "http://almoune.fr/img/p/2/3/1/4/2314.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-455",
    "name": "Thym (Zaatar) - Adida 500g",
    "price": 6.95,
    "purchasePrice": 6.587678,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-455",
    "barcode": "455",
    "imageUrl": "http://almoune.fr/img/p/2/3/1/5/2315.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-456",
    "name": "Sumac Libanais naturel - Adida 500g",
    "price": 9.4,
    "purchasePrice": 8.91,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-456",
    "barcode": "456",
    "imageUrl": "http://almoune.fr/img/p/2/3/1/6/2316.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-457",
    "name": "Menthe séchée - Adida 500g",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 3,
    "category": "Épices",
    "sku": "SKU-457",
    "barcode": "457",
    "imageUrl": "http://almoune.fr/img/p/2/3/1/7/2317.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-458",
    "name": "Poudre d'Oignon - Adida 500g",
    "price": 7.5,
    "purchasePrice": 7.11,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-458",
    "barcode": "458",
    "imageUrl": "http://almoune.fr/img/p/2/3/1/8/2318.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-459",
    "name": "Sésame cru - Adida 500g",
    "price": 4.5,
    "purchasePrice": 4.27,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-459",
    "barcode": "459",
    "imageUrl": "http://almoune.fr/img/p/2/3/1/9/2319.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-460",
    "name": "Fromage Halloumi Pitas 250gr",
    "price": 3.35,
    "purchasePrice": 3.34675,
    "stock": 0,
    "category": "Fromages libanais",
    "sku": "SKU-460",
    "barcode": "460",
    "imageUrl": "http://almoune.fr/img/p/2/0/7/2/2072.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-461",
    "name": "Kashkaval Brebis 400g env",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Fromages libanais",
    "sku": "SKU-461",
    "barcode": "461",
    "imageUrl": "http://almoune.fr/img/p/2/0/7/3/2073.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-462",
    "name": "kashkaval vache 400gr env",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": 0,
    "category": "Fromages libanais",
    "sku": "SKU-462",
    "barcode": "462",
    "imageUrl": "http://almoune.fr/img/p/2/0/7/4/2074.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-463",
    "name": "Fromage la Vache de Paris 500gr",
    "price": 1.99,
    "purchasePrice": 1.99,
    "stock": 21,
    "category": "Fromages libanais",
    "sku": "SKU-463",
    "barcode": "463",
    "imageUrl": "http://almoune.fr/img/p/2/0/7/5/2075.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-465",
    "name": "Labneh chèvre  200 gr.",
    "price": 3.32,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Yaourt et Labneh",
    "sku": "SKU-465",
    "barcode": "465",
    "imageUrl": "http://almoune.fr/img/p/2/0/7/7/2077.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-466",
    "name": "Fromage Akkawi traditionnel - Golden Plate 460g",
    "price": 5.9,
    "purchasePrice": 5.592417,
    "stock": -2,
    "category": "Fromages libanais",
    "sku": "SKU-466",
    "barcode": "466",
    "imageUrl": "http://almoune.fr/img/p/2/0/7/8/2078.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-467",
    "name": "Feuilles de vigne farcies - Paliria 280g",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 24,
    "category": "Conserves",
    "sku": "SKU-467",
    "barcode": "467",
    "imageUrl": "http://almoune.fr/img/p/2/0/7/9/2079.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-468",
    "name": "Fromage Blanc de Chypre \"baladiye\" Achnagal- 300g",
    "price": 2.99,
    "purchasePrice": 2.99,
    "stock": 0,
    "category": "Fromages libanais",
    "sku": "Ressemble au fromage baladiyeh",
    "barcode": "468",
    "imageUrl": "http://almoune.fr/img/p/2/0/8/0/2080.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-469",
    "name": "Huile d'olive Bio Terra DELYSSA 1L",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-469",
    "barcode": "469",
    "imageUrl": "http://almoune.fr/img/p/2/0/8/1/2081.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-471",
    "name": "Fèves Foul Recette Libanaise - Chtoura Garden 400gr",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 9,
    "category": "Accueil",
    "sku": "SKU-471",
    "barcode": "471",
    "imageUrl": "http://almoune.fr/img/p/2/0/8/3/2083.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-472",
    "name": "Foul - fèves pelées recette secrète - California Garden 400gr",
    "price": 1.54,
    "purchasePrice": 1.459716,
    "stock": 46,
    "category": "Conserves",
    "sku": "SKU-472",
    "barcode": "472",
    "imageUrl": "http://almoune.fr/img/p/4/0/4/7/4047.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-473",
    "name": "Noix de cajou grillées salées 250gr",
    "price": 3.95,
    "purchasePrice": 3.74,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-473",
    "barcode": "473",
    "imageUrl": "http://almoune.fr/img/p/2/3/2/4/2324.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-474",
    "name": "Baklava Mixtes (Boite en Plastique) - Douaihy 500g",
    "price": 12,
    "purchasePrice": 11.37,
    "stock": 0,
    "category": "Patisserie Douaihy",
    "sku": "SKU-474",
    "barcode": "474",
    "imageUrl": "http://almoune.fr/img/p/2/2/2/3/2223.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-475",
    "name": "Nougat Abricot rectangle barre Ghrawi 70gr",
    "price": 1.57,
    "purchasePrice": 1.49,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-475",
    "barcode": "475",
    "imageUrl": "http://almoune.fr/img/p/2/2/2/4/2224.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-476",
    "name": "Sucre glace - Adida 1kg",
    "price": 3.71,
    "purchasePrice": 3.52,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-476",
    "barcode": "476",
    "imageUrl": "http://almoune.fr/img/p/2/2/2/5/2225.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-477",
    "name": "Sept épices - Adida 500g",
    "price": 13.5,
    "purchasePrice": 12.796209,
    "stock": 7,
    "category": "Épices",
    "sku": "SKU-477",
    "barcode": "477",
    "imageUrl": "http://almoune.fr/img/p/2/2/2/6/2226.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-478",
    "name": "Thym en Poudre - Adida 500g",
    "price": 12,
    "purchasePrice": 11.37,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-478",
    "barcode": "478",
    "imageUrl": "http://almoune.fr/img/p/2/2/2/7/2227.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-479",
    "name": "Piments de la Jamaïque, Poivron Doux - Adida 50g",
    "price": 1.24,
    "purchasePrice": 1.18,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-479",
    "barcode": "479",
    "imageUrl": "http://almoune.fr/img/p/2/3/2/2/2322.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-480",
    "name": "Sumac Libanais naturel - Adida 50g",
    "price": 1.65,
    "purchasePrice": 1.56,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-480",
    "barcode": "480",
    "imageUrl": "http://almoune.fr/img/p/2/2/2/8/2228.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-481",
    "name": "Poudre d'Oignon - Adida 50g",
    "price": 1.3,
    "purchasePrice": 1.083333,
    "stock": 2,
    "category": "Épices",
    "sku": "SKU-481",
    "barcode": "481",
    "imageUrl": "http://almoune.fr/img/p/2/2/2/9/2229.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-482",
    "name": "Sept Épices - Adida 50g",
    "price": 1.95,
    "purchasePrice": 1.848341,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-482",
    "barcode": "482",
    "imageUrl": "http://almoune.fr/img/p/2/2/3/0/2230.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-483",
    "name": "Épices de Poulet Crispy - Adida 50g",
    "price": 1.24,
    "purchasePrice": 1.18,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-483",
    "barcode": "483",
    "imageUrl": "http://almoune.fr/img/p/2/2/3/1/2231.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-484",
    "name": "Épices de Pâte à Viande (lahm bi Ajin) - Adida 50g",
    "price": 1.24,
    "purchasePrice": 1.18,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-484",
    "barcode": "484",
    "imageUrl": "http://almoune.fr/img/p/2/2/3/2/2232.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-485",
    "name": "Farine de Poulet Rôti - Adida 500g",
    "price": 2.99,
    "purchasePrice": 2.83,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-485",
    "barcode": "485",
    "imageUrl": "http://almoune.fr/img/p/2/3/2/3/2323.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-486",
    "name": "Falafel en poudre - Adida 200g",
    "price": 2,
    "purchasePrice": 1.9,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-486",
    "barcode": "486",
    "imageUrl": "http://almoune.fr/img/p/2/2/3/3/2233.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-487",
    "name": "Jus Pyramide du Liban à l'Ananas - Junet 180ml",
    "price": 0.95,
    "purchasePrice": 0.900474,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-487",
    "barcode": "487",
    "imageUrl": "http://almoune.fr/img/p/2/2/3/4/2234.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-488",
    "name": "Jus aux Fraises et Bananes - Junet 250ml",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Jus",
    "sku": "SKU-488",
    "barcode": "488",
    "imageUrl": "http://almoune.fr/img/p/2/2/3/5/2235.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-489",
    "name": "Jus à la Mangue - Junet 250ml",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 165,
    "category": "Jus",
    "sku": "SKU-489",
    "barcode": "489",
    "imageUrl": "http://almoune.fr/img/p/2/2/3/6/2236.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-490",
    "name": "Jus à la Rose - Junet 250ml",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 79,
    "category": "Jus",
    "sku": "SKU-490",
    "barcode": "490",
    "imageUrl": "http://almoune.fr/img/p/2/2/3/7/2237.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-491",
    "name": "Jus de grenade - Junet 250ml",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Jus",
    "sku": "SKU-491",
    "barcode": "491",
    "imageUrl": "http://almoune.fr/img/p/2/2/3/8/2238.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-492",
    "name": "Jus de Goyave- Junet 250ml",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 61,
    "category": "Jus",
    "sku": "SKU-492",
    "barcode": "492",
    "imageUrl": "http://almoune.fr/img/p/2/2/3/9/2239.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-493",
    "name": "Jus au Tamarin - Junet 250ml",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 4,
    "category": "Jus",
    "sku": "SKU-493",
    "barcode": "493",
    "imageUrl": "http://almoune.fr/img/p/2/2/4/0/2240.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-494",
    "name": "Jus au Jallab - Junet 250ml",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 90,
    "category": "Jus",
    "sku": "SKU-494",
    "barcode": "494",
    "imageUrl": "http://almoune.fr/img/p/2/2/4/1/2241.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-495",
    "name": "Jus  aux fruits rouges (berries mix) - Junet 250ml",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Jus",
    "sku": "SKU-495",
    "barcode": "495",
    "imageUrl": "http://almoune.fr/img/p/2/2/4/2/2242.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-496",
    "name": "Jus à la Mangue - Junet 1l",
    "price": 3.29,
    "purchasePrice": 3.12,
    "stock": 0,
    "category": "Jus",
    "sku": "SKU-496",
    "barcode": "496",
    "imageUrl": "http://almoune.fr/img/p/2/2/4/3/2243.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-497",
    "name": "Jus de Goyave- Junet 1l",
    "price": 3.29,
    "purchasePrice": 3.12,
    "stock": 0,
    "category": "Jus",
    "sku": "SKU-497",
    "barcode": "497",
    "imageUrl": "http://almoune.fr/img/p/2/2/4/4/2244.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-498",
    "name": "Jus à l'Ananas - Junet 200ml",
    "price": 0.75,
    "purchasePrice": 0.71,
    "stock": 0,
    "category": "Jus",
    "sku": "SKU-498",
    "barcode": "498",
    "imageUrl": "http://almoune.fr/img/p/2/2/4/5/2245.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-499",
    "name": "Jus aux Fraises et Bananes - Junet 200ml",
    "price": 0.75,
    "purchasePrice": 0.71,
    "stock": 0,
    "category": "Jus",
    "sku": "SKU-499",
    "barcode": "499",
    "imageUrl": "http://almoune.fr/img/p/2/2/4/6/2246.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-500",
    "name": "Jus à l'Orange - Junet 200ml",
    "price": 0.75,
    "purchasePrice": 0.71,
    "stock": 0,
    "category": "Jus",
    "sku": "SKU-500",
    "barcode": "500",
    "imageUrl": "http://almoune.fr/img/p/2/2/4/7/2247.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-501",
    "name": "Bonbons Assortis, Nougat,Araysseh, Moghabara, Qamar Al Din, Malban - 750g",
    "price": 12.5,
    "purchasePrice": 10.416667,
    "stock": 0,
    "category": "Patisseries",
    "sku": "SKU-501",
    "barcode": "501",
    "imageUrl": "http://almoune.fr/img/p/2/2/4/8/2248.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-502",
    "name": "Cerneaux de noix Extra 1/4 blancs Chili 200gr",
    "price": 4.37,
    "purchasePrice": 4.14,
    "stock": -1,
    "category": "Fruits secs",
    "sku": "SKU-502",
    "barcode": "502",
    "imageUrl": "http://almoune.fr/img/p/2/2/4/9/2249.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-504",
    "name": "Poudre Custard Vanille (Light)  - Aruba 200g",
    "price": 2,
    "purchasePrice": 1.9,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-504",
    "barcode": "504",
    "imageUrl": "http://almoune.fr/img/p/2/2/5/0/2250.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-505",
    "name": "Poudre Custard Chocolat (Light) - Aruba 200g",
    "price": 2,
    "purchasePrice": 1.9,
    "stock": 16,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-505",
    "barcode": "505",
    "imageUrl": "http://almoune.fr/img/p/2/2/5/1/2251.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-506",
    "name": "Jus Pyramide du Liban à l'orange - Junet 180ml",
    "price": 0.95,
    "purchasePrice": 0.900474,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-506",
    "barcode": "506",
    "imageUrl": "http://almoune.fr/img/p/2/2/5/2/2252.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-507",
    "name": "Jus Pyramide du Liban à la mangue- Junet 180ml",
    "price": 0.95,
    "purchasePrice": 0.900474,
    "stock": 0,
    "category": "Jus",
    "sku": "SKU-507",
    "barcode": "507",
    "imageUrl": "http://almoune.fr/img/p/2/2/5/3/2253.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-508",
    "name": "Jus Pyramide du Liban à la fraise - Junet 180ml",
    "price": 0.5,
    "purchasePrice": 0.47,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-508",
    "barcode": "508",
    "imageUrl": "http://almoune.fr/img/p/2/2/5/4/2254.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-509",
    "name": "Mélange de Kashtalia  Aruba 200g",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-509",
    "barcode": "509",
    "imageUrl": "http://almoune.fr/img/p/2/2/5/5/2255.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-510",
    "name": "Mélange de Meghli  - Aruba 200g",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-510",
    "barcode": "510",
    "imageUrl": "http://almoune.fr/img/p/2/2/5/6/2256.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-511",
    "name": "Mélange de Sahlab Aruba 200g",
    "price": 2,
    "purchasePrice": 1.9,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-511",
    "barcode": "511",
    "imageUrl": "http://almoune.fr/img/p/2/2/5/7/2257.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-512",
    "name": "Biscuit Digestive au Chocolat - Gandour 195g",
    "price": 1.95,
    "purchasePrice": 1.85,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-512",
    "barcode": "512",
    "imageUrl": "http://almoune.fr/img/p/2/2/5/8/2258.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-513",
    "name": "Biscuit Sandwich Lucky au Chocolat (32gx12) - Gandour",
    "price": 2.5,
    "purchasePrice": 2.37,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-513",
    "barcode": "513",
    "imageUrl": "http://almoune.fr/img/p/2/2/5/9/2259.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-514",
    "name": "Biscuit Dabke au Citron - Gandour 28g",
    "price": 0.75,
    "purchasePrice": 0.7109,
    "stock": -2,
    "category": "Friandises",
    "sku": "SKU-514",
    "barcode": "514",
    "imageUrl": "http://almoune.fr/img/p/3/7/9/8/3798.jpg",
    "price_per_kg": 0.75
  },
  {
    "id": "csv-515",
    "name": "Biscuit Marie Original - Gandour 76.5g",
    "price": 0.65,
    "purchasePrice": 0.62,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-515",
    "barcode": "515",
    "imageUrl": "http://almoune.fr/img/p/2/2/6/1/2261.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-516",
    "name": "Biscuits Lucky 555 - Gandour 8 Paquets 76.5g- 612gr",
    "price": 7.85,
    "purchasePrice": 7.440758,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-516",
    "barcode": "516",
    "imageUrl": "http://almoune.fr/img/p/2/2/6/2/2262.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-517",
    "name": "Biscuit Sandwich Lucky au Chocolat - Gandour 32g",
    "price": 0.25,
    "purchasePrice": 0.47,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-517",
    "barcode": "517",
    "imageUrl": "http://almoune.fr/img/p/2/2/6/3/2263.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-518",
    "name": "Biscuit Unica au Chocolat Noir - Gandour 24g",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-518",
    "barcode": "518",
    "imageUrl": "http://almoune.fr/img/p/2/2/6/4/2264.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-519",
    "name": "Biscuit Unica aux Fraises - Gandour 24g",
    "price": 0.25,
    "purchasePrice": 0.236967,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-519",
    "barcode": "519",
    "imageUrl": "http://almoune.fr/img/p/2/2/6/5/2265.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-520",
    "name": "Biscuit Unica aux Noisettes - Gandour 24g",
    "price": 0.1,
    "purchasePrice": 0.236967,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-520",
    "barcode": "520",
    "imageUrl": "http://almoune.fr/img/p/2/2/6/6/2266.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-521",
    "name": "Biscuit Unica à la Vanille - Gandour 24g",
    "price": 0.25,
    "purchasePrice": 0.236967,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-521",
    "barcode": "521",
    "imageUrl": "http://almoune.fr/img/p/2/2/6/7/2267.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-522",
    "name": "Olives vertes au thym - Al Dayaa 660g",
    "price": 4.28,
    "purchasePrice": 4.06,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-522",
    "barcode": "522",
    "imageUrl": "http://almoune.fr/img/p/2/2/6/8/2268.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-523",
    "name": "Olives Vertes libanaises au Chatta (Piment rouge) - Al Dayaa 660g",
    "price": 4.28,
    "purchasePrice": 4.06,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-523",
    "barcode": "523",
    "imageUrl": "http://almoune.fr/img/p/2/2/6/9/2269.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-524",
    "name": "Olives Noires - Al Dayaa 250g",
    "price": 1.57,
    "purchasePrice": 1.49,
    "stock": 0,
    "category": "Olives",
    "sku": "SKU-524",
    "barcode": "524",
    "imageUrl": "http://almoune.fr/img/p/2/3/2/9/2329.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-525",
    "name": "Olives Noires - Al Dayaa 660g",
    "price": 4.58,
    "purchasePrice": 4.34,
    "stock": 0,
    "category": "Olives",
    "sku": "SKU-525",
    "barcode": "525",
    "imageUrl": "http://almoune.fr/img/p/2/3/2/8/2328.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-526",
    "name": "Concombres au Vinaigre - Al Dayaa 660g",
    "price": 3.6,
    "purchasePrice": 3.41,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-526",
    "barcode": "526",
    "imageUrl": "http://almoune.fr/img/p/2/2/7/2/2272.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-527",
    "name": "Concombre au Vinaigre en Tranches - Al Dayaa 500g",
    "price": 2,
    "purchasePrice": 1.9,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-527",
    "barcode": "527",
    "imageUrl": "http://almoune.fr/img/p/2/2/7/3/2273.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-528",
    "name": "Concombres Sauvages au Vinaigre -mekte Al Dayaa 660 gr",
    "price": 3.52,
    "purchasePrice": 3.34,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-528",
    "barcode": "528",
    "imageUrl": "http://almoune.fr/img/p/2/2/7/4/2274.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-529",
    "name": "Cafetière libanaise émaillée (Rakwe) bleue - 10 tasses",
    "price": 14.99,
    "purchasePrice": 12.491667,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-529",
    "barcode": "529",
    "imageUrl": "http://almoune.fr/img/p/2/3/2/7/2327.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-530",
    "name": "Aubergines Makdous- Al Dayaa 1kg",
    "price": 9.26,
    "purchasePrice": 8.78,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-530",
    "barcode": "530",
    "imageUrl": "http://almoune.fr/img/p/2/2/7/5/2275.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-531",
    "name": "Feuilles de Vigne Séchées- Al Dayaa 400g",
    "price": 4.27,
    "purchasePrice": 4.05,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-531",
    "barcode": "531",
    "imageUrl": "http://almoune.fr/img/p/2/2/7/6/2276.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-532",
    "name": "Eau de Rose- Al Dayaa 250ml",
    "price": 2.57,
    "purchasePrice": 2.44,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-532",
    "barcode": "532",
    "imageUrl": "http://almoune.fr/img/p/2/2/7/7/2277.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-533",
    "name": "Confiture de Figues- Al Dayaa 400g",
    "price": 4.49,
    "purchasePrice": 4.26,
    "stock": 0,
    "category": "Confitures",
    "sku": "Ferme et onctueuse",
    "barcode": "533",
    "imageUrl": "http://almoune.fr/img/p/2/2/7/8/2278.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-534",
    "name": "Mélasse de Caroube - Al Dayaa 450g",
    "price": 3.5,
    "purchasePrice": 3.32,
    "stock": 0,
    "category": "Mélasses et miels",
    "sku": "SKU-534",
    "barcode": "534",
    "imageUrl": "http://almoune.fr/img/p/2/2/7/9/2279.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-535",
    "name": "Mélasse de Grenade - Al Dayaa 250ml",
    "price": 3.55,
    "purchasePrice": 3.364929,
    "stock": 0,
    "category": "Mélasses et miels",
    "sku": "SKU-535",
    "barcode": "535",
    "imageUrl": "http://almoune.fr/img/p/2/2/8/0/2280.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-536",
    "name": "Chatta- Al Dayaa 800g",
    "price": 4.83,
    "purchasePrice": 4.58,
    "stock": 0,
    "category": "Concentrés",
    "sku": "SKU-536",
    "barcode": "536",
    "imageUrl": "http://almoune.fr/img/p/2/2/8/1/2281.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-537",
    "name": "Fèves Cuites (Foul Medammas) - Al Dayaa 400g",
    "price": 0.98,
    "purchasePrice": 0.93,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-537",
    "barcode": "537",
    "imageUrl": "http://almoune.fr/img/p/2/2/8/2/2282.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-538",
    "name": "Houmous Tahini - Al Dayaa 200g",
    "price": 0.84,
    "purchasePrice": 0.8,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-538",
    "barcode": "538",
    "imageUrl": "http://almoune.fr/img/p/2/2/8/3/2283.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-539",
    "name": "Houmous Tahini - Al Dayaa 400 gr",
    "price": 1.17,
    "purchasePrice": 1.11,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-539",
    "barcode": "539",
    "imageUrl": "http://almoune.fr/img/p/2/2/8/4/2284.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-540",
    "name": "Baba Ghanouj (caviar d’aubergines libanais) Al Dayaa 185 gr",
    "price": 1.17,
    "purchasePrice": 1.11,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-540",
    "barcode": "540",
    "imageUrl": "http://almoune.fr/img/p/2/2/8/5/2285.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-541",
    "name": "Baba Ghanouj (caviar d’aubergines libanais) Al Dayaa 375 gr",
    "price": 1.96,
    "purchasePrice": 1.86,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-541",
    "barcode": "541",
    "imageUrl": "http://almoune.fr/img/p/2/2/8/6/2286.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-542",
    "name": "Barbe à Papa (ghazal al Banat) - Douaihy 4 Pièces",
    "price": 6.99,
    "purchasePrice": 6.625592,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-542",
    "barcode": "542",
    "imageUrl": "http://almoune.fr/img/p/2/2/8/7/2287.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-543",
    "name": "Baklava Mixtes (Boite en Carton) - Douaihy 500g",
    "price": 17.5,
    "purchasePrice": 16.587678,
    "stock": 2,
    "category": "Patisserie Douaihy",
    "sku": "SKU-543",
    "barcode": "543",
    "imageUrl": "http://almoune.fr/img/p/2/2/8/8/2288.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-544",
    "name": "Cafetière libanaise émaillée (Rakwe) bleue - 8 tasses",
    "price": 11.99,
    "purchasePrice": 9.991667,
    "stock": -1,
    "category": "Cafés",
    "sku": "SKU-544",
    "barcode": "544",
    "imageUrl": "http://almoune.fr/img/p/2/3/2/6/2326.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-545",
    "name": "Baklava Premium book (Grand) - Douaihy 700g",
    "price": 28.3,
    "purchasePrice": 29.85782,
    "stock": 0,
    "category": "Baklava",
    "sku": "SKU-545",
    "barcode": "545",
    "imageUrl": "http://almoune.fr/img/p/2/2/8/9/2289.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-546",
    "name": "Baklava Premium (Petit) - Douaihy 360g",
    "price": 12.5,
    "purchasePrice": 14.22,
    "stock": 0,
    "category": "Baklava",
    "sku": "SKU-546",
    "barcode": "546",
    "imageUrl": "http://almoune.fr/img/p/2/2/9/0/2290.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-547",
    "name": "Trio de Dates, Sésames, Ghraybeh (mini)- Douaihy 250g",
    "price": 5.5,
    "purchasePrice": 5.21,
    "stock": 0,
    "category": "Patisserie Douaihy",
    "sku": "SKU-547",
    "barcode": "547",
    "imageUrl": "http://almoune.fr/img/p/2/2/9/1/2291.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-548",
    "name": "Namoura (Petite Boite)- Douaihy 250g",
    "price": 5.5,
    "purchasePrice": 5.21,
    "stock": 0,
    "category": "Promo",
    "sku": "SKU-548",
    "barcode": "548",
    "imageUrl": "http://almoune.fr/img/p/2/2/9/2/2292.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-549",
    "name": "Barazek (Petite Boite)- Douaihy 250g",
    "price": 5.99,
    "purchasePrice": 5.677725,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-549",
    "barcode": "549",
    "imageUrl": "http://almoune.fr/img/p/2/2/9/3/2293.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-550",
    "name": "Ghraybeh (Petite Boite)- Douaihy 250g",
    "price": 4.4,
    "purchasePrice": 5.21,
    "stock": 0,
    "category": "Promo",
    "sku": "SKU-550",
    "barcode": "550",
    "imageUrl": "http://almoune.fr/img/p/2/2/9/4/2294.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-551",
    "name": "Petits Fours (Petite Boite)- Douaihy 250g",
    "price": 4.4,
    "purchasePrice": 5.21,
    "stock": 0,
    "category": "Promo",
    "sku": "SKU-551",
    "barcode": "551",
    "imageUrl": "http://almoune.fr/img/p/2/2/9/5/2295.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-552",
    "name": "Maamoul, noix, pistache et dates- Douaihy 500gr.",
    "price": 12,
    "purchasePrice": 11.37,
    "stock": 0,
    "category": "Patisseries",
    "sku": "SKU-552",
    "barcode": "552",
    "imageUrl": "http://almoune.fr/img/p/2/2/9/6/2296.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-553",
    "name": "Biscuits Unica au Chocolat Noir (x24) - Gandour 600g",
    "price": 4.5,
    "purchasePrice": 4.27,
    "stock": -1,
    "category": "Friandises",
    "sku": "SKU-553",
    "barcode": "553",
    "imageUrl": "http://almoune.fr/img/p/2/2/9/7/2297.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-554",
    "name": "Biscuit Unica aux Fraises (x24) - Gandour 600g",
    "price": 4.5,
    "purchasePrice": 4.27,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-554",
    "barcode": "554",
    "imageUrl": "http://almoune.fr/img/p/2/2/9/8/2298.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-555",
    "name": "Biscuit Unica aux Noisettes (x24) - Gandour 600g",
    "price": 1.5,
    "purchasePrice": 4.27,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-555",
    "barcode": "555",
    "imageUrl": "http://almoune.fr/img/p/2/2/9/9/2299.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-556",
    "name": "Biscuit Unica à la Vanille (x24) - Gandour 600g",
    "price": 4.5,
    "purchasePrice": 4.27,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-556",
    "barcode": "556",
    "imageUrl": "http://almoune.fr/img/p/2/3/0/0/2300.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-557",
    "name": "Baba Ghanouj (caviar d'aubergines libanais)  - Chtoura Garden 850g",
    "price": 4.87,
    "purchasePrice": 4.62,
    "stock": 11,
    "category": "Conserves",
    "sku": "SKU-557",
    "barcode": "557",
    "imageUrl": "http://almoune.fr/img/p/2/3/0/1/2301.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-558",
    "name": "Ghee de vache (samneh) - Al Bakara al Haloub 800g",
    "price": 23.99,
    "purchasePrice": 22.739336,
    "stock": 12,
    "category": "Ghee - beurre clarifié - samneh",
    "sku": "SKU-558",
    "barcode": "558",
    "imageUrl": "http://almoune.fr/img/p/2/3/0/2/2302.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-559",
    "name": "Café Moulu à la Cardamome - Najjar 200g",
    "price": 5.45,
    "purchasePrice": 5.165877,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-559",
    "barcode": "559",
    "imageUrl": "http://almoune.fr/img/p/2/3/0/3/2303.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-560",
    "name": "Cafétière en cuivre (Rakwe) -2 tasses",
    "price": 8.99,
    "purchasePrice": 7.491667,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-560",
    "barcode": "560",
    "imageUrl": "http://almoune.fr/img/p/2/3/0/4/2304.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-561",
    "name": "Cafétière en cuivre (Rakwe) - 4 tasses",
    "price": 10.99,
    "purchasePrice": 9.158333,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-561",
    "barcode": "561",
    "imageUrl": "http://almoune.fr/img/p/2/3/0/5/2305.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-562",
    "name": "Cafétière en cuivre (Rakwe) - 5 tasses",
    "price": 11.99,
    "purchasePrice": 9.991667,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-562",
    "barcode": "562",
    "imageUrl": "http://almoune.fr/img/p/2/3/0/6/2306.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-563",
    "name": "Cafetière libanaise émaillée (Rakwe) bleue - 4 tasses",
    "price": 8.89,
    "purchasePrice": 7.41,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-563",
    "barcode": "563",
    "imageUrl": "http://almoune.fr/img/p/2/3/0/7/2307.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-564",
    "name": "Cafétière émaillée (Rakwe) - 8 tasses",
    "price": 8.89,
    "purchasePrice": 7.41,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-564",
    "barcode": "564",
    "imageUrl": "http://almoune.fr/img/p/2/3/0/8/2308.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-565",
    "name": "Cafétière émaillée (Rakwe) - 10 tasses",
    "price": 10,
    "purchasePrice": 8.33,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-565",
    "barcode": "565",
    "imageUrl": "http://almoune.fr/img/p/2/3/0/9/2309.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-566",
    "name": "Cafétière émaillée (Rakwe) - 12 tasses",
    "price": 11.56,
    "purchasePrice": 9.63,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-566",
    "barcode": "566",
    "imageUrl": "http://almoune.fr/img/p/2/3/1/0/2310.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-568",
    "name": "Gombos (Bemye) 620 gr. Suntant",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-568",
    "barcode": "568",
    "imageUrl": "http://almoune.fr/img/p/3/1/6/4/3164.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-569",
    "name": "Aubergines Grillées Natures ECE 590gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-569",
    "barcode": "569",
    "imageUrl": "http://almoune.fr/img/p/3/1/4/6/3146.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-571",
    "name": "Huile d'olive - Al Dayaa 1L",
    "price": 9.95,
    "purchasePrice": 9.43128,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-571",
    "barcode": "571",
    "imageUrl": "http://almoune.fr/img/p/2/4/1/0/2410.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-573",
    "name": "Castania Qualité Premium - 450g",
    "price": 7.99,
    "purchasePrice": 7.57346,
    "stock": -3,
    "category": "Fruits à coques grillés",
    "sku": "SKU-573",
    "barcode": "573",
    "imageUrl": "http://almoune.fr/img/p/4/0/3/3/4033.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-582",
    "name": "Jus de Citron A base de concentré - 125mL",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-582",
    "barcode": "582",
    "imageUrl": "http://almoune.fr/img/p/2/3/8/1/2381.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-586",
    "name": "Fromage Feta Bio - Hotos 200gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-586",
    "barcode": "586",
    "imageUrl": "http://almoune.fr/img/p/2/3/5/6/2356.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-595",
    "name": "Mélange de fruits secs Grillés salés Kernel AL KAZZI 250gr",
    "price": 6.75,
    "purchasePrice": 6.398104,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-595",
    "barcode": "595",
    "imageUrl": "http://almoune.fr/img/p/2/3/3/9/2339.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-596",
    "name": "Mélange de noix sans sel AL KAZZI - 300gr",
    "price": 9.78,
    "purchasePrice": 9.270142,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-596",
    "barcode": "596",
    "imageUrl": "http://almoune.fr/img/p/4/0/4/1/4041.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-597",
    "name": "Mélange de fruits secs delux AL KAZZI 450gr",
    "price": 13.95,
    "purchasePrice": 13.222749,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-597",
    "barcode": "597",
    "imageUrl": "http://almoune.fr/img/p/2/3/3/8/2338.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-598",
    "name": "Mélange Spécial de Thym (Zaatar) - Adida 500g",
    "price": 3.35,
    "purchasePrice": 3.175355,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-598",
    "barcode": "598",
    "imageUrl": "http://almoune.fr/img/p/2/3/4/2/2342.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-599",
    "name": "Huile d'olive Vierge Extra - Al Dayaa 500ml",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Huiles et vinaigres",
    "sku": "SKU-599",
    "barcode": "599",
    "imageUrl": "http://almoune.fr/img/p/2/3/4/1/2341.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-600",
    "name": "Biscuit Dabké Loukoum - Gandour 28,7gr",
    "price": 0.65,
    "purchasePrice": 0.616114,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-600",
    "barcode": "600",
    "imageUrl": "http://almoune.fr/img/p/2/3/4/3/2343.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-601",
    "name": "Manner Chocolat - 75g",
    "price": 0,
    "purchasePrice": 0,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-601",
    "barcode": "601",
    "imageUrl": "http://almoune.fr/img/p/2/3/4/4/2344.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-602",
    "name": "Manner Original - 75g",
    "price": 0,
    "purchasePrice": 0,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-602",
    "barcode": "602",
    "imageUrl": "http://almoune.fr/img/p/2/3/4/5/2345.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-603",
    "name": "Manner au citron - 75g",
    "price": 0,
    "purchasePrice": 0,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-603",
    "barcode": "603",
    "imageUrl": "http://almoune.fr/img/p/2/3/4/6/2346.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-604",
    "name": "Lina - Sedita 60g",
    "price": 0,
    "purchasePrice": 0,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-604",
    "barcode": "604",
    "imageUrl": "http://almoune.fr/img/p/2/3/4/7/2347.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-605",
    "name": "Mila - Sedita 150g",
    "price": 0,
    "purchasePrice": 0,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-605",
    "barcode": "605",
    "imageUrl": "http://almoune.fr/img/p/2/3/4/8/2348.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-606",
    "name": "Pastrami de Boeuf aux 3 épices - isla 100g",
    "price": 3.96,
    "purchasePrice": 3.753555,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-606",
    "barcode": "606",
    "imageUrl": "http://almoune.fr/img/p/2/3/5/0/2350.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-607",
    "name": "Riz Basmati - AL SHALAN 1kg",
    "price": 6.2,
    "purchasePrice": 5.876777,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-607",
    "barcode": "607",
    "imageUrl": "http://almoune.fr/img/p/2/3/5/1/2351.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-608",
    "name": "Houmous Tahina - Chtoura Garden 600 gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-608",
    "barcode": "608",
    "imageUrl": "http://almoune.fr/img/p/2/3/5/3/2353.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-609",
    "name": "Houmous Tahina - Chtoura Garden 850 gr",
    "price": 4.45,
    "purchasePrice": 4.218009,
    "stock": 1,
    "category": "Conserves",
    "sku": "SKU-609",
    "barcode": "609",
    "imageUrl": "http://almoune.fr/img/p/3/1/6/0/3160.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-610",
    "name": "Sahlab - Adida 500g",
    "price": 5,
    "purchasePrice": 4.739336,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-610",
    "barcode": "610",
    "imageUrl": "http://almoune.fr/img/p/2/3/5/5/2355.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-611",
    "name": "Castania REGULAR MIX - 300g",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-611",
    "barcode": "611",
    "imageUrl": "http://almoune.fr/img/p/2/3/5/7/2357.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-612",
    "name": "Cheveux d'ange - Tria 500g",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-612",
    "barcode": "612",
    "imageUrl": "http://almoune.fr/img/p/2/3/5/8/2358.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-613",
    "name": "Amandes effilées - Meyva 250g",
    "price": 2.25,
    "purchasePrice": 3.838863,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-613",
    "barcode": "613",
    "imageUrl": "http://almoune.fr/img/p/2/3/6/0/2360.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-615",
    "name": "Pignons de pin - Meyva 250g",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-615",
    "barcode": "615",
    "imageUrl": "http://almoune.fr/img/p/2/3/6/2/2362.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-616",
    "name": "Fromage à effiler - Suntat 200g",
    "price": 4.62,
    "purchasePrice": 4.379147,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-616",
    "barcode": "616",
    "imageUrl": "http://almoune.fr/img/p/2/3/6/3/2363.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-617",
    "name": "Rahat - Mounir Bissat 400g",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-617",
    "barcode": "617",
    "imageUrl": "http://almoune.fr/img/p/2/3/6/5/2365.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-618",
    "name": "Saucisse de marmelade aux noix - Beybaba 400g",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-618",
    "barcode": "618",
    "imageUrl": "http://almoune.fr/img/p/2/3/6/6/2366.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-619",
    "name": "Falafel en poudre - Baladna 400g",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-619",
    "barcode": "619",
    "imageUrl": "http://almoune.fr/img/p/2/3/6/7/2367.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-620",
    "name": "Dattes d'Iran - Meysa env. 600g",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-620",
    "barcode": "620",
    "imageUrl": "http://almoune.fr/img/p/2/3/6/8/2368.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-621",
    "name": "Kaak bâtonnets de Pain au sésame- Durra 454 g",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-621",
    "barcode": "621",
    "imageUrl": "http://almoune.fr/img/p/4/0/4/0/4040.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-622",
    "name": "Noisettes torréfiées - 100g",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-622",
    "barcode": "622",
    "imageUrl": "http://almoune.fr/img/p/2/3/7/1/2371.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-623",
    "name": "Eponge naturelle LUFFA - Ahlam",
    "price": 3.4,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Autres",
    "sku": "SKU-623",
    "barcode": "623",
    "imageUrl": "http://almoune.fr/img/p/2/3/7/2/2372.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-624",
    "name": "Riz long Basmati - Mahmood Rice 4.5 kg",
    "price": 23.99,
    "purchasePrice": 22.739336,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-624",
    "barcode": "624",
    "imageUrl": "http://almoune.fr/img/p/3/1/3/7/3137.jpg",
    "price_per_kg": 23.99
  },
  {
    "id": "csv-625",
    "name": "Mortier et pilon en bois",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-625",
    "barcode": "625",
    "imageUrl": "http://almoune.fr/img/p/2/3/7/6/2376.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-627",
    "name": "Safran d'Iran -  Esfedan 1g",
    "price": 5.49,
    "purchasePrice": 5.203791,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-627",
    "barcode": "627",
    "imageUrl": "http://almoune.fr/img/p/2/3/7/9/2379.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-634",
    "name": "Dattes d'Algérie - Brousse@fils 250gr.",
    "price": 1.29,
    "purchasePrice": 1.222749,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-634",
    "barcode": "634",
    "imageUrl": "http://almoune.fr/img/p/2/5/0/1/2501.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-637",
    "name": "Eau de rose 100% Naturelle Mymouné 25cL",
    "price": 11.26,
    "purchasePrice": 9.383886,
    "stock": 19,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-637",
    "barcode": "637",
    "imageUrl": "http://almoune.fr/img/p/2/3/8/2/2382.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-641",
    "name": "Biscuit et Loukoum",
    "price": 5.88,
    "purchasePrice": 5.57346,
    "stock": 0,
    "category": "Accueil",
    "sku": "Offre spéciale",
    "barcode": "641",
    "imageUrl": "http://almoune.fr/img/p/2/3/8/3/2383.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-644",
    "name": "Epices Fajitas Abido 50gr.",
    "price": 1.6,
    "purchasePrice": 1.516588,
    "stock": -2,
    "category": "Epices",
    "sku": "SKU-644",
    "barcode": "644",
    "imageUrl": "http://almoune.fr/img/p/2/3/8/4/2384.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-645",
    "name": "Coffee mate The original - 400 gr",
    "price": 7.95,
    "purchasePrice": 7.535545,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-645",
    "barcode": "645",
    "imageUrl": "http://almoune.fr/img/p/3/3/0/6/3306.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-646",
    "name": "Baklava Mixte - ZAITOUNE 600g",
    "price": 27.45,
    "purchasePrice": 26.018957,
    "stock": 0,
    "category": "Baklava",
    "sku": "SKU-646",
    "barcode": "646",
    "imageUrl": "http://almoune.fr/img/p/2/3/9/0/2390.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-647",
    "name": "Baklava Mixte - ZAITOUNE 400g",
    "price": 19.35,
    "purchasePrice": 18.341232,
    "stock": 0,
    "category": "Baklava",
    "sku": "SKU-647",
    "barcode": "647",
    "imageUrl": "http://almoune.fr/img/p/2/3/9/1/2391.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-648",
    "name": "Baklava Mixte BAWABET DIMASHQ 400g",
    "price": 24,
    "purchasePrice": 22.748815,
    "stock": -1,
    "category": "Baklava",
    "sku": "SKU-648",
    "barcode": "648",
    "imageUrl": "http://almoune.fr/img/p/3/9/1/6/3916.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-649",
    "name": "Akawi fromage en vrac  Boustani env. 290 g",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Fromages libanais",
    "sku": "SKU-649",
    "barcode": "649",
    "imageUrl": "http://almoune.fr/img/p/2/4/3/4/2434.jpg",
    "price_per_kg": 4.99
  },
  {
    "id": "csv-650",
    "name": "Lentilles blondes petite taille -  1000g",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 34,
    "category": "Légumineuses",
    "sku": "SKU-650",
    "barcode": "650",
    "imageUrl": "http://almoune.fr/img/p/2/3/9/3/2393.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-651",
    "name": "Offre café BLACK FRIDAY",
    "price": 15,
    "purchasePrice": 17.251185,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-651",
    "barcode": "651",
    "imageUrl": "http://almoune.fr/img/p/2/3/9/4/2394.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-654",
    "name": "Baklava Mixte BAWABET DIMASHQ 750g",
    "price": 39.5,
    "purchasePrice": 37.440758,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-654",
    "barcode": "654",
    "imageUrl": "http://almoune.fr/img/p/3/9/1/5/3915.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-655",
    "name": "Navets Marinés - MECHAALANY 600g",
    "price": 5.25,
    "purchasePrice": 4.976303,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-655",
    "barcode": "655",
    "imageUrl": "http://almoune.fr/img/p/3/1/5/4/3154.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-656",
    "name": "Concombres Sauvages Marinés - MECHAALANY 600g",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-656",
    "barcode": "656",
    "imageUrl": "http://almoune.fr/img/p/3/1/5/2/3152.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-658",
    "name": "Double crème - Vassilitsa 200g",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "Ressemble au double crème",
    "barcode": "658",
    "imageUrl": "http://almoune.fr/img/p/2/4/0/1/2401.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-659",
    "name": "Aubergines farcies à la Libanaise - DIWAN 380g",
    "price": 3.85,
    "purchasePrice": 3.649289,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-659",
    "barcode": "659",
    "imageUrl": "http://almoune.fr/img/p/3/1/4/5/3145.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-660",
    "name": "Yaourt Grec  BIO - KOLIOS 500g",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 87,
    "category": "Accueil",
    "sku": "SKU-660",
    "barcode": "660",
    "imageUrl": "http://almoune.fr/img/p/2/3/9/9/2399.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-661",
    "name": "Courgettes Farcies à la Libanaise - Diwan 380g",
    "price": 3.85,
    "purchasePrice": 3.649289,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-661",
    "barcode": "661",
    "imageUrl": "http://almoune.fr/img/p/3/1/2/9/3129.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-662",
    "name": "Boulettes de viande à la sauce tomate - Paliria 280g.",
    "price": 3.35,
    "purchasePrice": 3.175355,
    "stock": -1,
    "category": "Conserves",
    "sku": "SKU-662",
    "barcode": "662",
    "imageUrl": "http://almoune.fr/img/p/3/1/6/3/3163.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-664",
    "name": "Feuilles de vigne farcies au sirop de grenade - Paliria 400g",
    "price": 3.6,
    "purchasePrice": 3.412322,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-664",
    "barcode": "664",
    "imageUrl": "http://almoune.fr/img/p/2/4/0/5/2405.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-665",
    "name": "Aubergines Imam - Paliria 280g",
    "price": 3.55,
    "purchasePrice": 3.364929,
    "stock": -60,
    "category": "Accueil",
    "sku": "SKU-665",
    "barcode": "665",
    "imageUrl": "http://almoune.fr/img/p/3/7/9/9/3799.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-666",
    "name": "Falafel en poudre - SHP 200g",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-666",
    "barcode": "666",
    "imageUrl": "http://almoune.fr/img/p/2/4/2/2/2422.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-667",
    "name": "Miel au thym Grec - Atiki 250g",
    "price": 6.75,
    "purchasePrice": 6.398104,
    "stock": 0,
    "category": "Mélasses et miels",
    "sku": "SKU-667",
    "barcode": "667",
    "imageUrl": "http://almoune.fr/img/p/2/4/0/7/2407.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-668",
    "name": "Ghouraybe extra aux amandes - Keramiadas 420g",
    "price": 6.99,
    "purchasePrice": 6.625592,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-668",
    "barcode": "668",
    "imageUrl": "http://almoune.fr/img/p/2/4/0/8/2408.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-670",
    "name": "Bourma aux pistaches frais  - 500gr",
    "price": 9.99,
    "purchasePrice": 9.469194,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-670",
    "barcode": "670",
    "imageUrl": "http://almoune.fr/img/p/2/4/1/1/2411.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-671",
    "name": "Namoura 6 pcs - Bouchée Dorée env. 430g",
    "price": 9,
    "purchasePrice": 8.530806,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-671",
    "barcode": "671",
    "imageUrl": "http://almoune.fr/img/p/2/4/1/2/2412.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-672",
    "name": "Ghraybeh libanais - Douaihy 350g",
    "price": 14.49,
    "purchasePrice": 13.734597,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-672",
    "barcode": "672",
    "imageUrl": "http://almoune.fr/img/p/2/8/6/2/2862.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-673",
    "name": "Maamoul aux pétales de fleurs d'orange - DOUAIHY 350g",
    "price": 11.99,
    "purchasePrice": 11.364929,
    "stock": 0,
    "category": "Patisserie Douaihy",
    "sku": "SKU-673",
    "barcode": "673",
    "imageUrl": "http://almoune.fr/img/p/2/4/1/4/2414.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-674",
    "name": "Baklava Mixtes (Boite en carton) - DOUAIHY 250g",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": 2,
    "category": "Patisserie Douaihy",
    "sku": "SKU-674",
    "barcode": "674",
    "imageUrl": "http://almoune.fr/img/p/2/4/2/0/2420.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-675",
    "name": "Mélange de maamoul aux dattes, barazek, ghraybeh - Douaihy 500g",
    "price": 18.5,
    "purchasePrice": 17.535545,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-675",
    "barcode": "675",
    "imageUrl": "http://almoune.fr/img/p/2/9/6/2/2962.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-676",
    "name": "Maamoul aux noix, pistaches et dattes - DOUAIHY 1kg",
    "price": 22,
    "purchasePrice": 20.853081,
    "stock": 0,
    "category": "Patisserie Douaihy",
    "sku": "SKU-676",
    "barcode": "676",
    "imageUrl": "http://almoune.fr/img/p/2/4/1/6/2416.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-677",
    "name": "Ech el Belbol - Douaihy 300g",
    "price": 18.5,
    "purchasePrice": 17.535545,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-677",
    "barcode": "677",
    "imageUrl": "http://almoune.fr/img/p/2/8/6/1/2861.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-678",
    "name": "Labneh ( yaourt égouté) - Rona 500g",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -18,
    "category": "Yaourt et Labneh",
    "sku": "SKU-678",
    "barcode": "678",
    "imageUrl": "http://almoune.fr/img/p/2/4/2/1/2421.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-679",
    "name": "Falafel Fève - Basma 400g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-679",
    "barcode": "679",
    "imageUrl": "http://almoune.fr/img/p/2/4/2/4/2424.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-681",
    "name": "Mouloukhiye seché - SHP 200g",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-681",
    "barcode": "681",
    "imageUrl": "http://almoune.fr/img/p/2/4/3/1/2431.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-682",
    "name": "Idée cadeau - Panier Savon d'Alep",
    "price": 15.99,
    "purchasePrice": 15.156398,
    "stock": 0,
    "category": "Autres",
    "sku": "SKU-682",
    "barcode": "682",
    "imageUrl": "http://almoune.fr/img/p/2/4/2/5/2425.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-683",
    "name": "Feuille de vigne durra format familial 1.9kg",
    "price": 14.95,
    "purchasePrice": 14.170616,
    "stock": -40,
    "category": "Accueil",
    "sku": "SKU-683",
    "barcode": "683",
    "imageUrl": "http://almoune.fr/img/p/2/4/4/3/2443.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-684",
    "name": "Olives Noires Grecques de Kalamata - Elita 390g",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-684",
    "barcode": "684",
    "imageUrl": "http://almoune.fr/img/p/2/4/2/8/2428.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-685",
    "name": "Olives Grecques Farcies aux Amandes - Elita 390g",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 1,
    "category": "Olives",
    "sku": "SKU-685",
    "barcode": "685",
    "imageUrl": "http://almoune.fr/img/p/2/4/2/9/2429.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-686",
    "name": "Olives Vertes Grecques Farcies au Poivron Rouge  - Elita 390g",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 0,
    "category": "Olives",
    "sku": "SKU-686",
    "barcode": "686",
    "imageUrl": "http://almoune.fr/img/p/2/4/3/0/2430.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-687",
    "name": "Idée cadeau - Panier naturel",
    "price": 27.1,
    "purchasePrice": 25.687204,
    "stock": 0,
    "category": "Autres",
    "sku": "SKU-687",
    "barcode": "687",
    "imageUrl": "http://almoune.fr/img/p/2/4/3/2/2432.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-689",
    "name": "MENU REVEILLON - 5 mezzés, 8 pers",
    "price": 31.39,
    "purchasePrice": 32.834123,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-689",
    "barcode": "689",
    "imageUrl": "http://almoune.fr/img/p/2/4/3/3/2433.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-690",
    "name": "Fèves décortiquées 1kg",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 190,
    "category": "Légumineuses et grains",
    "sku": "SKU-690",
    "barcode": "690",
    "imageUrl": "http://almoune.fr/img/p/2/5/5/5/2555.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-692",
    "name": "Fruit sec grillé salé Extra  Fancy 200gr",
    "price": 3.95,
    "purchasePrice": 3.744076,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-692",
    "barcode": "692",
    "imageUrl": "http://almoune.fr/img/p/2/4/4/2/2442.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-694",
    "name": "Ghee Végétal Alworud 1900 gr",
    "price": 8.99,
    "purchasePrice": 8.521327,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-694",
    "barcode": "694",
    "imageUrl": "http://almoune.fr/img/p/2/4/4/4/2444.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-695",
    "name": "Thym vert mariné 600 gr Dayaa",
    "price": 4.95,
    "purchasePrice": 4.691943,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-695",
    "barcode": "695",
    "imageUrl": "http://almoune.fr/img/p/2/4/4/5/2445.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-697",
    "name": "Potiron Confit au sirop, 450gr",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-697",
    "barcode": "697",
    "imageUrl": "http://almoune.fr/img/p/2/4/4/6/2446.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-698",
    "name": "Noix confites au sirop 450 gr.",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 0,
    "category": "Confitures",
    "sku": "mraba el jozz",
    "barcode": "698",
    "imageUrl": "http://almoune.fr/img/p/3/1/4/9/3149.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-699",
    "name": "Confit d'aubergine au sirop 450",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 0,
    "category": "Accueil",
    "sku": "mraba el batenjan",
    "barcode": "699",
    "imageUrl": "http://almoune.fr/img/p/2/4/5/0/2450.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-700",
    "name": "Huile d'olive Grec LOUKAKOS 750ml",
    "price": 16.5,
    "purchasePrice": 15.63981,
    "stock": 0,
    "category": "Huiles et vinaigres",
    "sku": "Sélection Almouné goût intense",
    "barcode": "700",
    "imageUrl": "http://almoune.fr/img/p/2/4/5/2/2452.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-701",
    "name": "Sardines à l'huile végétale - Durra 90 gr.",
    "price": 1.65,
    "purchasePrice": 1.563981,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-701",
    "barcode": "701",
    "imageUrl": "http://almoune.fr/img/p/3/1/7/3/3173.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-703",
    "name": "Poivre Noir moulu Abido 50gr",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -5,
    "category": "Epices",
    "sku": "SKU-703",
    "barcode": "703",
    "imageUrl": "http://almoune.fr/img/p/2/4/5/5/2455.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-704",
    "name": "Ketchup Dolly's 340 gr",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-704",
    "barcode": "704",
    "imageUrl": "http://almoune.fr/img/p/2/4/5/6/2456.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-705",
    "name": "Kaak longs au sésame - Moulin d'or 400 gr",
    "price": 4.95,
    "purchasePrice": 4.691943,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-705",
    "barcode": "705",
    "imageUrl": "http://almoune.fr/img/p/2/4/5/7/2457.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-707",
    "name": "houmos chtoura 430gr",
    "price": 1.65,
    "purchasePrice": 1.563981,
    "stock": 41,
    "category": "Accueil",
    "sku": "SKU-707",
    "barcode": "707",
    "imageUrl": "http://almoune.fr/img/p/2/4/5/8/2458.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-711",
    "name": "Foul - fèves à la purée de sésame - California Garden 400g",
    "price": 1.54,
    "purchasePrice": 1.459716,
    "stock": 59,
    "category": "Conserves",
    "sku": "SKU-711",
    "barcode": "711",
    "imageUrl": "http://almoune.fr/img/p/3/5/9/5/3595.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-712",
    "name": "Fèves avec cumin - California Garden 400g",
    "price": 1.54,
    "purchasePrice": 1.459716,
    "stock": 71,
    "category": "Conserves",
    "sku": "SKU-712",
    "barcode": "712",
    "imageUrl": "http://almoune.fr/img/p/4/0/4/8/4048.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-713",
    "name": "Foul - fèves pelées au piment - California Garden 400 gr",
    "price": 1.54,
    "purchasePrice": 1.459716,
    "stock": 48,
    "category": "Accueil",
    "sku": "SKU-713",
    "barcode": "713",
    "imageUrl": "http://almoune.fr/img/p/3/5/9/3/3593.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-714",
    "name": "Foul - fèves Recette Libanaise - California Garden 400g",
    "price": 1.54,
    "purchasePrice": 1.459716,
    "stock": 178,
    "category": "Conserves",
    "sku": "SKU-714",
    "barcode": "714",
    "imageUrl": "http://almoune.fr/img/p/4/0/4/6/4046.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-715",
    "name": "Foul - fèves Recette Egyptienne - California Garden 400 gr",
    "price": 1.54,
    "purchasePrice": 1.459716,
    "stock": 40,
    "category": "Conserves",
    "sku": "SKU-715",
    "barcode": "715",
    "imageUrl": "http://almoune.fr/img/p/3/5/9/4/3594.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-716",
    "name": "Dattes d'Iran - 500g",
    "price": 2.8,
    "purchasePrice": 2.654028,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-716",
    "barcode": "716",
    "imageUrl": "http://almoune.fr/img/p/2/5/0/3/2503.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-718",
    "name": "Saucice au boeuf- Fulya 400g",
    "price": 2.1,
    "purchasePrice": 1.990521,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-718",
    "barcode": "718",
    "imageUrl": "http://almoune.fr/img/p/2/4/4/1/2441.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-722",
    "name": "Moutarde Hot dog Dolly's 260ml",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-722",
    "barcode": "722",
    "imageUrl": "http://almoune.fr/img/p/2/4/6/0/2460.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-723",
    "name": "kamar el din pates abricot séché au soleil  400gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-723",
    "barcode": "723",
    "imageUrl": "http://almoune.fr/img/p/2/4/6/1/2461.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-724",
    "name": "Foul Mdamas Al wadi 400gr",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": 20,
    "category": "Accueil",
    "sku": "SKU-724",
    "barcode": "724",
    "imageUrl": "http://almoune.fr/img/p/3/1/5/9/3159.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-725",
    "name": "Levure boulangère abido 50gr",
    "price": 1.2,
    "purchasePrice": 1.137441,
    "stock": 9,
    "category": "Epices",
    "sku": "SKU-725",
    "barcode": "725",
    "imageUrl": "http://almoune.fr/img/p/2/4/6/3/2463.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-726",
    "name": "Purée d'Aubergines grillées Paliria 2.6 kg",
    "price": 12.99,
    "purchasePrice": 12.312796,
    "stock": -160,
    "category": "Accueil",
    "sku": "SKU-726",
    "barcode": "726",
    "imageUrl": "http://almoune.fr/img/p/2/4/6/4/2464.jpg",
    "price_per_kg": 12.99
  },
  {
    "id": "csv-727",
    "name": "Raifort (chrzan) 190g. Rolnik",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 9,
    "category": "Condiments",
    "sku": "SKU-727",
    "barcode": "727",
    "imageUrl": "http://almoune.fr/img/p/3/0/9/8/3098.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-728",
    "name": "Akkawi (akawi) Fromage du Liban  270 g",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-728",
    "barcode": "728",
    "imageUrl": "http://almoune.fr/img/p/2/4/6/6/2466.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-732",
    "name": "Limonade Libanaise authentique Junet 250ml",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 73,
    "category": "Accueil",
    "sku": "SKU-732",
    "barcode": "732",
    "imageUrl": "http://almoune.fr/img/p/3/4/8/0/3480.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-734",
    "name": "Yaourt Laban Fromage du Liban 1kg",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Yaourt et Labneh",
    "sku": "SKU-734",
    "barcode": "734",
    "imageUrl": "http://almoune.fr/img/p/2/4/6/5/2465.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-735",
    "name": "Mayonnaise - Dolly's 250g",
    "price": 1.95,
    "purchasePrice": 1.848341,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-735",
    "barcode": "735",
    "imageUrl": "http://almoune.fr/img/p/2/4/7/6/2476.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-736",
    "name": "Gelée à la Fraise ou Jello  - Aruba 85g",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-736",
    "barcode": "736",
    "imageUrl": "http://almoune.fr/img/p/3/1/0/6/3106.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-737",
    "name": "Jello Ananas Aruba 85g",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-737",
    "barcode": "737",
    "imageUrl": "http://almoune.fr/img/p/3/0/1/3/3013.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-738",
    "name": "Jello Fruit rouge Aruba 50g",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-738",
    "barcode": "738",
    "imageUrl": "http://almoune.fr/img/p/3/0/9/9/3099.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-742",
    "name": "Pois chiches gros calibre 42/44 excellente qualité - 25kg",
    "price": 99,
    "purchasePrice": 93.838863,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-742",
    "barcode": "742",
    "imageUrl": "http://almoune.fr/img/p/3/9/6/7/3967.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-744",
    "name": "Epices  Tawouk ADIDA 500gr",
    "price": 8.5,
    "purchasePrice": 8.056872,
    "stock": 18,
    "category": "Épices",
    "sku": "SKU-744",
    "barcode": "744",
    "imageUrl": "http://almoune.fr/img/p/3/1/0/0/3100.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-745",
    "name": "Epices  Shawarma au poulet Adida 500gr",
    "price": 9.5,
    "purchasePrice": 9.004739,
    "stock": 0,
    "category": "Epices",
    "sku": "SKU-745",
    "barcode": "745",
    "imageUrl": "http://almoune.fr/img/p/3/1/0/1/3101.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-746",
    "name": "Epices shawarma viande 500gr",
    "price": 7,
    "purchasePrice": 6.635071,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-746",
    "barcode": "746",
    "imageUrl": "http://almoune.fr/img/p/3/0/8/6/3086.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-747",
    "name": "Epices falafel Adida 500gr",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 1,
    "category": "Epices",
    "sku": "SKU-747",
    "barcode": "747",
    "imageUrl": "http://almoune.fr/img/p/3/0/8/7/3087.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-748",
    "name": "Septs épices Adida 500gr",
    "price": 6.25,
    "purchasePrice": 5.924171,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-748",
    "barcode": "748",
    "imageUrl": "http://almoune.fr/img/p/2/8/7/4/2874.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-750",
    "name": "Pois chiches dragées - Castania 100gr",
    "price": 2.15,
    "purchasePrice": 2.037915,
    "stock": 12,
    "category": "Friandises",
    "sku": "SKU-750",
    "barcode": "750",
    "imageUrl": "http://almoune.fr/img/p/3/7/4/6/3746.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-751",
    "name": "Fèves Foul - Foody 400g",
    "price": 0.85,
    "purchasePrice": 0.805687,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-751",
    "barcode": "751",
    "imageUrl": "http://almoune.fr/img/p/2/4/7/8/2478.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-755",
    "name": "Riz basmati RAII 5kg",
    "price": 19.5,
    "purchasePrice": 18.483412,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-755",
    "barcode": "755",
    "imageUrl": "http://almoune.fr/img/p/2/6/6/7/2667.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-760",
    "name": "Mélasse de grenade Durra 1L",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": 24,
    "category": "Mélasses et miels",
    "sku": "SKU-760",
    "barcode": "760",
    "imageUrl": "http://almoune.fr/img/p/3/4/7/8/3478.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-765",
    "name": "sucre vanilline Dr. Oekter 10 sachet 80g.",
    "price": 2.1,
    "purchasePrice": 1.990521,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-765",
    "barcode": "765",
    "imageUrl": "http://almoune.fr/img/p/3/0/8/8/3088.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-766",
    "name": "Dattes d'Algérie - Brousse@fils 500gr",
    "price": 2.49,
    "purchasePrice": 2.36019,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-766",
    "barcode": "766",
    "imageUrl": "http://almoune.fr/img/p/2/5/0/0/2500.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-767",
    "name": "Mélasse sucre de canne naturelle 400 gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 14,
    "category": "Mélasses et miels",
    "sku": "SKU-767",
    "barcode": "767",
    "imageUrl": "http://almoune.fr/img/p/3/6/3/0/3630.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-770",
    "name": "Ail semoule 500gr",
    "price": 8.99,
    "purchasePrice": 8.521327,
    "stock": -1,
    "category": "Épices",
    "sku": "SKU-770",
    "barcode": "770",
    "imageUrl": "http://almoune.fr/img/p/3/0/1/7/3017.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-771",
    "name": "Maggi en cube, poulet boite 500 gr",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-771",
    "barcode": "771",
    "imageUrl": "http://almoune.fr/img/p/2/9/8/5/2985.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-772",
    "name": "Zaatar vert d'Alep Baladna 400gr",
    "price": 4.35,
    "purchasePrice": 4.123223,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-772",
    "barcode": "772",
    "imageUrl": "http://almoune.fr/img/p/3/0/8/9/3089.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-774",
    "name": "Bicarbonate alimentaire Aruba 250g",
    "price": 1.49,
    "purchasePrice": 1.412322,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-774",
    "barcode": "774",
    "imageUrl": "http://almoune.fr/img/p/3/0/5/7/3057.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-775",
    "name": "Halawa pistaches - Baladna 350g",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": 0,
    "category": "Halawa",
    "sku": "SKU-775",
    "barcode": "775",
    "imageUrl": "http://almoune.fr/img/p/2/4/7/7/2477.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-776",
    "name": "Mélasse de Grenade - Al Rabih 500ml",
    "price": 7.35,
    "purchasePrice": 6.966825,
    "stock": 0,
    "category": "Mélasses et miels",
    "sku": "SKU-776",
    "barcode": "776",
    "imageUrl": "http://almoune.fr/img/p/2/4/6/8/2468.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-778",
    "name": "pâte d'arachides 500gr",
    "price": 2.4,
    "purchasePrice": 2.274882,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-778",
    "barcode": "778",
    "imageUrl": "http://almoune.fr/img/p/3/0/9/0/3090.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-781",
    "name": "Tahini (crème de sésame) - Al wadi 454g",
    "price": 6.25,
    "purchasePrice": 5.924171,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-781",
    "barcode": "781",
    "imageUrl": "http://almoune.fr/img/p/2/4/7/9/2479.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-782",
    "name": "Biscuits Petit Beurre Natures  - Ulker 450g",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-782",
    "barcode": "782",
    "imageUrl": "http://almoune.fr/img/p/2/4/6/9/2469.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-783",
    "name": "Sauce Tomate 370g Sesobel",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Concentrés",
    "sku": "SKU-783",
    "barcode": "783",
    "imageUrl": "http://almoune.fr/img/p/3/0/9/1/3091.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-785",
    "name": "Dattes d'Algérie - 1kg",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-785",
    "barcode": "785",
    "imageUrl": "http://almoune.fr/img/p/2/5/0/4/2504.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-786",
    "name": "Dattes - Sukkari 600g",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-786",
    "barcode": "786",
    "imageUrl": "http://almoune.fr/img/p/3/1/3/6/3136.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-796",
    "name": "Feuilles de vigne farcies Bio - Paliria 200g",
    "price": 2.65,
    "purchasePrice": 2.511848,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-796",
    "barcode": "796",
    "imageUrl": "http://almoune.fr/img/p/3/1/6/2/3162.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-797",
    "name": "Makdous d'aubergines - Mechelany foods 575 G",
    "price": 8.95,
    "purchasePrice": 8.483412,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "Makdous d'aubergines",
    "barcode": "797",
    "imageUrl": "http://almoune.fr/img/p/3/0/9/2/3092.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-801",
    "name": "Tahina (crème de sésame) - Al Kanater 450g",
    "price": 5.25,
    "purchasePrice": 4.976303,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-801",
    "barcode": "801",
    "imageUrl": "http://almoune.fr/img/p/3/6/3/9/3639.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-805",
    "name": "Concombres au Vinaigre 1kg - Al Dayaa",
    "price": 5.25,
    "purchasePrice": 4.976303,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-805",
    "barcode": "805",
    "imageUrl": "http://almoune.fr/img/p/2/4/7/2/2472.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-806",
    "name": "Concombres Sauvages au Vinaigre 1kg - Al Dayaa",
    "price": 5.45,
    "purchasePrice": 5.165877,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "Offre spéciale",
    "barcode": "806",
    "imageUrl": "http://almoune.fr/img/p/2/4/7/3/2473.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-807",
    "name": "Charbon tefeha 400g.",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-807",
    "barcode": "807",
    "imageUrl": "http://almoune.fr/img/p/2/8/7/7/2877.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-808",
    "name": "Sirop de Jellab (Jallab)  - Anjar 60cl",
    "price": 5.49,
    "purchasePrice": 5.203791,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-808",
    "barcode": "808",
    "imageUrl": "http://almoune.fr/img/p/2/4/7/4/2474.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-811",
    "name": "Choucroute 850gr_ Rolnik",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-811",
    "barcode": "811",
    "imageUrl": "http://almoune.fr/img/p/2/4/9/1/2491.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-813",
    "name": "Bourma (baklava) aux pistaches - Al-Sharq 1kg",
    "price": 32,
    "purchasePrice": 30.331754,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-813",
    "barcode": "813",
    "imageUrl": "http://almoune.fr/img/p/2/4/8/0/2480.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-814",
    "name": "Baklava (assabeh) - Al-Sharq 1kg",
    "price": 27,
    "purchasePrice": 25.592417,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-814",
    "barcode": "814",
    "imageUrl": "http://almoune.fr/img/p/2/4/8/2/2482.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-815",
    "name": "Baklava spéciale aux pistaches - Al-Sharq 1kg",
    "price": 32,
    "purchasePrice": 30.331754,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-815",
    "barcode": "815",
    "imageUrl": "http://almoune.fr/img/p/2/4/8/4/2484.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-816",
    "name": "Baklava Mixte - Al-Sharq 450g",
    "price": 14.99,
    "purchasePrice": 14.208531,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-816",
    "barcode": "816",
    "imageUrl": "http://almoune.fr/img/p/2/4/8/6/2486.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-817",
    "name": "Maamoul aux noix, pistaches et dattes - Al-Sharq 750g",
    "price": 17.49,
    "purchasePrice": 16.578199,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-817",
    "barcode": "817",
    "imageUrl": "http://almoune.fr/img/p/2/4/8/8/2488.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-818",
    "name": "Baklava Mixte - ZAITOUNE 750g",
    "price": 32,
    "purchasePrice": 30.331754,
    "stock": 0,
    "category": "Baklava",
    "sku": "SKU-818",
    "barcode": "818",
    "imageUrl": "http://almoune.fr/img/p/2/4/8/9/2489.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-819",
    "name": "Café Haseeb super Extra à la cardamome 500gr",
    "price": 14.45,
    "purchasePrice": 13.696682,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-819",
    "barcode": "819",
    "imageUrl": "http://almoune.fr/img/p/3/6/1/6/3616.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-820",
    "name": "Infusion de réglisse-160g Ramzy",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-820",
    "barcode": "820",
    "imageUrl": "http://almoune.fr/img/p/2/5/1/8/2518.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-821",
    "name": "Maamoul aux pistaches - AGHATI 500g",
    "price": 18.5,
    "purchasePrice": 17.535545,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-821",
    "barcode": "821",
    "imageUrl": "http://almoune.fr/img/p/2/4/9/3/2493.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-822",
    "name": "Maamoul aux noix - AGHATI 500g",
    "price": 19.5,
    "purchasePrice": 18.483412,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-822",
    "barcode": "822",
    "imageUrl": "http://almoune.fr/img/p/3/1/2/4/3124.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-823",
    "name": "Maamoul aux dattes - AGHATI 500g",
    "price": 16.5,
    "purchasePrice": 15.63981,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-823",
    "barcode": "823",
    "imageUrl": "http://almoune.fr/img/p/2/4/9/5/2495.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-824",
    "name": "Maamoul mixte 7 pièces - 500g",
    "price": 9.5,
    "purchasePrice": 9.004739,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-824",
    "barcode": "824",
    "imageUrl": "http://almoune.fr/img/p/2/4/9/6/2496.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-826",
    "name": "Baklava mixte - 250g",
    "price": 7.25,
    "purchasePrice": 6.872038,
    "stock": 9,
    "category": "Accueil",
    "sku": "SKU-826",
    "barcode": "826",
    "imageUrl": "http://almoune.fr/img/p/2/4/9/7/2497.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-827",
    "name": "Namoura 6 pcs - environ 300g",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-827",
    "barcode": "827",
    "imageUrl": "http://almoune.fr/img/p/2/4/9/8/2498.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-828",
    "name": "Cigares aux dattes - 250g",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-828",
    "barcode": "828",
    "imageUrl": "http://almoune.fr/img/p/2/5/0/6/2506.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-829",
    "name": "Tamara 250 gr - Biscuit D'or",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-829",
    "barcode": "829",
    "imageUrl": "http://almoune.fr/img/p/2/5/0/7/2507.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-830",
    "name": "Castania Super Extra - 300g",
    "price": 7.25,
    "purchasePrice": 6.872038,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-830",
    "barcode": "830",
    "imageUrl": "http://almoune.fr/img/p/2/5/0/8/2508.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-831",
    "name": "Kaak ghreybe au sésame - Moulin d'or 470g",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-831",
    "barcode": "831",
    "imageUrl": "http://almoune.fr/img/p/2/5/0/9/2509.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-832",
    "name": "Kaak - Biscuit d'or 250g",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "pain et Kaak",
    "sku": "SKU-832",
    "barcode": "832",
    "imageUrl": "http://almoune.fr/img/p/2/5/1/1/2511.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-833",
    "name": "Colorants pour oeufs de Pâques - Rouge",
    "price": 1.35,
    "purchasePrice": 1.125,
    "stock": 47,
    "category": "Accueil",
    "sku": "SKU-833",
    "barcode": "833",
    "imageUrl": "http://almoune.fr/img/p/2/5/3/1/2531.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-834",
    "name": "Colorants pour oeufs de Pâques - Vert",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-834",
    "barcode": "834",
    "imageUrl": "http://almoune.fr/img/p/2/5/3/0/2530.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-835",
    "name": "Colorants pour oeufs de Pâques - Jaune",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-835",
    "barcode": "835",
    "imageUrl": "http://almoune.fr/img/p/2/5/2/9/2529.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-836",
    "name": "Colorants pour oeufs de Pâques - Bleu",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-836",
    "barcode": "836",
    "imageUrl": "http://almoune.fr/img/p/2/5/2/8/2528.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-837",
    "name": "Colorants pour oeufs de Pâques",
    "price": 5,
    "purchasePrice": 4.739336,
    "stock": 0,
    "category": "Autres",
    "sku": "SKU-837",
    "barcode": "837",
    "imageUrl": "http://almoune.fr/img/p/2/5/2/7/2527.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-839",
    "name": "Assortiment de maamoul - Douaihy 500gr",
    "price": 17.75,
    "purchasePrice": 16.824645,
    "stock": -8,
    "category": "Accueil",
    "sku": "SKU-839",
    "barcode": "839",
    "imageUrl": "http://almoune.fr/img/p/2/5/2/5/2525.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-841",
    "name": "Cha-Cha maxx 34.5g LU",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-841",
    "barcode": "841",
    "imageUrl": "http://almoune.fr/img/p/2/5/4/2/2542.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-842",
    "name": "Coffee mate 800 g",
    "price": 9.99,
    "purchasePrice": 9.469194,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-842",
    "barcode": "842",
    "imageUrl": "http://almoune.fr/img/p/3/3/0/3/3303.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-843",
    "name": "Feuilles de vigne farcies - Paliria 2.1 kg (70 pièces)",
    "price": 16.5,
    "purchasePrice": 15.63981,
    "stock": 3,
    "category": "Conserves",
    "sku": "SKU-843",
    "barcode": "843",
    "imageUrl": "http://almoune.fr/img/p/3/7/3/3/3733.jpg",
    "price_per_kg": 16.5
  },
  {
    "id": "csv-844",
    "name": "Tahini ou tahina (crème de sésame) Shahin 800 gr",
    "price": 8.95,
    "purchasePrice": 8.483412,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-844",
    "barcode": "844",
    "imageUrl": "http://almoune.fr/img/p/4/0/4/5/4045.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-845",
    "name": "Café nature Abi Nasr 200 gr.",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-845",
    "barcode": "845",
    "imageUrl": "http://almoune.fr/img/p/2/5/2/3/2523.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-846",
    "name": "Café cardamome Abi Nasr 200gr",
    "price": 3.35,
    "purchasePrice": 3.175355,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-846",
    "barcode": "846",
    "imageUrl": "http://almoune.fr/img/p/2/5/2/2/2522.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-847",
    "name": "Café Nature Abi Nasr Grand 454 gr",
    "price": 7.75,
    "purchasePrice": 7.345972,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-847",
    "barcode": "847",
    "imageUrl": "http://almoune.fr/img/p/3/3/0/5/3305.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-848",
    "name": "Halawa halva nature Shahin 400gr",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 0,
    "category": "Halawa",
    "sku": "SKU-848",
    "barcode": "848",
    "imageUrl": "http://almoune.fr/img/p/3/1/1/1/3111.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-849",
    "name": "Halawa halva Pistache shahin 400gr",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Halawa",
    "sku": "SKU-849",
    "barcode": "849",
    "imageUrl": "http://almoune.fr/img/p/3/1/1/2/3112.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-851",
    "name": "Amidon de maïs Aruba 200 gr",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-851",
    "barcode": "851",
    "imageUrl": "http://almoune.fr/img/p/3/1/7/0/3170.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-852",
    "name": "Riz Basmati - AL SHALAN 5kg",
    "price": 25.5,
    "purchasePrice": 24.170616,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-852",
    "barcode": "852",
    "imageUrl": "http://almoune.fr/img/p/2/5/3/6/2536.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-853",
    "name": "Semoule Extra moyenne 1kg",
    "price": 2.35,
    "purchasePrice": 2.227488,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-853",
    "barcode": "853",
    "imageUrl": "http://almoune.fr/img/p/2/5/3/8/2538.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-855",
    "name": "Thé noir Al Arosa 250gr.",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 32,
    "category": "Accueil",
    "sku": "SKU-855",
    "barcode": "855",
    "imageUrl": "http://almoune.fr/img/p/2/5/4/1/2541.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-858",
    "name": "Haricots Géants à la sauce tomate Paliria 280 gr.",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 12,
    "category": "Conserves",
    "sku": "SKU-858",
    "barcode": "858",
    "imageUrl": "http://almoune.fr/img/p/2/7/7/6/2776.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-860",
    "name": "Lupin salé 250gr. Saladitos",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Chips et apéritifs",
    "sku": "SKU-860",
    "barcode": "860",
    "imageUrl": "http://almoune.fr/img/p/2/8/1/4/2814.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-861",
    "name": "Lupin Salé 810 gr. Saladitos",
    "price": 4.4,
    "purchasePrice": 4.170616,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-861",
    "barcode": "861",
    "imageUrl": "http://almoune.fr/img/p/2/9/8/6/2986.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-862",
    "name": "Pâte de dattes Ziné 1kg",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-862",
    "barcode": "862",
    "imageUrl": "http://almoune.fr/img/p/3/0/5/9/3059.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-865",
    "name": "Butter ghee (samneh) - VACHE DE PARIS 800g",
    "price": 17.5,
    "purchasePrice": 16.587678,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-865",
    "barcode": "865",
    "imageUrl": "http://almoune.fr/img/p/2/5/4/5/2545.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-867",
    "name": "Krikita silver 450gr",
    "price": 8.49,
    "purchasePrice": 8.047393,
    "stock": 8,
    "category": "Chips et apéritifs",
    "sku": "SKU-867",
    "barcode": "867",
    "imageUrl": "http://almoune.fr/img/p/4/0/4/3/4043.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-868",
    "name": "Arome de menthe 300 ml Anjar",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-868",
    "barcode": "868",
    "imageUrl": "http://almoune.fr/img/p/3/0/6/0/3060.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-869",
    "name": "Mastic de chios ou meske 50gr",
    "price": 14.75,
    "purchasePrice": 13.981043,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-869",
    "barcode": "869",
    "imageUrl": "http://almoune.fr/img/p/2/5/8/5/2585.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-870",
    "name": "Piment fort en paillettes - Epices d'or 100g",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-870",
    "barcode": "870",
    "imageUrl": "http://almoune.fr/img/p/3/0/6/1/3061.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-871",
    "name": "Krikita nuts Gold 450gr.",
    "price": 10.95,
    "purchasePrice": 10.379147,
    "stock": 8,
    "category": "Fruits à coques grillés",
    "sku": "SKU-871",
    "barcode": "871",
    "imageUrl": "http://almoune.fr/img/p/4/0/4/2/4042.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-878",
    "name": "Baklava Hallab 250gr",
    "price": 14,
    "purchasePrice": 13.270142,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-878",
    "barcode": "878",
    "imageUrl": "http://almoune.fr/img/p/3/1/1/9/3119.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-879",
    "name": "Homous Chtoura 185g",
    "price": 1.49,
    "purchasePrice": 1.412322,
    "stock": 19,
    "category": "Conserves",
    "sku": "SKU-879",
    "barcode": "879",
    "imageUrl": "http://almoune.fr/img/p/2/8/8/2/2882.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-880",
    "name": "Mahmood Café 3 en 1  24 x 18gr 432gr",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 28,
    "category": "Accueil",
    "sku": "SKU-880",
    "barcode": "880",
    "imageUrl": "http://almoune.fr/img/p/2/7/4/7/2747.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-883",
    "name": "Épices shawarma Poulet Abido 500gr",
    "price": 14.5,
    "purchasePrice": 13.744076,
    "stock": -11,
    "category": "Épices",
    "sku": "SKU-883",
    "barcode": "883",
    "imageUrl": "http://almoune.fr/img/p/3/8/3/5/3835.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-886",
    "name": "Pistaches en poudre 250gr.",
    "price": 10.5,
    "purchasePrice": 9.952607,
    "stock": 15,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-886",
    "barcode": "886",
    "imageUrl": "http://almoune.fr/img/p/3/9/6/6/3966.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-887",
    "name": "Ghee vegetal Aseel  2 kg",
    "price": 17.95,
    "purchasePrice": 17.014218,
    "stock": 4,
    "category": "Aliments et Laitiers",
    "sku": "SKU-887",
    "barcode": "887",
    "imageUrl": "http://almoune.fr/img/p/3/3/7/8/3378.jpg",
    "price_per_kg": 17.95
  },
  {
    "id": "csv-893",
    "name": "Shanklesh Golden plate 420 gr",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-893",
    "barcode": "893",
    "imageUrl": "http://almoune.fr/img/p/2/8/8/3/2883.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-895",
    "name": "Café Oriental Massat 250gr",
    "price": 2.35,
    "purchasePrice": 3.175355,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-895",
    "barcode": "895",
    "imageUrl": "http://almoune.fr/img/p/3/6/9/7/3697.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-896",
    "name": "Tahini Bio (crème de sésame) 280gr.",
    "price": 3.95,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-896",
    "barcode": "896",
    "imageUrl": "http://almoune.fr/img/p/2/7/8/4/2784.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-900",
    "name": "Baies de Goji 150 gr.",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-900",
    "barcode": "900",
    "imageUrl": "http://almoune.fr/img/p/2/5/8/8/2588.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-901",
    "name": "Vermicelles - Tosca 1kg",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-901",
    "barcode": "901",
    "imageUrl": "http://almoune.fr/img/p/2/6/1/6/2616.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-903",
    "name": "Savon Maryam",
    "price": 3.75,
    "purchasePrice": 3.125,
    "stock": 0,
    "category": "Autres",
    "sku": "SKU-903",
    "barcode": "903",
    "imageUrl": "http://almoune.fr/img/p/2/7/9/2/2792.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-904",
    "name": "Makdous Anjar 600gr",
    "price": 7.75,
    "purchasePrice": 7.345972,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-904",
    "barcode": "904",
    "imageUrl": "http://almoune.fr/img/p/3/1/6/6/3166.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-905",
    "name": "Crème lavante Visage Lait d’ânesse 100ml",
    "price": 4.75,
    "purchasePrice": 3.958333,
    "stock": 0,
    "category": "Autres",
    "sku": "SKU-905",
    "barcode": "905",
    "imageUrl": "http://almoune.fr/img/p/2/5/6/4/2564.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-906",
    "name": "Okra Paliria Bamiya bi zeit 280g",
    "price": 3.95,
    "purchasePrice": 3.744076,
    "stock": 13,
    "category": "Conserves",
    "sku": "SKU-906",
    "barcode": "906",
    "imageUrl": "http://almoune.fr/img/p/3/1/2/0/3120.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-909",
    "name": "Zaatar pour infusion 100gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Infusions",
    "sku": "SKU-909",
    "barcode": "909",
    "imageUrl": "http://almoune.fr/img/p/3/1/2/1/3121.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-910",
    "name": "Pétales de rose de qualité supérieure Durra 80gr",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Infusions",
    "sku": "SKU-910",
    "barcode": "910",
    "imageUrl": "http://almoune.fr/img/p/2/7/6/2/2762.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-911",
    "name": "Cuillère ou paille à Maté - dorée (bombilla)",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": -11,
    "category": "Accueil",
    "sku": "SKU-911",
    "barcode": "911",
    "imageUrl": "http://almoune.fr/img/p/3/6/9/8/3698.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-912",
    "name": "Olive vert Grillé marinée dans l'huile 940gr.",
    "price": 7.99,
    "purchasePrice": 7.57346,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-912",
    "barcode": "912",
    "imageUrl": "http://almoune.fr/img/p/3/1/5/1/3151.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-916",
    "name": "Pignons longs 250g",
    "price": 17,
    "purchasePrice": 16.113744,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-916",
    "barcode": "916",
    "imageUrl": "http://almoune.fr/img/p/2/7/8/9/2789.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-919",
    "name": "Cappuccino Tora Bika - 20 sachets",
    "price": 9.99,
    "purchasePrice": 9.469194,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-919",
    "barcode": "919",
    "imageUrl": "http://almoune.fr/img/p/4/4/2/1/4421.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-921",
    "name": "Fromage Happy Cow 400gr",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-921",
    "barcode": "921",
    "imageUrl": "http://almoune.fr/img/p/2/9/8/0/2980.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-924",
    "name": "Cardamome Verte En Capsules Chirag 500g",
    "price": 45,
    "purchasePrice": 42.654028,
    "stock": 5,
    "category": "Épices",
    "sku": "SKU-924",
    "barcode": "924",
    "imageUrl": "http://almoune.fr/img/p/4/4/9/0/4490.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-926",
    "name": "Boulgour fin brun Fark 1kg",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -26,
    "category": "Légumineuses et grains",
    "sku": "SKU-926",
    "barcode": "926",
    "imageUrl": "http://almoune.fr/img/p/2/7/3/0/2730.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-928",
    "name": "Vin Rouge Reserve Du Couvent - 37 cl KSARA",
    "price": 6.8,
    "purchasePrice": 5.666667,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-928",
    "barcode": "928",
    "imageUrl": "http://almoune.fr/img/p/3/6/2/0/3620.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-929",
    "name": "Vin Rosé Sunset - 37,5 cl KSARA",
    "price": 6.8,
    "purchasePrice": 5.666667,
    "stock": -83,
    "category": "Accueil",
    "sku": "SKU-929",
    "barcode": "929",
    "imageUrl": "http://almoune.fr/img/p/3/5/7/0/3570.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-930",
    "name": "Vin rouge Petit noir Cave Kouroum 2015 - 75 cl",
    "price": 9.99,
    "purchasePrice": 8.325,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-930",
    "barcode": "930",
    "imageUrl": "http://almoune.fr/img/p/3/6/0/2/3602.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-934",
    "name": "Halawa Pistaches - Durra 350g",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 2,
    "category": "Halawa",
    "sku": "SKU-934",
    "barcode": "934",
    "imageUrl": "http://almoune.fr/img/p/2/5/4/8/2548.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-935",
    "name": "Halawa Nature - Durra 350g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 11,
    "category": "Halawa",
    "sku": "SKU-935",
    "barcode": "935",
    "imageUrl": "http://almoune.fr/img/p/2/5/4/9/2549.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-936",
    "name": "Maamoul Deemah",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-936",
    "barcode": "936",
    "imageUrl": "http://almoune.fr/img/p/2/9/9/8/2998.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-937",
    "name": "Pâté de Boeuf ZWAN 200gr",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-937",
    "barcode": "937",
    "imageUrl": "http://almoune.fr/img/p/2/5/5/0/2550.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-938",
    "name": "Café Moulu cardamome Hamwi 180g",
    "price": 3.35,
    "purchasePrice": 3.175355,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-938",
    "barcode": "938",
    "imageUrl": "http://almoune.fr/img/p/2/5/5/1/2551.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-939",
    "name": "Corned beef - Al Raii 340g",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-939",
    "barcode": "939",
    "imageUrl": "http://almoune.fr/img/p/3/0/5/6/3056.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-940",
    "name": "Mloukhiyeh 200 gr Durra",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 12,
    "category": "Aliments et Laitiers",
    "sku": "SKU-940",
    "barcode": "940",
    "imageUrl": "http://almoune.fr/img/p/3/0/6/6/3066.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-942",
    "name": "Nescafé 3en1 20 sachets 330g.",
    "price": 6.55,
    "purchasePrice": 6.208531,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-942",
    "barcode": "942",
    "imageUrl": "http://almoune.fr/img/p/2/5/6/6/2566.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-948",
    "name": "Sumac Sofram 400gr",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-948",
    "barcode": "948",
    "imageUrl": "http://almoune.fr/img/p/2/7/5/0/2750.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-953",
    "name": "Feuilles de Vigne Diamantis 550 gr.",
    "price": 10.5,
    "purchasePrice": 9.952607,
    "stock": 9,
    "category": "Conserves",
    "sku": "SKU-953",
    "barcode": "953",
    "imageUrl": "http://almoune.fr/img/p/3/1/4/2/3142.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-958",
    "name": "Pignons de pin de Sibérie 250 g",
    "price": 9.99,
    "purchasePrice": 9.469194,
    "stock": 8,
    "category": "Fruits secs",
    "sku": "SKU-958",
    "barcode": "958",
    "imageUrl": "http://almoune.fr/img/p/2/5/5/2/2552.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-960",
    "name": "Pignons de pin de Sibérie 100 g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 5,
    "category": "Fruits secs",
    "sku": "SKU-960",
    "barcode": "960",
    "imageUrl": "http://almoune.fr/img/p/2/5/5/4/2554.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-961",
    "name": "Feuilles de vigne Baytoty",
    "price": 2.65,
    "purchasePrice": 2.511848,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-961",
    "barcode": "961",
    "imageUrl": "http://almoune.fr/img/p/2/9/9/1/2991.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-963",
    "name": "Légume mariné kostopoulos 580gr.",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": -2,
    "category": "Légumes Marinés",
    "sku": "SKU-963",
    "barcode": "963",
    "imageUrl": "http://almoune.fr/img/p/2/7/8/3/2783.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-964",
    "name": "Jus de citron bio LIMMI 250 mL",
    "price": 1.49,
    "purchasePrice": 1.412322,
    "stock": 0,
    "category": "Boissons",
    "sku": "SKU-964",
    "barcode": "964",
    "imageUrl": "http://almoune.fr/img/p/2/6/5/2/2652.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-971",
    "name": "Foul moudammas Al Wadi 400g.",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 43,
    "category": "Conserves",
    "sku": "SKU-971",
    "barcode": "971",
    "imageUrl": "http://almoune.fr/img/p/3/1/5/7/3157.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-975",
    "name": "Concentré de tomates bio 190gr",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Concentrés",
    "sku": "SKU-975",
    "barcode": "975",
    "imageUrl": "http://almoune.fr/img/p/3/0/8/3/3083.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-976",
    "name": "Aubergines à la provencale bio 520gr.",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-976",
    "barcode": "976",
    "imageUrl": "http://almoune.fr/img/p/3/0/0/2/3002.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-977",
    "name": "Safran d'Iran 0.6 gr.",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-977",
    "barcode": "977",
    "imageUrl": "http://almoune.fr/img/p/3/1/3/1/3131.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-980",
    "name": "custard Aruba 300gr.",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-980",
    "barcode": "980",
    "imageUrl": "http://almoune.fr/img/p/2/9/9/5/2995.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-986",
    "name": "Pois chiche dragées O'Régal 250 g.",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 21,
    "category": "Gourmandises",
    "sku": "SKU-986",
    "barcode": "986",
    "imageUrl": "http://almoune.fr/img/p/3/1/3/0/3130.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-987",
    "name": "Houmous Chtoura 420gr.",
    "price": 1.1,
    "purchasePrice": 1.042654,
    "stock": 2,
    "category": "Conserves",
    "sku": "SKU-987",
    "barcode": "987",
    "imageUrl": "http://almoune.fr/img/p/3/6/4/6/3646.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-988",
    "name": "Fèves Grandes - Durra- 800g",
    "price": 2.26,
    "purchasePrice": 2.14218,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-988",
    "barcode": "988",
    "imageUrl": "http://almoune.fr/img/p/2/5/5/6/2556.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-991",
    "name": "Falafel en poudre avec moule offert  300gr. Durra",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 3,
    "category": "Légumineuses",
    "sku": "SKU-991",
    "barcode": "991",
    "imageUrl": "http://almoune.fr/img/p/2/9/8/4/2984.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-997",
    "name": "Gaufrettes choco 24 La vita",
    "price": 0.25,
    "purchasePrice": 0.236967,
    "stock": 12,
    "category": "Friandises",
    "sku": "SKU-997",
    "barcode": "997",
    "imageUrl": "http://almoune.fr/img/p/3/0/6/7/3067.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-999",
    "name": "Pignons longs 100g.",
    "price": 6.75,
    "purchasePrice": 6.398104,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-999",
    "barcode": "999",
    "imageUrl": "http://almoune.fr/img/p/2/7/9/0/2790.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1001",
    "name": "Amandes O'Régal 250gr.",
    "price": 3.39,
    "purchasePrice": 3.21327,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1001",
    "barcode": "1001",
    "imageUrl": "http://almoune.fr/img/p/4/0/5/6/4056.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1002",
    "name": "Pépites de tournesol O'Régal 100gr.",
    "price": 0.85,
    "purchasePrice": 0.805687,
    "stock": -2,
    "category": "Fruits à coques grillés",
    "sku": "SKU-1002",
    "barcode": "1002",
    "imageUrl": "http://almoune.fr/img/p/2/9/0/5/2905.jpg",
    "price_per_kg": 0.85
  },
  {
    "id": "csv-1004",
    "name": "Huile d'olive Grecque LOUKAKOS 500ml",
    "price": 7.5,
    "purchasePrice": 8.521327,
    "stock": 3,
    "category": "Accueil",
    "sku": "Selection Almouné goût prononcé",
    "barcode": "1004",
    "imageUrl": "http://almoune.fr/img/p/2/5/5/7/2557.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1008",
    "name": "Freekeh 700 gr.",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": 0,
    "category": "Boulghour",
    "sku": "SKU-1008",
    "barcode": "1008",
    "imageUrl": "http://almoune.fr/img/p/3/0/6/8/3068.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1009",
    "name": "Sauce piquante Dolly's 85gr.",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-1009",
    "barcode": "1009",
    "imageUrl": "http://almoune.fr/img/p/3/0/6/9/3069.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1010",
    "name": "Sauce tomate YAMAMA",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Concentrés",
    "sku": "SKU-1010",
    "barcode": "1010",
    "imageUrl": "http://almoune.fr/img/p/3/0/7/0/3070.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1018",
    "name": "Thé cardamome Ahmad 500 gr.",
    "price": 10.55,
    "purchasePrice": 10,
    "stock": 9,
    "category": "Accueil",
    "sku": "SKU-1018",
    "barcode": "1018",
    "imageUrl": "http://almoune.fr/img/p/4/3/5/2/4352.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1019",
    "name": "Maamoul Bawabet Dimashq pistache noix 500gr.",
    "price": 15.5,
    "purchasePrice": 14.691943,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-1019",
    "barcode": "1019",
    "imageUrl": "http://almoune.fr/img/p/2/6/4/0/2640.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1022",
    "name": "Légumes marinés mélangés Dayaa 600gr.",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-1022",
    "barcode": "1022",
    "imageUrl": "http://almoune.fr/img/p/2/7/9/4/2794.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1026",
    "name": "Nescafé 3 en 1 10sachet",
    "price": 2.65,
    "purchasePrice": 2.511848,
    "stock": 0,
    "category": "Boissons",
    "sku": "SKU-1026",
    "barcode": "1026",
    "imageUrl": "http://almoune.fr/img/p/2/5/7/1/2571.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1028",
    "name": "Safran d'Iran 0.6 gr.",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1028",
    "barcode": "1028",
    "imageUrl": "http://almoune.fr/img/p/2/5/7/3/2573.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1029",
    "name": "Bissat Halawa sans sucre 250 g",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Halawa",
    "sku": "SKU-1029",
    "barcode": "1029",
    "imageUrl": "http://almoune.fr/img/p/3/0/4/4/3044.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1038",
    "name": "Labneh Mouneh zaatar Artisanal 200g.",
    "price": 6,
    "purchasePrice": 5.687204,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-1038",
    "barcode": "1038",
    "imageUrl": "http://almoune.fr/img/p/3/2/2/2/3222.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1039",
    "name": "Labneh Mouneh artisanal nature 200g.",
    "price": 6,
    "purchasePrice": 5.687204,
    "stock": -18,
    "category": "Produits laitiers",
    "sku": "SKU-1039",
    "barcode": "1039",
    "imageUrl": "http://almoune.fr/img/p/3/2/2/3/3223.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1047",
    "name": "Pâtes Orzo large (langues d'oiseaux) 500g.",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": -11,
    "category": "Accueil",
    "sku": "SKU-1047",
    "barcode": "1047",
    "imageUrl": "http://almoune.fr/img/p/3/0/4/5/3045.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1049",
    "name": "Citron fersan 1L",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": -14,
    "category": "Accueil",
    "sku": "SKU-1049",
    "barcode": "1049",
    "imageUrl": "http://almoune.fr/img/p/3/0/7/5/3075.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1051",
    "name": "Tahini ou tahina (crème de sésame) - Shahin 380 gr",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1051",
    "barcode": "1051",
    "imageUrl": "http://almoune.fr/img/p/3/1/1/5/3115.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1052",
    "name": "Poudre de Riz Abido 500gr.",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1052",
    "barcode": "1052",
    "imageUrl": "http://almoune.fr/img/p/3/0/4/7/3047.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1053",
    "name": "Maamoul Noix douaihy Grand pièce 70gr.",
    "price": 1.27,
    "purchasePrice": 1.2,
    "stock": -278,
    "category": "Patisserie Douaihy",
    "sku": "SKU-1053",
    "barcode": "1053",
    "imageUrl": "http://almoune.fr/img/p/2/8/8/7/2887.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1054",
    "name": "Maamoul Pistaches Douaihy Grande pièce 70gr.",
    "price": 1.47,
    "purchasePrice": 1.393365,
    "stock": 0,
    "category": "Patisserie Douaihy",
    "sku": "SKU-1054",
    "barcode": "1054",
    "imageUrl": "http://almoune.fr/img/p/3/0/4/8/3048.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1055",
    "name": "Shatta Rana 474ml",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Concentrés",
    "sku": "SKU-1055",
    "barcode": "1055",
    "imageUrl": "http://almoune.fr/img/p/3/0/4/9/3049.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1056",
    "name": "Barazek Aghati 500gr.",
    "price": 16.5,
    "purchasePrice": 15.63981,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1056",
    "barcode": "1056",
    "imageUrl": "http://almoune.fr/img/p/3/0/1/5/3015.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1057",
    "name": "Chewing gum gandour 13.5g.",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1057",
    "barcode": "1057",
    "imageUrl": "http://almoune.fr/img/p/3/0/5/0/3050.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1059",
    "name": "Baklava Premium Aghati 1kg",
    "price": 32,
    "purchasePrice": 30.331754,
    "stock": -1,
    "category": "Baklava",
    "sku": "SKU-1059",
    "barcode": "1059",
    "imageUrl": "http://almoune.fr/img/p/3/0/5/1/3051.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1062",
    "name": "Bourma Cajou douaihy 1kg",
    "price": 18.46,
    "purchasePrice": 17.49763,
    "stock": 0,
    "category": "Patisserie Douaihy",
    "sku": "SKU-1062",
    "barcode": "1062",
    "imageUrl": "http://almoune.fr/img/p/3/0/5/3/3053.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1063",
    "name": "Bourma pistaches Douaihy 1kg",
    "price": 27,
    "purchasePrice": 25.592417,
    "stock": 0,
    "category": "Patisseries",
    "sku": "SKU-1063",
    "barcode": "1063",
    "imageUrl": "http://almoune.fr/img/p/3/0/5/4/3054.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1064",
    "name": "Makdous, Aubergines farcies Chtoura 350gr.",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-1064",
    "barcode": "1064",
    "imageUrl": "http://almoune.fr/img/p/2/6/7/0/2670.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1065",
    "name": "Sésame blanc O'régal 1kg",
    "price": 4.5,
    "purchasePrice": 5.21327,
    "stock": 6,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1065",
    "barcode": "1065",
    "imageUrl": "http://almoune.fr/img/p/3/2/4/5/3245.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1066",
    "name": "Sésame doré O'régal 1kg",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 2,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1066",
    "barcode": "1066",
    "imageUrl": "http://almoune.fr/img/p/3/1/8/7/3187.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1070",
    "name": "Maggi cubes ِaromatisés au poulet 504g",
    "price": 7.99,
    "purchasePrice": 7.57346,
    "stock": -7,
    "category": "Condiments",
    "sku": "SKU-1070",
    "barcode": "1070",
    "imageUrl": "http://almoune.fr/img/p/2/7/6/5/2765.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1077",
    "name": "Makdous Chtoura 3kg",
    "price": 19.99,
    "purchasePrice": 18.947867,
    "stock": 13,
    "category": "Conserves",
    "sku": "SKU-1077",
    "barcode": "1077",
    "imageUrl": "http://almoune.fr/img/p/4/4/9/5/4495.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1078",
    "name": "Karabij aux pistaches - Douaihy 400gr.",
    "price": 17.5,
    "purchasePrice": 16.587678,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-1078",
    "barcode": "1078",
    "imageUrl": "http://almoune.fr/img/p/2/5/9/0/2590.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1079",
    "name": "Hummus tahini Kasih 510g",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1079",
    "barcode": "1079",
    "imageUrl": "http://almoune.fr/img/p/3/1/5/8/3158.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1081",
    "name": "Lebanese mastic Loukoum Alkodess 600gr.",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1081",
    "barcode": "1081",
    "imageUrl": "http://almoune.fr/img/p/2/9/9/6/2996.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1083",
    "name": "Boisson instantanée Guava (30g) Aruba",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": 0,
    "category": "Boissons",
    "sku": "SKU-1083",
    "barcode": "1083",
    "imageUrl": "http://almoune.fr/img/p/3/0/0/6/3006.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1084",
    "name": "Boisson instantanée Fraise (30g) Aruba",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": -4,
    "category": "Jus en poudre instantanée",
    "sku": "SKU-1084",
    "barcode": "1084",
    "imageUrl": "http://almoune.fr/img/p/3/0/0/3/3003.jpg",
    "price_per_kg": 0.99
  },
  {
    "id": "csv-1085",
    "name": "Boisson instantanée  Ice tea Aruba",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": 0,
    "category": "Jus en poudre instantanée",
    "sku": "SKU-1085",
    "barcode": "1085",
    "imageUrl": "http://almoune.fr/img/p/3/0/0/7/3007.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1086",
    "name": "Boisson instantanée rose (30g) Aruba",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": 0,
    "category": "Jus en poudre instantanée",
    "sku": "SKU-1086",
    "barcode": "1086",
    "imageUrl": "http://almoune.fr/img/p/3/1/0/9/3109.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1087",
    "name": "Boisson instantanée orange (30g) Aruba",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": 0,
    "category": "Jus en poudre instantanée",
    "sku": "SKU-1087",
    "barcode": "1087",
    "imageUrl": "http://almoune.fr/img/p/3/0/0/5/3005.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1088",
    "name": "Boisson instantanée berries (30g) Aruba",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": 0,
    "category": "Jus en poudre instantanée",
    "sku": "SKU-1088",
    "barcode": "1088",
    "imageUrl": "http://almoune.fr/img/p/3/1/0/5/3105.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1090",
    "name": "Lebanese  rose Loukoum  Alkodess 600gr.",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1090",
    "barcode": "1090",
    "imageUrl": "http://almoune.fr/img/p/3/1/3/4/3134.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1091",
    "name": "Maamoul Dattes Dima 16 pieces",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1091",
    "barcode": "1091",
    "imageUrl": "http://almoune.fr/img/p/2/6/4/3/2643.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1093",
    "name": "Corned beef - Exeter 198gr",
    "price": 4.15,
    "purchasePrice": 3.933649,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1093",
    "barcode": "1093",
    "imageUrl": "http://almoune.fr/img/p/3/1/7/1/3171.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1094",
    "name": "Boisson instantanée ice tea (30g) Aruba",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": 0,
    "category": "Boissons",
    "sku": "SKU-1094",
    "barcode": "1094",
    "imageUrl": "http://almoune.fr/img/p/2/6/4/7/2647.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1096",
    "name": "Vinaigre du cidre  de pomme Bio 50 cL",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Huiles et vinaigres",
    "sku": "SKU-1096",
    "barcode": "1096",
    "imageUrl": "http://almoune.fr/img/p/2/6/5/4/2654.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1098",
    "name": "Vinaigre de vin rouge  Bio 50 cL",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Huiles et vinaigres",
    "sku": "SKU-1098",
    "barcode": "1098",
    "imageUrl": "http://almoune.fr/img/p/2/7/6/4/2764.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1101",
    "name": "Epices basterma Abido 50g",
    "price": 1.59,
    "purchasePrice": 1.507109,
    "stock": 4,
    "category": "Épices",
    "sku": "SKU-1101",
    "barcode": "1101",
    "imageUrl": "http://almoune.fr/img/p/2/6/6/1/2661.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1102",
    "name": "Chocolat YOYO",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": -1,
    "category": "Friandises",
    "sku": "SKU-1102",
    "barcode": "1102",
    "imageUrl": "http://almoune.fr/img/p/2/6/6/2/2662.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1105",
    "name": "Confiture de Figues- Al Dayaa 800g",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Confitures",
    "sku": "Ferme et onctueuse",
    "barcode": "1105",
    "imageUrl": "http://almoune.fr/img/p/3/0/1/0/3010.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1106",
    "name": "Eau de fleur d'oranger - Al Dayaa 250ml",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1106",
    "barcode": "1106",
    "imageUrl": "http://almoune.fr/img/p/2/7/2/0/2720.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1107",
    "name": "Café Najjar Super extra Cardamome 450g.",
    "price": 9.75,
    "purchasePrice": 9.241706,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1107",
    "barcode": "1107",
    "imageUrl": "http://almoune.fr/img/p/3/3/4/6/3346.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1108",
    "name": "Café Najjar Super extra Cardamome 200gr",
    "price": 3.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1108",
    "barcode": "1108",
    "imageUrl": "http://almoune.fr/img/p/2/7/2/7/2727.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1110",
    "name": "Café super extra cardamome Najjar",
    "price": 6.75,
    "purchasePrice": 6.398104,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1110",
    "barcode": "1110",
    "imageUrl": "http://almoune.fr/img/p/3/3/4/7/3347.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1111",
    "name": "Piment rouge en paillettes - Abido 50gr.",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-1111",
    "barcode": "1111",
    "imageUrl": "http://almoune.fr/img/p/3/9/6/2/3962.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1112",
    "name": "Epices moghrabiyeh ou moghrabieh Abido 50 gr.",
    "price": 1.85,
    "purchasePrice": 1.753555,
    "stock": 14,
    "category": "Épices",
    "sku": "SKU-1112",
    "barcode": "1112",
    "imageUrl": "http://almoune.fr/img/p/2/6/7/4/2674.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1113",
    "name": "Crème Chantilly Aruba 80gr.",
    "price": 1.75,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1113",
    "barcode": "1113",
    "imageUrl": "http://almoune.fr/img/p/2/7/2/9/2729.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1114",
    "name": "Pistaches décortiquées d'Iran  en vrac 1kg",
    "price": 39.75,
    "purchasePrice": 37.677725,
    "stock": 1,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1114",
    "barcode": "1114",
    "imageUrl": "http://almoune.fr/img/p/2/6/6/5/2665.jpg",
    "price_per_kg": 39.75
  },
  {
    "id": "csv-1115",
    "name": "Courgettes Farcies à la Libanaise 1800g- Diwan",
    "price": 10.9,
    "purchasePrice": 10.331754,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1115",
    "barcode": "1115",
    "imageUrl": "http://almoune.fr/img/p/3/1/6/5/3165.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1118",
    "name": "Paprika De Hongrie moulu 500g. Espig",
    "price": 8.45,
    "purchasePrice": 8.009479,
    "stock": -8,
    "category": "Épices",
    "sku": "SKU-1118",
    "barcode": "1118",
    "imageUrl": "http://almoune.fr/img/p/3/1/7/4/3174.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1119",
    "name": "Boisson instantanée mangue (30g) Aruba",
    "price": 0.4,
    "purchasePrice": 0.379147,
    "stock": -2,
    "category": "Jus en poudre instantanée",
    "sku": "SKU-1119",
    "barcode": "1119",
    "imageUrl": "http://almoune.fr/img/p/3/0/0/4/3004.jpg",
    "price_per_kg": 0.4
  },
  {
    "id": "csv-1120",
    "name": "Boulgour gros brun  Fark 1kg",
    "price": 2.69,
    "purchasePrice": 2.549763,
    "stock": 0,
    "category": "Boulghour",
    "sku": "SKU-1120",
    "barcode": "1120",
    "imageUrl": "http://almoune.fr/img/p/2/7/1/9/2719.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1121",
    "name": "Quatre Epices 1kg",
    "price": 27.99,
    "purchasePrice": 26.530806,
    "stock": 1,
    "category": "Épices",
    "sku": "SKU-1121",
    "barcode": "1121",
    "imageUrl": "http://almoune.fr/img/p/2/7/2/1/2721.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1126",
    "name": "Bourma  Cajou 350gr.",
    "price": 7,
    "purchasePrice": 6.635071,
    "stock": 4,
    "category": "Gourmandises",
    "sku": "SKU-1126",
    "barcode": "1126",
    "imageUrl": "http://almoune.fr/img/p/2/8/4/3/2843.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1131",
    "name": "Tahini (crème de sésame) - Shahin 2kg",
    "price": 18.99,
    "purchasePrice": 18,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1131",
    "barcode": "1131",
    "imageUrl": "http://almoune.fr/img/p/3/1/1/6/3116.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1133",
    "name": "Nescafé 2 en 1 20 sachets 330gr",
    "price": 2.99,
    "purchasePrice": 5.677725,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-1133",
    "barcode": "1133",
    "imageUrl": "http://almoune.fr/img/p/2/9/6/9/2969.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1134",
    "name": "Datte au chocolat au amandes Sahara Delights",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1134",
    "barcode": "1134",
    "imageUrl": "http://almoune.fr/img/p/2/9/7/0/2970.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1135",
    "name": "Datte au chocolat Sahara Delights",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1135",
    "barcode": "1135",
    "imageUrl": "http://almoune.fr/img/p/2/9/7/1/2971.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1136",
    "name": "Pois chiche Cantolivia",
    "price": 7.15,
    "purchasePrice": 6.777251,
    "stock": -54,
    "category": "Conserves",
    "sku": "SKU-1136",
    "barcode": "1136",
    "imageUrl": "http://almoune.fr/img/p/2/9/7/2/2972.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1145",
    "name": "hummus Kasih 1kg",
    "price": 13.5,
    "purchasePrice": 12.796209,
    "stock": 11,
    "category": "Conserves",
    "sku": "SKU-1145",
    "barcode": "1145",
    "imageUrl": "http://almoune.fr/img/p/3/1/1/8/3118.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1148",
    "name": "Olives vertes libanaises - Chtoura Garden 1kg",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1148",
    "barcode": "1148",
    "imageUrl": "http://almoune.fr/img/p/2/9/7/3/2973.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1149",
    "name": "Houmous tahina au piment - Chtoura Garden420g",
    "price": 1.95,
    "purchasePrice": 1.848341,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-1149",
    "barcode": "1149",
    "imageUrl": "http://almoune.fr/img/p/2/9/7/4/2974.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1150",
    "name": "Houmous tahina Chtoura 420g",
    "price": 1.49,
    "purchasePrice": 1.412322,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1150",
    "barcode": "1150",
    "imageUrl": "http://almoune.fr/img/p/2/9/7/6/2976.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1151",
    "name": "Basra Mélasse de dattes Chtoura 800gr.",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 9,
    "category": "Mélasses et miels",
    "sku": "SKU-1151",
    "barcode": "1151",
    "imageUrl": "http://almoune.fr/img/p/2/9/7/7/2977.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1152",
    "name": "ketchup aux tomates Chtoura 340 gr.",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-1152",
    "barcode": "1152",
    "imageUrl": "http://almoune.fr/img/p/2/9/7/8/2978.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1153",
    "name": "Mélasse de caroube Anjar 800gr.",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": 0,
    "category": "Mélasses et miels",
    "sku": "SKU-1153",
    "barcode": "1153",
    "imageUrl": "http://almoune.fr/img/p/2/9/7/9/2979.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1154",
    "name": "Olives noires Chtoura 1kg",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Olives",
    "sku": "SKU-1154",
    "barcode": "1154",
    "imageUrl": "http://almoune.fr/img/p/3/0/2/5/3025.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1155",
    "name": "Mélange de fruits secs, grillés et salés - Krikita classic 250gr",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 7,
    "category": "Chips et apéritifs",
    "sku": "SKU-1155",
    "barcode": "1155",
    "imageUrl": "http://almoune.fr/img/p/4/3/4/4/4344.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1158",
    "name": "custard chocolat Aruba carton 200gr",
    "price": 2.1,
    "purchasePrice": 1.990521,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1158",
    "barcode": "1158",
    "imageUrl": "http://almoune.fr/img/p/2/9/9/3/2993.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1162",
    "name": "custard chocolat Aruba 300 gr",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1162",
    "barcode": "1162",
    "imageUrl": "http://almoune.fr/img/p/2/9/9/4/2994.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1165",
    "name": "Bière blonde Beirut beer 33 cl",
    "price": 3.19,
    "purchasePrice": 2.658333,
    "stock": -966,
    "category": "Bières",
    "sku": "SKU-1165",
    "barcode": "1165",
    "imageUrl": "http://almoune.fr/img/p/3/6/0/0/3600.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1166",
    "name": "Huile d'olive extra vierge - Boulos 25cl",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 11,
    "category": "Huiles et vinaigres",
    "sku": "SKU-1166",
    "barcode": "1166",
    "imageUrl": "http://almoune.fr/img/p/3/6/1/4/3614.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1167",
    "name": "Huile d'olive vierge extra - Boulos 75cl",
    "price": 16.49,
    "purchasePrice": 15.630332,
    "stock": 3,
    "category": "Huiles et vinaigres",
    "sku": "SKU-1167",
    "barcode": "1167",
    "imageUrl": "http://almoune.fr/img/p/3/7/7/8/3778.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1168",
    "name": "Navets Marinés Boulos 650gr.",
    "price": 6.37,
    "purchasePrice": 6.037915,
    "stock": 1,
    "category": "Légumes Marinés",
    "sku": "SKU-1168",
    "barcode": "1168",
    "imageUrl": "http://almoune.fr/img/p/3/0/1/8/3018.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1169",
    "name": "Vinaigre de pomme Boulos 50 cl",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 3,
    "category": "Huiles et vinaigres",
    "sku": "SKU-1169",
    "barcode": "1169",
    "imageUrl": "http://almoune.fr/img/p/3/0/2/8/3028.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1170",
    "name": "Vinaigre de raisin Boulos 50cl",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -1,
    "category": "Huiles et vinaigres",
    "sku": "SKU-1170",
    "barcode": "1170",
    "imageUrl": "http://almoune.fr/img/p/3/0/2/9/3029.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1171",
    "name": "Mélasse de grenade Boulos 25cl",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 0,
    "category": "Mélasses et miels",
    "sku": "SKU-1171",
    "barcode": "1171",
    "imageUrl": "http://almoune.fr/img/p/3/0/3/0/3030.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1172",
    "name": "Blé pelé Gardenia 907 gr.",
    "price": 2.7,
    "purchasePrice": 2.559242,
    "stock": -1,
    "category": "Légumineuses et grains",
    "sku": "SKU-1172",
    "barcode": "1172",
    "imageUrl": "http://almoune.fr/img/p/3/0/3/1/3031.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1174",
    "name": "Olives noires tranchées - Boulos 600gr",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 0,
    "category": "Olives",
    "sku": "SKU-1174",
    "barcode": "1174",
    "imageUrl": "http://almoune.fr/img/p/3/0/1/9/3019.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1175",
    "name": "Falafel Gardenia 200gr.",
    "price": 2.1,
    "purchasePrice": 1.99,
    "stock": 0,
    "category": "Légumineuses et grains",
    "sku": "SKU-1175",
    "barcode": "1175",
    "imageUrl": "http://almoune.fr/img/p/3/0/3/4/3034.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1176",
    "name": "Mouloukhiyé séché Gardenia 200 gr",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 13,
    "category": "Légumineuses et grains",
    "sku": "SKU-1176",
    "barcode": "1176",
    "imageUrl": "http://almoune.fr/img/p/3/6/8/3/3683.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1177",
    "name": "Zaatar Libanais Gardenia 454 gr.",
    "price": 9.25,
    "purchasePrice": 8.767773,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1177",
    "barcode": "1177",
    "imageUrl": "http://almoune.fr/img/p/4/0/3/7/4037.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1180",
    "name": "Vin blanc de blanc - 37,5 cl KSARA",
    "price": 6.8,
    "purchasePrice": 5.666667,
    "stock": -70,
    "category": "Accueil",
    "sku": "SKU-1180",
    "barcode": "1180",
    "imageUrl": "http://almoune.fr/img/p/3/5/7/1/3571.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1181",
    "name": "Vin Rosé Sunset - 75 cl KSARA",
    "price": 10.9,
    "purchasePrice": 9.083333,
    "stock": 15,
    "category": "Accueil",
    "sku": "SKU-1181",
    "barcode": "1181",
    "imageUrl": "http://almoune.fr/img/p/3/5/7/2/3572.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1182",
    "name": "Vin blanc de blanc - 75 cl KSARA",
    "price": 10.9,
    "purchasePrice": 9.083333,
    "stock": -48,
    "category": "Accueil",
    "sku": "SKU-1182",
    "barcode": "1182",
    "imageUrl": "http://almoune.fr/img/p/3/5/7/3/3573.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1183",
    "name": "Confiture de fleur d'oranger 450gr. Alrabih",
    "price": 10.5,
    "purchasePrice": 12.78673,
    "stock": 1,
    "category": "Confitures",
    "sku": "SKU-1183",
    "barcode": "1183",
    "imageUrl": "http://almoune.fr/img/p/4/0/2/1/4021.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1192",
    "name": "Meghli - Cortas 200 gr",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1192",
    "barcode": "1192",
    "imageUrl": "http://almoune.fr/img/p/3/0/3/7/3037.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1193",
    "name": "Haricots Blancs Géants - Lamsa 800gr",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1193",
    "barcode": "1193",
    "imageUrl": "http://almoune.fr/img/p/3/0/3/8/3038.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1195",
    "name": "Cœurs sablés - Biscuit D'or 200 gr.",
    "price": 2.95,
    "purchasePrice": 2.796209,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1195",
    "barcode": "1195",
    "imageUrl": "http://almoune.fr/img/p/3/0/3/9/3039.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1196",
    "name": "Cornes de gazelle - Biscuit D'or 200 Gr.",
    "price": 2.95,
    "purchasePrice": 2.796209,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1196",
    "barcode": "1196",
    "imageUrl": "http://almoune.fr/img/p/3/0/4/0/3040.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1197",
    "name": "Graybé - Biscuit D'or 200 Gr.",
    "price": 2.95,
    "purchasePrice": 2.796209,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1197",
    "barcode": "1197",
    "imageUrl": "http://almoune.fr/img/p/3/0/4/1/3041.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1198",
    "name": "Biscuits Demi Lune - Biscuit D'or 195 gr.",
    "price": 2.95,
    "purchasePrice": 2.796209,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1198",
    "barcode": "1198",
    "imageUrl": "http://almoune.fr/img/p/3/0/4/6/3046.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1202",
    "name": "Halloumi Déan Gourmet 200gr.",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Fromages libanais",
    "sku": "SKU-1202",
    "barcode": "1202",
    "imageUrl": "http://almoune.fr/img/p/3/2/2/6/3226.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1203",
    "name": "Ail en poudre Abido 50gr",
    "price": 1.9,
    "purchasePrice": 1.800948,
    "stock": 2,
    "category": "Épices",
    "sku": "SKU-1203",
    "barcode": "1203",
    "imageUrl": "http://almoune.fr/img/p/2/9/0/3/2903.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1204",
    "name": "kashkaval Déan 350",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Produits laitiers",
    "sku": "SKU-1204",
    "barcode": "1204",
    "imageUrl": "http://almoune.fr/img/p/3/2/3/3/3233.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1206",
    "name": "Houmous Al Wadi 400gr.",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 7,
    "category": "Conserves",
    "sku": "SKU-1206",
    "barcode": "1206",
    "imageUrl": "http://almoune.fr/img/p/2/8/6/9/2869.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1207",
    "name": "Kishk (Keshek) - Alghota 800gr.",
    "price": 6.75,
    "purchasePrice": 6.398104,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1207",
    "barcode": "1207",
    "imageUrl": "http://almoune.fr/img/p/3/1/2/7/3127.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1208",
    "name": "Foul (fèves) avec pois chiche Al Wadi 400gr",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -1,
    "category": "Légumineuses et grains",
    "sku": "SKU-1208",
    "barcode": "1208",
    "imageUrl": "http://almoune.fr/img/p/3/5/9/2/3592.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-1209",
    "name": "Kaak en boule au sésame - Al forno 400gr",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1209",
    "barcode": "1209",
    "imageUrl": "http://almoune.fr/img/p/3/1/6/9/3169.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1210",
    "name": "Kaak longs au sésame - Al forno 400gr.",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1210",
    "barcode": "1210",
    "imageUrl": "http://almoune.fr/img/p/3/1/6/8/3168.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1211",
    "name": "Akawi Lailand 200gr",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": 0,
    "category": "Produits laitiers",
    "sku": "SKU-1211",
    "barcode": "1211",
    "imageUrl": "http://almoune.fr/img/p/3/2/3/5/3235.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1213",
    "name": "soujouk 1.2",
    "price": 19.75,
    "purchasePrice": 18.720379,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-1213",
    "barcode": "1213",
    "imageUrl": "http://almoune.fr/img/p/3/2/2/5/3225.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1216",
    "name": "Zaatar Abido 5kg",
    "price": 42.25,
    "purchasePrice": 40.047393,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-1216",
    "barcode": "1216",
    "imageUrl": "http://almoune.fr/img/p/3/9/7/4/3974.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1217",
    "name": "Fenugrec entier Abido 50g",
    "price": 1.7,
    "purchasePrice": 1.611374,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-1217",
    "barcode": "1217",
    "imageUrl": "http://almoune.fr/img/p/2/8/6/4/2864.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1219",
    "name": "Concombres Marinés Mechaalany en vrac 500gr.",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-1219",
    "barcode": "1219",
    "imageUrl": "http://almoune.fr/img/p/3/4/0/9/3409.jpg",
    "price_per_kg": 2.99
  },
  {
    "id": "csv-1222",
    "name": "Nawashef mix Aghati 1kg",
    "price": 27.5,
    "purchasePrice": 26.066351,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1222",
    "barcode": "1222",
    "imageUrl": "http://almoune.fr/img/p/3/1/4/1/3141.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1223",
    "name": "Baklava mix au miel Aghati 500gr",
    "price": 17,
    "purchasePrice": 16.113744,
    "stock": 0,
    "category": "Baklava",
    "sku": "SKU-1223",
    "barcode": "1223",
    "imageUrl": "http://almoune.fr/img/p/2/9/0/9/2909.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1225",
    "name": "Halava  Ou halva Bissat Offre lots",
    "price": 19.9,
    "purchasePrice": 18.862559,
    "stock": 0,
    "category": "Halawa",
    "sku": "SKU-1225",
    "barcode": "1225",
    "imageUrl": "http://almoune.fr/img/p/2/8/8/6/2886.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1227",
    "name": "Fruits secs grillés salés Extra Fancy 350gr",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Chips et apéritifs",
    "sku": "SKU-1227",
    "barcode": "1227",
    "imageUrl": "http://almoune.fr/img/p/3/1/3/2/3132.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1228",
    "name": "Fruits grillés sans sel Fancy 350gr",
    "price": 7.99,
    "purchasePrice": 10.900474,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-1228",
    "barcode": "1228",
    "imageUrl": "http://almoune.fr/img/p/2/8/7/1/2871.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1230",
    "name": "Yerba maté TARAGUI 500g.",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": -20,
    "category": "Accueil",
    "sku": "SKU-1230",
    "barcode": "1230",
    "imageUrl": "http://almoune.fr/img/p/3/6/8/1/3681.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1232",
    "name": "Majdoule Golden Plate 225g.",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-1232",
    "barcode": "1232",
    "imageUrl": "http://almoune.fr/img/p/3/2/2/1/3221.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1235",
    "name": "Mekté Concombre sauvage Mechelany 430gr. net",
    "price": 3.6,
    "purchasePrice": 3.412322,
    "stock": -1,
    "category": "Légumes Marinés",
    "sku": "SKU-1235",
    "barcode": "1235",
    "imageUrl": "http://almoune.fr/img/p/3/1/7/6/3176.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1236",
    "name": "Mélasse de grenade Anjar 600ml",
    "price": 7.65,
    "purchasePrice": 7.251185,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-1236",
    "barcode": "1236",
    "imageUrl": "http://almoune.fr/img/p/4/1/9/6/4196.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1240",
    "name": "Manouché grande taille",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-1240",
    "barcode": "1240",
    "imageUrl": "http://almoune.fr/img/p/3/2/3/6/3236.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1242",
    "name": "Miel grec Atiki 1Kg",
    "price": 20.75,
    "purchasePrice": 19.668246,
    "stock": 0,
    "category": "Mélasses et miels",
    "sku": "SKU-1242",
    "barcode": "1242",
    "imageUrl": "http://almoune.fr/img/p/3/7/1/1/3711.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1244",
    "name": "Huile d'olive Boulos 4.5 l",
    "price": 64.99,
    "purchasePrice": 61.601896,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-1244",
    "barcode": "1244",
    "imageUrl": "http://almoune.fr/img/p/3/8/4/5/3845.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1246",
    "name": "Barazek libanais - Douaihy 500g",
    "price": 11.55,
    "purchasePrice": 10.947867,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1246",
    "barcode": "1246",
    "imageUrl": "http://almoune.fr/img/p/3/1/3/3/3133.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1259",
    "name": "Vinaigre Balsamique Yamama 300mL",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Huiles et vinaigres",
    "sku": "SKU-1259",
    "barcode": "1259",
    "imageUrl": "http://almoune.fr/img/p/2/9/6/3/2963.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1262",
    "name": "Baklava assortiment book douaihy 400g.",
    "price": 17.5,
    "purchasePrice": 16.587678,
    "stock": 0,
    "category": "Baklava",
    "sku": "SKU-1262",
    "barcode": "1262",
    "imageUrl": "http://almoune.fr/img/p/2/9/1/0/2910.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1263",
    "name": "Thé Ceylon nature - Ahmad Tea 500gr",
    "price": 10.55,
    "purchasePrice": 10,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-1263",
    "barcode": "1263",
    "imageUrl": "http://almoune.fr/img/p/4/3/5/3/4353.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1264",
    "name": "Fruits secs caramélisés tendres (semsmiyeh) - Douaihy 250g",
    "price": 8.5,
    "purchasePrice": 8.056872,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1264",
    "barcode": "1264",
    "imageUrl": "http://almoune.fr/img/p/3/9/0/4/3904.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1265",
    "name": "Makanek Au kilos halal",
    "price": 0,
    "purchasePrice": 0,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1265",
    "barcode": "1265",
    "imageUrl": "http://almoune.fr/img/p/3/2/2/4/3224.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1269",
    "name": "Café soluble Gold Mahmood 48x2 gr",
    "price": 5.99,
    "purchasePrice": 5.677725,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-1269",
    "barcode": "1269",
    "imageUrl": "http://almoune.fr/img/p/2/9/6/4/2964.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1270",
    "name": "Cappuccino Classic Mahmood 25 gr",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-1270",
    "barcode": "1270",
    "imageUrl": "http://almoune.fr/img/p/2/9/6/5/2965.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1271",
    "name": "Cappuccino Classic MAHMOOD 20x25g",
    "price": 9.25,
    "purchasePrice": 8.767773,
    "stock": 12,
    "category": "Accueil",
    "sku": "SKU-1271",
    "barcode": "1271",
    "imageUrl": "http://almoune.fr/img/p/2/9/6/6/2966.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1272",
    "name": "Biscuit chocolaté ALFAKHR 30g.",
    "price": 0.35,
    "purchasePrice": 0.331754,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1272",
    "barcode": "1272",
    "imageUrl": "http://almoune.fr/img/p/2/9/6/7/2967.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1273",
    "name": "Biscuit ALFAKHR 24 pièces 720g.",
    "price": 7.99,
    "purchasePrice": 7.57346,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1273",
    "barcode": "1273",
    "imageUrl": "http://almoune.fr/img/p/2/9/6/8/2968.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1274",
    "name": "Foul Bajella, Grosses Fèves cuites 400g. Chtoura",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": 110,
    "category": "Conserves",
    "sku": "SKU-1274",
    "barcode": "1274",
    "imageUrl": "http://almoune.fr/img/p/2/9/9/7/2997.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1275",
    "name": "Fruits secs caramélisés tendres (semsmiyeh) - Douaihy  500gr.",
    "price": 14.99,
    "purchasePrice": 14.208531,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1275",
    "barcode": "1275",
    "imageUrl": "http://almoune.fr/img/p/3/9/0/5/3905.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1276",
    "name": "Baklava - Douaihy Edition spéciale Love 750g.",
    "price": 34.99,
    "purchasePrice": 33.165877,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-1276",
    "barcode": "1276",
    "imageUrl": "http://almoune.fr/img/p/2/9/4/2/2942.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1277",
    "name": "Pain Markouk 210gr.",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 0,
    "category": "pain et Kaak",
    "sku": "SKU-1277",
    "barcode": "1277",
    "imageUrl": "http://almoune.fr/img/p/3/0/5/5/3055.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1279",
    "name": "Graine de Courge Grillé salé Al Kazzi 250g.",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-1279",
    "barcode": "1279",
    "imageUrl": "http://almoune.fr/img/p/2/9/4/8/2948.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1280",
    "name": "Mélange extra Fruit sec grillé salé Kazzi 250 gr.",
    "price": 4.49,
    "purchasePrice": 4.255924,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-1280",
    "barcode": "1280",
    "imageUrl": "http://almoune.fr/img/p/2/9/4/9/2949.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1281",
    "name": "Mélange fruit sec Supreme Al KAZZI 450gr.",
    "price": 8.95,
    "purchasePrice": 8.483412,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-1281",
    "barcode": "1281",
    "imageUrl": "http://almoune.fr/img/p/2/9/5/0/2950.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1282",
    "name": "Mélange Fruit sec Grillé salé Extra - Al Kazzi 450 gr.",
    "price": 6.85,
    "purchasePrice": 6.492891,
    "stock": 3,
    "category": "Fruits secs",
    "sku": "SKU-1282",
    "barcode": "1282",
    "imageUrl": "http://almoune.fr/img/p/4/0/3/1/4031.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1283",
    "name": "Mélange fruits secs Deluxe - Al Kazzi 300gr.",
    "price": 7.75,
    "purchasePrice": 7.345972,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-1283",
    "barcode": "1283",
    "imageUrl": "http://almoune.fr/img/p/4/0/3/2/4032.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1284",
    "name": "Mélange fruit sec super Extra AL KAZZI 250gr.",
    "price": 6.75,
    "purchasePrice": 6.398104,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-1284",
    "barcode": "1284",
    "imageUrl": "http://almoune.fr/img/p/2/9/5/7/2957.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1285",
    "name": "Arachides enrobées Cricri Al KAZZI 300gr.",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-1285",
    "barcode": "1285",
    "imageUrl": "http://almoune.fr/img/p/2/9/5/8/2958.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1286",
    "name": "Mélange fruits secs grillés salés suprême mixte Al KAZZI 300gr.",
    "price": 7.49,
    "purchasePrice": 7.099526,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-1286",
    "barcode": "1286",
    "imageUrl": "http://almoune.fr/img/p/4/0/3/0/4030.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1287",
    "name": "Arome d'amande Naturel pro 115ml",
    "price": 8.95,
    "purchasePrice": 8.483412,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1287",
    "barcode": "1287",
    "imageUrl": "http://almoune.fr/img/p/3/6/1/5/3615.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1289",
    "name": "RUBY KATAKIT boite 24",
    "price": 4.5,
    "purchasePrice": 6.151659,
    "stock": -3,
    "category": "Friandises",
    "sku": "SKU-1289",
    "barcode": "1289",
    "imageUrl": "http://almoune.fr/img/p/3/2/9/9/3299.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1291",
    "name": "Offre super extra 2+1 Cri cri Al kazzi",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": 1,
    "category": "Chips et apéritifs",
    "sku": "SKU-1291",
    "barcode": "1291",
    "imageUrl": "http://almoune.fr/img/p/3/2/1/9/3219.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1292",
    "name": "Offre Al kazzi super Extra 15%",
    "price": 10.99,
    "purchasePrice": 10.417062,
    "stock": 0,
    "category": "Chips et apéritifs",
    "sku": "SKU-1292",
    "barcode": "1292",
    "imageUrl": "http://almoune.fr/img/p/3/2/0/9/3209.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1297",
    "name": "Hot dog de poulet - ZWAN 400g.",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1297",
    "barcode": "1297",
    "imageUrl": "http://almoune.fr/img/p/3/1/7/2/3172.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1302",
    "name": "Paprika Sofram 500gr.",
    "price": 4.22,
    "purchasePrice": 4,
    "stock": -1,
    "category": "Épices",
    "sku": "SKU-1302",
    "barcode": "1302",
    "imageUrl": "http://almoune.fr/img/p/3/3/9/8/3398.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1303",
    "name": "Hibiscus Abido 30gr.",
    "price": 1.1,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Infusions",
    "sku": "SKU-1303",
    "barcode": "1303",
    "imageUrl": "http://almoune.fr/img/p/3/0/2/4/3024.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1305",
    "name": "Crème Caramel Naturel 80g. 4 personnes DOMO",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 36,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1305",
    "barcode": "1305",
    "imageUrl": "http://almoune.fr/img/p/3/0/2/0/3020.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1306",
    "name": "Jello ou Jelly cerise Végétale 6 boites  510 gr DOMO",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-1306",
    "barcode": "1306",
    "imageUrl": "http://almoune.fr/img/p/3/1/1/0/3110.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1307",
    "name": "Coffee Mate Original 800g.",
    "price": 9.99,
    "purchasePrice": 9.469194,
    "stock": 1,
    "category": "Cafés",
    "sku": "SKU-1307",
    "barcode": "1307",
    "imageUrl": "http://almoune.fr/img/p/4/0/4/4/4044.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1308",
    "name": "Coriandre déshydraté 90 g. Sainte lucie",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-1308",
    "barcode": "1308",
    "imageUrl": "http://almoune.fr/img/p/3/0/4/3/3043.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1309",
    "name": "Paprika fumé - Selection des chefs 450g",
    "price": 10.75,
    "purchasePrice": 10.189573,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1309",
    "barcode": "1309",
    "imageUrl": "http://almoune.fr/img/p/4/0/5/9/4059.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1311",
    "name": "Mix pour bouillon Abido 68g.",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-1311",
    "barcode": "1311",
    "imageUrl": "http://almoune.fr/img/p/3/9/6/1/3961.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1313",
    "name": "Arak Brun 70cl.",
    "price": 30.5,
    "purchasePrice": 25.416667,
    "stock": -1,
    "category": "Arack ou Arak Libanais",
    "sku": "SKU-1313",
    "barcode": "1313",
    "imageUrl": "http://almoune.fr/img/p/3/7/1/2/3712.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1314",
    "name": "Zaatar du Village Déan 1kg",
    "price": 19.99,
    "purchasePrice": 18.947867,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1314",
    "barcode": "1314",
    "imageUrl": "http://almoune.fr/img/p/3/0/9/4/3094.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1318",
    "name": "Zaatar Thym Dean gourmet 250 gr",
    "price": 5.49,
    "purchasePrice": 5.203791,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1318",
    "barcode": "1318",
    "imageUrl": "http://almoune.fr/img/p/3/0/9/7/3097.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1319",
    "name": "Aubergines Farcies - 1.8kg Diwan",
    "price": 11.99,
    "purchasePrice": 11.364929,
    "stock": -1,
    "category": "Conserves",
    "sku": "SKU-1319",
    "barcode": "1319",
    "imageUrl": "http://almoune.fr/img/p/4/0/3/8/4038.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1320",
    "name": "Tahini (crème de sésame) - Al Wadi 908gr.",
    "price": 10.49,
    "purchasePrice": 9.943128,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1320",
    "barcode": "1320",
    "imageUrl": "http://almoune.fr/img/p/3/0/9/5/3095.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1321",
    "name": "Olives greques farcie à l'ail - Elita 215g",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-1321",
    "barcode": "1321",
    "imageUrl": "http://almoune.fr/img/p/3/0/9/6/3096.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1324",
    "name": "Tahini Kamel Bissat 900gr.",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1324",
    "barcode": "1324",
    "imageUrl": "http://almoune.fr/img/p/3/2/8/4/3284.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1325",
    "name": "Kaak chamsine 300gr.",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": -1,
    "category": "Apéritifs et pain",
    "sku": "SKU-1325",
    "barcode": "1325",
    "imageUrl": "http://almoune.fr/img/p/3/7/1/3/3713.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1329",
    "name": "Raisins secs Golden (blonds) O'regal 500gr.",
    "price": 3.89,
    "purchasePrice": 3.687204,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-1329",
    "barcode": "1329",
    "imageUrl": "http://almoune.fr/img/p/3/7/1/4/3714.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1331",
    "name": "Amandes Suprêmes crues O'regal 400gr.",
    "price": 5.65,
    "purchasePrice": 5.35545,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-1331",
    "barcode": "1331",
    "imageUrl": "http://almoune.fr/img/p/3/7/1/5/3715.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1333",
    "name": "Pain fin Markouk - Sun Bread 240g.",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": -20,
    "category": "Accueil",
    "sku": "SKU-1333",
    "barcode": "1333",
    "imageUrl": "http://almoune.fr/img/p/3/2/0/7/3207.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1334",
    "name": "Assortiment de petits fours - Douaihy 400gr.",
    "price": 13.99,
    "purchasePrice": 13.260664,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-1334",
    "barcode": "1334",
    "imageUrl": "http://almoune.fr/img/p/3/2/1/6/3216.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1336",
    "name": "Basterma 100gr Qualité artisanal halal",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Viandes - Poissons",
    "sku": "SKU-1336",
    "barcode": "1336",
    "imageUrl": "http://almoune.fr/img/p/3/2/4/6/3246.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1338",
    "name": "Biscuits à la crème saveur chocolat (16 pièces) DEEMAH 500g",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1338",
    "barcode": "1338",
    "imageUrl": "http://almoune.fr/img/p/3/2/2/0/3220.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1339",
    "name": "Mélange d'épices pour kabseh - Abido 50g.",
    "price": 1.85,
    "purchasePrice": 1.753555,
    "stock": -10,
    "category": "Épices",
    "sku": "SKU-1339",
    "barcode": "1339",
    "imageUrl": "http://almoune.fr/img/p/3/9/6/3/3963.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1340",
    "name": "Foul recette Palestinien - California Garden 400gr.",
    "price": 1.54,
    "purchasePrice": 1.459716,
    "stock": 85,
    "category": "Conserves",
    "sku": "SKU-1340",
    "barcode": "1340",
    "imageUrl": "http://almoune.fr/img/p/4/0/4/9/4049.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1341",
    "name": "Pâté de poulet aux olives Halal - Zwan 340gr.",
    "price": 3.35,
    "purchasePrice": 3.175355,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1341",
    "barcode": "1341",
    "imageUrl": "http://almoune.fr/img/p/3/1/8/4/3184.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1342",
    "name": "Pâté de Poulet Halal - Zwan 850gr.",
    "price": 7.99,
    "purchasePrice": 7.57346,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1342",
    "barcode": "1342",
    "imageUrl": "http://almoune.fr/img/p/3/7/1/6/3716.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1343",
    "name": "Fromage Cuite 8 portions Happy Cow 120gr.",
    "price": 1.85,
    "purchasePrice": 1.753555,
    "stock": 2,
    "category": "Fromages libanais",
    "sku": "SKU-1343",
    "barcode": "1343",
    "imageUrl": "http://almoune.fr/img/p/3/3/1/1/3311.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1344",
    "name": "Tahini (crème de sésame) - Cortas 907gr.",
    "price": 7.99,
    "purchasePrice": 7.57346,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1344",
    "barcode": "1344",
    "imageUrl": "http://almoune.fr/img/p/3/2/7/6/3276.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1346",
    "name": "Arachides pelées grillées sans sel - O'regal 1kg",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": -1,
    "category": "Fruits à coques grillés",
    "sku": "SKU-1346",
    "barcode": "1346",
    "imageUrl": "http://almoune.fr/img/p/3/7/1/7/3717.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1347",
    "name": "Arachides grillées salées - O'regal 500 gr.",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-1347",
    "barcode": "1347",
    "imageUrl": "http://almoune.fr/img/p/3/7/1/8/3718.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1348",
    "name": "Double concentré de tomate Durra 800gr.",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": 15,
    "category": "Concentrés",
    "sku": "SKU-1348",
    "barcode": "1348",
    "imageUrl": "http://almoune.fr/img/p/3/1/7/7/3177.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1349",
    "name": "Confiture d'abricot durra 430 gr.",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Confitures",
    "sku": "SKU-1349",
    "barcode": "1349",
    "imageUrl": "http://almoune.fr/img/p/3/1/7/8/3178.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1351",
    "name": "Hallawa bissat chocolat 200gr.",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 0,
    "category": "Halawa",
    "sku": "SKU-1351",
    "barcode": "1351",
    "imageUrl": "http://almoune.fr/img/p/3/2/6/1/3261.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1360",
    "name": "Hot Dog Boeuf Zwan 400gr.",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-1360",
    "barcode": "1360",
    "imageUrl": "http://almoune.fr/img/p/3/1/8/5/3185.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1361",
    "name": "Chich barak 12 pieces",
    "price": 9.5,
    "purchasePrice": 9.004739,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-1361",
    "barcode": "1361",
    "imageUrl": "http://almoune.fr/img/p/3/1/8/0/3180.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1362",
    "name": "Barazek Chamsin 500gr.",
    "price": 8.99,
    "purchasePrice": 8.521327,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1362",
    "barcode": "1362",
    "imageUrl": "http://almoune.fr/img/p/3/1/7/9/3179.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1363",
    "name": "Pâté de poulet au piment - Zwan 200gr",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1363",
    "barcode": "1363",
    "imageUrl": "http://almoune.fr/img/p/3/1/8/1/3181.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1365",
    "name": "Poivrons Marine Kostopoulos 250 gr.",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-1365",
    "barcode": "1365",
    "imageUrl": "http://almoune.fr/img/p/3/1/8/6/3186.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1366",
    "name": "Ails doux aux fines Herbes Coquet 195gr. net",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1366",
    "barcode": "1366",
    "imageUrl": "http://almoune.fr/img/p/3/1/8/3/3183.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1367",
    "name": "mhalabiyeh Gardenia 200g.",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1367",
    "barcode": "1367",
    "imageUrl": "http://almoune.fr/img/p/3/2/8/2/3282.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1370",
    "name": "Piments marinés - Chtoura Garden 500gr.",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-1370",
    "barcode": "1370",
    "imageUrl": "http://almoune.fr/img/p/3/1/8/8/3188.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1371",
    "name": "Lupin en Saumure 100gr.",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": 0,
    "category": "Chips et apéritifs",
    "sku": "SKU-1371",
    "barcode": "1371",
    "imageUrl": "http://almoune.fr/img/p/3/1/9/1/3191.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1372",
    "name": "Aubergines Séchées à farcir 100g env. 40 pièces",
    "price": 5.5,
    "purchasePrice": 5.677725,
    "stock": 0,
    "category": "Légumineuses",
    "sku": "SKU-1372",
    "barcode": "1372",
    "imageUrl": "http://almoune.fr/img/p/3/2/0/1/3201.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1376",
    "name": "Makdous Chtoura 600gr.",
    "price": 8.75,
    "purchasePrice": 8.293839,
    "stock": 40,
    "category": "Accueil",
    "sku": "SKU-1376",
    "barcode": "1376",
    "imageUrl": "http://almoune.fr/img/p/3/1/9/7/3197.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1377",
    "name": "Confiture de Fraise Durra 430gr.",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 1,
    "category": "Confitures",
    "sku": "SKU-1377",
    "barcode": "1377",
    "imageUrl": "http://almoune.fr/img/p/3/2/0/2/3202.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1379",
    "name": "Baklava Mix Zaitoune 200gr.",
    "price": 11.99,
    "purchasePrice": 11.364929,
    "stock": -1,
    "category": "Baklava",
    "sku": "SKU-1379",
    "barcode": "1379",
    "imageUrl": "http://almoune.fr/img/p/3/2/0/0/3200.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1380",
    "name": "Yoyo Gaufrette Fraise 12 pcs 30gr.",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1380",
    "barcode": "1380",
    "imageUrl": "http://almoune.fr/img/p/3/1/9/9/3199.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1381",
    "name": "Gaufrette Vanille Yoyo 12x30gr.",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1381",
    "barcode": "1381",
    "imageUrl": "http://almoune.fr/img/p/3/1/9/8/3198.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1382",
    "name": "Biscuit Crème Banane 16 x 37 gr.",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1382",
    "barcode": "1382",
    "imageUrl": "http://almoune.fr/img/p/3/2/0/4/3204.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1383",
    "name": "Eau de fleur d'oranger - Chtoura Garden 250 ml",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1383",
    "barcode": "1383",
    "imageUrl": "http://almoune.fr/img/p/3/7/1/9/3719.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1384",
    "name": "Houmous tahina - Chtoura Fields 380 gr.",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1384",
    "barcode": "1384",
    "imageUrl": "http://almoune.fr/img/p/3/7/2/0/3720.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1385",
    "name": "Houmous Tahina Spécial durra 220gr.",
    "price": 1.7,
    "purchasePrice": 1.611374,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1385",
    "barcode": "1385",
    "imageUrl": "http://almoune.fr/img/p/3/1/9/3/3193.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1386",
    "name": "Houmous Tahini Spéciale Offre x3 Durra 220gr.",
    "price": 4.49,
    "purchasePrice": 4.255924,
    "stock": 1,
    "category": "Conserves",
    "sku": "SKU-1386",
    "barcode": "1386",
    "imageUrl": "http://almoune.fr/img/p/3/1/9/4/3194.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1387",
    "name": "Foul recette syrienne 400 gr Durra",
    "price": 1.15,
    "purchasePrice": 1.090047,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1387",
    "barcode": "1387",
    "imageUrl": "http://almoune.fr/img/p/3/5/9/1/3591.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1388",
    "name": "Foul Bajela Chtoura 600gr.",
    "price": 1.74,
    "purchasePrice": 1.649289,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1388",
    "barcode": "1388",
    "imageUrl": "http://almoune.fr/img/p/3/2/0/5/3205.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1389",
    "name": "Aubergine marinée Moussaka Durra 400gr.",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1389",
    "barcode": "1389",
    "imageUrl": "http://almoune.fr/img/p/3/1/9/5/3195.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1390",
    "name": "Confiture de fraise 1000gr. Chtoura",
    "price": 2.75,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Confitures",
    "sku": "SKU-1390",
    "barcode": "1390",
    "imageUrl": "http://almoune.fr/img/p/3/1/9/0/3190.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1391",
    "name": "Double Concentré de tomate 880gr.",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": 0,
    "category": "Concentrés",
    "sku": "SKU-1391",
    "barcode": "1391",
    "imageUrl": "http://almoune.fr/img/p/3/2/1/2/3212.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1392",
    "name": "Assaisonnement Vegeta 200gr.",
    "price": 2.49,
    "purchasePrice": 2.36019,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-1392",
    "barcode": "1392",
    "imageUrl": "http://almoune.fr/img/p/3/2/1/1/3211.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1393",
    "name": "Baking Pouder 100gr. Abido",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -1,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1393",
    "barcode": "1393",
    "imageUrl": "http://almoune.fr/img/p/3/2/1/3/3213.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1394",
    "name": "Poivre Noir Gardenia 50gr.",
    "price": 1.65,
    "purchasePrice": 1.563981,
    "stock": -8,
    "category": "Épices",
    "sku": "SKU-1394",
    "barcode": "1394",
    "imageUrl": "http://almoune.fr/img/p/3/2/1/4/3214.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1395",
    "name": "Poivre Noir entier Abido 50g.",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 9,
    "category": "Épices",
    "sku": "SKU-1395",
    "barcode": "1395",
    "imageUrl": "http://almoune.fr/img/p/3/2/1/5/3215.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1397",
    "name": "Yerba maté TARAGUI 1kg",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-1397",
    "barcode": "1397",
    "imageUrl": "http://almoune.fr/img/p/3/6/8/2/3682.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1399",
    "name": "Gingembre morceaux séchés en vrac 50gr.",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 1,
    "category": "Épices",
    "sku": "SKU-1399",
    "barcode": "1399",
    "imageUrl": "http://almoune.fr/img/p/3/7/7/9/3779.jpg",
    "price_per_kg": 1.5
  },
  {
    "id": "csv-1401",
    "name": "Poudre d'amande - O'Regal 500 gr.",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 2,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1401",
    "barcode": "1401",
    "imageUrl": "http://almoune.fr/img/p/3/7/2/1/3721.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1402",
    "name": "Tête de chocolat Tarboosh Gandour x4 72g.",
    "price": 2.95,
    "purchasePrice": 2.796209,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-1402",
    "barcode": "1402",
    "imageUrl": "http://almoune.fr/img/p/3/3/0/9/3309.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1403",
    "name": "Biscuit tendre au date 15x21g",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1403",
    "barcode": "1403",
    "imageUrl": "http://almoune.fr/img/p/3/2/2/9/3229.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1404",
    "name": "Gombo Bamia - Chtoura Garden 600gr.",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 12,
    "category": "Conserves",
    "sku": "SKU-1404",
    "barcode": "1404",
    "imageUrl": "http://almoune.fr/img/p/3/2/3/2/3232.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1405",
    "name": "Jalapeno piments en tranches - Chtoura Garden 480gr.",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1405",
    "barcode": "1405",
    "imageUrl": "http://almoune.fr/img/p/3/2/3/1/3231.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1406",
    "name": "Makdous Mechaalany 450 gr - Aubergines farcies au Noix",
    "price": 8.49,
    "purchasePrice": 8.047393,
    "stock": 4,
    "category": "Légumes Marinés",
    "sku": "SKU-1406",
    "barcode": "1406",
    "imageUrl": "http://almoune.fr/img/p/3/2/3/0/3230.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1409",
    "name": "Kaak Fingers - Moulin d'or 310g.",
    "price": 4.95,
    "purchasePrice": 4.691943,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1409",
    "barcode": "1409",
    "imageUrl": "http://almoune.fr/img/p/3/2/3/7/3237.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1410",
    "name": "Kaak boulette au sésame - Moulin d'or 400gr.",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1410",
    "barcode": "1410",
    "imageUrl": "http://almoune.fr/img/p/3/2/3/9/3239.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1411",
    "name": "Ich el belbol douaihy mix 400gr.",
    "price": 14.99,
    "purchasePrice": 14.208531,
    "stock": 0,
    "category": "Patisserie Douaihy",
    "sku": "SKU-1411",
    "barcode": "1411",
    "imageUrl": "http://almoune.fr/img/p/3/2/4/7/3247.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1412",
    "name": "Ghroybe - Douaihy 400g",
    "price": 10.99,
    "purchasePrice": 10.417062,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1412",
    "barcode": "1412",
    "imageUrl": "http://almoune.fr/img/p/3/2/4/9/3249.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1413",
    "name": "Barazek - Douaihy édition Lebanon with Love 300g.",
    "price": 14.25,
    "purchasePrice": 13.507109,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-1413",
    "barcode": "1413",
    "imageUrl": "http://almoune.fr/img/p/3/2/4/2/3242.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1414",
    "name": "Ghraybe édition Lebanon with love - Douaihy 400g",
    "price": 12.25,
    "purchasePrice": 11.611374,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1414",
    "barcode": "1414",
    "imageUrl": "http://almoune.fr/img/p/3/2/4/3/3243.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1415",
    "name": "Noix de Coco râpée - O'Regal 500 gr.",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1415",
    "barcode": "1415",
    "imageUrl": "http://almoune.fr/img/p/3/7/2/2/3722.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1418",
    "name": "Pignon de Pin long Wassim 100gr.",
    "price": 6.49,
    "purchasePrice": 6.151659,
    "stock": 0,
    "category": "Fruits secs",
    "sku": "SKU-1418",
    "barcode": "1418",
    "imageUrl": "http://almoune.fr/img/p/3/2/4/4/3244.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1419",
    "name": "Anis en Grain 250 gr.",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Épice brute",
    "sku": "SKU-1419",
    "barcode": "1419",
    "imageUrl": "http://almoune.fr/img/p/3/7/2/3/3723.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1420",
    "name": "Baba Ghannouge Chtoura Garden 185g",
    "price": 2.49,
    "purchasePrice": 2.36019,
    "stock": 22,
    "category": "Conserves",
    "sku": "SKU-1420",
    "barcode": "1420",
    "imageUrl": "http://almoune.fr/img/p/4/3/9/3/4393.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1421",
    "name": "HAlva ou Halawa Al Burj 400gr. Pistache",
    "price": 5.99,
    "purchasePrice": 5.677725,
    "stock": 0,
    "category": "Halawa",
    "sku": "SKU-1421",
    "barcode": "1421",
    "imageUrl": "http://almoune.fr/img/p/3/2/5/8/3258.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1422",
    "name": "Halva ou Halwa Pistache Al BURJ 400gr. Super Extra",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Halawa",
    "sku": "SKU-1422",
    "barcode": "1422",
    "imageUrl": "http://almoune.fr/img/p/3/2/6/0/3260.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1424",
    "name": "Petites pépites de melon grillées et salées - Al Samir 300 gr.",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-1424",
    "barcode": "1424",
    "imageUrl": "http://almoune.fr/img/p/3/7/3/4/3734.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1428",
    "name": "Labneh Chèvre boulette 745gr. Golden Plate",
    "price": 9.75,
    "purchasePrice": 9.241706,
    "stock": -160,
    "category": "Yaourt et Labneh",
    "sku": "SKU-1428",
    "barcode": "1428",
    "imageUrl": "http://almoune.fr/img/p/3/2/5/0/3250.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1429",
    "name": "Pain Choufen pain à la Farine D'orge Moulin d'or 270 gr.",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": -2,
    "category": "pain et Kaak",
    "sku": "SKU-1429",
    "barcode": "1429",
    "imageUrl": "http://almoune.fr/img/p/3/2/5/3/3253.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1430",
    "name": "Gaufrette Nouba LU 10x17.5g",
    "price": 5.49,
    "purchasePrice": 5.203791,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-1430",
    "barcode": "1430",
    "imageUrl": "http://almoune.fr/img/p/3/2/5/7/3257.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1431",
    "name": "Soupe au poulet et vermicelles - Maggi 60gr.",
    "price": 1.49,
    "purchasePrice": 1.412322,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1431",
    "barcode": "1431",
    "imageUrl": "http://almoune.fr/img/p/3/2/5/6/3256.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1432",
    "name": "Kaak Asroune - Moulin d'or 150 g",
    "price": 2.75,
    "purchasePrice": 3.308057,
    "stock": 0,
    "category": "pain et Kaak",
    "sku": "SKU-1432",
    "barcode": "1432",
    "imageUrl": "http://almoune.fr/img/p/3/7/8/6/3786.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1436",
    "name": "Pate de dattes - Al Jazeera 1Kg",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1436",
    "barcode": "1436",
    "imageUrl": "http://almoune.fr/img/p/3/7/2/4/3724.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1445",
    "name": "Amande fumé",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -2,
    "category": "Fruits secs",
    "sku": "SKU-1445",
    "barcode": "1445",
    "imageUrl": "http://almoune.fr/img/p/3/3/3/1/3331.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1447",
    "name": "Café Najjar Selection 450gr.",
    "price": 6.85,
    "purchasePrice": 6.492891,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1447",
    "barcode": "1447",
    "imageUrl": "http://almoune.fr/img/p/3/7/2/5/3725.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1448",
    "name": "Qamareddine pâte d’abricots séchés 400 gr",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": 22,
    "category": "Friandises",
    "sku": "SKU-1448",
    "barcode": "1448",
    "imageUrl": "http://almoune.fr/img/p/3/5/4/0/3540.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1449",
    "name": "Halva pistaches - Al Burj 800 gr",
    "price": 9.25,
    "purchasePrice": 8.767773,
    "stock": 0,
    "category": "Halawa",
    "sku": "SKU-1449",
    "barcode": "1449",
    "imageUrl": "http://almoune.fr/img/p/3/7/7/4/3774.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1454",
    "name": "Sirop - Vimto 0.72L",
    "price": 6.49,
    "purchasePrice": 6.151659,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1454",
    "barcode": "1454",
    "imageUrl": "http://almoune.fr/img/p/3/2/8/5/3285.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1456",
    "name": "Graines de Tournesol Grillées Salées Al Fakhr 150g",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 19,
    "category": "Accueil",
    "sku": "SKU-1456",
    "barcode": "1456",
    "imageUrl": "http://almoune.fr/img/p/4/4/2/2/4422.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1457",
    "name": "Dingo Chocolat 24 pièces",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": -5,
    "category": "Friandises",
    "sku": "SKU-1457",
    "barcode": "1457",
    "imageUrl": "http://almoune.fr/img/p/3/2/8/1/3281.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1461",
    "name": "Twist Choco 24",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1461",
    "barcode": "1461",
    "imageUrl": "http://almoune.fr/img/p/3/2/9/8/3298.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1466",
    "name": "Yerba maté - Secadero 250gr.",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1466",
    "barcode": "1466",
    "imageUrl": "http://almoune.fr/img/p/3/2/7/0/3270.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1468",
    "name": "Bourgoul brun fin Gardenia 907gr",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": -2,
    "category": "Boulghour",
    "sku": "SKU-1468",
    "barcode": "1468",
    "imageUrl": "http://almoune.fr/img/p/3/2/9/6/3296.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1469",
    "name": "Soupe Maggi vegétarienne 59gr.",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-1469",
    "barcode": "1469",
    "imageUrl": "http://almoune.fr/img/p/3/2/9/2/3292.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1470",
    "name": "Maggi box 12x 59gr sachets",
    "price": 14.99,
    "purchasePrice": 14.208531,
    "stock": -2,
    "category": "Condiments",
    "sku": "SKU-1470",
    "barcode": "1470",
    "imageUrl": "http://almoune.fr/img/p/3/2/9/5/3295.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1471",
    "name": "Maamoul aux Pistaches Aghati 500gr",
    "price": 21.99,
    "purchasePrice": 20.843602,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1471",
    "barcode": "1471",
    "imageUrl": "http://almoune.fr/img/p/3/2/6/9/3269.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1472",
    "name": "Maamoul aux dattes et semoule - Aghati 1000gr.",
    "price": 27.5,
    "purchasePrice": 26.066351,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1472",
    "barcode": "1472",
    "imageUrl": "http://almoune.fr/img/p/3/2/8/0/3280.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1473",
    "name": "Riz en Poudre (farine de riz) Gardenia 400gr.",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1473",
    "barcode": "1473",
    "imageUrl": "http://almoune.fr/img/p/3/2/8/3/3283.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1476",
    "name": "Fleurs d'Hibiscus 100gr.",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 1,
    "category": "Infusions",
    "sku": "SKU-1476",
    "barcode": "1476",
    "imageUrl": "http://almoune.fr/img/p/3/7/2/6/3726.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1477",
    "name": "Haricot blanc petite taille 900gr.",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 5,
    "category": "Légumineuses et grains",
    "sku": "SKU-1477",
    "barcode": "1477",
    "imageUrl": "http://almoune.fr/img/p/3/7/2/8/3728.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1478",
    "name": "Loukoum libanais à la rose Shahin 500gr.",
    "price": 7.49,
    "purchasePrice": 7.099526,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1478",
    "barcode": "1478",
    "imageUrl": "http://almoune.fr/img/p/3/2/6/8/3268.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1479",
    "name": "Amandes blanchies - O'Regal 400 gr.",
    "price": 4.2,
    "purchasePrice": 3.981043,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-1479",
    "barcode": "1479",
    "imageUrl": "http://almoune.fr/img/p/3/7/2/9/3729.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1480",
    "name": "Pignons de pin - O'Regal 250 gr.",
    "price": 10.55,
    "purchasePrice": 10,
    "stock": 19,
    "category": "Fruits secs",
    "sku": "SKU-1480",
    "barcode": "1480",
    "imageUrl": "http://almoune.fr/img/p/3/7/3/0/3730.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1482",
    "name": "Zaatar Libanais Second House Products 250 gr",
    "price": 4.85,
    "purchasePrice": 4.597156,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1482",
    "barcode": "1482",
    "imageUrl": "http://almoune.fr/img/p/3/2/7/5/3275.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1483",
    "name": "Maamoul aux dattes - Al Sultan 600gr.",
    "price": 13.5,
    "purchasePrice": 12.796209,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1483",
    "barcode": "1483",
    "imageUrl": "http://almoune.fr/img/p/3/2/6/2/3262.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1484",
    "name": "Maamoul aux Noix - Al Sultan 500gr.",
    "price": 13.5,
    "purchasePrice": 12.796209,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1484",
    "barcode": "1484",
    "imageUrl": "http://almoune.fr/img/p/3/2/6/3/3263.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1485",
    "name": "Halawa Diwan Nature Vanille 907gr.",
    "price": 6.95,
    "purchasePrice": 5.791667,
    "stock": 0,
    "category": "Halawa",
    "sku": "SKU-1485",
    "barcode": "1485",
    "imageUrl": "http://almoune.fr/img/p/3/2/7/7/3277.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1486",
    "name": "Maamoul aux pistaches - Al Sultan 350gr.",
    "price": 14.5,
    "purchasePrice": 13.744076,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1486",
    "barcode": "1486",
    "imageUrl": "http://almoune.fr/img/p/3/2/6/4/3264.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1487",
    "name": "Ghreybe - Al Sultan 400gr.",
    "price": 9.99,
    "purchasePrice": 9.469194,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1487",
    "barcode": "1487",
    "imageUrl": "http://almoune.fr/img/p/3/2/6/5/3265.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1488",
    "name": "Barazek - Al Sultan 350gr.",
    "price": 12.99,
    "purchasePrice": 12.312796,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1488",
    "barcode": "1488",
    "imageUrl": "http://almoune.fr/img/p/3/2/6/7/3267.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1489",
    "name": "Meghli SHP 200gr.",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 2,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1489",
    "barcode": "1489",
    "imageUrl": "http://almoune.fr/img/p/3/2/7/2/3272.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1490",
    "name": "Tamarin Durra 250gr.",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -6,
    "category": "Fruits secs",
    "sku": "SKU-1490",
    "barcode": "1490",
    "imageUrl": "http://almoune.fr/img/p/3/3/7/0/3370.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1491",
    "name": "Nougat Douaihy rest. Au Kg",
    "price": 17.93,
    "purchasePrice": 16.995261,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1491",
    "barcode": "1491",
    "imageUrl": "http://almoune.fr/img/p/3/4/0/3/3403.jpg",
    "price_per_kg": 17.93
  },
  {
    "id": "csv-1492",
    "name": "Épices shawarma viande Gardenia 50 gr.",
    "price": 1.9,
    "purchasePrice": 1.800948,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-1492",
    "barcode": "1492",
    "imageUrl": "http://almoune.fr/img/p/3/7/3/1/3731.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1493",
    "name": "Moule Maamoul en plastique 3 en 1",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Autres",
    "sku": "SKU-1493",
    "barcode": "1493",
    "imageUrl": "http://almoune.fr/img/p/3/7/3/2/3732.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1497",
    "name": "Dattes farcies 10 pièces Dattes Deluxe",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1497",
    "barcode": "1497",
    "imageUrl": "http://almoune.fr/img/p/3/2/7/8/3278.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1498",
    "name": "Dattes farcies 20 pièces Dattes Deluxe",
    "price": 10.99,
    "purchasePrice": 10.417062,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1498",
    "barcode": "1498",
    "imageUrl": "http://almoune.fr/img/p/3/2/7/9/3279.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1500",
    "name": "Pistaches Premium 250gr. Grecques",
    "price": 9,
    "purchasePrice": 8.530806,
    "stock": 9,
    "category": "Fruits secs",
    "sku": "SKU-1500",
    "barcode": "1500",
    "imageUrl": "http://almoune.fr/img/p/3/3/6/2/3362.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1509",
    "name": "Sirop de rose - Anjar 600 ml",
    "price": 5.95,
    "purchasePrice": 5.63981,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1509",
    "barcode": "1509",
    "imageUrl": "http://almoune.fr/img/p/3/2/7/1/3271.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1510",
    "name": "Marjolaine séchée en vrac - 30gr.",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 19,
    "category": "Accueil",
    "sku": "SKU-1510",
    "barcode": "1510",
    "imageUrl": "http://almoune.fr/img/p/3/7/3/5/3735.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-1511",
    "name": "Ghee Samne Baqara el Haloub 400g. Golden Medal",
    "price": 9.75,
    "purchasePrice": 9.241706,
    "stock": 0,
    "category": "Ghee - beurre clarifié - samneh",
    "sku": "SKU-1511",
    "barcode": "1511",
    "imageUrl": "http://almoune.fr/img/p/3/3/1/2/3312.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1512",
    "name": "Vermicelle - Tayba 1Kg",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-1512",
    "barcode": "1512",
    "imageUrl": "http://almoune.fr/img/p/3/2/9/7/3297.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1513",
    "name": "Houmous Chtoura sachet de 500 gr",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1513",
    "barcode": "1513",
    "imageUrl": "http://almoune.fr/img/p/3/2/9/3/3293.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1515",
    "name": "Coffee mate 450gr.",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-1515",
    "barcode": "1515",
    "imageUrl": "http://almoune.fr/img/p/3/3/4/1/3341.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1519",
    "name": "Boulghour brun fin 1kg Chtoura garden",
    "price": 3.35,
    "purchasePrice": 3.175355,
    "stock": 0,
    "category": "Boulghour",
    "sku": "SKU-1519",
    "barcode": "1519",
    "imageUrl": "http://almoune.fr/img/p/3/3/3/7/3337.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1520",
    "name": "Maamoul Douaihy aux pistaches Grande pièce enveloppée dans un sachet",
    "price": 2.49,
    "purchasePrice": 2.36019,
    "stock": -17,
    "category": "Accueil",
    "sku": "SKU-1520",
    "barcode": "1520",
    "imageUrl": "http://almoune.fr/img/p/3/2/8/9/3289.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1521",
    "name": "Maamoul Douaihy aux Noix 70 gr enveloppée dans un sachet",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-1521",
    "barcode": "1521",
    "imageUrl": "http://almoune.fr/img/p/3/2/8/8/3288.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1522",
    "name": "Maamoul Douaihy aux dattes Grande pièce enveloppée dans un sachet",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-1522",
    "barcode": "1522",
    "imageUrl": "http://almoune.fr/img/p/3/2/8/7/3287.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1523",
    "name": "Gardénia en bourgeons",
    "price": 14.99,
    "purchasePrice": 13.627273,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1523",
    "barcode": "1523",
    "imageUrl": "http://almoune.fr/img/p/3/2/9/1/3291.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1524",
    "name": "Malban douaihy 1kg",
    "price": 17.94,
    "purchasePrice": 17,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1524",
    "barcode": "1524",
    "imageUrl": "http://almoune.fr/img/p/3/3/9/9/3399.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1526",
    "name": "Paprika fort fumé - El Avion 75 gr",
    "price": 2.35,
    "purchasePrice": 2.227488,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-1526",
    "barcode": "1526",
    "imageUrl": "http://almoune.fr/img/p/3/3/9/4/3394.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1527",
    "name": "Décoration Oeuf de Pâques collant - Anatoli",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 46,
    "category": "Autres",
    "sku": "SKU-1527",
    "barcode": "1527",
    "imageUrl": "http://almoune.fr/img/p/3/8/1/1/3811.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1528",
    "name": "Colorant Rouge pour oeuf de Pâques et pâtisserie ANATOLI 3g avec gants",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1528",
    "barcode": "1528",
    "imageUrl": "http://almoune.fr/img/p/3/8/1/0/3810.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1529",
    "name": "Colorant Jaune pour oeuf de Pâques et pâtisserie ANATOLI 3g avec gants",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": 23,
    "category": "Accueil",
    "sku": "SKU-1529",
    "barcode": "1529",
    "imageUrl": "http://almoune.fr/img/p/3/8/0/9/3809.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1530",
    "name": "Colorant vert pour oeuf de Pâques et pâtisserie Anatoli 3g avec Gants",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": 27,
    "category": "Autres",
    "sku": "SKU-1530",
    "barcode": "1530",
    "imageUrl": "http://almoune.fr/img/p/3/8/0/8/3808.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1539",
    "name": "Halawa pistaches - Arkan 375 gr",
    "price": 4.95,
    "purchasePrice": 4.691943,
    "stock": 0,
    "category": "Halawa",
    "sku": "SKU-1539",
    "barcode": "1539",
    "imageUrl": "http://almoune.fr/img/p/3/7/6/5/3765.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1540",
    "name": "Tahini Arkan 800gr.",
    "price": 8.6,
    "purchasePrice": 8.151659,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1540",
    "barcode": "1540",
    "imageUrl": "http://almoune.fr/img/p/3/6/6/2/3662.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1545",
    "name": "Sumac extra naturel Al Baraka 50gr.",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": -1,
    "category": "Épices",
    "sku": "SKU-1545",
    "barcode": "1545",
    "imageUrl": "http://almoune.fr/img/p/3/3/2/7/3327.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1546",
    "name": "Concombres Marines Al Baraka 650 gr",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-1546",
    "barcode": "1546",
    "imageUrl": "http://almoune.fr/img/p/3/3/2/5/3325.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1547",
    "name": "Concombres Sauvages Marines Al Baraka 650 gr",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-1547",
    "barcode": "1547",
    "imageUrl": "http://almoune.fr/img/p/3/3/2/6/3326.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1548",
    "name": "Olives Vertes Libanaises Al Baraka 600 gr",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1548",
    "barcode": "1548",
    "imageUrl": "http://almoune.fr/img/p/3/3/1/8/3318.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1549",
    "name": "Olives noires libanaises  - AL Baraka 600 gr",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1549",
    "barcode": "1549",
    "imageUrl": "http://almoune.fr/img/p/3/3/1/9/3319.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1550",
    "name": "Zaatar Libanais ALbaraka 250 gr",
    "price": 5.49,
    "purchasePrice": 5.203791,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1550",
    "barcode": "1550",
    "imageUrl": "http://almoune.fr/img/p/3/3/2/0/3320.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1551",
    "name": "Aubergines Confites à L'huile ALbaraka 600 gr",
    "price": 7.75,
    "purchasePrice": 7.345972,
    "stock": -3,
    "category": "Légumes Marinés",
    "sku": "SKU-1551",
    "barcode": "1551",
    "imageUrl": "http://almoune.fr/img/p/3/3/2/8/3328.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1552",
    "name": "Savon Libanais cuit au chaudron Baladi ALbaraka 150 gr",
    "price": 1.99,
    "purchasePrice": 1.658333,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1552",
    "barcode": "1552",
    "imageUrl": "http://almoune.fr/img/p/3/3/2/4/3324.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1553",
    "name": "Huile D'olive Extra Vierge Al BARAKA 250 ml",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Huiles et vinaigres",
    "sku": "SKU-1553",
    "barcode": "1553",
    "imageUrl": "http://almoune.fr/img/p/3/3/2/1/3321.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1554",
    "name": "Huile D'olive Extra Vierge Libanaise  ALbaraka 750 mL",
    "price": 12.75,
    "purchasePrice": 12.085308,
    "stock": 0,
    "category": "Huiles et vinaigres",
    "sku": "SKU-1554",
    "barcode": "1554",
    "imageUrl": "http://almoune.fr/img/p/3/3/2/2/3322.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1555",
    "name": "Huile D'olive Extra Vierge Libanaise ALbaraka 1,4 L",
    "price": 18.75,
    "purchasePrice": 17.772512,
    "stock": 0,
    "category": "Huiles et vinaigres",
    "sku": "SKU-1555",
    "barcode": "1555",
    "imageUrl": "http://almoune.fr/img/p/3/3/2/3/3323.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1557",
    "name": "Navets Marinés Hikayat 2- 1050 gr",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-1557",
    "barcode": "1557",
    "imageUrl": "http://almoune.fr/img/p/3/3/1/5/3315.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1558",
    "name": "Artichauts Hikayat 1050 gr",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1558",
    "barcode": "1558",
    "imageUrl": "http://almoune.fr/img/p/3/3/1/4/3314.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1559",
    "name": "Concombres Marinés Hikayat 600gr",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": -14,
    "category": "Conserves",
    "sku": "SKU-1559",
    "barcode": "1559",
    "imageUrl": "http://almoune.fr/img/p/3/3/1/6/3316.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1560",
    "name": "Halawa pistaches - Arkan 750 gr",
    "price": 6.99,
    "purchasePrice": 6.625592,
    "stock": -1,
    "category": "Halawa",
    "sku": "SKU-1560",
    "barcode": "1560",
    "imageUrl": "http://almoune.fr/img/p/3/7/6/6/3766.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1561",
    "name": "Sirop de Jellab Crowan 2.5 L",
    "price": 14.99,
    "purchasePrice": 14.208531,
    "stock": -9,
    "category": "Accueil",
    "sku": "SKU-1561",
    "barcode": "1561",
    "imageUrl": "http://almoune.fr/img/p/3/4/1/7/3417.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1562",
    "name": "Baba Ghanouj Chtoura Garden 370 gr",
    "price": 2.85,
    "purchasePrice": 2.701422,
    "stock": 31,
    "category": "Conserves",
    "sku": "SKU-1562",
    "barcode": "1562",
    "imageUrl": "http://almoune.fr/img/p/4/0/3/9/4039.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1563",
    "name": "Zaatar halabi Rouge - ALarjawi 500 gr",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1563",
    "barcode": "1563",
    "imageUrl": "http://almoune.fr/img/p/3/3/1/3/3313.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1564",
    "name": "Aubergines Grillées Hikayat 2 1050 gr",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1564",
    "barcode": "1564",
    "imageUrl": "http://almoune.fr/img/p/3/3/1/7/3317.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1565",
    "name": "Mélasse de grenade  Al Baraka 350 gr",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 0,
    "category": "Mélasses et miels",
    "sku": "SKU-1565",
    "barcode": "1565",
    "imageUrl": "http://almoune.fr/img/p/3/3/3/6/3336.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1566",
    "name": "Ghee végétal Aseel 1 kg",
    "price": 10.95,
    "purchasePrice": 10.379147,
    "stock": 1,
    "category": "Ghee - beurre clarifié - samneh",
    "sku": "SKU-1566",
    "barcode": "1566",
    "imageUrl": "http://almoune.fr/img/p/3/3/7/7/3377.jpg",
    "price_per_kg": 10.95
  },
  {
    "id": "csv-1570",
    "name": "Baklava de qualité  Aghati 250 gr",
    "price": 11.99,
    "purchasePrice": 11.364929,
    "stock": 0,
    "category": "Baklava",
    "sku": "SKU-1570",
    "barcode": "1570",
    "imageUrl": "http://almoune.fr/img/p/3/3/4/0/3340.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1571",
    "name": "Amidon de Mais Gardenia 200 gr",
    "price": 2.1,
    "purchasePrice": 1.990521,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1571",
    "barcode": "1571",
    "imageUrl": "http://almoune.fr/img/p/3/3/5/7/3357.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1573",
    "name": "Boulgour Gros blanc Grain de Frais 1 kg",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": -11,
    "category": "Boulghour",
    "sku": "SKU-1573",
    "barcode": "1573",
    "imageUrl": "http://almoune.fr/img/p/3/3/5/0/3350.jpg",
    "price_per_kg": 3.25
  },
  {
    "id": "csv-1574",
    "name": "Boulgour Fin blanc Grain de Frais 1 kg",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Boulghour",
    "sku": "SKU-1574",
    "barcode": "1574",
    "imageUrl": "http://almoune.fr/img/p/3/3/4/9/3349.jpg",
    "price_per_kg": 3.25
  },
  {
    "id": "csv-1575",
    "name": "Semoule moyenne Le Renard 2 kg",
    "price": 5.95,
    "purchasePrice": 5.63981,
    "stock": 0,
    "category": "Légumineuses et grains",
    "sku": "SKU-1575",
    "barcode": "1575",
    "imageUrl": "http://almoune.fr/img/p/3/3/5/8/3358.jpg",
    "price_per_kg": 5.95
  },
  {
    "id": "csv-1576",
    "name": "Sardines à l'huile d'olive - 125 gr",
    "price": 1.49,
    "purchasePrice": 1.412322,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1576",
    "barcode": "1576",
    "imageUrl": "http://almoune.fr/img/p/3/3/4/8/3348.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1577",
    "name": "Infusion Camomille Bio 20 x 24 gr",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Infusions",
    "sku": "SKU-1577",
    "barcode": "1577",
    "imageUrl": "http://almoune.fr/img/p/3/4/1/9/3419.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1578",
    "name": "Graines De Chia Bio Noir Grain de Frais 250 gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-1578",
    "barcode": "1578",
    "imageUrl": "http://almoune.fr/img/p/3/3/5/2/3352.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1579",
    "name": "Haricots blanc gros calibre Cidacos 570 gr",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 5,
    "category": "Conserves",
    "sku": "SKU-1579",
    "barcode": "1579",
    "imageUrl": "http://almoune.fr/img/p/3/3/8/8/3388.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1581",
    "name": "Haricots Blancs Cidacos 570 gr",
    "price": 2.15,
    "purchasePrice": 2.037915,
    "stock": 0,
    "category": "Légumineuses",
    "sku": "SKU-1581",
    "barcode": "1581",
    "imageUrl": "http://almoune.fr/img/p/3/3/6/8/3368.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1582",
    "name": "Pois Chiches Ceci Cidacos 570 gr",
    "price": 2.15,
    "purchasePrice": 2.037915,
    "stock": 0,
    "category": "Légumineuses et grains",
    "sku": "SKU-1582",
    "barcode": "1582",
    "imageUrl": "http://almoune.fr/img/p/3/3/8/7/3387.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1583",
    "name": "Pois Chiches Ceci Cidacos 570 gr",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-1583",
    "barcode": "1583",
    "imageUrl": "http://almoune.fr/img/p/3/3/9/2/3392.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1585",
    "name": "Riz Chtoura Garden 1 kg",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -8,
    "category": "Accueil",
    "sku": "SKU-1585",
    "barcode": "1585",
    "imageUrl": "http://almoune.fr/img/p/3/4/7/2/3472.jpg",
    "price_per_kg": 2.75
  },
  {
    "id": "csv-1586",
    "name": "Riz Mahmood 900 gr",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1586",
    "barcode": "1586",
    "imageUrl": "http://almoune.fr/img/p/3/3/8/6/3386.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1587",
    "name": "Riz Chtoura Garden 5 kg",
    "price": 18.49,
    "purchasePrice": 17.526066,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-1587",
    "barcode": "1587",
    "imageUrl": "http://almoune.fr/img/p/3/4/2/5/3425.jpg",
    "price_per_kg": 18.49
  },
  {
    "id": "csv-1588",
    "name": "Film Alimentaire Grand",
    "price": 11.4,
    "purchasePrice": 9.5,
    "stock": -13,
    "category": "Autres",
    "sku": "SKU-1588",
    "barcode": "1588",
    "imageUrl": "http://almoune.fr/img/p/3/3/8/5/3385.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1593",
    "name": "Riz en poudre (farine de riz) Abido 500gr.",
    "price": 2.55,
    "purchasePrice": 2.417062,
    "stock": 24,
    "category": "Accueil",
    "sku": "SKU-1593",
    "barcode": "1593",
    "imageUrl": "http://almoune.fr/img/p/3/3/5/1/3351.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1597",
    "name": "Bourma pistaches fabriqués au Liban en vrac 4 pièces ≈ 135 gr",
    "price": 4.95,
    "purchasePrice": 4.691943,
    "stock": 0,
    "category": "Baklava",
    "sku": "SKU-1597",
    "barcode": "1597",
    "imageUrl": "http://almoune.fr/img/p/3/3/8/3/3383.jpg",
    "price_per_kg": 4.95
  },
  {
    "id": "csv-1600",
    "name": "Amandes grillées salées premium de Grèce 250gr.",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 3,
    "category": "Fruits à coques grillés",
    "sku": "SKU-1600",
    "barcode": "1600",
    "imageUrl": "http://almoune.fr/img/p/3/3/4/5/3345.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1602",
    "name": "Maamoul aux dattes Wassim 400gr",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1602",
    "barcode": "1602",
    "imageUrl": "http://almoune.fr/img/p/3/4/7/7/3477.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1607",
    "name": "Thé Ceylon Horse head 400 gr",
    "price": 9.75,
    "purchasePrice": 9.241706,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1607",
    "barcode": "1607",
    "imageUrl": "http://almoune.fr/img/p/3/4/1/5/3415.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1611",
    "name": "Mélasse de grenade Mymouné 100% naturelle 250 ml",
    "price": 9.75,
    "purchasePrice": 9.241706,
    "stock": 16,
    "category": "Accueil",
    "sku": "SKU-1611",
    "barcode": "1611",
    "imageUrl": "http://almoune.fr/img/p/3/3/7/1/3371.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1612",
    "name": "Barbe à Papa (ghazal al Banat) - Douaihy 9 Pièces",
    "price": 15,
    "purchasePrice": 14.218009,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1612",
    "barcode": "1612",
    "imageUrl": "http://almoune.fr/img/p/3/3/7/3/3373.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1615",
    "name": "Namoura Douaihy au kilo",
    "price": 12,
    "purchasePrice": 11.374408,
    "stock": 0,
    "category": "Patisseries Douaihy",
    "sku": "SKU-1615",
    "barcode": "1615",
    "imageUrl": "http://almoune.fr/img/p/3/4/0/8/3408.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1616",
    "name": "Concombre Mariné Mechaalany en vrac 500gr.",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-1616",
    "barcode": "1616",
    "imageUrl": "http://almoune.fr/img/p/3/4/1/2/3412.jpg",
    "price_per_kg": 2.99
  },
  {
    "id": "csv-1617",
    "name": "Piment doux en poudre (paprika) - Bédros 25Og",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": -55,
    "category": "Accueil",
    "sku": "SKU-1617",
    "barcode": "1617",
    "imageUrl": "http://almoune.fr/img/p/3/4/2/6/3426.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1618",
    "name": "Paprika doux fumé - El Avion 75 gr",
    "price": 2.35,
    "purchasePrice": 2.227488,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-1618",
    "barcode": "1618",
    "imageUrl": "http://almoune.fr/img/p/3/4/2/7/3427.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1619",
    "name": "Cigares aux dattes 250 gr - Biscuit D'or",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1619",
    "barcode": "1619",
    "imageUrl": "http://almoune.fr/img/p/3/4/7/3/3473.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1620",
    "name": "Bourma pistaches 6 pièces fabriqués au Liban en vrac ≈ 200 gr",
    "price": 7.49,
    "purchasePrice": 7.099526,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1620",
    "barcode": "1620",
    "imageUrl": "http://almoune.fr/img/p/3/4/3/0/3430.jpg",
    "price_per_kg": 7.49
  },
  {
    "id": "csv-1621",
    "name": "Bourma pistaches fabriqués au Liban en vrac 12 pièces ≈ 400 gr",
    "price": 14.25,
    "purchasePrice": 13.507109,
    "stock": -5,
    "category": "Accueil",
    "sku": "SKU-1621",
    "barcode": "1621",
    "imageUrl": "http://almoune.fr/img/p/3/4/3/3/3433.jpg",
    "price_per_kg": 14.25
  },
  {
    "id": "csv-1622",
    "name": "Baklava pistaches fabriqués au Liban 1.5 kg",
    "price": 45,
    "purchasePrice": 42.654028,
    "stock": 0,
    "category": "Baklava",
    "sku": "SKU-1622",
    "barcode": "1622",
    "imageUrl": "http://almoune.fr/img/p/3/4/3/4/3434.jpg",
    "price_per_kg": 45
  },
  {
    "id": "csv-1623",
    "name": "Kol w chokr (baklava) cajou fabriqués au Liban 1.5 kg",
    "price": 34.9,
    "purchasePrice": 33.080569,
    "stock": 0,
    "category": "Baklava",
    "sku": "SKU-1623",
    "barcode": "1623",
    "imageUrl": "http://almoune.fr/img/p/3/4/7/5/3475.jpg",
    "price_per_kg": 34.9
  },
  {
    "id": "csv-1624",
    "name": "Bokaj cajou fabriqués au Liban 1 kg",
    "price": 23.99,
    "purchasePrice": 22.739336,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-1624",
    "barcode": "1624",
    "imageUrl": "http://almoune.fr/img/p/3/8/9/2/3892.jpg",
    "price_per_kg": 23.99
  },
  {
    "id": "csv-1626",
    "name": "Bourma cajou fabriqués au Liban en vrac 4 pièces ≈ 135 gr",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1626",
    "barcode": "1626",
    "imageUrl": "http://almoune.fr/img/p/3/4/4/7/3447.jpg",
    "price_per_kg": 3.49
  },
  {
    "id": "csv-1627",
    "name": "Bourma cajou fabriqués au Liban en vrac 6 pièces ≈ 200 gr",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1627",
    "barcode": "1627",
    "imageUrl": "http://almoune.fr/img/p/3/4/4/8/3448.jpg",
    "price_per_kg": 4.99
  },
  {
    "id": "csv-1628",
    "name": "Bourma cajou fabriqués au Liban en vrac 12 pièces ≈ 400 gr",
    "price": 9.75,
    "purchasePrice": 9.241706,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1628",
    "barcode": "1628",
    "imageUrl": "http://almoune.fr/img/p/3/4/4/9/3449.jpg",
    "price_per_kg": 9.75
  },
  {
    "id": "csv-1629",
    "name": "Assabeh cajou fabriqués au Liban en vrac 6 pièces ≈ 130 gr",
    "price": 3.35,
    "purchasePrice": 3.175355,
    "stock": 15,
    "category": "Accueil",
    "sku": "SKU-1629",
    "barcode": "1629",
    "imageUrl": "http://almoune.fr/img/p/3/4/5/3/3453.jpg",
    "price_per_kg": 3.35
  },
  {
    "id": "csv-1630",
    "name": "Assabeh cajou fabriqués au Liban en vrac 13 pièces ≈ 270 gr",
    "price": 6.49,
    "purchasePrice": 6.151659,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-1630",
    "barcode": "1630",
    "imageUrl": "http://almoune.fr/img/p/3/4/5/4/3454.jpg",
    "price_per_kg": 6.49
  },
  {
    "id": "csv-1631",
    "name": "Bokaj cajou fabriqués au Liban en vrac 4 pièces ≈ 80 gr",
    "price": 2.85,
    "purchasePrice": 2.701422,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-1631",
    "barcode": "1631",
    "imageUrl": "http://almoune.fr/img/p/3/4/6/1/3461.jpg",
    "price_per_kg": 2.85
  },
  {
    "id": "csv-1632",
    "name": "Bokaj cajou fabriqués au Liban en vrac 6 pièces ≈ 120 gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-1632",
    "barcode": "1632",
    "imageUrl": "http://almoune.fr/img/p/3/4/6/2/3462.jpg",
    "price_per_kg": 2.99
  },
  {
    "id": "csv-1634",
    "name": "Baklava cajou fabriqués au Liban en vrac 4 pièces ≈ 100 gr",
    "price": 2.49,
    "purchasePrice": 2.36019,
    "stock": 27,
    "category": "Accueil",
    "sku": "SKU-1634",
    "barcode": "1634",
    "imageUrl": "http://almoune.fr/img/p/3/4/6/4/3464.jpg",
    "price_per_kg": 2.49
  },
  {
    "id": "csv-1635",
    "name": "Baklava cajou fabriqués au Liban en vrac 6 pièces ≈ 150 gr",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 28,
    "category": "Accueil",
    "sku": "SKU-1635",
    "barcode": "1635",
    "imageUrl": "http://almoune.fr/img/p/3/4/6/6/3466.jpg",
    "price_per_kg": 3.75
  },
  {
    "id": "csv-1636",
    "name": "Baklava cajou fabriqués au Liban en vrac 12 pièces ≈ 300 gr",
    "price": 7.49,
    "purchasePrice": 7.099526,
    "stock": 24,
    "category": "Accueil",
    "sku": "SKU-1636",
    "barcode": "1636",
    "imageUrl": "http://almoune.fr/img/p/3/4/6/8/3468.jpg",
    "price_per_kg": 7.49
  },
  {
    "id": "csv-1638",
    "name": "crème d'ail - Mille Olives 200 gr",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1638",
    "barcode": "1638",
    "imageUrl": "http://almoune.fr/img/p/3/4/8/3/3483.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1639",
    "name": "Jello ou gelée fraise halal - Domo 85 gr",
    "price": 1.09,
    "purchasePrice": 1.033175,
    "stock": 44,
    "category": "Accueil",
    "sku": "SKU-1639",
    "barcode": "1639",
    "imageUrl": "http://almoune.fr/img/p/3/5/0/1/3501.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1640",
    "name": "Jello ou gelée ananas halal - Domo 85 gr",
    "price": 1.09,
    "purchasePrice": 1.033175,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1640",
    "barcode": "1640",
    "imageUrl": "http://almoune.fr/img/p/3/5/0/6/3506.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1641",
    "name": "Haricots géants cuits en sauce tomate - Paliria 2 kg",
    "price": 17.5,
    "purchasePrice": 16.587678,
    "stock": -30,
    "category": "Conserves",
    "sku": "SKU-1641",
    "barcode": "1641",
    "imageUrl": "http://almoune.fr/img/p/3/4/7/9/3479.jpg",
    "price_per_kg": 17.5
  },
  {
    "id": "csv-1642",
    "name": "Houmous Tahina - Chtoura Garden 1 kg",
    "price": 0,
    "purchasePrice": 0,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1642",
    "barcode": "1642",
    "imageUrl": "http://almoune.fr/img/p/3/4/8/1/3481.jpg",
    "price_per_kg": 0
  },
  {
    "id": "csv-1643",
    "name": "Meghli (dessert oriental) - Al Rabih 400 gr",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 1,
    "category": "Gourmandises",
    "sku": "SKU-1643",
    "barcode": "1643",
    "imageUrl": "http://almoune.fr/img/p/3/5/0/9/3509.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1644",
    "name": "Mohalabia Domo 200 gr",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 1,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1644",
    "barcode": "1644",
    "imageUrl": "http://almoune.fr/img/p/3/4/8/8/3488.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1645",
    "name": "Meghli Domo 250 gr",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 1,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1645",
    "barcode": "1645",
    "imageUrl": "http://almoune.fr/img/p/3/5/3/4/3534.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1646",
    "name": "Préparation pour Falafel - Al Wadi 200 gr",
    "price": 2.35,
    "purchasePrice": 2.227488,
    "stock": 2,
    "category": "Légumineuses",
    "sku": "SKU-1646",
    "barcode": "1646",
    "imageUrl": "http://almoune.fr/img/p/3/4/9/0/3490.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1650",
    "name": "Freekeh Abido 500 gr",
    "price": 4.49,
    "purchasePrice": 4.976303,
    "stock": 36,
    "category": "Légumineuses et grains",
    "sku": "SKU-1650",
    "barcode": "1650",
    "imageUrl": "http://almoune.fr/img/p/3/4/9/4/3494.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1651",
    "name": "Baba Ghannoug Durra 370 gr",
    "price": 2.15,
    "purchasePrice": 2.037915,
    "stock": 24,
    "category": "Conserves",
    "sku": "SKU-1651",
    "barcode": "1651",
    "imageUrl": "http://almoune.fr/img/p/3/5/0/8/3508.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1652",
    "name": "Baba ghanouj Durra 850 gr",
    "price": 4.49,
    "purchasePrice": 4.255924,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1652",
    "barcode": "1652",
    "imageUrl": "http://almoune.fr/img/p/3/4/9/7/3497.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1653",
    "name": "Pois chiches cuits Picuezo 2.7 kg",
    "price": 7.99,
    "purchasePrice": 7.57346,
    "stock": -316,
    "category": "Conserves",
    "sku": "SKU-1653",
    "barcode": "1653",
    "imageUrl": "http://almoune.fr/img/p/3/4/9/5/3495.jpg",
    "price_per_kg": 7.99
  },
  {
    "id": "csv-1654",
    "name": "Pistaches extra grecques grillées sans sel - 250 gr",
    "price": 5.49,
    "purchasePrice": 5.203791,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-1654",
    "barcode": "1654",
    "imageUrl": "http://almoune.fr/img/p/3/5/1/2/3512.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1655",
    "name": "Pistaches de qualité grillées salées d'Iran - 250 gr",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1655",
    "barcode": "1655",
    "imageUrl": "http://almoune.fr/img/p/3/5/1/4/3514.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1656",
    "name": "Noix de cajou grillées salées du Brésil - 250 gr",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 78,
    "category": "Fruits à coques grillés",
    "sku": "SKU-1656",
    "barcode": "1656",
    "imageUrl": "http://almoune.fr/img/p/3/5/3/5/3535.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1657",
    "name": "Noix de cajou grillé Grand calibre sans sel - 250 gr",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1657",
    "barcode": "1657",
    "imageUrl": "http://almoune.fr/img/p/3/5/1/6/3516.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1658",
    "name": "Amandes grecques grillées sans sel - 250 gr",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 85,
    "category": "Fruits à coques grillés",
    "sku": "SKU-1658",
    "barcode": "1658",
    "imageUrl": "http://almoune.fr/img/p/3/5/1/7/3517.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1659",
    "name": "Amandes émondées frites aux fines herbes - 250 gr",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-1659",
    "barcode": "1659",
    "imageUrl": "http://almoune.fr/img/p/3/5/1/8/3518.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1660",
    "name": "Amandes émondées frites au paprika piquant - 250 gr",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-1660",
    "barcode": "1660",
    "imageUrl": "http://almoune.fr/img/p/3/5/1/9/3519.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1662",
    "name": "Baking powder Aruba 100 gr",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 5,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1662",
    "barcode": "1662",
    "imageUrl": "http://almoune.fr/img/p/3/5/3/2/3532.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1663",
    "name": "Nougats aux pistaches Douaihy 6 pièces - 150 gr",
    "price": 4.49,
    "purchasePrice": 4.255924,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1663",
    "barcode": "1663",
    "imageUrl": "http://almoune.fr/img/p/3/5/3/6/3536.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1664",
    "name": "Nougats libanais Douaihy (Malban) 6 pièces - 180 gr",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1664",
    "barcode": "1664",
    "imageUrl": "http://almoune.fr/img/p/3/5/3/8/3538.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1665",
    "name": "Nougat libanais à la pâte d’abricots séchés (qamareddine) Douaihy 6 pièces - 110 gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1665",
    "barcode": "1665",
    "imageUrl": "http://almoune.fr/img/p/3/5/3/9/3539.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1666",
    "name": "Assortiment de 15 pièces de nougats libanais Douaihy - 360 gr",
    "price": 9.95,
    "purchasePrice": 9.43128,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1666",
    "barcode": "1666",
    "imageUrl": "http://almoune.fr/img/p/3/5/2/7/3527.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1668",
    "name": "Moghrabieh qualité extra - Al Rashidi 900 gr",
    "price": 4.35,
    "purchasePrice": 4.123223,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-1668",
    "barcode": "1668",
    "imageUrl": "http://almoune.fr/img/p/3/5/4/3/3543.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1669",
    "name": "Sirop de Jallab Crowan 600 ml",
    "price": 5.49,
    "purchasePrice": 5.203791,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1669",
    "barcode": "1669",
    "imageUrl": "http://almoune.fr/img/p/3/5/4/2/3542.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1670",
    "name": "Assortiment de baklava Al Sultan 350 gr",
    "price": 15.5,
    "purchasePrice": 14.691943,
    "stock": 0,
    "category": "Baklava",
    "sku": "SKU-1670",
    "barcode": "1670",
    "imageUrl": "http://almoune.fr/img/p/3/5/8/5/3585.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1672",
    "name": "Jus de pomme pétillant BIO Duo Santé 275 ml",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Jus",
    "sku": "SKU-1672",
    "barcode": "1672",
    "imageUrl": "http://almoune.fr/img/p/3/5/4/4/3544.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1673",
    "name": "Mojito sans alcool Vida Pop 275 ml",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -71,
    "category": "Jus",
    "sku": "SKU-1673",
    "barcode": "1673",
    "imageUrl": "http://almoune.fr/img/p/3/5/4/5/3545.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1674",
    "name": "Gressins kaak au thym ou zaatar - Soler's 140 gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-1674",
    "barcode": "1674",
    "imageUrl": "http://almoune.fr/img/p/3/5/6/4/3564.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1675",
    "name": "Jus d'abricot Red Santé 250 ml",
    "price": 1.85,
    "purchasePrice": 1.753555,
    "stock": 6,
    "category": "Jus",
    "sku": "SKU-1675",
    "barcode": "1675",
    "imageUrl": "http://almoune.fr/img/p/3/5/4/6/3546.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1679",
    "name": "Sirop de rose Naturel Mymouné 50 cl",
    "price": 11.99,
    "purchasePrice": 11.364929,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-1679",
    "barcode": "1679",
    "imageUrl": "http://almoune.fr/img/p/3/5/4/7/3547.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1680",
    "name": "Sirop de mûres Naturel - Mymouné 50 cl",
    "price": 11.9,
    "purchasePrice": 11.279621,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-1680",
    "barcode": "1680",
    "imageUrl": "http://almoune.fr/img/p/3/5/4/8/3548.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1681",
    "name": "Coriandre déshydratée 103 gr",
    "price": 8.5,
    "purchasePrice": 8.056872,
    "stock": -1,
    "category": "Épices",
    "sku": "SKU-1681",
    "barcode": "1681",
    "imageUrl": "http://almoune.fr/img/p/3/5/5/6/3556.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1683",
    "name": "Jus de Grenade BIO Red Santé 250 ml",
    "price": 1.85,
    "purchasePrice": 1.753555,
    "stock": -2,
    "category": "Jus",
    "sku": "SKU-1683",
    "barcode": "1683",
    "imageUrl": "http://almoune.fr/img/p/3/5/4/9/3549.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1684",
    "name": "Boisson pétillante à la mangue Kazouza 1941 - 275 ml",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": 1,
    "category": "Jus",
    "sku": "SKU-1684",
    "barcode": "1684",
    "imageUrl": "http://almoune.fr/img/p/3/5/5/0/3550.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1685",
    "name": "Jus pétillant de grenade BIO Duo Santé 275 ml",
    "price": 1.85,
    "purchasePrice": 1.753555,
    "stock": -43,
    "category": "Jus",
    "sku": "SKU-1685",
    "barcode": "1685",
    "imageUrl": "http://almoune.fr/img/p/3/5/5/1/3551.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1686",
    "name": "Boisson pétillante au citron Kazouza 1941 - 275 ml",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": -156,
    "category": "Jus",
    "sku": "SKU-1686",
    "barcode": "1686",
    "imageUrl": "http://almoune.fr/img/p/3/5/5/2/3552.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1687",
    "name": "Bière sans alcool 0% Cedar's premium 275 ml",
    "price": 1.45,
    "purchasePrice": 1.374408,
    "stock": -66,
    "category": "Jus",
    "sku": "SKU-1687",
    "barcode": "1687",
    "imageUrl": "http://almoune.fr/img/p/3/5/5/3/3553.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1688",
    "name": "Boisson pétillante à la pastèque Kazouza 1941 - 275 ml",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": -105,
    "category": "Jus",
    "sku": "SKU-1688",
    "barcode": "1688",
    "imageUrl": "http://almoune.fr/img/p/3/5/5/4/3554.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1689",
    "name": "Boisson pétillante au tamarin Kazouza 1941 - 275 ml",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": -109,
    "category": "Jus",
    "sku": "kazouza",
    "barcode": "1689",
    "imageUrl": "http://almoune.fr/img/p/3/5/5/5/3555.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1690",
    "name": "Coriandre déshydratée en vrac 30 gr",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-1690",
    "barcode": "1690",
    "imageUrl": "http://almoune.fr/img/p/3/5/5/7/3557.jpg",
    "price_per_kg": 2.5
  },
  {
    "id": "csv-1692",
    "name": "Haricots géants en sauce tomate - Paliria 280 gr",
    "price": 2.66,
    "purchasePrice": 2.521327,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1692",
    "barcode": "1692",
    "imageUrl": "http://almoune.fr/img/p/3/7/3/6/3736.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1693",
    "name": "Graines de Tournesol Grillées Sans Sel AlFakhr 150g",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 1,
    "category": "Apéritifs et pain",
    "sku": "SKU-1693",
    "barcode": "1693",
    "imageUrl": "http://almoune.fr/img/p/4/4/3/1/4431.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1696",
    "name": "Fruits secs grillés premium mix - Al Kazzi 220 gr",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-1696",
    "barcode": "1696",
    "imageUrl": "http://almoune.fr/img/p/3/7/3/7/3737.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1697",
    "name": "Safran d'Iran meilleure qualité du marché 0,5 gr",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1697",
    "barcode": "1697",
    "imageUrl": "http://almoune.fr/img/p/3/5/6/6/3566.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1698",
    "name": "Persil déshydraté Ducros 65 gr",
    "price": 4,
    "purchasePrice": 3.791469,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-1698",
    "barcode": "1698",
    "imageUrl": "http://almoune.fr/img/p/3/6/3/1/3631.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1699",
    "name": "Riz basmati Kaalar XXL 5kg",
    "price": 21,
    "purchasePrice": 19.905213,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-1699",
    "barcode": "1699",
    "imageUrl": "http://almoune.fr/img/p/3/5/8/3/3583.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1702",
    "name": "Farine de blé T.55 Minoterie Matignon 1 kg",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": -310,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1702",
    "barcode": "1702",
    "imageUrl": "http://almoune.fr/img/p/3/5/8/4/3584.jpg",
    "price_per_kg": 1.75
  },
  {
    "id": "csv-1704",
    "name": "Almaza bière blonde du Liban 33 cl",
    "price": 3.39,
    "purchasePrice": 2.825,
    "stock": 94,
    "category": "Bières",
    "sku": "SKU-1704",
    "barcode": "1704",
    "imageUrl": "http://almoune.fr/img/p/3/5/8/2/3582.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1705",
    "name": "Pistaches décortiquées tranchées 500 gr",
    "price": 18.89,
    "purchasePrice": 17.905213,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1705",
    "barcode": "1705",
    "imageUrl": "http://almoune.fr/img/p/3/5/8/8/3588.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1706",
    "name": "Zhourat ou Tisane libanaise aux herbes et aux amandes - Gardenia100 gr",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-1706",
    "barcode": "1706",
    "imageUrl": "http://almoune.fr/img/p/3/5/9/0/3590.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1707",
    "name": "Courgettes farcies Chtoura Garden 350 gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1707",
    "barcode": "1707",
    "imageUrl": "http://almoune.fr/img/p/4/2/5/1/4251.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1708",
    "name": "Pistaches décortiquées tranchées / kg",
    "price": 34,
    "purchasePrice": 32.227488,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1708",
    "barcode": "1708",
    "imageUrl": "http://almoune.fr/img/p/3/5/9/6/3596.jpg",
    "price_per_kg": 34
  },
  {
    "id": "csv-1709",
    "name": "Fèves cuites Cortas 850 gr",
    "price": 2.2,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1709",
    "barcode": "1709",
    "imageUrl": "http://almoune.fr/img/p/3/5/9/9/3599.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1710",
    "name": "Vin rouge Coteaux du Liban - Rouge passion 2016 - 75 cl",
    "price": 8.75,
    "purchasePrice": 8.75,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1710",
    "barcode": "1710",
    "imageUrl": "http://almoune.fr/img/p/3/6/0/3/3603.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1711",
    "name": "Arak Gantous 50 cl",
    "price": 21.5,
    "purchasePrice": 23.333333,
    "stock": -2,
    "category": "Arack ou Arak Libanais",
    "sku": "SKU-1711",
    "barcode": "1711",
    "imageUrl": "http://almoune.fr/img/p/3/6/0/6/3606.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1712",
    "name": "Vin blanc IXSIR - Altitudes 2022 - 75 cl",
    "price": 15.99,
    "purchasePrice": 13.325,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-1712",
    "barcode": "1712",
    "imageUrl": "http://almoune.fr/img/p/3/6/0/5/3605.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1713",
    "name": "Vin rosé Altitudes - IXSIR 2019 - 75 cl",
    "price": 15.99,
    "purchasePrice": 13.325,
    "stock": 20,
    "category": "Accueil",
    "sku": "SKU-1713",
    "barcode": "1713",
    "imageUrl": "http://almoune.fr/img/p/3/6/0/7/3607.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1714",
    "name": "Vin rouge Altitudes - IXSIR 2020 - 75 cl",
    "price": 15.99,
    "purchasePrice": 13.325,
    "stock": 36,
    "category": "Accueil",
    "sku": "SKU-1714",
    "barcode": "1714",
    "imageUrl": "http://almoune.fr/img/p/3/6/0/8/3608.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1715",
    "name": "Manouché zaatar croustillant - Soler's 180 gr",
    "price": 3.69,
    "purchasePrice": 3.49763,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-1715",
    "barcode": "1715",
    "imageUrl": "http://almoune.fr/img/p/3/6/0/9/3609.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1716",
    "name": "Arak libanais Brun 70 cl",
    "price": 32,
    "purchasePrice": 26.666667,
    "stock": -7,
    "category": "Arack ou Arak Libanais",
    "sku": "SKU-1716",
    "barcode": "1716",
    "imageUrl": "http://almoune.fr/img/p/3/6/1/0/3610.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1717",
    "name": "Vin rouge Bretèches 2020 - Château Kefraya 75 cl",
    "price": 11.85,
    "purchasePrice": 9.875,
    "stock": -44,
    "category": "Accueil",
    "sku": "SKU-1717",
    "barcode": "1717",
    "imageUrl": "http://almoune.fr/img/p/3/6/1/1/3611.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1718",
    "name": "Vin blanc Bretèches 2022 - Château Kefraya 75 cl",
    "price": 11.85,
    "purchasePrice": 9.875,
    "stock": -61,
    "category": "Accueil",
    "sku": "SKU-1718",
    "barcode": "1718",
    "imageUrl": "http://almoune.fr/img/p/3/6/1/2/3612.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1719",
    "name": "Vin rosé Bretèches 2022 - Château Kefraya 75 cl",
    "price": 11.85,
    "purchasePrice": 9.875,
    "stock": -18,
    "category": "Accueil",
    "sku": "SKU-1719",
    "barcode": "1719",
    "imageUrl": "http://almoune.fr/img/p/3/6/1/3/3613.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1720",
    "name": "Café Haseeb super Extra à la cardamome 200 gr",
    "price": 5.49,
    "purchasePrice": 5.203791,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-1720",
    "barcode": "1720",
    "imageUrl": "http://almoune.fr/img/p/3/6/2/5/3625.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1722",
    "name": "Foul medammas Chtoura Garden 475 gr",
    "price": 1.65,
    "purchasePrice": 1.563981,
    "stock": -22,
    "category": "Conserves",
    "sku": "SKU-1722",
    "barcode": "1722",
    "imageUrl": "http://almoune.fr/img/p/3/6/2/1/3621.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1723",
    "name": "Fèves cuites avec pois chiches Chtoura Garden 475 gr",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 42,
    "category": "Conserves",
    "sku": "SKU-1723",
    "barcode": "1723",
    "imageUrl": "http://almoune.fr/img/p/3/6/2/3/3623.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1724",
    "name": "Fèves cuites (foul mdamas seda) de qualité supérieure en saumure - California Garden 400 gr",
    "price": 1.54,
    "purchasePrice": 1.459716,
    "stock": 184,
    "category": "Conserves",
    "sku": "SKU-1724",
    "barcode": "1724",
    "imageUrl": "http://almoune.fr/img/p/3/6/2/6/3626.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1725",
    "name": "Foul (fèves cuites) recette saoudienne - California Garden 400 gr",
    "price": 1.54,
    "purchasePrice": 1.459716,
    "stock": 37,
    "category": "Conserves",
    "sku": "SKU-1725",
    "barcode": "1725",
    "imageUrl": "http://almoune.fr/img/p/3/6/2/7/3627.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1726",
    "name": "Citrons noirs séchés \"Loumi\" - Namazi 150 gr",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 10,
    "category": "Epices",
    "sku": "SKU-1726",
    "barcode": "1726",
    "imageUrl": "http://almoune.fr/img/p/3/6/2/8/3628.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1727",
    "name": "Cookies chocolat blanc Al Fakhr - 12 pièces",
    "price": 6.25,
    "purchasePrice": 5.924171,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1727",
    "barcode": "1727",
    "imageUrl": "http://almoune.fr/img/p/3/6/3/3/3633.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1728",
    "name": "Cookies chocolat au lait Al Fakhr - 12 pièces",
    "price": 5.25,
    "purchasePrice": 4.976303,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1728",
    "barcode": "1728",
    "imageUrl": "http://almoune.fr/img/p/3/6/3/4/3634.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1729",
    "name": "Eau de rose Cortas 500 ml",
    "price": 4.6,
    "purchasePrice": 3.833333,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-1729",
    "barcode": "1729",
    "imageUrl": "http://almoune.fr/img/p/3/6/2/9/3629.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1730",
    "name": "Thon à l'huile 185 gr",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1730",
    "barcode": "1730",
    "imageUrl": "http://almoune.fr/img/p/3/6/4/0/3640.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1731",
    "name": "Gomme arabique ambrée - en vrac - 100 gr",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1731",
    "barcode": "1731",
    "imageUrl": "http://almoune.fr/img/p/3/6/3/6/3636.jpg",
    "price_per_kg": 1.99
  },
  {
    "id": "csv-1732",
    "name": "Houmous tahina - Chtoura Garden 1kg",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1732",
    "barcode": "1732",
    "imageUrl": "http://almoune.fr/img/p/3/6/4/1/3641.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1733",
    "name": "Mélange de fruits à coque grillés salés - qualité premium en vrac - 250 gr",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-1733",
    "barcode": "1733",
    "imageUrl": "http://almoune.fr/img/p/3/6/3/2/3632.jpg",
    "price_per_kg": 4.99
  },
  {
    "id": "csv-1735",
    "name": "Eau de roses  Al Baraka 250 ml",
    "price": 2.95,
    "purchasePrice": 2.796209,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1735",
    "barcode": "1735",
    "imageUrl": "http://almoune.fr/img/p/3/6/3/5/3635.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1741",
    "name": "Mélasse de caroube naturelle - Gardénia 330 gr",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Mélasses et miels",
    "sku": "SKU-1741",
    "barcode": "1741",
    "imageUrl": "http://almoune.fr/img/p/3/6/3/7/3637.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1742",
    "name": "Mélange de fruits à coque goût fumé - qualité premium en vrac - 250 gr",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-1742",
    "barcode": "1742",
    "imageUrl": "http://almoune.fr/img/p/3/6/3/8/3638.jpg",
    "price_per_kg": 4.99
  },
  {
    "id": "csv-1743",
    "name": "Arak Jawary 75 cl",
    "price": 29.99,
    "purchasePrice": 24.991667,
    "stock": 0,
    "category": "Arack ou Arak Libanais",
    "sku": "SKU-1743",
    "barcode": "1743",
    "imageUrl": "http://almoune.fr/img/p/3/6/4/4/3644.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1744",
    "name": "Vin rouge Château les Cèdres 2014 - Domaine Wardy - 75 cl",
    "price": 27.5,
    "purchasePrice": 22.916667,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1744",
    "barcode": "1744",
    "imageUrl": "http://almoune.fr/img/p/3/6/4/5/3645.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1745",
    "name": "Vin rouge 2018 - Domaine Wardy - 75 cl",
    "price": 11.99,
    "purchasePrice": 9.991667,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1745",
    "barcode": "1745",
    "imageUrl": "http://almoune.fr/img/p/3/6/5/3/3653.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1746",
    "name": "Vin blanc 2019 - Domaine Wardy - 75 cl",
    "price": 13.64,
    "purchasePrice": 11.364929,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1746",
    "barcode": "1746",
    "imageUrl": "http://almoune.fr/img/p/3/6/5/4/3654.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1747",
    "name": "Cafetière libanaise en inox (Rakwe) - 4 tasses",
    "price": 0,
    "purchasePrice": 0,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-1747",
    "barcode": "1747",
    "imageUrl": "http://almoune.fr/img/p/3/6/5/5/3655.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1748",
    "name": "Cafetière libanaise en inox (Rakwe) - 5 tasses",
    "price": 0,
    "purchasePrice": 0,
    "stock": 1,
    "category": "Cafés",
    "sku": "SKU-1748",
    "barcode": "1748",
    "imageUrl": "http://almoune.fr/img/p/3/6/5/7/3657.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1749",
    "name": "Cafetière libanaise en inox (Rakwe) - 6 tasses",
    "price": 0,
    "purchasePrice": 0,
    "stock": 1,
    "category": "Cafés",
    "sku": "SKU-1749",
    "barcode": "1749",
    "imageUrl": "http://almoune.fr/img/p/3/6/5/8/3658.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1750",
    "name": "Cafetière libanaise en inox (Rakwe) - 7 tasses",
    "price": 0,
    "purchasePrice": 0,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-1750",
    "barcode": "1750",
    "imageUrl": "http://almoune.fr/img/p/3/6/6/8/3668.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1751",
    "name": "Cafetière libanaise en inox (Rakwe) - 8 tasses",
    "price": 0,
    "purchasePrice": 0,
    "stock": 1,
    "category": "Cafés",
    "sku": "SKU-1751",
    "barcode": "1751",
    "imageUrl": "http://almoune.fr/img/p/3/6/6/9/3669.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1752",
    "name": "Cafetière libanaise émaillée (Rakwe) verte  - 10 tasses",
    "price": 0,
    "purchasePrice": 0,
    "stock": 1,
    "category": "Cafés",
    "sku": "SKU-1752",
    "barcode": "1752",
    "imageUrl": "http://almoune.fr/img/p/3/6/7/2/3672.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1753",
    "name": "Cafétière libanaise émaillée (Rakwe) verte - 8 tasses",
    "price": 0,
    "purchasePrice": 0,
    "stock": 1,
    "category": "Cafés",
    "sku": "SKU-1753",
    "barcode": "1753",
    "imageUrl": "http://almoune.fr/img/p/3/6/7/1/3671.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1754",
    "name": "Cafetière libanaise émaillée (Rakwe) verte - 4 tasses",
    "price": 0,
    "purchasePrice": 0,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-1754",
    "barcode": "1754",
    "imageUrl": "http://almoune.fr/img/p/3/6/7/3/3673.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1755",
    "name": "12 tasses à café libanaises (dorées)",
    "price": 0,
    "purchasePrice": 0,
    "stock": 1,
    "category": "Cafés",
    "sku": "SKU-1755",
    "barcode": "1755",
    "imageUrl": "http://almoune.fr/img/p/3/6/6/4/3664.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1756",
    "name": "12 tasses à café libanaises (bleues)",
    "price": 0,
    "purchasePrice": 0,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-1756",
    "barcode": "1756",
    "imageUrl": "http://almoune.fr/img/p/3/6/6/3/3663.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1757",
    "name": "Castania Qualité Premium - 300 gr",
    "price": 0,
    "purchasePrice": 0,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-1757",
    "barcode": "1757",
    "imageUrl": "http://almoune.fr/img/p/3/6/4/2/3642.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1759",
    "name": "Vin blanc coteaux du Liban - Blanc Finesse 2020 - 75 cl",
    "price": 12.25,
    "purchasePrice": 10.208333,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1759",
    "barcode": "1759",
    "imageUrl": "http://almoune.fr/img/p/3/6/7/4/3674.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1760",
    "name": "Mélange de fruits à coque grillés salés - Al Fakhr 900 gr",
    "price": 17.9,
    "purchasePrice": 16.966825,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-1760",
    "barcode": "1760",
    "imageUrl": "http://almoune.fr/img/p/3/6/5/9/3659.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1761",
    "name": "Freekeh Chtoura Fields 800gr.",
    "price": 6.85,
    "purchasePrice": 6.492891,
    "stock": 0,
    "category": "Légumineuses et grains",
    "sku": "SKU-1761",
    "barcode": "1761",
    "imageUrl": "http://almoune.fr/img/p/3/6/4/7/3647.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1762",
    "name": "Chips de pita au zaatar - Soler's 150 gr",
    "price": 3.69,
    "purchasePrice": 3.49763,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-1762",
    "barcode": "1762",
    "imageUrl": "http://almoune.fr/img/p/3/6/6/6/3666.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1763",
    "name": "Batônnets de dattes au son de blé - Soler's 260 gr",
    "price": 3.69,
    "purchasePrice": 3.49763,
    "stock": -1,
    "category": "Gourmandises",
    "sku": "SKU-1763",
    "barcode": "1763",
    "imageUrl": "http://almoune.fr/img/p/3/6/4/9/3649.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1764",
    "name": "Tahini Arkan 400gr.",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1764",
    "barcode": "1764",
    "imageUrl": "http://almoune.fr/img/p/3/6/6/0/3660.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1765",
    "name": "Zaatar Halabi rouge - Alnasser 400gr.",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1765",
    "barcode": "1765",
    "imageUrl": "http://almoune.fr/img/p/3/6/7/5/3675.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1766",
    "name": "Bamiyan, okra, gombo 800gr Diwan",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1766",
    "barcode": "1766",
    "imageUrl": "http://almoune.fr/img/p/3/6/5/2/3652.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1767",
    "name": "Sumac Naturel 1Kg",
    "price": 10.8,
    "purchasePrice": 10.236967,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-1767",
    "barcode": "1767",
    "imageUrl": "http://almoune.fr/img/p/3/6/5/1/3651.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1773",
    "name": "Jus en poudre à l'orange - Ice Refreshing 400 gr",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -1,
    "category": "Jus en poudre instantanée",
    "sku": "SKU-1773",
    "barcode": "1773",
    "imageUrl": "http://almoune.fr/img/p/3/6/7/6/3676.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1774",
    "name": "Jus en poudre mangue 12 sachets - Ice Refreshing 360 gr",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -1,
    "category": "Jus en poudre instantanée",
    "sku": "SKU-1774",
    "barcode": "1774",
    "imageUrl": "http://almoune.fr/img/p/3/6/7/7/3677.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1782",
    "name": "Maamoul aux dates et semoule - Aghati 1kg",
    "price": 27.5,
    "purchasePrice": 26.066351,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1782",
    "barcode": "1782",
    "imageUrl": "http://almoune.fr/img/p/3/6/8/5/3685.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1783",
    "name": "Chatta Boulos 300 gr.",
    "price": 4.15,
    "purchasePrice": 3.933649,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1783",
    "barcode": "1783",
    "imageUrl": "http://almoune.fr/img/p/3/7/3/8/3738.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1784",
    "name": "Sahlab DOMO 200 gr.",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1784",
    "barcode": "1784",
    "imageUrl": "http://almoune.fr/img/p/3/7/3/9/3739.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1785",
    "name": "Craquelins aux olives - Soler's 180 gr",
    "price": 3.69,
    "purchasePrice": 3.49763,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-1785",
    "barcode": "1785",
    "imageUrl": "http://almoune.fr/img/p/3/6/6/7/3667.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1787",
    "name": "Thym Mixte Alep (Zaatar Halabi vert)  - Al Osrah 400 g",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1787",
    "barcode": "1787",
    "imageUrl": "http://almoune.fr/img/p/3/6/7/9/3679.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1789",
    "name": "Café Moulu à la Cardamome - Najjar 450g",
    "price": 9.85,
    "purchasePrice": 9.336493,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-1789",
    "barcode": "1789",
    "imageUrl": "http://almoune.fr/img/p/3/7/4/0/3740.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1790",
    "name": "Pâte de piments - Hikayat 660 gr",
    "price": 3.55,
    "purchasePrice": 3.364929,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1790",
    "barcode": "1790",
    "imageUrl": "http://almoune.fr/img/p/3/7/4/4/3744.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1795",
    "name": "Sirop de rose Chtoura 75cl",
    "price": 7.25,
    "purchasePrice": 6.872038,
    "stock": 25,
    "category": "Accueil",
    "sku": "SKU-1795",
    "barcode": "1795",
    "imageUrl": "http://almoune.fr/img/p/3/7/4/5/3745.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1796",
    "name": "Mloukhieh feuilles entières- Chtoura Garden 800gr",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1796",
    "barcode": "1796",
    "imageUrl": "http://almoune.fr/img/p/3/7/7/7/3777.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1797",
    "name": "Mloukhieh  feuilles hachées - Chtoura Garden 800gr",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 12,
    "category": "Conserves",
    "sku": "SKU-1797",
    "barcode": "1797",
    "imageUrl": "http://almoune.fr/img/p/3/7/7/6/3776.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1798",
    "name": "Verjus (Hamod el Hosrom) - Chtoura Garden 250 mL",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Huiles et vinaigres",
    "sku": "SKU-1798",
    "barcode": "1798",
    "imageUrl": "http://almoune.fr/img/p/3/7/7/0/3770.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1804",
    "name": "Pistaches d'Iran crues décortiquées - O'Regal 500gr",
    "price": 19.9,
    "purchasePrice": 18.862559,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1804",
    "barcode": "1804",
    "imageUrl": "http://almoune.fr/img/p/3/7/4/7/3747.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1809",
    "name": "Menthe séchée en vrac 500gr.",
    "price": 7.75,
    "purchasePrice": 7.345972,
    "stock": -25,
    "category": "Épices",
    "sku": "SKU-1809",
    "barcode": "1809",
    "imageUrl": "http://almoune.fr/img/p/3/9/3/2/3932.jpg",
    "price_per_kg": 7.75
  },
  {
    "id": "csv-1810",
    "name": "Épices taouk ou tawouk Abido 500gr.",
    "price": 9.75,
    "purchasePrice": 9.241706,
    "stock": -9,
    "category": "Épices",
    "sku": "SKU-1810",
    "barcode": "1810",
    "imageUrl": "http://almoune.fr/img/p/3/8/3/3/3833.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1811",
    "name": "Poivre noir 250gr.",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-1811",
    "barcode": "1811",
    "imageUrl": "http://almoune.fr/img/p/3/8/3/4/3834.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1814",
    "name": "Okra (gombo) séchés Algota - 400 gr",
    "price": 11.49,
    "purchasePrice": 10.890995,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-1814",
    "barcode": "1814",
    "imageUrl": "http://almoune.fr/img/p/3/7/0/3/3703.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1815",
    "name": "Jus en poudre mûre 12 sachets - Ice Refreshing 360 gr",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 4,
    "category": "Jus en poudre instantanée",
    "sku": "SKU-1815",
    "barcode": "1815",
    "imageUrl": "http://almoune.fr/img/p/3/7/0/4/3704.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1816",
    "name": "Jus en poudre citron 12 sachets - Ice Refreshing 360 gr",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Jus en poudre instantanée",
    "sku": "SKU-1816",
    "barcode": "1816",
    "imageUrl": "http://almoune.fr/img/p/3/7/0/5/3705.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1817",
    "name": "Jus en poudre cocktail 12 sachets - Ice Refreshing 360 gr",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -13,
    "category": "Jus en poudre instantanée",
    "sku": "SKU-1817",
    "barcode": "1817",
    "imageUrl": "http://almoune.fr/img/p/3/7/0/6/3706.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1818",
    "name": "Pois chiches secs Mexicain grand calibre 500 gr",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Légumineuses",
    "sku": "SKU-1818",
    "barcode": "1818",
    "imageUrl": "http://almoune.fr/img/p/3/7/0/8/3708.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1819",
    "name": "Amandes Carmel crues en vrac 500 gr",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1819",
    "barcode": "1819",
    "imageUrl": "http://almoune.fr/img/p/3/7/0/9/3709.jpg",
    "price_per_kg": 5.5
  },
  {
    "id": "csv-1825",
    "name": "Bonbons lucioles acidulées Halal 90 g",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 24,
    "category": "Friandises",
    "sku": "SKU-1825",
    "barcode": "1825",
    "imageUrl": "http://almoune.fr/img/p/4/2/9/4/4294.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1826",
    "name": "Salade mechouïa piquante - Fantasia 350 g",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-1826",
    "barcode": "1826",
    "imageUrl": "http://almoune.fr/img/p/3/7/5/3/3753.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1827",
    "name": "Salade mechouïa douce - Fantasia 350 g",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-1827",
    "barcode": "1827",
    "imageUrl": "http://almoune.fr/img/p/3/7/5/2/3752.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1828",
    "name": "Riz long parfumé en vrac 1kg",
    "price": 2.39,
    "purchasePrice": 2.265403,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1828",
    "barcode": "1828",
    "imageUrl": "http://almoune.fr/img/p/3/7/5/4/3754.jpg",
    "price_per_kg": 2.39
  },
  {
    "id": "csv-1829",
    "name": "Riz Basmati Inde 5 kg",
    "price": 13.5,
    "purchasePrice": 12.796209,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1829",
    "barcode": "1829",
    "imageUrl": "http://almoune.fr/img/p/3/7/5/7/3757.jpg",
    "price_per_kg": 13.5
  },
  {
    "id": "csv-1830",
    "name": "Pistaches décortiquées 200 g",
    "price": 6.49,
    "purchasePrice": 6.151659,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1830",
    "barcode": "1830",
    "imageUrl": "http://almoune.fr/img/p/3/7/5/5/3755.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1831",
    "name": "Pignons de pin de Sibérie 200 g",
    "price": 7.99,
    "purchasePrice": 7.57346,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1831",
    "barcode": "1831",
    "imageUrl": "http://almoune.fr/img/p/3/7/5/6/3756.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1832",
    "name": "Pâtes capellini N°3 - Savino 500 g",
    "price": 1.29,
    "purchasePrice": 1.222749,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-1832",
    "barcode": "1832",
    "imageUrl": "http://almoune.fr/img/p/3/7/5/8/3758.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1833",
    "name": "Fusili bio au blé complet 500 g",
    "price": 1.45,
    "purchasePrice": 1.374408,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-1833",
    "barcode": "1833",
    "imageUrl": "http://almoune.fr/img/p/3/7/5/9/3759.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1834",
    "name": "Coquillettes bio 500 g",
    "price": 1.39,
    "purchasePrice": 1.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1834",
    "barcode": "1834",
    "imageUrl": "http://almoune.fr/img/p/3/7/6/0/3760.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1836",
    "name": "Halva pistaches Grec - Olympos 400 g",
    "price": 5.5,
    "purchasePrice": 4.583333,
    "stock": 8,
    "category": "Halawa",
    "sku": "SKU-1836",
    "barcode": "1836",
    "imageUrl": "http://almoune.fr/img/p/3/7/6/1/3761.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1837",
    "name": "Halva vanille grec Olympos 400 g",
    "price": 4.49,
    "purchasePrice": 3.741667,
    "stock": 10,
    "category": "Halawa",
    "sku": "SKU-1837",
    "barcode": "1837",
    "imageUrl": "http://almoune.fr/img/p/3/7/6/2/3762.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1838",
    "name": "NESCAFÉ® 2 en 1 sans sucre (x30 sticks)",
    "price": 11.49,
    "purchasePrice": 10.890995,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-1838",
    "barcode": "1838",
    "imageUrl": "http://almoune.fr/img/p/3/7/6/3/3763.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1839",
    "name": "Pois chiches cuits au naturel - Chtoura Garden 400 gr",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": 93,
    "category": "Conserves",
    "sku": "SKU-1839",
    "barcode": "1839",
    "imageUrl": "http://almoune.fr/img/p/3/7/6/4/3764.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1840",
    "name": "Fruits secs grillés fumés qualité premium - Al Fakhr 900gr.",
    "price": 17.9,
    "purchasePrice": 16.966825,
    "stock": 58,
    "category": "Fruits à coques grillés",
    "sku": "SKU-1840",
    "barcode": "1840",
    "imageUrl": "http://almoune.fr/img/p/3/7/6/7/3767.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1844",
    "name": "Mélange d'olives dénoyautées - Fresh 150gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1844",
    "barcode": "1844",
    "imageUrl": "http://almoune.fr/img/p/3/7/6/8/3768.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1845",
    "name": "Wafer sticks chocolat-noisettes - Bolero 400 gr.",
    "price": 3.75,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1845",
    "barcode": "1845",
    "imageUrl": "http://almoune.fr/img/p/3/7/6/9/3769.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1848",
    "name": "Zaatar halabi vert - Alarjawi 500 gr",
    "price": 3.35,
    "purchasePrice": 3.175355,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1848",
    "barcode": "1848",
    "imageUrl": "http://almoune.fr/img/p/3/7/4/1/3741.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1849",
    "name": "Okra (gombo) séchés petite taille - Algota 200 gr",
    "price": 8.49,
    "purchasePrice": 8.047393,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-1849",
    "barcode": "1849",
    "imageUrl": "http://almoune.fr/img/p/3/7/4/9/3749.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1851",
    "name": "Mouloukhiyé séchée - Wassim 200 gr",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Légumineuses",
    "sku": "SKU-1851",
    "barcode": "1851",
    "imageUrl": "http://almoune.fr/img/p/3/7/7/2/3772.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1852",
    "name": "Aubergines façon moussaka à l'huile d'olive- Chtoura Garden 380 gr",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1852",
    "barcode": "1852",
    "imageUrl": "http://almoune.fr/img/p/3/8/5/1/3851.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1853",
    "name": "Halva extra pistaches - Al Burj 800 gr",
    "price": 13.99,
    "purchasePrice": 13.260664,
    "stock": -7,
    "category": "Halawa",
    "sku": "SKU-1853",
    "barcode": "1853",
    "imageUrl": "http://almoune.fr/img/p/3/7/7/5/3775.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1860",
    "name": "Poivre Noir entier en vrac 50g",
    "price": 1.35,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-1860",
    "barcode": "1860",
    "imageUrl": "http://almoune.fr/img/p/3/7/8/3/3783.jpg",
    "price_per_kg": 1.35
  },
  {
    "id": "csv-1861",
    "name": "Clous de Girofle Entiers en vrac 30g",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-1861",
    "barcode": "1861",
    "imageUrl": "http://almoune.fr/img/p/3/7/8/4/3784.jpg",
    "price_per_kg": 1.75
  },
  {
    "id": "csv-1862",
    "name": "Citrons Séchés Blancs (Loumi) 300 g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-1862",
    "barcode": "1862",
    "imageUrl": "http://almoune.fr/img/p/3/7/8/5/3785.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1866",
    "name": "Baba ghannouge - Al Wadi 385 gr.",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1866",
    "barcode": "1866",
    "imageUrl": "http://almoune.fr/img/p/3/7/8/8/3788.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1867",
    "name": "Foul Bajela California Garden 400gr",
    "price": 1.54,
    "purchasePrice": 1.459716,
    "stock": 71,
    "category": "Conserves",
    "sku": "SKU-1867",
    "barcode": "1867",
    "imageUrl": "http://almoune.fr/img/p/3/7/8/9/3789.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1873",
    "name": "Foul au piment - California Garden 400 gr",
    "price": 1.54,
    "purchasePrice": 1.459716,
    "stock": 30,
    "category": "Accueil",
    "sku": "SKU-1873",
    "barcode": "1873",
    "imageUrl": "http://almoune.fr/img/p/3/7/9/0/3790.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1874",
    "name": "Loukoum libanais au mastic - Shahin 500gr",
    "price": 7.99,
    "purchasePrice": 7.57346,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1874",
    "barcode": "1874",
    "imageUrl": "http://almoune.fr/img/p/3/7/9/2/3792.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1875",
    "name": "Melasse de raisin 800gr.",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-1875",
    "barcode": "1875",
    "imageUrl": "http://almoune.fr/img/p/4/1/0/8/4108.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1876",
    "name": "Nido lait entier en poudre 1.8 kg",
    "price": 30.99,
    "purchasePrice": 29.374408,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-1876",
    "barcode": "1876",
    "imageUrl": "http://almoune.fr/img/p/3/7/9/4/3794.jpg",
    "price_per_kg": 30.99
  },
  {
    "id": "csv-1877",
    "name": "Boulghour fin blanc premium quality - Chtoura Fields 900 gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Boulghour",
    "sku": "SKU-1877",
    "barcode": "1877",
    "imageUrl": "http://almoune.fr/img/p/3/7/9/5/3795.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1878",
    "name": "Vermicelles - Macaronto 500 gr",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1878",
    "barcode": "1878",
    "imageUrl": "http://almoune.fr/img/p/3/7/9/6/3796.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1880",
    "name": "Raha ou Loukoum au mastic - Bissat 400 gr.",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-1880",
    "barcode": "1880",
    "imageUrl": "http://almoune.fr/img/p/3/8/0/1/3801.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1884",
    "name": "Kaak Asroune - Al furno 180g",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -13,
    "category": "Accueil",
    "sku": "SKU-1884",
    "barcode": "1884",
    "imageUrl": "http://almoune.fr/img/p/3/7/9/7/3797.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1890",
    "name": "Baklava Hallab Mixte 450gr.",
    "price": 20.9,
    "purchasePrice": 19.810427,
    "stock": 0,
    "category": "Baklava",
    "sku": "SKU-1890",
    "barcode": "1890",
    "imageUrl": "http://almoune.fr/img/p/3/8/8/0/3880.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1891",
    "name": "Baklava Mixte Hallab 900gr.",
    "price": 37.9,
    "purchasePrice": 35.924171,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-1891",
    "barcode": "1891",
    "imageUrl": "http://almoune.fr/img/p/3/8/4/7/3847.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1894",
    "name": "Mélasse de dattes - Wassim 500gr.",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Mélasses et miels",
    "sku": "SKU-1894",
    "barcode": "1894",
    "imageUrl": "http://almoune.fr/img/p/3/8/0/0/3800.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1899",
    "name": "Maamoul Raha Hamdan 20x20gr",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Gâteaux - Biscuits orientaux",
    "sku": "SKU-1899",
    "barcode": "1899",
    "imageUrl": "http://almoune.fr/img/p/3/8/4/4/3844.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1900",
    "name": "Barazek Hamdan 350gr",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Gâteaux - Biscuits orientaux",
    "sku": "SKU-1900",
    "barcode": "1900",
    "imageUrl": "http://almoune.fr/img/p/3/8/4/2/3842.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1901",
    "name": "Riz BAsmati Abu Kass 4.5kg",
    "price": 21.9,
    "purchasePrice": 20.758294,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-1901",
    "barcode": "1901",
    "imageUrl": "http://almoune.fr/img/p/4/3/1/0/4310.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1906",
    "name": "Courgette séché Rosana 24 pieces",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-1906",
    "barcode": "1906",
    "imageUrl": "http://almoune.fr/img/p/4/2/6/3/4263.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1907",
    "name": "Basboussa Noix de coco - Holw el Sham",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 11,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1907",
    "barcode": "1907",
    "imageUrl": "http://almoune.fr/img/p/3/8/4/0/3840.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1911",
    "name": "Barazek Douaihy 400gr",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": 1,
    "category": "Gourmandises",
    "sku": "SKU-1911",
    "barcode": "1911",
    "imageUrl": "http://almoune.fr/img/p/3/8/2/2/3822.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1912",
    "name": "Maamoul sachets individuels Douaihy 350 gr",
    "price": 13.5,
    "purchasePrice": 12.796209,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1912",
    "barcode": "1912",
    "imageUrl": "http://almoune.fr/img/p/3/9/2/7/3927.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1913",
    "name": "Baklava sachet individuel Douaihy 600 gr",
    "price": 23.9,
    "purchasePrice": 22.654028,
    "stock": 0,
    "category": "Baklava",
    "sku": "SKU-1913",
    "barcode": "1913",
    "imageUrl": "http://almoune.fr/img/p/3/8/3/8/3838.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1914",
    "name": "Assortiment de baklava en sachets individuels - Douaihy 350g",
    "price": 15.5,
    "purchasePrice": 14.691943,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1914",
    "barcode": "1914",
    "imageUrl": "http://almoune.fr/img/p/3/8/3/9/3839.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1915",
    "name": "Assortiment de maamoul sachets individuels - Douaihy 600gr.",
    "price": 18.5,
    "purchasePrice": 17.535545,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1915",
    "barcode": "1915",
    "imageUrl": "http://almoune.fr/img/p/3/9/2/4/3924.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1916",
    "name": "Barazek Al Rawda 700g",
    "price": 9.99,
    "purchasePrice": 9.469194,
    "stock": 0,
    "category": "Gâteaux - Biscuits orientaux",
    "sku": "SKU-1916",
    "barcode": "1916",
    "imageUrl": "http://almoune.fr/img/p/3/8/2/0/3820.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1917",
    "name": "Makdousse Baladna 950g",
    "price": 9.99,
    "purchasePrice": 9.469194,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-1917",
    "barcode": "1917",
    "imageUrl": "http://almoune.fr/img/p/3/8/2/1/3821.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1918",
    "name": "Savon d'Alep 100% naturel - Al Halabi 200g",
    "price": 2.5,
    "purchasePrice": 2.083333,
    "stock": 4,
    "category": "Autres",
    "sku": "SKU-1918",
    "barcode": "1918",
    "imageUrl": "http://almoune.fr/img/p/3/8/1/9/3819.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1921",
    "name": "Concombre sauvage Gardenia 600gr.",
    "price": 5.95,
    "purchasePrice": 5.63981,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-1921",
    "barcode": "1921",
    "imageUrl": "http://almoune.fr/img/p/3/8/8/4/3884.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1922",
    "name": "Concombres marinés Boulos 650gr.",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-1922",
    "barcode": "1922",
    "imageUrl": "http://almoune.fr/img/p/3/8/8/3/3883.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1923",
    "name": "Crème d'ail à la Libanaise - Flavva 200g",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1923",
    "barcode": "1923",
    "imageUrl": "http://almoune.fr/img/p/3/8/8/5/3885.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1924",
    "name": "Concombres sauvages marinés - Cortas 3000g.",
    "price": 8.75,
    "purchasePrice": 8.293839,
    "stock": 23,
    "category": "Légumes Marinés",
    "sku": "SKU-1924",
    "barcode": "1924",
    "imageUrl": "http://almoune.fr/img/p/3/8/1/7/3817.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1925",
    "name": "Baking Powder Gardenia 100gr",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 11,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1925",
    "barcode": "1925",
    "imageUrl": "http://almoune.fr/img/p/3/8/8/2/3882.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1926",
    "name": "Epice Shawarma viande Gardenia 454 gr",
    "price": 10.5,
    "purchasePrice": 9.952607,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-1926",
    "barcode": "1926",
    "imageUrl": "http://almoune.fr/img/p/3/8/1/6/3816.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1927",
    "name": "Epices kafta Gardenia 50gr.",
    "price": 1.7,
    "purchasePrice": 1.611374,
    "stock": -17,
    "category": "Épices",
    "sku": "SKU-1927",
    "barcode": "1927",
    "imageUrl": "http://almoune.fr/img/p/3/8/1/3/3813.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1928",
    "name": "Epices Kebbeh Gardenia 454gr.",
    "price": 10.5,
    "purchasePrice": 9.952607,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1928",
    "barcode": "1928",
    "imageUrl": "http://almoune.fr/img/p/3/8/1/5/3815.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1929",
    "name": "Epice  ou pétale de Carthame 20gr.",
    "price": 1.85,
    "purchasePrice": 1.753555,
    "stock": 17,
    "category": "Accueil",
    "sku": "SKU-1929",
    "barcode": "1929",
    "imageUrl": "http://almoune.fr/img/p/3/8/1/4/3814.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1930",
    "name": "Sept épices Gardenia 50gr.",
    "price": 1.7,
    "purchasePrice": 1.611374,
    "stock": 11,
    "category": "Accueil",
    "sku": "SKU-1930",
    "barcode": "1930",
    "imageUrl": "http://almoune.fr/img/p/3/8/1/2/3812.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1932",
    "name": "Sumac Dean Gourmet 1kg",
    "price": 15,
    "purchasePrice": 14.218009,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-1932",
    "barcode": "1932",
    "imageUrl": "http://almoune.fr/img/p/3/8/3/7/3837.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1939",
    "name": "Pois chiches en bocal - Faïza 400g",
    "price": 2.2,
    "purchasePrice": 2.085308,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-1939",
    "barcode": "1939",
    "imageUrl": "http://almoune.fr/img/p/3/8/0/2/3802.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1942",
    "name": "Ketchup Durra 450gr",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-1942",
    "barcode": "1942",
    "imageUrl": "http://almoune.fr/img/p/3/8/0/5/3805.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1943",
    "name": "Ketchup doux -Durra 500g",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-1943",
    "barcode": "1943",
    "imageUrl": "http://almoune.fr/img/p/3/8/0/4/3804.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1944",
    "name": "Préparation pour falafel - Durra 175g.",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 39,
    "category": "Légumineuses et grains",
    "sku": "SKU-1944",
    "barcode": "1944",
    "imageUrl": "http://almoune.fr/img/p/3/8/0/3/3803.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1945",
    "name": "Keshek bocal Pito 700gr.",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 2,
    "category": "Aliments et Laitiers",
    "sku": "SKU-1945",
    "barcode": "1945",
    "imageUrl": "http://almoune.fr/img/p/3/8/2/5/3825.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1946",
    "name": "Colorant bleu pour oeuf de Pâques et pâtisserie ANATOLI 3g avec gants",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": 27,
    "category": "Autres",
    "sku": "SKU-1946",
    "barcode": "1946",
    "imageUrl": "http://almoune.fr/img/p/3/8/0/7/3807.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1948",
    "name": "Figues séchées Evias moelleuses (nouvelle récolte) - 1 kg",
    "price": 15.95,
    "purchasePrice": 15.118483,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1948",
    "barcode": "1948",
    "imageUrl": "http://almoune.fr/img/p/3/8/2/6/3826.jpg",
    "price_per_kg": 15.95
  },
  {
    "id": "csv-1949",
    "name": "Zaatar libanais - Second House 500g",
    "price": 6.25,
    "purchasePrice": 5.924171,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-1949",
    "barcode": "1949",
    "imageUrl": "http://almoune.fr/img/p/3/8/2/4/3824.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1952",
    "name": "Vin blanc de l'observatoire - Ksara 75 cl",
    "price": 9.5,
    "purchasePrice": 7.916667,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1952",
    "barcode": "1952",
    "imageUrl": "http://almoune.fr/img/p/3/8/2/7/3827.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1953",
    "name": "Vin rosé de Ksara - Ksara 75 cl",
    "price": 9.5,
    "purchasePrice": 7.916667,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-1953",
    "barcode": "1953",
    "imageUrl": "http://almoune.fr/img/p/3/8/2/9/3829.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1954",
    "name": "Vin rouge du prieuré - Ksara 75 cl",
    "price": 9.5,
    "purchasePrice": 7.916667,
    "stock": 22,
    "category": "Accueil",
    "sku": "SKU-1954",
    "barcode": "1954",
    "imageUrl": "http://almoune.fr/img/p/3/8/3/1/3831.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1958",
    "name": "Zaatar rouge d'Alep 1kg",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-1958",
    "barcode": "1958",
    "imageUrl": "http://almoune.fr/img/p/3/9/2/3/3923.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1959",
    "name": "Mélange pour falafel - Abido 200g",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1959",
    "barcode": "1959",
    "imageUrl": "http://almoune.fr/img/p/3/9/2/2/3922.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1960",
    "name": "Riz Basmati XXL 4.5kg Mahmood",
    "price": 20.95,
    "purchasePrice": 19.85782,
    "stock": -13,
    "category": "Accueil",
    "sku": "SKU-1960",
    "barcode": "1960",
    "imageUrl": "http://almoune.fr/img/p/3/9/2/1/3921.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1961",
    "name": "Sauce piquante Rana 100ml",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Condiments",
    "sku": "SKU-1961",
    "barcode": "1961",
    "imageUrl": "http://almoune.fr/img/p/3/9/2/0/3920.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1962",
    "name": "Navets marinés Durra 1.4 kg",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-1962",
    "barcode": "1962",
    "imageUrl": "http://almoune.fr/img/p/3/9/1/9/3919.jpg",
    "price_per_kg": 3.5
  },
  {
    "id": "csv-1963",
    "name": "Mélasse de grenade Chtoura 250 ml",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Mélasses et miels",
    "sku": "SKU-1963",
    "barcode": "1963",
    "imageUrl": "http://almoune.fr/img/p/3/9/1/8/3918.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1966",
    "name": "Arak Mijana Crystal 500ml",
    "price": 23.5,
    "purchasePrice": 19.583333,
    "stock": 0,
    "category": "Arack ou Arak Libanais",
    "sku": "SKU-1966",
    "barcode": "1966",
    "imageUrl": "http://almoune.fr/img/p/3/8/5/2/3852.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1967",
    "name": "Arak Ksara 35cl",
    "price": 21.5,
    "purchasePrice": 17.916667,
    "stock": 0,
    "category": "Arack ou Arak Libanais",
    "sku": "SKU-1967",
    "barcode": "1967",
    "imageUrl": "http://almoune.fr/img/p/3/8/5/3/3853.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1968",
    "name": "Mélasse de grenade Al Wadi 680g",
    "price": 5.99,
    "purchasePrice": 5.677725,
    "stock": 0,
    "category": "Mélasses et miels",
    "sku": "SKU-1968",
    "barcode": "1968",
    "imageUrl": "http://almoune.fr/img/p/3/8/5/4/3854.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1969",
    "name": "Tahini (crème de sésame) - Kasih 900gr.",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1969",
    "barcode": "1969",
    "imageUrl": "http://almoune.fr/img/p/3/8/4/9/3849.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1971",
    "name": "Crème Chantilly 7ébgr - Domo 72g",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-1971",
    "barcode": "1971",
    "imageUrl": "http://almoune.fr/img/p/3/8/5/5/3855.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1972",
    "name": "Riz Basmati XXL 907gr Mahmood",
    "price": 3.95,
    "purchasePrice": 3.744076,
    "stock": 20,
    "category": "Accueil",
    "sku": "SKU-1972",
    "barcode": "1972",
    "imageUrl": "http://almoune.fr/img/p/3/8/5/0/3850.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1973",
    "name": "Kaak boulette Alforno 400gr.",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1973",
    "barcode": "1973",
    "imageUrl": "http://almoune.fr/img/p/3/8/7/5/3875.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1975",
    "name": "Castania Super Extra vert 450gr",
    "price": 9.95,
    "purchasePrice": 9.43128,
    "stock": 5,
    "category": "Fruits à coques grillés",
    "sku": "SKU-1975",
    "barcode": "1975",
    "imageUrl": "http://almoune.fr/img/p/3/8/3/6/3836.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1976",
    "name": "Nestlé lait concentré sucré 305mL",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-1976",
    "barcode": "1976",
    "imageUrl": "http://almoune.fr/img/p/3/8/7/9/3879.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1977",
    "name": "Epices Makloubeh 50gr Abido",
    "price": 1.6,
    "purchasePrice": 1.516588,
    "stock": -1,
    "category": "Épices",
    "sku": "SKU-1977",
    "barcode": "1977",
    "imageUrl": "http://almoune.fr/img/p/3/8/7/8/3878.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1978",
    "name": "Anis étoilé 30gr. Abido",
    "price": 1.85,
    "purchasePrice": 1.753555,
    "stock": -2,
    "category": "Épice brute",
    "sku": "SKU-1978",
    "barcode": "1978",
    "imageUrl": "http://almoune.fr/img/p/3/8/7/7/3877.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1979",
    "name": "Epices Kleija 50gr Abido",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 2,
    "category": "Épices",
    "sku": "SKU-1979",
    "barcode": "1979",
    "imageUrl": "http://almoune.fr/img/p/3/8/7/4/3874.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1980",
    "name": "Ail en tranches déshydraté 50gr Abido",
    "price": 1.79,
    "purchasePrice": 1.696682,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1980",
    "barcode": "1980",
    "imageUrl": "http://almoune.fr/img/p/3/8/7/6/3876.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1982",
    "name": "Légumes au vinaigre Gardenia 600g",
    "price": 3.89,
    "purchasePrice": 3.687204,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-1982",
    "barcode": "1982",
    "imageUrl": "http://almoune.fr/img/p/3/8/4/8/3848.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1984",
    "name": "Fèves sèches gros calibre 800g",
    "price": 3.89,
    "purchasePrice": 3.687204,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-1984",
    "barcode": "1984",
    "imageUrl": "http://almoune.fr/img/p/3/8/7/3/3873.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1995",
    "name": "Loacker gaufrettes aux noisettes 12 pièces 540g",
    "price": 10.5,
    "purchasePrice": 9.952607,
    "stock": 7,
    "category": "Gourmandises",
    "sku": "SKU-1995",
    "barcode": "1995",
    "imageUrl": "http://almoune.fr/img/p/3/8/5/8/3858.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1996",
    "name": "Loacker gaufrette aux noisettes 1 pièce 45g",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": -2,
    "category": "Gourmandises",
    "sku": "SKU-1996",
    "barcode": "1996",
    "imageUrl": "http://almoune.fr/img/p/3/8/5/7/3857.jpg",
    "price_per_kg": 1
  },
  {
    "id": "csv-1997",
    "name": "Caprice gaufrettes fourrées aux noisttes - Papadopoulos 400g",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 11,
    "category": "Gourmandises",
    "sku": "SKU-1997",
    "barcode": "1997",
    "imageUrl": "http://almoune.fr/img/p/3/8/5/6/3856.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1998",
    "name": "Baklava luxury Jordanien premium - Skystar 500gr",
    "price": 29,
    "purchasePrice": 27.488152,
    "stock": 0,
    "category": "Baklava",
    "sku": "SKU-1998",
    "barcode": "1998",
    "imageUrl": "http://almoune.fr/img/p/3/8/5/9/3859.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1999",
    "name": "Baklava luxury Jordanien premium - Skystar 200gr.",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": 0,
    "category": "Baklava",
    "sku": "SKU-1999",
    "barcode": "1999",
    "imageUrl": "http://almoune.fr/img/p/3/8/6/1/3861.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2002",
    "name": "Halawa pistaches - Durra 700g",
    "price": 7.65,
    "purchasePrice": 7.251185,
    "stock": 0,
    "category": "Halawa",
    "sku": "SKU-2002",
    "barcode": "2002",
    "imageUrl": "http://almoune.fr/img/p/3/8/6/2/3862.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2003",
    "name": "Halawa nature - Durra 700g",
    "price": 5.99,
    "purchasePrice": 5.677725,
    "stock": 0,
    "category": "Halawa",
    "sku": "SKU-2003",
    "barcode": "2003",
    "imageUrl": "http://almoune.fr/img/p/3/8/6/4/3864.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2004",
    "name": "Aubergines grillées - Durra 650g",
    "price": 4.65,
    "purchasePrice": 4.407583,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-2004",
    "barcode": "2004",
    "imageUrl": "http://almoune.fr/img/p/3/8/6/6/3866.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2005",
    "name": "Café Najjar nature 450g",
    "price": 9.45,
    "purchasePrice": 8.957346,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2005",
    "barcode": "2005",
    "imageUrl": "http://almoune.fr/img/p/3/8/6/7/3867.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2006",
    "name": "Baba ghanouj (caviar d’aubergines libanais) - Al Wadi 820g",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": 0,
    "category": "Entrées-Mezzé",
    "sku": "SKU-2006",
    "barcode": "2006",
    "imageUrl": "http://almoune.fr/img/p/3/8/6/8/3868.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2007",
    "name": "Arôme de fleur d'oranger - Al Wadi 500 ml",
    "price": 4.65,
    "purchasePrice": 4.407583,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2007",
    "barcode": "2007",
    "imageUrl": "http://almoune.fr/img/p/3/8/6/9/3869.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2008",
    "name": "Graines de citrouille - Krikita 220 g",
    "price": 4.49,
    "purchasePrice": 4.255924,
    "stock": 6,
    "category": "Apéritifs et pain",
    "sku": "SKU-2008",
    "barcode": "2008",
    "imageUrl": "http://almoune.fr/img/p/4/3/4/0/4340.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2009",
    "name": "Arôme de fleur d'oranger - Al Wadi 300 ml",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 34,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-2009",
    "barcode": "2009",
    "imageUrl": "http://almoune.fr/img/p/3/8/7/2/3872.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2021",
    "name": "Assortiment de baklava - Hallab 650g",
    "price": 29.9,
    "purchasePrice": 28.341232,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2021",
    "barcode": "2021",
    "imageUrl": "http://almoune.fr/img/p/3/8/8/6/3886.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2023",
    "name": "Hummus pimenté exceptionnellement authentique - Flavva 200g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2023",
    "barcode": "2023",
    "imageUrl": "http://almoune.fr/img/p/3/8/8/7/3887.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2024",
    "name": "Caviar d'aubergine à la libanaise exceptionnellement authentique - Flavva 200g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Entrées-Mezzé",
    "sku": "SKU-2024",
    "barcode": "2024",
    "imageUrl": "http://almoune.fr/img/p/3/8/9/1/3891.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2025",
    "name": "Hummus betterave exceptionnellement authentique - Flavva 200g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Entrées-Mezzé",
    "sku": "SKU-2025",
    "barcode": "2025",
    "imageUrl": "http://almoune.fr/img/p/3/8/8/8/3888.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2026",
    "name": "Hummus au basilic exceptionnellement authentique - Flavva 200g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Entrées-Mezzé",
    "sku": "SKU-2026",
    "barcode": "2026",
    "imageUrl": "http://almoune.fr/img/p/3/8/8/9/3889.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2027",
    "name": "Hummus à l'ail exceptionnellement authentique - Flavva 200g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Entrées-Mezzé",
    "sku": "SKU-2027",
    "barcode": "2027",
    "imageUrl": "http://almoune.fr/img/p/3/8/9/0/3890.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2030",
    "name": "Café Haseeb Deluxe Cardamome édition Diamond - 500g",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-2030",
    "barcode": "2030",
    "imageUrl": "http://almoune.fr/img/p/3/9/0/6/3906.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2031",
    "name": "Baklava syrien fabrication artisanale 450g.",
    "price": 22.5,
    "purchasePrice": 21.327014,
    "stock": 0,
    "category": "Baklava",
    "sku": "SKU-2031",
    "barcode": "2031",
    "imageUrl": "http://almoune.fr/img/p/3/8/9/3/3893.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2032",
    "name": "Baklava syrien fabrication artisanale 900gr.",
    "price": 34.9,
    "purchasePrice": 33.080569,
    "stock": 0,
    "category": "Baklava",
    "sku": "SKU-2032",
    "barcode": "2032",
    "imageUrl": "http://almoune.fr/img/p/3/8/9/7/3897.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2033",
    "name": "Baklava syrien fabrication artisanale 2Kg - Eich el bolbol pistaches.",
    "price": 70,
    "purchasePrice": 66.350711,
    "stock": 0,
    "category": "Baklava",
    "sku": "SKU-2033",
    "barcode": "2033",
    "imageUrl": "http://almoune.fr/img/p/3/9/0/0/3900.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2034",
    "name": "Baklava syrien fabrication artisanale 2Kg - Mabrouma aux pistaches",
    "price": 70,
    "purchasePrice": 66.350711,
    "stock": 0,
    "category": "Baklava",
    "sku": "SKU-2034",
    "barcode": "2034",
    "imageUrl": "http://almoune.fr/img/p/3/9/0/2/3902.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2035",
    "name": "Hummus aux poivrons exceptionnellement authentique - Flavva 200g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Entrées-Mezzé",
    "sku": "SKU-2035",
    "barcode": "2035",
    "imageUrl": "http://almoune.fr/img/p/3/9/0/7/3907.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2036",
    "name": "Sept épices Gardenia en bocal 125g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-2036",
    "barcode": "2036",
    "imageUrl": "http://almoune.fr/img/p/3/9/0/8/3908.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2037",
    "name": "Vin rouge Ksara et mélange fruits secs Castania",
    "price": 22.65,
    "purchasePrice": 21.469194,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2037",
    "barcode": "2037",
    "imageUrl": "http://almoune.fr/img/p/3/9/0/9/3909.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2038",
    "name": "Baklava Hallab Mixte 450gr.",
    "price": 20.9,
    "purchasePrice": 19.810427,
    "stock": 17,
    "category": "Baklava",
    "sku": "SKU-2038",
    "barcode": "2038",
    "imageUrl": "http://almoune.fr/img/p/3/9/1/1/3911.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2040",
    "name": "Baklava Douaihy Edition spéciale Love 450g",
    "price": 23.5,
    "purchasePrice": 22.274882,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-2040",
    "barcode": "2040",
    "imageUrl": "http://almoune.fr/img/p/3/9/3/0/3930.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2041",
    "name": "Baklava Premium book édition spéciale - Douaihy 700g",
    "price": 32.5,
    "purchasePrice": 37.819905,
    "stock": 0,
    "category": "Baklava",
    "sku": "SKU-2041",
    "barcode": "2041",
    "imageUrl": "http://almoune.fr/img/p/3/9/2/9/3929.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2042",
    "name": "Makdous d'aubergines - Baladna  600g",
    "price": 8.95,
    "purchasePrice": 8.483412,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-2042",
    "barcode": "2042",
    "imageUrl": "http://almoune.fr/img/p/3/9/3/1/3931.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2045",
    "name": "Rare miel d’Eryngo (Chawke) du Liban - L’atelier du miel 230g",
    "price": 17.9,
    "purchasePrice": 16.966825,
    "stock": 0,
    "category": "Mélasses et miels",
    "sku": "SKU-2045",
    "barcode": "2045",
    "imageUrl": "http://almoune.fr/img/p/3/9/3/3/3933.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2046",
    "name": "Délicieux miel de thym du Liban - L'atelier du miel 230g",
    "price": 17.5,
    "purchasePrice": 16.587678,
    "stock": 3,
    "category": "Mélasses et miels",
    "sku": "SKU-2046",
    "barcode": "2046",
    "imageUrl": "http://almoune.fr/img/p/3/9/4/1/3941.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2047",
    "name": "Grand miel de chêne du Liban - L'atelier du miel  230g",
    "price": 19.9,
    "purchasePrice": 18.862559,
    "stock": 4,
    "category": "Mélasses et miels",
    "sku": "SKU-2047",
    "barcode": "2047",
    "imageUrl": "http://almoune.fr/img/p/3/9/3/4/3934.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2048",
    "name": "Miel de cèdre du Liban goût exceptionnel - L'atelier du miel 230g",
    "price": 19.9,
    "purchasePrice": 18.862559,
    "stock": 0,
    "category": "Mélasses et miels",
    "sku": "SKU-2048",
    "barcode": "2048",
    "imageUrl": "http://almoune.fr/img/p/3/9/3/5/3935.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2049",
    "name": "Miel d'agrumes libanais - L'atelier du miel 230g",
    "price": 17.5,
    "purchasePrice": 16.587678,
    "stock": 0,
    "category": "Mélasses et miels",
    "sku": "SKU-2049",
    "barcode": "2049",
    "imageUrl": "http://almoune.fr/img/p/3/9/3/6/3936.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2050",
    "name": "Confiture de figue  au miel 50% - L'atelier du miel 230gr.",
    "price": 13.5,
    "purchasePrice": 12.796209,
    "stock": 0,
    "category": "Confitures",
    "sku": "SKU-2050",
    "barcode": "2050",
    "imageUrl": "http://almoune.fr/img/p/3/9/3/8/3938.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2051",
    "name": "Confiture d'abricot au miel 50% - L'atelier du miel 230g",
    "price": 13.5,
    "purchasePrice": 12.796209,
    "stock": 2,
    "category": "Confitures",
    "sku": "SKU-2051",
    "barcode": "2051",
    "imageUrl": "http://almoune.fr/img/p/3/9/3/9/3939.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2052",
    "name": "Confiture de fraise au miel 50% - L'atelier du miel",
    "price": 13.5,
    "purchasePrice": 12.796209,
    "stock": 0,
    "category": "Confitures",
    "sku": "SKU-2052",
    "barcode": "2052",
    "imageUrl": "http://almoune.fr/img/p/3/9/4/0/3940.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2053",
    "name": "Coffret dégustation 3 variétés de miels libanais - L'atelier du miel 3 x 30g",
    "price": 13.5,
    "purchasePrice": 12.796209,
    "stock": 0,
    "category": "Mélasses et miels",
    "sku": "SKU-2053",
    "barcode": "2053",
    "imageUrl": "http://almoune.fr/img/p/3/9/3/7/3937.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2056",
    "name": "Assortiment de baklava libanais - Douaihy édition ruban - 500gr.",
    "price": 17.5,
    "purchasePrice": 16.587678,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-2056",
    "barcode": "2056",
    "imageUrl": "http://almoune.fr/img/p/3/9/4/4/3944.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2057",
    "name": "Barbe à papa fraise, banane, myrtille - Lazez 50g",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-2057",
    "barcode": "2057",
    "imageUrl": "http://almoune.fr/img/p/3/9/4/2/3942.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2060",
    "name": "Aubergine grillée à l'huile - Savino 225gr",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 10,
    "category": "Conserves",
    "sku": "SKU-2060",
    "barcode": "2060",
    "imageUrl": "http://almoune.fr/img/p/3/9/4/5/3945.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2061",
    "name": "Artichauts grillés à l'huile 225gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 8,
    "category": "Conserves",
    "sku": "SKU-2061",
    "barcode": "2061",
    "imageUrl": "http://almoune.fr/img/p/3/9/4/6/3946.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2062",
    "name": "Sardines à l'huile de tournesol 125gr",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-2062",
    "barcode": "2062",
    "imageUrl": "http://almoune.fr/img/p/3/9/4/7/3947.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2063",
    "name": "Sardines pimentées 125gr",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2063",
    "barcode": "2063",
    "imageUrl": "http://almoune.fr/img/p/3/9/4/8/3948.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2064",
    "name": "Cerneaux de noix extra - Wassim 400g",
    "price": 4.36,
    "purchasePrice": 4.132701,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-2064",
    "barcode": "2064",
    "imageUrl": "http://almoune.fr/img/p/3/9/5/7/3957.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2065",
    "name": "Kaak croustillants thym sésame - Al Forno 400g",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2065",
    "barcode": "2065",
    "imageUrl": "http://almoune.fr/img/p/3/9/4/9/3949.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2066",
    "name": "Kaak croustillants au sésame (korchelli) - Al Forno 400g",
    "price": 2.99,
    "purchasePrice": 3.554502,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2066",
    "barcode": "2066",
    "imageUrl": "http://almoune.fr/img/p/3/9/5/0/3950.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2067",
    "name": "Café moulu libanais - Maatouk 200g",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-2067",
    "barcode": "2067",
    "imageUrl": "http://almoune.fr/img/p/3/9/5/1/3951.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2068",
    "name": "Coffee mate light - Nestlé 450g",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Boissons",
    "sku": "SKU-2068",
    "barcode": "2068",
    "imageUrl": "http://almoune.fr/img/p/3/9/5/2/3952.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2069",
    "name": "Kaak libanais - Chamsine 320g",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2069",
    "barcode": "2069",
    "imageUrl": "http://almoune.fr/img/p/3/9/5/3/3953.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2070",
    "name": "Choco Prince - Lu 28,5g",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 8,
    "category": "Friandises",
    "sku": "SKU-2070",
    "barcode": "2070",
    "imageUrl": "http://almoune.fr/img/p/3/9/5/4/3954.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2071",
    "name": "Bouchées de pain - Moulin d'or 48 pièces 225g",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2071",
    "barcode": "2071",
    "imageUrl": "http://almoune.fr/img/p/3/9/5/5/3955.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2072",
    "name": "Tora Bika creamy latte - 20 x 30g",
    "price": 9.99,
    "purchasePrice": 9.469194,
    "stock": 3,
    "category": "Boissons",
    "sku": "SKU-2072",
    "barcode": "2072",
    "imageUrl": "http://almoune.fr/img/p/3/9/5/6/3956.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2075",
    "name": "Mélange d'épices pour barbecue - Abido 50g",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 7,
    "category": "Épices",
    "sku": "SKU-2075",
    "barcode": "2075",
    "imageUrl": "http://almoune.fr/img/p/3/9/6/0/3960.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2076",
    "name": "Epices Biryani - Abido 50g",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-2076",
    "barcode": "2076",
    "imageUrl": "http://almoune.fr/img/p/3/9/5/9/3959.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2077",
    "name": "Epices falafel - Gardenia 50g",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2077",
    "barcode": "2077",
    "imageUrl": "http://almoune.fr/img/p/3/9/5/8/3958.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2080",
    "name": "Concombres marinés - Gardenia 600g",
    "price": 5.95,
    "purchasePrice": 5.63981,
    "stock": -6,
    "category": "Légumes Marinés",
    "sku": "SKU-2080",
    "barcode": "2080",
    "imageUrl": "http://almoune.fr/img/p/3/9/6/4/3964.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2082",
    "name": "Olives noires libanaises - Cortas 625g",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2082",
    "barcode": "2082",
    "imageUrl": "http://almoune.fr/img/p/3/9/6/5/3965.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2084",
    "name": "Concombres marinés - Cortas 3kg",
    "price": 8.75,
    "purchasePrice": 8.293839,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-2084",
    "barcode": "2084",
    "imageUrl": "http://almoune.fr/img/p/3/9/6/8/3968.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2085",
    "name": "Wafer bar chocolat - Divani 5 x 30g",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 21,
    "category": "Friandises",
    "sku": "SKU-2085",
    "barcode": "2085",
    "imageUrl": "http://almoune.fr/img/p/3/9/7/0/3970.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2086",
    "name": "Cookies chocolat noir Al Fakhr - 12 pièces",
    "price": 6.25,
    "purchasePrice": 5.924171,
    "stock": 0,
    "category": "Friandises",
    "sku": "SKU-2086",
    "barcode": "2086",
    "imageUrl": "http://almoune.fr/img/p/3/9/6/9/3969.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2087",
    "name": "Wafer milk chocolat - Divani 5 x 30g",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 20,
    "category": "Friandises",
    "sku": "SKU-2087",
    "barcode": "2087",
    "imageUrl": "http://almoune.fr/img/p/3/9/7/1/3971.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2088",
    "name": "Foul mdamas - Fèves avec pois chiches en saumure - California Garden 400g",
    "price": 1.54,
    "purchasePrice": 1.459716,
    "stock": 80,
    "category": "Conserves",
    "sku": "SKU-2088",
    "barcode": "2088",
    "imageUrl": "http://almoune.fr/img/p/4/0/0/6/4006.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2089",
    "name": "Zaatar halabai rouge - Al Osrah 400gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-2089",
    "barcode": "2089",
    "imageUrl": "http://almoune.fr/img/p/3/9/7/3/3973.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2091",
    "name": "Mélange fruits à coques goût fromage - Al Fakhr 900 gr",
    "price": 17.9,
    "purchasePrice": 16.966825,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-2091",
    "barcode": "2091",
    "imageUrl": "http://almoune.fr/img/p/3/9/9/0/3990.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2097",
    "name": "5 sucettes assorties - Pierrot Gourmand",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 8,
    "category": "Friandises",
    "sku": "SKU-2097",
    "barcode": "2097",
    "imageUrl": "http://almoune.fr/img/p/3/9/7/6/3976.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2099",
    "name": "Sumac moulu - Spico 500gr.",
    "price": 5.25,
    "purchasePrice": 4.976303,
    "stock": 0,
    "category": "Épice brute",
    "sku": "SKU-2099",
    "barcode": "2099",
    "imageUrl": "http://almoune.fr/img/p/3/9/9/1/3991.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2101",
    "name": "Zaatar Halabi SHP 500gr",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2101",
    "barcode": "2101",
    "imageUrl": "http://almoune.fr/img/p/4/1/9/8/4198.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2102",
    "name": "Miel de forêt - Atiki 250gr",
    "price": 8.25,
    "purchasePrice": 7.819905,
    "stock": 0,
    "category": "Mélasses et miels",
    "sku": "SKU-2102",
    "barcode": "2102",
    "imageUrl": "http://almoune.fr/img/p/3/9/7/9/3979.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2103",
    "name": "Feuilles de vigne farcies pimentées - Paliria 280 gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2103",
    "barcode": "2103",
    "imageUrl": "http://almoune.fr/img/p/3/9/7/8/3978.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2104",
    "name": "Custard vanille - SHP 350 gr",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-2104",
    "barcode": "2104",
    "imageUrl": "http://almoune.fr/img/p/3/9/8/5/3985.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2106",
    "name": "Samneh ghee de chèvre et brebis - Two sheep 908 gr.",
    "price": 22.95,
    "purchasePrice": 21.753555,
    "stock": 2,
    "category": "Ghee - beurre clarifié - samneh",
    "sku": "SKU-2106",
    "barcode": "2106",
    "imageUrl": "http://almoune.fr/img/p/3/9/8/6/3986.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2107",
    "name": "Baba ghanouj (caviar d’aubergines libanais) - Alsaadah 400g",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 22,
    "category": "Conserves",
    "sku": "SKU-2107",
    "barcode": "2107",
    "imageUrl": "http://almoune.fr/img/p/3/9/8/7/3987.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2108",
    "name": "Mélange fruits à coques salés - Al Fakhr 500 gr",
    "price": 9.99,
    "purchasePrice": 9.469194,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-2108",
    "barcode": "2108",
    "imageUrl": "http://almoune.fr/img/p/3/9/8/8/3988.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2109",
    "name": "Mélange fruits à coques fumés - Al Fakhr 500 gr",
    "price": 9.99,
    "purchasePrice": 9.469194,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-2109",
    "barcode": "2109",
    "imageUrl": "http://almoune.fr/img/p/3/9/8/9/3989.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2118",
    "name": "Kaak croustillants anis sésame - Kameiha bakery 400 g",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2118",
    "barcode": "2118",
    "imageUrl": "http://almoune.fr/img/p/4/0/0/5/4005.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2119",
    "name": "Makdous farcies aux poivrons et aux noix - Boulos 600 g",
    "price": 9.75,
    "purchasePrice": 9.241706,
    "stock": 5,
    "category": "Légumes Marinés",
    "sku": "SKU-2119",
    "barcode": "2119",
    "imageUrl": "http://almoune.fr/img/p/4/0/0/8/4008.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2120",
    "name": "Boisson pétillante à la grenade  Kazouza 1941 - 275 ml",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": -32,
    "category": "Jus",
    "sku": "SKU-2120",
    "barcode": "2120",
    "imageUrl": "http://almoune.fr/img/p/4/0/1/0/4010.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2121",
    "name": "Bière sans alcool 0% Mexican Cedar's premium 275 ml",
    "price": 1.45,
    "purchasePrice": 1.374408,
    "stock": 143,
    "category": "Jus",
    "sku": "SKU-2121",
    "barcode": "2121",
    "imageUrl": "http://almoune.fr/img/p/3/9/9/6/3996.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2122",
    "name": "Bière à la pomme sans alcool 0% Cedar's premium 275 ml",
    "price": 1.45,
    "purchasePrice": 1.374408,
    "stock": -24,
    "category": "Accueil",
    "sku": "SKU-2122",
    "barcode": "2122",
    "imageUrl": "http://almoune.fr/img/p/3/9/9/7/3997.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2123",
    "name": "Bicarbonate de soude alimentaire - Gardenia 150g",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-2123",
    "barcode": "2123",
    "imageUrl": "http://almoune.fr/img/p/3/9/9/8/3998.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2124",
    "name": "Foul medammes Egyptien - Royal Hills 400 g",
    "price": 1.15,
    "purchasePrice": 1.090047,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-2124",
    "barcode": "2124",
    "imageUrl": "http://almoune.fr/img/p/3/9/9/9/3999.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2125",
    "name": "Légumes marinés mélangés Turcs - Yonca 680 g",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-2125",
    "barcode": "2125",
    "imageUrl": "http://almoune.fr/img/p/4/0/0/0/4000.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2126",
    "name": "Tomates séchées au soleil Turques - Yonca 680 g",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2126",
    "barcode": "2126",
    "imageUrl": "http://almoune.fr/img/p/4/0/0/1/4001.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2127",
    "name": "Mini piments forts Trurques - Yonca 660 g",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2127",
    "barcode": "2127",
    "imageUrl": "http://almoune.fr/img/p/4/0/0/2/4002.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2128",
    "name": "Huile d'olive libanaise - Chtoura mountain 750 ml",
    "price": 12.75,
    "purchasePrice": 12.085308,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2128",
    "barcode": "2128",
    "imageUrl": "http://almoune.fr/img/p/4/0/0/3/4003.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2129",
    "name": "Huile d'olive libanaise - Chtoura Mountain 4L",
    "price": 54.95,
    "purchasePrice": 52.085308,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2129",
    "barcode": "2129",
    "imageUrl": "http://almoune.fr/img/p/4/0/0/4/4004.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2133",
    "name": "Houmous tahina - Al Rabih 400g",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": -2,
    "category": "Entrées-Mezzé",
    "sku": "SKU-2133",
    "barcode": "2133",
    "imageUrl": "http://almoune.fr/img/p/4/0/1/6/4016.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2134",
    "name": "Graines de citrouille salées - Al Amira 300g",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": 0,
    "category": "Apéritifs et pain",
    "sku": "SKU-2134",
    "barcode": "2134",
    "imageUrl": "http://almoune.fr/img/p/4/0/1/8/4018.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2136",
    "name": "Zaatar Halabi rouge - Durra 400g",
    "price": 4.35,
    "purchasePrice": 4.123223,
    "stock": 12,
    "category": "Accueil",
    "sku": "SKU-2136",
    "barcode": "2136",
    "imageUrl": "http://almoune.fr/img/p/4/0/1/9/4019.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2137",
    "name": "Houmous tahina - Al Wadi 850g",
    "price": 3.65,
    "purchasePrice": 3.459716,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-2137",
    "barcode": "2137",
    "imageUrl": "http://almoune.fr/img/p/4/0/2/0/4020.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2138",
    "name": "Jello ou gelée ananas 5achtés +1 gratuit halal - Domo 85 gr",
    "price": 5.45,
    "purchasePrice": 5.165877,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-2138",
    "barcode": "2138",
    "imageUrl": "http://almoune.fr/img/p/4/0/1/2/4012.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2139",
    "name": "Jello ou gelée fraise 5 achetés + 1 gratuit  halal - Domo 85 gr",
    "price": 5.45,
    "purchasePrice": 5.165877,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-2139",
    "barcode": "2139",
    "imageUrl": "http://almoune.fr/img/p/4/0/1/5/4015.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2140",
    "name": "Chewing Gum au mastic - Ma'mon Sharawi 210g",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": 8,
    "category": "Gourmandises",
    "sku": "SKU-2140",
    "barcode": "2140",
    "imageUrl": "http://almoune.fr/img/p/4/0/2/9/4029.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2141",
    "name": "Pâte de tomate - Chtoura Garden 800gr.",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Concentrés",
    "sku": "SKU-2141",
    "barcode": "2141",
    "imageUrl": "http://almoune.fr/img/p/4/0/2/8/4028.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2142",
    "name": "Citrons noirs séchés \"Loumi\" - Alsaadah 150 gr",
    "price": 2.55,
    "purchasePrice": 2.417062,
    "stock": 0,
    "category": "Epices",
    "sku": "SKU-2142",
    "barcode": "2142",
    "imageUrl": "http://almoune.fr/img/p/4/0/2/7/4027.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2143",
    "name": "Maamoul aux pistaches - Al Sultan 500g",
    "price": 19.5,
    "purchasePrice": 18.483412,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-2143",
    "barcode": "2143",
    "imageUrl": "http://almoune.fr/img/p/4/0/3/6/4036.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2144",
    "name": "Assiette pour mezze en mélaminé grande taille - 1 pièce",
    "price": 4.25,
    "purchasePrice": 3.541667,
    "stock": 75,
    "category": "Autres",
    "sku": "SKU-2144",
    "barcode": "2144",
    "imageUrl": "http://almoune.fr/img/p/4/0/5/0/4050.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2148",
    "name": "Yerba maté argentin 100% naturel - Amanda 500.gr",
    "price": 7.25,
    "purchasePrice": 6.872038,
    "stock": 0,
    "category": "Boissons",
    "sku": "SKU-2148",
    "barcode": "2148",
    "imageUrl": "http://almoune.fr/img/p/4/0/5/4/4054.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2149",
    "name": "Kaak  Boules Extra - Moulin d'or 310g",
    "price": 4.95,
    "purchasePrice": 4.691943,
    "stock": 22,
    "category": "Accueil",
    "sku": "SKU-2149",
    "barcode": "2149",
    "imageUrl": "http://almoune.fr/img/p/4/0/5/2/4052.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2151",
    "name": "Cerneaux de noix Extra 1/4  - origine Chili - 500g",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-2151",
    "barcode": "2151",
    "imageUrl": "http://almoune.fr/img/p/4/0/5/5/4055.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2152",
    "name": "Olives vertes du Liban naturelles  - Chalhoub's Pantry 600gr.",
    "price": 4.49,
    "purchasePrice": 4.255924,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2152",
    "barcode": "2152",
    "imageUrl": "http://almoune.fr/img/p/4/0/7/0/4070.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2154",
    "name": "Olives Noires du Liban Naturelles - Chalhoub's Pantry 600gr.",
    "price": 4.49,
    "purchasePrice": 4.255924,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2154",
    "barcode": "2154",
    "imageUrl": "http://almoune.fr/img/p/4/0/6/9/4069.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2155",
    "name": "Mekte (concombres sauvages marinés) - Chalhoub's Pantry 600gr.",
    "price": 5.55,
    "purchasePrice": 5.260664,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-2155",
    "barcode": "2155",
    "imageUrl": "http://almoune.fr/img/p/4/0/6/8/4068.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2156",
    "name": "Concombre Mariné naturelle  - Chalhoub's Pantry 600gr.",
    "price": 5.55,
    "purchasePrice": 5.260664,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "SKU-2156",
    "barcode": "2156",
    "imageUrl": "http://almoune.fr/img/p/4/0/6/7/4067.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2157",
    "name": "Eau de fleurs d'oranger naturelle libanaise - Chalhoub's Pantry 250ml",
    "price": 7.99,
    "purchasePrice": 7.57346,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2157",
    "barcode": "2157",
    "imageUrl": "http://almoune.fr/img/p/4/0/6/3/4063.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2158",
    "name": "Mélasse de grenade naturelle artisanale 250 ml",
    "price": 7.49,
    "purchasePrice": 7.099526,
    "stock": 0,
    "category": "Grenade",
    "sku": "SKU-2158",
    "barcode": "2158",
    "imageUrl": "http://almoune.fr/img/p/4/0/5/7/4057.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2159",
    "name": "Makdous libanais à l'huile d'olive - Chalhoub's Pantry 370 gr",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Légumes Marinés",
    "sku": "Qualitée Exceptionnelle",
    "barcode": "2159",
    "imageUrl": "http://almoune.fr/img/p/4/0/6/6/4066.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2160",
    "name": "Confiture figues sésame libanaise - Chalhoub's Pantry 220g",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Confitures",
    "sku": "SKU-2160",
    "barcode": "2160",
    "imageUrl": "http://almoune.fr/img/p/4/0/6/5/4065.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2161",
    "name": "Confiture d'abricot artisanal libanaise - Chalhoub's Pantry 220g",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Confitures",
    "sku": "SKU-2161",
    "barcode": "2161",
    "imageUrl": "http://almoune.fr/img/p/4/0/6/4/4064.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2162",
    "name": "Sumac Naturel Libanais - Chalhoub's Pantry 40g",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-2162",
    "barcode": "2162",
    "imageUrl": "http://almoune.fr/img/p/4/0/6/2/4062.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2163",
    "name": "Graines d'anis naturelles du Liban - Chalhoub's Pantry 40gr.",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-2163",
    "barcode": "2163",
    "imageUrl": "http://almoune.fr/img/p/4/0/6/1/4061.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2164",
    "name": "Zaatar libanais naturel - Chalhoub's Pantry 100g",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2164",
    "barcode": "2164",
    "imageUrl": "http://almoune.fr/img/p/4/0/6/0/4060.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2165",
    "name": "Huile d'olive Du sud du Liban - Chalhoub's Pantry 750 ml",
    "price": 14.75,
    "purchasePrice": 13.981043,
    "stock": 0,
    "category": "Huiles et vinaigres",
    "sku": "SKU-2165",
    "barcode": "2165",
    "imageUrl": "http://almoune.fr/img/p/4/0/5/8/4058.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2171",
    "name": "Cumin Moulu Jasmeen 500g",
    "price": 9.99,
    "purchasePrice": 9.469194,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-2171",
    "barcode": "2171",
    "imageUrl": "http://almoune.fr/img/p/4/5/1/2/4512.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2186",
    "name": "Eau de fleur d'oranger Boulos 25cl",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 17,
    "category": "Accueil",
    "sku": "SKU-2186",
    "barcode": "2186",
    "imageUrl": "http://almoune.fr/img/p/4/1/4/4/4144.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2187",
    "name": "Nescafé 3 en 1 30 x 20g Classic",
    "price": 11.89,
    "purchasePrice": 11.270142,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2187",
    "barcode": "2187",
    "imageUrl": "http://almoune.fr/img/p/4/2/5/0/4250.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2190",
    "name": "zaatar frenade 400gr Baladna",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-2190",
    "barcode": "2190",
    "imageUrl": "http://almoune.fr/img/p/4/2/0/9/4209.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2191",
    "name": "Zaatar sumac 400gr Baladna",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2191",
    "barcode": "2191",
    "imageUrl": "http://almoune.fr/img/p/4/2/1/0/4210.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2230",
    "name": "Olives noires Boulos 1kg",
    "price": 9.49,
    "purchasePrice": 8.995261,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-2230",
    "barcode": "2230",
    "imageUrl": "http://almoune.fr/img/p/4/1/3/2/4132.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2231",
    "name": "Olives vertes 1kg  Boulos",
    "price": 9.49,
    "purchasePrice": 8.995261,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-2231",
    "barcode": "2231",
    "imageUrl": "http://almoune.fr/img/p/4/1/3/1/4131.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2240",
    "name": "Bourghoul fin brun 900gr Altunsa",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 50,
    "category": "Accueil",
    "sku": "SKU-2240",
    "barcode": "2240",
    "imageUrl": "http://almoune.fr/img/p/4/2/5/4/4254.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2251",
    "name": "Eau de Rose 250ml Boulos",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 23,
    "category": "Accueil",
    "sku": "SKU-2251",
    "barcode": "2251",
    "imageUrl": "http://almoune.fr/img/p/4/1/3/5/4135.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2258",
    "name": "Poids de cuisson Terre cuite",
    "price": 12.5,
    "purchasePrice": 10.416667,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2258",
    "barcode": "2258",
    "imageUrl": "http://almoune.fr/img/p/4/2/0/6/4206.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2259",
    "name": "Assiette pour mezze en mélaminé petite taille - 1 pièce",
    "price": 3.75,
    "purchasePrice": 3.125,
    "stock": 9,
    "category": "Autres",
    "sku": "SKU-2259",
    "barcode": "2259",
    "imageUrl": "http://almoune.fr/img/p/4/0/7/1/4071.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2261",
    "name": "Cardamome Moulue Chirag 1kg",
    "price": 79,
    "purchasePrice": 74.881517,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2261",
    "barcode": "2261",
    "imageUrl": "http://almoune.fr/img/p/4/4/8/9/4489.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2267",
    "name": "Tahini Crème De Sésame Al Kanater 330g",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2267",
    "barcode": "2267",
    "imageUrl": "http://almoune.fr/img/p/4/5/0/9/4509.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2276",
    "name": "Cardamome moulue 20gr Gardenia",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2276",
    "barcode": "2276",
    "imageUrl": "http://almoune.fr/img/p/4/0/7/2/4072.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2277",
    "name": "Piment de la Jamaïque moulu",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2277",
    "barcode": "2277",
    "imageUrl": "http://almoune.fr/img/p/4/1/1/5/4115.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2278",
    "name": "Mahleb Moulu Gardenia 20g",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 13,
    "category": "Accueil",
    "sku": "SKU-2278",
    "barcode": "2278",
    "imageUrl": "http://almoune.fr/img/p/4/4/7/0/4470.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2279",
    "name": "Cardamome entière 20gr Gardenia",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-2279",
    "barcode": "2279",
    "imageUrl": "http://almoune.fr/img/p/4/1/2/3/4123.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2280",
    "name": "Épices pour Samké Harra Gardenia Grain d'Or 50g",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 12,
    "category": "Épices",
    "sku": "SKU-2280",
    "barcode": "2280",
    "imageUrl": "http://almoune.fr/img/p/4/3/6/5/4365.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2288",
    "name": "Navets Marinés 1350gr Alsaadah",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2288",
    "barcode": "2288",
    "imageUrl": "http://almoune.fr/img/p/4/1/5/9/4159.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2297",
    "name": "Lentilles rouge Gardenia 907g",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 24,
    "category": "Accueil",
    "sku": "SKU-2297",
    "barcode": "2297",
    "imageUrl": "http://almoune.fr/img/p/4/3/1/4/4314.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2308",
    "name": "Noix de cajou crues 1Kg",
    "price": 15.99,
    "purchasePrice": 15.156398,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2308",
    "barcode": "2308",
    "imageUrl": "http://almoune.fr/img/p/4/1/2/5/4125.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2311",
    "name": "Riz Basmati 5kg Al Wazah",
    "price": 24.5,
    "purchasePrice": 23.222749,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-2311",
    "barcode": "2311",
    "imageUrl": "http://almoune.fr/img/p/4/1/2/0/4120.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2327",
    "name": "Promo MATE Taragui 250gr.",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -229,
    "category": "Accueil",
    "sku": "SKU-2327",
    "barcode": "2327",
    "imageUrl": "http://almoune.fr/img/p/4/0/9/0/4090.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2328",
    "name": "Zaatar Premium Naturel 1kg BOULOS",
    "price": 18.75,
    "purchasePrice": 17.772512,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2328",
    "barcode": "2328",
    "imageUrl": "http://almoune.fr/img/p/4/1/1/9/4119.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2332",
    "name": "Epices pour soujouk gardenia 50g",
    "price": 1.9,
    "purchasePrice": 1.800948,
    "stock": -3,
    "category": "Accueil",
    "sku": "SKU-2332",
    "barcode": "2332",
    "imageUrl": "http://almoune.fr/img/p/4/1/1/7/4117.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2333",
    "name": "Noix de muscade moulue gardenia 20g",
    "price": 1.9,
    "purchasePrice": 1.800948,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2333",
    "barcode": "2333",
    "imageUrl": "http://almoune.fr/img/p/4/0/8/0/4080.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2334",
    "name": "Top juice orange 190 ml",
    "price": 0.95,
    "purchasePrice": 0.900474,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2334",
    "barcode": "2334",
    "imageUrl": "http://almoune.fr/img/p/4/0/8/3/4083.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2335",
    "name": "TOP juice ananas 190ml",
    "price": 0.95,
    "purchasePrice": 0.900474,
    "stock": -229,
    "category": "Accueil",
    "sku": "SKU-2335",
    "barcode": "2335",
    "imageUrl": "http://almoune.fr/img/p/4/0/8/2/4082.jpg",
    "price_per_kg": 0.95
  },
  {
    "id": "csv-2336",
    "name": "Top juice mangue 190ml",
    "price": 0.95,
    "purchasePrice": 0.900474,
    "stock": -11,
    "category": "Accueil",
    "sku": "SKU-2336",
    "barcode": "2336",
    "imageUrl": "http://almoune.fr/img/p/4/0/8/1/4081.jpg",
    "price_per_kg": 0.95
  },
  {
    "id": "csv-2337",
    "name": "Confiture de Rose Naturelle 350 gr Mymoune",
    "price": 7.85,
    "purchasePrice": 7.440758,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-2337",
    "barcode": "2337",
    "imageUrl": "http://almoune.fr/img/p/4/1/1/4/4114.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2339",
    "name": "Haricot Géant 800g  Arev",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2339",
    "barcode": "2339",
    "imageUrl": "http://almoune.fr/img/p/4/1/0/2/4102.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2340",
    "name": "Kri kri ou cricri Castania 100g",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2340",
    "barcode": "2340",
    "imageUrl": "http://almoune.fr/img/p/4/0/7/7/4077.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2341",
    "name": "Castania extra nuts 300g",
    "price": 6.49,
    "purchasePrice": 6.151659,
    "stock": 16,
    "category": "Accueil",
    "sku": "SKU-2341",
    "barcode": "2341",
    "imageUrl": "http://almoune.fr/img/p/4/0/8/4/4084.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2342",
    "name": "bourghoul Gros brun 907 gr Gardenia",
    "price": 3.55,
    "purchasePrice": 3.364929,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-2342",
    "barcode": "2342",
    "imageUrl": "http://almoune.fr/img/p/4/0/7/9/4079.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2344",
    "name": "Kaak shami durra 400gr",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2344",
    "barcode": "2344",
    "imageUrl": "http://almoune.fr/img/p/4/1/6/0/4160.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2349",
    "name": "Epice Kebbeh Gardenia 50gr",
    "price": 1.7,
    "purchasePrice": 1.611374,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2349",
    "barcode": "2349",
    "imageUrl": "http://almoune.fr/img/p/4/1/0/1/4101.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2352",
    "name": "Savon Huile d'olive Liban au chaudron",
    "price": 1.99,
    "purchasePrice": 1.658333,
    "stock": 13,
    "category": "Accueil",
    "sku": "SKU-2352",
    "barcode": "2352",
    "imageUrl": "http://almoune.fr/img/p/4/1/0/5/4105.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2353",
    "name": "Savon au chaudron et Laurier Liban Boulos",
    "price": 2.49,
    "purchasePrice": 2.36019,
    "stock": 15,
    "category": "Accueil",
    "sku": "SKU-2353",
    "barcode": "2353",
    "imageUrl": "http://almoune.fr/img/p/4/1/3/6/4136.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2354",
    "name": "Savon huile d'olive 1 kg au Chaudron Liban",
    "price": 10,
    "purchasePrice": 8.333333,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-2354",
    "barcode": "2354",
    "imageUrl": "http://almoune.fr/img/p/4/1/0/4/4104.jpg",
    "price_per_kg": 10
  },
  {
    "id": "csv-2355",
    "name": "Savon boulos laurier 1kg",
    "price": 12.5,
    "purchasePrice": 10.416667,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-2355",
    "barcode": "2355",
    "imageUrl": "http://almoune.fr/img/p/4/1/0/3/4103.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2356",
    "name": "Melasse de caroubes 800gr Boulos",
    "price": 6.85,
    "purchasePrice": 6.492891,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2356",
    "barcode": "2356",
    "imageUrl": "http://almoune.fr/img/p/4/1/1/8/4118.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2357",
    "name": "Jus de Verjus (Hosrom) 250ml Boulos",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2357",
    "barcode": "2357",
    "imageUrl": "http://almoune.fr/img/p/4/1/3/4/4134.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2358",
    "name": "Zaatar Premium 250gr Boulos",
    "price": 8.35,
    "purchasePrice": 7.914692,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2358",
    "barcode": "2358",
    "imageUrl": "http://almoune.fr/img/p/4/1/0/9/4109.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2359",
    "name": "Sirop de Rose Boulos 500ml",
    "price": 4.95,
    "purchasePrice": 4.125,
    "stock": 23,
    "category": "Accueil",
    "sku": "SKU-2359",
    "barcode": "2359",
    "imageUrl": "http://almoune.fr/img/p/4/0/8/6/4086.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2360",
    "name": "Huile d'Olive Extra Vergin 500mL Boulos",
    "price": 10.9,
    "purchasePrice": 10.331754,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2360",
    "barcode": "2360",
    "imageUrl": "http://almoune.fr/img/p/4/1/4/2/4142.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2361",
    "name": "Najjar Cardamome 450 gr selection",
    "price": 8.75,
    "purchasePrice": 8.293839,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2361",
    "barcode": "2361",
    "imageUrl": "http://almoune.fr/img/p/4/1/1/6/4116.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2367",
    "name": "Riz en poudre gardenia 907gr",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-2367",
    "barcode": "2367",
    "imageUrl": "http://almoune.fr/img/p/4/0/8/7/4087.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2369",
    "name": "Thym vert moulu ou zaatar pure 200gr Gardenia",
    "price": 7.85,
    "purchasePrice": 7.440758,
    "stock": 28,
    "category": "Accueil",
    "sku": "SKU-2369",
    "barcode": "2369",
    "imageUrl": "http://almoune.fr/img/p/4/0/9/4/4094.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2370",
    "name": "Café Hamwi Extra Cardamome 450gr",
    "price": 15.99,
    "purchasePrice": 15.156398,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-2370",
    "barcode": "2370",
    "imageUrl": "http://almoune.fr/img/p/4/0/9/5/4095.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2371",
    "name": "Lupins marinés salés Narenj 540gr",
    "price": 2.89,
    "purchasePrice": 2.739336,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-2371",
    "barcode": "2371",
    "imageUrl": "http://almoune.fr/img/p/4/0/9/6/4096.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2372",
    "name": "Sauce BBQ 420g Durra",
    "price": 1.75,
    "purchasePrice": 2.132701,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-2372",
    "barcode": "2372",
    "imageUrl": "http://almoune.fr/img/p/4/0/9/2/4092.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2373",
    "name": "Ketchup durra piquant 500gr",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 13,
    "category": "Accueil",
    "sku": "SKU-2373",
    "barcode": "2373",
    "imageUrl": "http://almoune.fr/img/p/4/0/9/7/4097.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2374",
    "name": "Unica signature noix de coco 408 gr",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2374",
    "barcode": "2374",
    "imageUrl": "http://almoune.fr/img/p/4/0/9/9/4099.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2375",
    "name": "Unica chocolat signature Chocolat 408gr",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2375",
    "barcode": "2375",
    "imageUrl": "http://almoune.fr/img/p/4/0/9/8/4098.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2376",
    "name": "Unica signature noisette 408gr",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2376",
    "barcode": "2376",
    "imageUrl": "http://almoune.fr/img/p/4/1/0/0/4100.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2380",
    "name": "Eau de fleur d'oranger 50cl 100% naturelle mymoune",
    "price": 16.5,
    "purchasePrice": 15.63981,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-2380",
    "barcode": "2380",
    "imageUrl": "http://almoune.fr/img/p/4/1/1/0/4110.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2381",
    "name": "Melasse de grenade Anjar 300mL",
    "price": 4.95,
    "purchasePrice": 4.691943,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-2381",
    "barcode": "2381",
    "imageUrl": "http://almoune.fr/img/p/4/1/2/2/4122.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2382",
    "name": "Loukoum Grecque Rose 300gr",
    "price": 3.5,
    "purchasePrice": 2.916667,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2382",
    "barcode": "2382",
    "imageUrl": "http://almoune.fr/img/p/4/1/0/7/4107.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2386",
    "name": "Cake cerise lahfa",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2386",
    "barcode": "2386",
    "imageUrl": "http://almoune.fr/img/p/4/1/3/0/4130.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2387",
    "name": "riz basmati kaalar 1kg",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2387",
    "barcode": "2387",
    "imageUrl": "http://almoune.fr/img/p/4/1/2/6/4126.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2390",
    "name": "pétales de rose sechée 25 g",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-2390",
    "barcode": "2390",
    "imageUrl": "http://almoune.fr/img/p/4/1/2/7/4127.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2391",
    "name": "Loukoum rose",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-2391",
    "barcode": "2391",
    "imageUrl": "http://almoune.fr/img/p/4/1/2/8/4128.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2392",
    "name": "loukoum mistika",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2392",
    "barcode": "2392",
    "imageUrl": "http://almoune.fr/img/p/4/1/2/9/4129.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2393",
    "name": "amandes blanchies crues 1kg",
    "price": 14.49,
    "purchasePrice": 13.734597,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-2393",
    "barcode": "2393",
    "imageUrl": "http://almoune.fr/img/p/4/1/2/4/4124.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2395",
    "name": "epices pour grillades gardenia",
    "price": 1.8,
    "purchasePrice": 1.706161,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-2395",
    "barcode": "2395",
    "imageUrl": "http://almoune.fr/img/p/4/1/3/3/4133.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2397",
    "name": "Manouché croustillant 100gr Soler's",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2397",
    "barcode": "2397",
    "imageUrl": "http://almoune.fr/img/p/4/1/3/7/4137.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2399",
    "name": "Damasco Kaak 250gr",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 17,
    "category": "Accueil",
    "sku": "SKU-2399",
    "barcode": "2399",
    "imageUrl": "http://almoune.fr/img/p/4/1/3/9/4139.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2401",
    "name": "Jus de Mangue Kassatly 250ml",
    "price": 1.95,
    "purchasePrice": 1.848341,
    "stock": 16,
    "category": "Accueil",
    "sku": "SKU-2401",
    "barcode": "2401",
    "imageUrl": "http://almoune.fr/img/p/4/1/3/8/4138.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2402",
    "name": "Jus de Guyave 250cl Kassatly",
    "price": 1.95,
    "purchasePrice": 1.848341,
    "stock": 13,
    "category": "Accueil",
    "sku": "SKU-2402",
    "barcode": "2402",
    "imageUrl": "http://almoune.fr/img/p/4/1/4/0/4140.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2404",
    "name": "jardinière marinée 660 g al dayaa",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2404",
    "barcode": "2404",
    "imageUrl": "http://almoune.fr/img/p/4/1/4/1/4141.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2407",
    "name": "mix de légumes alsaadah",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2407",
    "barcode": "2407",
    "imageUrl": "http://almoune.fr/img/p/4/1/4/9/4149.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2409",
    "name": "Lupin Hikayat 2 660 g",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2409",
    "barcode": "2409",
    "imageUrl": "http://almoune.fr/img/p/4/1/5/0/4150.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2414",
    "name": "Vinaigre blanc chtoura 1L",
    "price": 2.35,
    "purchasePrice": 2.227488,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2414",
    "barcode": "2414",
    "imageUrl": "http://almoune.fr/img/p/4/1/5/1/4151.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2423",
    "name": "Miel de fleur Arev 1kg",
    "price": 9.75,
    "purchasePrice": 9.241706,
    "stock": -13,
    "category": "Accueil",
    "sku": "SKU-2423",
    "barcode": "2423",
    "imageUrl": "http://almoune.fr/img/p/4/1/4/8/4148.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2425",
    "name": "Presure super maya",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 12,
    "category": "Accueil",
    "sku": "SKU-2425",
    "barcode": "2425",
    "imageUrl": "http://almoune.fr/img/p/4/1/4/5/4145.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2427",
    "name": "haricot blanc géant chtoura 900gr",
    "price": 6.75,
    "purchasePrice": 6.398104,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-2427",
    "barcode": "2427",
    "imageUrl": "http://almoune.fr/img/p/4/1/5/2/4152.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2436",
    "name": "Variante de légume Mechaalany 600gr",
    "price": 4.95,
    "purchasePrice": 4.691943,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-2436",
    "barcode": "2436",
    "imageUrl": "http://almoune.fr/img/p/4/1/4/7/4147.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2437",
    "name": "canelle moulue 100G",
    "price": 2,
    "purchasePrice": 1.895735,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2437",
    "barcode": "2437",
    "imageUrl": "http://almoune.fr/img/p/4/1/4/6/4146.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2439",
    "name": "bicarbonate Spico 500 g",
    "price": 4.85,
    "purchasePrice": 4.041667,
    "stock": -11,
    "category": "Accueil",
    "sku": "SKU-2439",
    "barcode": "2439",
    "imageUrl": "http://almoune.fr/img/p/4/1/5/4/4154.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2440",
    "name": "mix baklava hallab 250 g",
    "price": 12,
    "purchasePrice": 11.374408,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2440",
    "barcode": "2440",
    "imageUrl": "http://almoune.fr/img/p/4/1/5/3/4153.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2441",
    "name": "café city one 3 en 1 250 g",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2441",
    "barcode": "2441",
    "imageUrl": "http://almoune.fr/img/p/4/1/5/8/4158.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2445",
    "name": "Triangle Tony's Food 500gr",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2445",
    "barcode": "2445",
    "imageUrl": "http://almoune.fr/img/p/4/1/5/7/4157.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2446",
    "name": "Barbe a papa Naturel douaihy 100g",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2446",
    "barcode": "2446",
    "imageUrl": "http://almoune.fr/img/p/4/1/5/6/4156.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2447",
    "name": "Pain protéiné 270gr Moulin d'or",
    "price": 2.85,
    "purchasePrice": 2.701422,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2447",
    "barcode": "2447",
    "imageUrl": "http://almoune.fr/img/p/4/1/5/5/4155.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2452",
    "name": "OAT DATES ROLLS",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2452",
    "barcode": "2452",
    "imageUrl": "http://almoune.fr/img/p/4/1/6/2/4162.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2453",
    "name": "BARAZEK moulin d'or 390 g",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2453",
    "barcode": "2453",
    "imageUrl": "http://almoune.fr/img/p/4/1/6/5/4165.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2454",
    "name": "vanilla kaak biscuits",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2454",
    "barcode": "2454",
    "imageUrl": "http://almoune.fr/img/p/4/1/6/7/4167.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2455",
    "name": "HONEY OAT biscuits 290 g",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2455",
    "barcode": "2455",
    "imageUrl": "http://almoune.fr/img/p/4/1/6/4/4164.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2463",
    "name": "Jus ANANAS MACCAW 180ml",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": -15,
    "category": "Accueil",
    "sku": "SKU-2463",
    "barcode": "2463",
    "imageUrl": "http://almoune.fr/img/p/4/1/6/8/4168.jpg",
    "price_per_kg": 0.5
  },
  {
    "id": "csv-2465",
    "name": "Jus Fraise Banane 180ml",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": 24,
    "category": "Accueil",
    "sku": "SKU-2465",
    "barcode": "2465",
    "imageUrl": "http://almoune.fr/img/p/4/1/6/9/4169.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2470",
    "name": "thon à l'huile tournesol",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": -79,
    "category": "Accueil",
    "sku": "SKU-2470",
    "barcode": "2470",
    "imageUrl": "http://almoune.fr/img/p/4/1/7/1/4171.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2471",
    "name": "proteines de soja 150 g",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2471",
    "barcode": "2471",
    "imageUrl": "http://almoune.fr/img/p/4/1/7/0/4170.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2499",
    "name": "Huile d'Olive Vierge Boulos 250ml",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 10,
    "category": "Huiles et vinaigres",
    "sku": "SKU-2499",
    "barcode": "2499",
    "imageUrl": "http://almoune.fr/img/p/4/4/3/7/4437.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2516",
    "name": "Concentré de Tomate Kasih 4x130g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 8,
    "category": "Condiments",
    "sku": "SKU-2516",
    "barcode": "2516",
    "imageUrl": "http://almoune.fr/img/p/4/4/5/6/4456.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2518",
    "name": "Thé Noir Lipton Yellow Label 100 Sachets 150g",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2518",
    "barcode": "2518",
    "imageUrl": "http://almoune.fr/img/p/4/5/0/0/4500.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2526",
    "name": "café amer cardamone hala",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 103,
    "category": "Cafés",
    "sku": "SKU-2526",
    "barcode": "2526",
    "imageUrl": "http://almoune.fr/img/p/4/3/8/0/4380.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2550",
    "name": "Feuilles de Vigne Farcies au Riz Epsilon 2000g",
    "price": 8.97,
    "purchasePrice": 8.50237,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2550",
    "barcode": "2550",
    "imageUrl": "http://almoune.fr/img/p/4/4/4/6/4446.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2567",
    "name": "Crème Chantilly Fraise 72gr Domo",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-2567",
    "barcode": "2567",
    "imageUrl": "http://almoune.fr/img/p/4/2/4/7/4247.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2568",
    "name": "Custard Vanille DOMO 300g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 5,
    "category": "Boissons",
    "sku": "SKU-2568",
    "barcode": "2568",
    "imageUrl": "http://almoune.fr/img/p/4/4/6/3/4463.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2569",
    "name": "CUSTARD Chocolat 300gr DOMO",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2569",
    "barcode": "2569",
    "imageUrl": "http://almoune.fr/img/p/4/2/1/6/4216.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2584",
    "name": "Eau de source 50cl",
    "price": 0.5,
    "purchasePrice": 0.473934,
    "stock": -25,
    "category": "Accueil",
    "sku": "SKU-2584",
    "barcode": "2584",
    "imageUrl": "http://almoune.fr/img/p/4/3/0/6/4306.jpg",
    "price_per_kg": 0.5
  },
  {
    "id": "csv-2601",
    "name": "Préparation pour Sahlab Abido 500g",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 2,
    "category": "Produits du monde",
    "sku": "SKU-2601",
    "barcode": "2601",
    "imageUrl": "http://almoune.fr/img/p/4/4/5/8/4458.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2602",
    "name": "Arak Gantous 70 cl",
    "price": 34,
    "purchasePrice": 28.333333,
    "stock": 0,
    "category": "Arack ou Arak Libanais",
    "sku": "SKU-2602",
    "barcode": "2602",
    "imageUrl": "http://almoune.fr/img/p/4/1/7/2/4172.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2609",
    "name": "Acide citrique en vrac 100gr",
    "price": 1.4,
    "purchasePrice": 1.327014,
    "stock": 11,
    "category": "Accueil",
    "sku": "SKU-2609",
    "barcode": "2609",
    "imageUrl": "http://almoune.fr/img/p/4/1/7/6/4176.jpg",
    "price_per_kg": 1.4
  },
  {
    "id": "csv-2610",
    "name": "Manouché croustillant zaatar vrac 200g",
    "price": 3.6,
    "purchasePrice": 3.412322,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2610",
    "barcode": "2610",
    "imageUrl": "http://almoune.fr/img/p/4/1/7/3/4173.jpg",
    "price_per_kg": 3.6
  },
  {
    "id": "csv-2611",
    "name": "Sept épices vrac 50 g",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2611",
    "barcode": "2611",
    "imageUrl": "http://almoune.fr/img/p/4/1/7/4/4174.jpg",
    "price_per_kg": 1.5
  },
  {
    "id": "csv-2612",
    "name": "Piment fort moulu vrac 100g",
    "price": 0,
    "purchasePrice": 0,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2612",
    "barcode": "2612",
    "imageUrl": "http://almoune.fr/img/p/4/1/7/5/4175.jpg",
    "price_per_kg": 0
  },
  {
    "id": "csv-2616",
    "name": "Poivre noir moulu vrac 100g",
    "price": 0,
    "purchasePrice": 0,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2616",
    "barcode": "2616",
    "imageUrl": "http://almoune.fr/img/p/4/1/7/7/4177.jpg",
    "price_per_kg": 0
  },
  {
    "id": "csv-2620",
    "name": "Lentilles Rouges Concassées (Corail) El Mazraa 500g",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 20,
    "category": "Aliments et Laitiers",
    "sku": "SKU-2620",
    "barcode": "2620",
    "imageUrl": "http://almoune.fr/img/p/4/4/5/2/4452.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2632",
    "name": "Café Beyrouti Cardamone 200gr",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 36,
    "category": "Boissons",
    "sku": "SKU-2632",
    "barcode": "2632",
    "imageUrl": "http://almoune.fr/img/p/4/4/3/4/4434.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2633",
    "name": "Café Libanais Supérieur Beyrouti 200g",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 13,
    "category": "Boissons",
    "sku": "SKU-2633",
    "barcode": "2633",
    "imageUrl": "http://almoune.fr/img/p/4/4/3/5/4435.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2648",
    "name": "Moghrabiyeh Sec Gardenia Grain d'Or 907g",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Légumineuses et grains",
    "sku": "SKU-2648",
    "barcode": "2648",
    "imageUrl": "http://almoune.fr/img/p/4/4/3/8/4438.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2650",
    "name": "Hummus kasih creamy 135g",
    "price": 0.95,
    "purchasePrice": 0.900474,
    "stock": 11,
    "category": "Accueil",
    "sku": "SKU-2650",
    "barcode": "2650",
    "imageUrl": "http://almoune.fr/img/p/4/2/1/3/4213.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2651",
    "name": "Hummus kasih chili 135g",
    "price": 1.15,
    "purchasePrice": 1.090047,
    "stock": 11,
    "category": "Accueil",
    "sku": "SKU-2651",
    "barcode": "2651",
    "imageUrl": "http://almoune.fr/img/p/4/2/1/2/4212.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2652",
    "name": "Hummus au piment rouge kasih 4 540g",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": 17,
    "category": "Accueil",
    "sku": "SKU-2652",
    "barcode": "2652",
    "imageUrl": "http://almoune.fr/img/p/4/4/8/2/4482.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2654",
    "name": "Riz Egyptien masri aldoha 1kg",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 28,
    "category": "Accueil",
    "sku": "SKU-2654",
    "barcode": "2654",
    "imageUrl": "http://almoune.fr/img/p/4/1/7/8/4178.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2687",
    "name": "Sucre Saveur Vanille Aruba 100g",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 11,
    "category": "Accueil",
    "sku": "SKU-2687",
    "barcode": "2687",
    "imageUrl": "http://almoune.fr/img/p/4/4/6/4/4464.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2698",
    "name": "Tahini Kunuz Alshaam 800gr",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-2698",
    "barcode": "2698",
    "imageUrl": "http://almoune.fr/img/p/4/2/2/5/4225.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2710",
    "name": "Tahini al yaman 907gr",
    "price": 10.55,
    "purchasePrice": 10,
    "stock": 7,
    "category": "Aliments et Laitiers",
    "sku": "SKU-2710",
    "barcode": "2710",
    "imageUrl": "http://almoune.fr/img/p/4/4/4/0/4440.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2715",
    "name": "Chips Master Kettle Cooked Sel et Vinaigre 170g",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 11,
    "category": "Chips et apéritifs",
    "sku": "SKU-2715",
    "barcode": "2715",
    "imageUrl": "http://almoune.fr/img/p/4/3/8/9/4389.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2716",
    "name": "Chips de Maïs au Beurre de Cacahuète Buffies Master 72g",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2716",
    "barcode": "2716",
    "imageUrl": "http://almoune.fr/img/p/4/3/8/8/4388.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2720",
    "name": "huile d'olive bio Tunisienne PHOENICIA 1ere cueillette 500ml",
    "price": 15.99,
    "purchasePrice": 15.156398,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2720",
    "barcode": "2720",
    "imageUrl": "http://almoune.fr/img/p/4/1/8/1/4181.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2721",
    "name": "Huile d'olive bio Tunisienne Phoenicia 3eme cueillette 500mL",
    "price": 16.75,
    "purchasePrice": 15.876777,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2721",
    "barcode": "2721",
    "imageUrl": "http://almoune.fr/img/p/4/1/8/3/4183.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2722",
    "name": "Huile d'olive bio Tunisienne Phoenicia 2eme cueillette 500mL",
    "price": 15.99,
    "purchasePrice": 15.156398,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2722",
    "barcode": "2722",
    "imageUrl": "http://almoune.fr/img/p/4/1/8/5/4185.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2727",
    "name": "sésame Blanc en vrac 100gr",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-2727",
    "barcode": "2727",
    "imageUrl": "http://almoune.fr/img/p/4/1/8/8/4188.jpg",
    "price_per_kg": 0.99
  },
  {
    "id": "csv-2729",
    "name": "fruit sec Arménien pomme peche poire 275gr",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 26,
    "category": "Confitures",
    "sku": "SKU-2729",
    "barcode": "2729",
    "imageUrl": "http://almoune.fr/img/p/4/1/7/9/4179.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2732",
    "name": "Summac Libanais premium 500gr  en vrac",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-2732",
    "barcode": "2732",
    "imageUrl": "http://almoune.fr/img/p/4/1/8/7/4187.jpg",
    "price_per_kg": 12.5
  },
  {
    "id": "csv-2733",
    "name": "Paprika doux fumé en vrac 100gr",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-2733",
    "barcode": "2733",
    "imageUrl": "http://almoune.fr/img/p/4/1/8/6/4186.jpg",
    "price_per_kg": 2.25
  },
  {
    "id": "csv-2744",
    "name": "Huile d'olive vierge Boulos 4 L",
    "price": 69.85,
    "purchasePrice": 66.208531,
    "stock": 11,
    "category": "Condiments",
    "sku": "SKU-2744",
    "barcode": "2744",
    "imageUrl": "http://almoune.fr/img/p/4/1/9/0/4190.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2747",
    "name": "Huile d'olive Afrin ALKHEIR 1L",
    "price": 16.75,
    "purchasePrice": 15.876777,
    "stock": 71,
    "category": "Accueil",
    "sku": "SKU-2747",
    "barcode": "2747",
    "imageUrl": "http://almoune.fr/img/p/4/4/2/6/4426.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2751",
    "name": "Baklava Hallab 900gr",
    "price": 14,
    "purchasePrice": 13.270142,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-2751",
    "barcode": "2751",
    "imageUrl": "http://almoune.fr/img/p/4/1/9/1/4191.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2754",
    "name": "Vinaigre de Vin Rouge Récoltes Naturelles 500ml",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-2754",
    "barcode": "2754",
    "imageUrl": "http://almoune.fr/img/p/4/4/2/8/4428.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2755",
    "name": "Concombres Marinés - MECHAALANY 600g",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-2755",
    "barcode": "2755",
    "imageUrl": "http://almoune.fr/img/p/4/1/9/2/4192.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2763",
    "name": "Mélange de Snacks Fiesta Mix Krikita 225g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2763",
    "barcode": "2763",
    "imageUrl": "http://almoune.fr/img/p/4/3/4/2/4342.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2788",
    "name": "Luncheon Meat Poulet Goût Bœuf Al-Raii Halal 200g",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Conserves",
    "sku": "SKU-2788",
    "barcode": "2788",
    "imageUrl": "http://almoune.fr/img/p/4/3/7/1/4371.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2789",
    "name": "corne poulet 200 gr ALRAII",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-2789",
    "barcode": "2789",
    "imageUrl": "http://almoune.fr/img/p/4/4/6/8/4468.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2790",
    "name": "Pain Libanais (quantité non limité) - 5 pièces 220~240 gr",
    "price": 1.45,
    "purchasePrice": 1.374408,
    "stock": 9541,
    "category": "Accueil",
    "sku": "SKU-2790",
    "barcode": "2790",
    "imageUrl": "http://almoune.fr/img/p/4/1/9/3/4193.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2803",
    "name": "Mélange Poulet Croustillant Épicé Abido 500g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 1,
    "category": "Épices",
    "sku": "SKU-2803",
    "barcode": "2803",
    "imageUrl": "http://almoune.fr/img/p/4/4/5/7/4457.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2824",
    "name": "Pate de dattes AlNAKHIL 1kg",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-2824",
    "barcode": "2824",
    "imageUrl": "http://almoune.fr/img/p/4/4/3/0/4430.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2827",
    "name": "Café Haseeb Deluxe Cardamome édition Diamond - 200g",
    "price": 5.45,
    "purchasePrice": 5.165877,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-2827",
    "barcode": "2827",
    "imageUrl": "http://almoune.fr/img/p/4/1/9/4/4194.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2838",
    "name": "Jus de Verjus (Hosrom) 500ml Boulos",
    "price": 8.35,
    "purchasePrice": 7.914692,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-2838",
    "barcode": "2838",
    "imageUrl": "http://almoune.fr/img/p/4/1/9/5/4195.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2839",
    "name": "summac Libanais boulos 100gr",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": 15,
    "category": "Accueil",
    "sku": "SKU-2839",
    "barcode": "2839",
    "imageUrl": "http://almoune.fr/img/p/4/2/4/6/4246.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2848",
    "name": "melasse de raisins Rabih 700 ml",
    "price": 7.85,
    "purchasePrice": 7.440758,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-2848",
    "barcode": "2848",
    "imageUrl": "http://almoune.fr/img/p/4/4/9/7/4497.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2849",
    "name": "Melasse de caroube Rabih 700 ml",
    "price": 6.99,
    "purchasePrice": 6.625592,
    "stock": 1,
    "category": "Mélasses et miels",
    "sku": "SKU-2849",
    "barcode": "2849",
    "imageUrl": "http://almoune.fr/img/p/4/4/4/3/4443.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2854",
    "name": "Préparation pour Mouhallabieh Al-Rabih 400g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 14,
    "category": "Accueil",
    "sku": "SKU-2854",
    "barcode": "2854",
    "imageUrl": "http://almoune.fr/img/p/4/4/6/0/4460.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2860",
    "name": "Assortiment Baklava Aghati 500g",
    "price": 29,
    "purchasePrice": 27.488152,
    "stock": 36,
    "category": "Baklava",
    "sku": "SKU-2860",
    "barcode": "2860",
    "imageUrl": "http://almoune.fr/img/p/4/3/6/2/4362.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2861",
    "name": "Sirop de Datte Basra 450g",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": 7,
    "category": "Confitures",
    "sku": "SKU-2861",
    "barcode": "2861",
    "imageUrl": "http://almoune.fr/img/p/4/4/1/5/4415.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2864",
    "name": "Sirop d'Abricot Kamardine Chtoura Garden 600ml",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": 4,
    "category": "Boissons",
    "sku": "SKU-2864",
    "barcode": "2864",
    "imageUrl": "http://almoune.fr/img/p/4/4/7/6/4476.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2893",
    "name": "Vermicelle 400 gr Habo",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 35,
    "category": "Accueil",
    "sku": "SKU-2893",
    "barcode": "2893",
    "imageUrl": "http://almoune.fr/img/p/4/3/1/3/4313.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2901",
    "name": "Chips de Pomme de Terre Saveur de Sel Master 145g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 22,
    "category": "Accueil",
    "sku": "SKU-2901",
    "barcode": "2901",
    "imageUrl": "http://almoune.fr/img/p/4/3/9/0/4390.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2926",
    "name": "Purée d'aubergines grillées - Paliria 680g",
    "price": 4.49,
    "purchasePrice": 4.255924,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-2926",
    "barcode": "2926",
    "imageUrl": "http://almoune.fr/img/p/4/1/9/7/4197.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2927",
    "name": "Purée d'Aubergines Grillées Paliria 480g",
    "price": 2.95,
    "purchasePrice": 2.796209,
    "stock": 73,
    "category": "Accueil",
    "sku": "SKU-2927",
    "barcode": "2927",
    "imageUrl": "http://almoune.fr/img/p/4/5/0/5/4505.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2929",
    "name": "Huile d'olive Boulos 470ml Squeez",
    "price": 7.99,
    "purchasePrice": 7.57346,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-2929",
    "barcode": "2929",
    "imageUrl": "http://almoune.fr/img/p/4/4/2/4/4424.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2930",
    "name": "Navet mariné Rabih 600gr",
    "price": 4.95,
    "purchasePrice": 4.691943,
    "stock": 2,
    "category": "Aliments et Laitiers",
    "sku": "SKU-2930",
    "barcode": "2930",
    "imageUrl": "http://almoune.fr/img/p/4/4/4/4/4444.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2934",
    "name": "Crème de pistache 600gr Pisti",
    "price": 13.95,
    "purchasePrice": 13.222749,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2934",
    "barcode": "2934",
    "imageUrl": "http://almoune.fr/img/p/4/1/9/9/4199.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2942",
    "name": "Huile de Tournesol Soléa 5L",
    "price": 9.99,
    "purchasePrice": 9.469194,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2942",
    "barcode": "2942",
    "imageUrl": "http://almoune.fr/img/p/4/4/2/7/4427.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2948",
    "name": "Aubergines Farcies au Riz (Yalanci) Baytoty 458g",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 22,
    "category": "Accueil",
    "sku": "SKU-2948",
    "barcode": "2948",
    "imageUrl": "http://almoune.fr/img/p/4/3/9/4/4394.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2950",
    "name": "Aubergine Grillée Chtoura 585 gr",
    "price": 3.95,
    "purchasePrice": 3.744076,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-2950",
    "barcode": "2950",
    "imageUrl": "http://almoune.fr/img/p/4/2/0/7/4207.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2952",
    "name": "Confiture De Citrouille Baytoty 660g",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-2952",
    "barcode": "2952",
    "imageUrl": "http://almoune.fr/img/p/4/4/9/1/4491.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2958",
    "name": "Mini cookies chocolat Papadopoulos 70gr",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2958",
    "barcode": "2958",
    "imageUrl": "http://almoune.fr/img/p/4/2/1/5/4215.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2959",
    "name": "Mini cookies Classique Papapodoulos 70gr",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-2959",
    "barcode": "2959",
    "imageUrl": "http://almoune.fr/img/p/4/2/0/5/4205.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2960",
    "name": "Biscotello cacao et crème 200gr",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-2960",
    "barcode": "2960",
    "imageUrl": "http://almoune.fr/img/p/4/2/0/4/4204.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2961",
    "name": "Miranda  Biscuits Classiques 250gr",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": -40,
    "category": "Produits",
    "sku": "SKU-2961",
    "barcode": "2961",
    "imageUrl": "http://almoune.fr/img/p/4/2/0/2/4202.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2967",
    "name": "Maamoul dattes Douaihy 450gr",
    "price": 13.99,
    "purchasePrice": 13.260664,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-2967",
    "barcode": "2967",
    "imageUrl": "http://almoune.fr/img/p/4/2/0/8/4208.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2973",
    "name": "Caprice gaufrettes fourrées aux noisttes 115gr - Papadopoulos",
    "price": 2.49,
    "purchasePrice": 2.36019,
    "stock": 66,
    "category": "Gourmandises",
    "sku": "SKU-2973",
    "barcode": "2973",
    "imageUrl": "http://almoune.fr/img/p/4/2/0/1/4201.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2978",
    "name": "Foul ou fève cuite Kasih 380 gr",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-2978",
    "barcode": "2978",
    "imageUrl": "http://almoune.fr/img/p/4/2/1/4/4214.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2980",
    "name": "Concentré de Tomate Fiorella 800g",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 33,
    "category": "Tomate",
    "sku": "SKU-2980",
    "barcode": "2980",
    "imageUrl": "http://almoune.fr/img/p/4/4/5/3/4453.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2985",
    "name": "Zaatar Extra Gardenia 300gr",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-2985",
    "barcode": "2985",
    "imageUrl": "http://almoune.fr/img/p/4/2/4/4/4244.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2988",
    "name": "Maamoul Alzahra'a 16 g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-2988",
    "barcode": "2988",
    "imageUrl": "http://almoune.fr/img/p/4/2/2/2/4222.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2989",
    "name": "Maamoul Alshamiyah blé complet",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -26,
    "category": "Accueil",
    "sku": "SKU-2989",
    "barcode": "2989",
    "imageUrl": "http://almoune.fr/img/p/4/2/2/3/4223.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2990",
    "name": "Maamoul Alshamiyah au cardamome",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -31,
    "category": "Accueil",
    "sku": "SKU-2990",
    "barcode": "2990",
    "imageUrl": "http://almoune.fr/img/p/4/2/2/0/4220.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2991",
    "name": "Maamoul Alshamiyah Datte",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -22,
    "category": "Accueil",
    "sku": "SKU-2991",
    "barcode": "2991",
    "imageUrl": "http://almoune.fr/img/p/4/2/1/9/4219.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2992",
    "name": "Maamoul Alshamiyah Datte Jumbo 720g",
    "price": 5.99,
    "purchasePrice": 5.677725,
    "stock": -23,
    "category": "Accueil",
    "sku": "SKU-2992",
    "barcode": "2992",
    "imageUrl": "http://almoune.fr/img/p/4/2/1/8/4218.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-2993",
    "name": "Concombre au Vinaigre Durra 650gr",
    "price": 5.85,
    "purchasePrice": 5.545024,
    "stock": 23,
    "category": "Accueil",
    "sku": "SKU-2993",
    "barcode": "2993",
    "imageUrl": "http://almoune.fr/img/p/4/2/1/7/4217.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3008",
    "name": "Yaman Tahini 454g",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-3008",
    "barcode": "3008",
    "imageUrl": "http://almoune.fr/img/p/4/4/4/1/4441.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3018",
    "name": "Manne et sucrières en boite 150gr",
    "price": 5.99,
    "purchasePrice": 5.677725,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-3018",
    "barcode": "3018",
    "imageUrl": "http://almoune.fr/img/p/4/2/2/4/4224.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3022",
    "name": "Poudre de Baobab 250g",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 7,
    "category": "Accueil",
    "sku": "Origine Togolaise",
    "barcode": "3022",
    "imageUrl": "http://almoune.fr/img/p/4/5/1/1/4511.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3025",
    "name": "Graines de tourne-sol décortiquées 200g",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 2,
    "category": "Accueil",
    "sku": "Croc'ellas",
    "barcode": "3025",
    "imageUrl": "http://almoune.fr/img/p/4/4/9/3/4493.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3026",
    "name": "Bouillon Saveur Épices Adja 1kg",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-3026",
    "barcode": "3026",
    "imageUrl": "http://almoune.fr/img/p/4/4/8/8/4488.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3031",
    "name": "Charbon Naturel de Noix de Coco en Cubes Cocotamara 1kg",
    "price": 7.99,
    "purchasePrice": 6.658333,
    "stock": 3,
    "category": "Accessoires",
    "sku": "SKU-3031",
    "barcode": "3031",
    "imageUrl": "http://almoune.fr/img/p/4/4/3/2/4432.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3036",
    "name": "Chakchouka Légèrement Piquante Fantasia 350g",
    "price": 2.1,
    "purchasePrice": 1.990521,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-3036",
    "barcode": "3036",
    "imageUrl": "http://almoune.fr/img/p/4/4/6/6/4466.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3039",
    "name": "Harissa 135gr",
    "price": 0.77,
    "purchasePrice": 0.729858,
    "stock": 23,
    "category": "Condiments",
    "sku": "SKU-3039",
    "barcode": "3039",
    "imageUrl": "http://almoune.fr/img/p/4/4/8/5/4485.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3040",
    "name": "Harissa 380gr",
    "price": 1.85,
    "purchasePrice": 1.753555,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-3040",
    "barcode": "3040",
    "imageUrl": "http://almoune.fr/img/p/4/4/8/6/4486.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3044",
    "name": "Haricots Verts Extra-Fins 660g",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-3044",
    "barcode": "3044",
    "imageUrl": "http://almoune.fr/img/p/4/4/1/1/4411.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3047",
    "name": "Kaak Al-Raii longo pain 400gr",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -13,
    "category": "Accueil",
    "sku": "SKU-3047",
    "barcode": "3047",
    "imageUrl": "http://almoune.fr/img/p/4/2/4/5/4245.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3051",
    "name": "Arachides Crues Blanchies Pro Fruit 1kg",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 4,
    "category": "Accueil",
    "sku": "Origine: Chine",
    "barcode": "3051",
    "imageUrl": "http://almoune.fr/img/p/4/5/0/4/4504.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3052",
    "name": "Mélange De Légumes Marinés Chtoura Garden 600g",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-3052",
    "barcode": "3052",
    "imageUrl": "http://almoune.fr/img/p/4/5/0/6/4506.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3053",
    "name": "Riz Basmati 1121 Sella Extra Long Grain Boustan 900g",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-3053",
    "barcode": "3053",
    "imageUrl": "http://almoune.fr/img/p/4/3/9/6/4396.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3054",
    "name": "Mélasse de Grenade Al Wadi 410g",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 19,
    "category": "Accueil",
    "sku": "SKU-3054",
    "barcode": "3054",
    "imageUrl": "http://almoune.fr/img/p/4/3/4/5/4345.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3060",
    "name": "Huile d'Olive Extra Vierge Déan Gourmet 750 ml",
    "price": 14.99,
    "purchasePrice": 14.208531,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-3060",
    "barcode": "3060",
    "imageUrl": "http://almoune.fr/img/p/4/4/2/5/4425.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3061",
    "name": "Molokhia séché Shamiate 200gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": -23,
    "category": "Accueil",
    "sku": "SKU-3061",
    "barcode": "3061",
    "imageUrl": "http://almoune.fr/img/p/4/2/6/1/4261.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3064",
    "name": "Café Moyen Moulu avec Extra Cardamome Hamwi 180g",
    "price": 6.99,
    "purchasePrice": 6.625592,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3064",
    "barcode": "3064",
    "imageUrl": "http://almoune.fr/img/p/4/4/2/9/4429.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3074",
    "name": "shamiate red zaatar 300 g",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3074",
    "barcode": "3074",
    "imageUrl": "http://almoune.fr/img/p/4/2/6/8/4268.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3075",
    "name": "shamiate green zaatar 300 g",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-3075",
    "barcode": "3075",
    "imageUrl": "http://almoune.fr/img/p/4/2/6/9/4269.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3085",
    "name": "sumac gardenia  454g grain d:or",
    "price": 11.5,
    "purchasePrice": 10.900474,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-3085",
    "barcode": "3085",
    "imageUrl": "http://almoune.fr/img/p/4/2/7/0/4270.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3086",
    "name": "Loukoum Kanater rose 500gr",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-3086",
    "barcode": "3086",
    "imageUrl": "http://almoune.fr/img/p/4/2/3/0/4230.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3089",
    "name": "Caviar d'aubergine Baba ghannouj Rabih 185g",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Aliments et Laitiers",
    "sku": "SKU-3089",
    "barcode": "3089",
    "imageUrl": "http://almoune.fr/img/p/4/2/2/6/4226.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3090",
    "name": "Houmous tahina - Al Rabih 200g",
    "price": 1.45,
    "purchasePrice": 1.374408,
    "stock": 0,
    "category": "Entrées-Mezzé",
    "sku": "SKU-3090",
    "barcode": "3090",
    "imageUrl": "http://almoune.fr/img/p/4/2/2/7/4227.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3093",
    "name": "Graines de courge grillées sans sel 250gr",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 0,
    "category": "Fruits à coques grillés",
    "sku": "SKU-3093",
    "barcode": "3093",
    "imageUrl": "http://almoune.fr/img/p/4/2/2/9/4229.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3121",
    "name": "Miel de Fleurs Fantasia 1 kg",
    "price": 8.89,
    "purchasePrice": 8.42654,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3121",
    "barcode": "3121",
    "imageUrl": "http://almoune.fr/img/p/4/4/2/3/4423.jpg",
    "price_per_kg": 8.89
  },
  {
    "id": "csv-3123",
    "name": "Loukoum kanater Mastic 500g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-3123",
    "barcode": "3123",
    "imageUrl": "http://almoune.fr/img/p/4/2/3/2/4232.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3135",
    "name": "hayda savon alep16% 180G",
    "price": 5,
    "purchasePrice": 4.166667,
    "stock": 58,
    "category": "Autres",
    "sku": "SKU-3135",
    "barcode": "3135",
    "imageUrl": "http://almoune.fr/img/p/4/4/7/3/4473.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3137",
    "name": "hayda savon dalep 4% 100G",
    "price": 12,
    "purchasePrice": 10,
    "stock": 2,
    "category": "Autres",
    "sku": "SKU-3137",
    "barcode": "3137",
    "imageUrl": "http://almoune.fr/img/p/4/2/8/4/4284.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3144",
    "name": "parfums dalep 4% 125G",
    "price": 4,
    "purchasePrice": 3.333333,
    "stock": 7,
    "category": "Autres",
    "sku": "SKU-3144",
    "barcode": "3144",
    "imageUrl": "http://almoune.fr/img/p/4/2/7/9/4279.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3149",
    "name": "savon alep 16% 180 G",
    "price": 6,
    "purchasePrice": 5,
    "stock": 4,
    "category": "Autres",
    "sku": "SKU-3149",
    "barcode": "3149",
    "imageUrl": "http://almoune.fr/img/p/4/4/7/4/4474.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3161",
    "name": "Ghee Végétal (Beurre Clarifié) El Nakhletein 700g",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 2,
    "category": "Condiments",
    "sku": "SKU-3161",
    "barcode": "3161",
    "imageUrl": "http://almoune.fr/img/p/4/4/1/8/4418.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3162",
    "name": "Confiture de Fraise Premium BEST 380g",
    "price": 1.9,
    "purchasePrice": 1.800948,
    "stock": 4,
    "category": "Fruits secs",
    "sku": "SKU-3162",
    "barcode": "3162",
    "imageUrl": "http://almoune.fr/img/p/4/4/1/7/4417.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3164",
    "name": "Riz Golden Sella Shama 5kg",
    "price": 23.5,
    "purchasePrice": 22.274882,
    "stock": 2,
    "category": "Riz et vermicelles",
    "sku": "SKU-3164",
    "barcode": "3164",
    "imageUrl": "http://almoune.fr/img/p/4/3/9/8/4398.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3165",
    "name": "samaya haricots blancs",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-3165",
    "barcode": "3165",
    "imageUrl": "http://almoune.fr/img/p/4/3/0/5/4305.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3166",
    "name": "Pois Chiches El Bled 540g",
    "price": 2.49,
    "purchasePrice": 2.36019,
    "stock": 85,
    "category": "Conserves",
    "sku": "SKU-3166",
    "barcode": "3166",
    "imageUrl": "http://almoune.fr/img/p/4/3/9/1/4391.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3167",
    "name": "Petits Pois Extra-Fins 660g",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-3167",
    "barcode": "3167",
    "imageUrl": "http://almoune.fr/img/p/4/4/0/8/4408.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3168",
    "name": "Petits Pois Extra-Fins & Jeunes Carottes660g",
    "price": 2.85,
    "purchasePrice": 2.701422,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-3168",
    "barcode": "3168",
    "imageUrl": "http://almoune.fr/img/p/4/4/0/7/4407.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3169",
    "name": "Riz Golden Sella Shama 2kg",
    "price": 9.99,
    "purchasePrice": 9.469194,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-3169",
    "barcode": "3169",
    "imageUrl": "http://almoune.fr/img/p/4/3/9/7/4397.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3179",
    "name": "Gaufrettes Tout Cacao Konafetto Roshen 216g",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-3179",
    "barcode": "3179",
    "imageUrl": "http://almoune.fr/img/p/4/4/4/8/4448.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3180",
    "name": "Gaufrettes aux Noisettes Konafetto Roshen 216g",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 4,
    "category": "Gourmandises",
    "sku": "SKU-3180",
    "barcode": "3180",
    "imageUrl": "http://almoune.fr/img/p/4/4/4/9/4449.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3181",
    "name": "Gaufrettes au Lait et Cacao Konafetto Roshen 216g",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-3181",
    "barcode": "3181",
    "imageUrl": "http://almoune.fr/img/p/4/4/4/7/4447.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3189",
    "name": "savon alep cuisson 100% olive",
    "price": 2.25,
    "purchasePrice": 1.875,
    "stock": 119,
    "category": "Savon d'Alep - Cosmétiques",
    "sku": "SKU-3189",
    "barcode": "3189",
    "imageUrl": "http://almoune.fr/img/p/4/2/8/0/4280.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3197",
    "name": "Graines de Pastèque Grillées Castania 300g",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 5,
    "category": "Apéritifs et pain",
    "sku": "SKU-3197",
    "barcode": "3197",
    "imageUrl": "http://almoune.fr/img/p/4/4/3/6/4436.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3199",
    "name": "Chips de Pomme de Terre Kettle Cooked Saveur Moutarde au Miel Master170gr",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": 6,
    "category": "Chips et apéritifs",
    "sku": "SKU-3199",
    "barcode": "3199",
    "imageUrl": "http://almoune.fr/img/p/4/3/8/7/4387.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3200",
    "name": "Chips de Pommes de Terre Saveur Fromage Français Master 145g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 18,
    "category": "Accueil",
    "sku": "SKU-3200",
    "barcode": "3200",
    "imageUrl": "http://almoune.fr/img/p/4/3/8/2/4382.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3202",
    "name": "Gombos Verts en Saumure Chtoura Garden 840g",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3202",
    "barcode": "3202",
    "imageUrl": "http://almoune.fr/img/p/4/4/5/9/4459.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3207",
    "name": "Keshk Baladi Algota 500g",
    "price": 4.75,
    "purchasePrice": 4.50237,
    "stock": 9,
    "category": "Accueil",
    "sku": "SKU-3207",
    "barcode": "3207",
    "imageUrl": "http://almoune.fr/img/p/4/4/6/1/4461.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3209",
    "name": "Concentré de Tomate Rosso 250g",
    "price": 1.1,
    "purchasePrice": 1.042654,
    "stock": 10,
    "category": "Condiments",
    "sku": "SKU-3209",
    "barcode": "3209",
    "imageUrl": "http://almoune.fr/img/p/4/4/5/4/4454.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3216",
    "name": "Nido Lait 900gr",
    "price": 13.95,
    "purchasePrice": 13.222749,
    "stock": 1,
    "category": "Aliments et Laitiers",
    "sku": "SKU-3216",
    "barcode": "3216",
    "imageUrl": "http://almoune.fr/img/p/4/2/6/0/4260.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3229",
    "name": "Sirop de Tamarin Premium Boulos 500ml",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 2,
    "category": "Boissons",
    "sku": "SKU-3229",
    "barcode": "3229",
    "imageUrl": "http://almoune.fr/img/p/4/4/1/2/4412.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3231",
    "name": "feuilles de vigne Durra 300g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-3231",
    "barcode": "3231",
    "imageUrl": "http://almoune.fr/img/p/4/2/4/9/4249.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3233",
    "name": "Piments Marinés Boulos 600g",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-3233",
    "barcode": "3233",
    "imageUrl": "http://almoune.fr/img/p/4/4/4/2/4442.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3235",
    "name": "Thé pomegrenade 3X alattar",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 17,
    "category": "Boissons",
    "sku": "SKU-3235",
    "barcode": "3235",
    "imageUrl": "http://almoune.fr/img/p/4/2/7/3/4273.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3236",
    "name": "Thé Gingembre 3X alattar",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 10,
    "category": "Boissons",
    "sku": "SKU-3236",
    "barcode": "3236",
    "imageUrl": "http://almoune.fr/img/p/4/2/7/2/4272.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3237",
    "name": "Thé wild thyme 3X alattar",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 19,
    "category": "Boissons",
    "sku": "SKU-3237",
    "barcode": "3237",
    "imageUrl": "http://almoune.fr/img/p/4/2/7/6/4276.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3238",
    "name": "Thé sage 3X Alattar",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 19,
    "category": "Boissons",
    "sku": "SKU-3238",
    "barcode": "3238",
    "imageUrl": "http://almoune.fr/img/p/4/2/7/1/4271.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3239",
    "name": "Thé Alattar Cumin 3X",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 5,
    "category": "Boissons",
    "sku": "SKU-3239",
    "barcode": "3239",
    "imageUrl": "http://almoune.fr/img/p/4/2/7/5/4275.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3240",
    "name": "Thé Alattar 3X Zhourat",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 2,
    "category": "Boissons",
    "sku": "SKU-3240",
    "barcode": "3240",
    "imageUrl": "http://almoune.fr/img/p/4/2/7/4/4274.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3254",
    "name": "Assortiment Baklava 200gr douaihy",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": 21,
    "category": "Accueil",
    "sku": "SKU-3254",
    "barcode": "3254",
    "imageUrl": "http://almoune.fr/img/p/4/2/5/8/4258.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3261",
    "name": "Shamiate Baklava 150g",
    "price": 8.5,
    "purchasePrice": 8.056872,
    "stock": 3,
    "category": "Produits",
    "sku": "SKU-3261",
    "barcode": "3261",
    "imageUrl": "http://almoune.fr/img/p/4/2/5/5/4255.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3262",
    "name": "Shamiate Baklava 250 g",
    "price": 13.5,
    "purchasePrice": 12.796209,
    "stock": 3,
    "category": "Produits",
    "sku": "SKU-3262",
    "barcode": "3262",
    "imageUrl": "http://almoune.fr/img/p/4/2/5/6/4256.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3263",
    "name": "Shamiate Baklava 400 g",
    "price": 19.5,
    "purchasePrice": 18.483412,
    "stock": 0,
    "category": "Produits",
    "sku": "SKU-3263",
    "barcode": "3263",
    "imageUrl": "http://almoune.fr/img/p/4/2/5/7/4257.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3264",
    "name": "Sirop De Canne A Sucre Mélasse Murana",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 14,
    "category": "Accueil",
    "sku": "SKU-3264",
    "barcode": "3264",
    "imageUrl": "http://almoune.fr/img/p/4/4/9/2/4492.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3265",
    "name": "Aubergine séché al Gota 75g",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-3265",
    "barcode": "3265",
    "imageUrl": "http://almoune.fr/img/p/4/2/6/2/4262.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3266",
    "name": "Baba Ghanouj 130 gr kasih",
    "price": 1.35,
    "purchasePrice": 1.279621,
    "stock": 39,
    "category": "Aliments et Laitiers",
    "sku": "SKU-3266",
    "barcode": "3266",
    "imageUrl": "http://almoune.fr/img/p/4/2/5/2/4252.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3267",
    "name": "baba ghanouj kasih 4x130gr",
    "price": 4.85,
    "purchasePrice": 4.597156,
    "stock": 29,
    "category": "Aliments et Laitiers",
    "sku": "SKU-3267",
    "barcode": "3267",
    "imageUrl": "http://almoune.fr/img/p/4/2/5/3/4253.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3272",
    "name": "Savon nigelle olive noire",
    "price": 2.99,
    "purchasePrice": 2.491667,
    "stock": 94,
    "category": "Autres",
    "sku": "SKU-3272",
    "barcode": "3272",
    "imageUrl": "http://almoune.fr/img/p/4/2/8/1/4281.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3277",
    "name": "Savon Bayram coffret x 6",
    "price": 20,
    "purchasePrice": 16.666667,
    "stock": 7,
    "category": "Savon d'Alep - Cosmétiques",
    "sku": "SKU-3277",
    "barcode": "3277",
    "imageUrl": "http://almoune.fr/img/p/4/2/7/7/4277.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3291",
    "name": "Graines de Lupins en Saumure 390g",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 2,
    "category": "Apéritifs et pain",
    "sku": "SKU-3291",
    "barcode": "3291",
    "imageUrl": "http://almoune.fr/img/p/4/4/0/2/4402.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3292",
    "name": "Huile de tournesol 1L",
    "price": 2.45,
    "purchasePrice": 2.322275,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-3292",
    "barcode": "3292",
    "imageUrl": "http://almoune.fr/img/p/4/3/2/0/4320.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3294",
    "name": "Zaatar Narenj 450 gr",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3294",
    "barcode": "3294",
    "imageUrl": "http://almoune.fr/img/p/4/2/6/7/4267.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3299",
    "name": "zaatar  250 gr second house",
    "price": 4.25,
    "purchasePrice": 4.028436,
    "stock": 0,
    "category": "Boissons",
    "sku": "SKU-3299",
    "barcode": "3299",
    "imageUrl": "http://almoune.fr/img/p/4/2/6/6/4266.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3302",
    "name": "pipore 500 g yerba mate",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": 0,
    "category": "Cafés",
    "sku": "SKU-3302",
    "barcode": "3302",
    "imageUrl": "http://almoune.fr/img/p/4/2/6/4/4264.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3305",
    "name": "indomie crevette X1 70gr",
    "price": 0.57,
    "purchasePrice": 0.540284,
    "stock": 20,
    "category": "Accueil",
    "sku": "SKU-3305",
    "barcode": "3305",
    "imageUrl": "http://almoune.fr/img/p/4/2/3/3/4233.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3307",
    "name": "DOUAIHY",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": -6,
    "category": "Accueil",
    "sku": "SKU-3307",
    "barcode": "3307",
    "imageUrl": "http://almoune.fr/img/p/4/2/3/4/4234.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3309",
    "name": "Crème Chantilly 130gr Algota",
    "price": 2.09,
    "purchasePrice": 1.981043,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-3309",
    "barcode": "3309",
    "imageUrl": "http://almoune.fr/img/p/4/2/5/9/4259.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3311",
    "name": "Café Maatouk Cardamone 200gr",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3311",
    "barcode": "3311",
    "imageUrl": "http://almoune.fr/img/p/4/2/6/5/4265.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3319",
    "name": "mayo sauce 380 G",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3319",
    "barcode": "3319",
    "imageUrl": "http://almoune.fr/img/p/4/3/0/4/4304.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3320",
    "name": "Harissa Du Cap Bon Jouda 70g",
    "price": 0.65,
    "purchasePrice": 0.616114,
    "stock": 20,
    "category": "Accueil",
    "sku": "SKU-3320",
    "barcode": "3320",
    "imageUrl": "http://almoune.fr/img/p/4/4/8/7/4487.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3333",
    "name": "Graines de Lin Doré Bio Grain de Frais 425g",
    "price": 3,
    "purchasePrice": 2.843602,
    "stock": 9,
    "category": "Aliments et Laitiers",
    "sku": "SKU-3333",
    "barcode": "3333",
    "imageUrl": "http://almoune.fr/img/p/4/4/5/1/4451.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3334",
    "name": "Noix De Coco Râpée 120g",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-3334",
    "barcode": "3334",
    "imageUrl": "http://almoune.fr/img/p/4/4/9/4/4494.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3337",
    "name": "Kaak Short zaatar  - Moulin d'or 310g",
    "price": 4.95,
    "purchasePrice": 4.691943,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-3337",
    "barcode": "3337",
    "imageUrl": "http://almoune.fr/img/p/4/2/8/5/4285.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3340",
    "name": "Café Turc à la Cardamome Hala 12 Sachets x 25g",
    "price": 19,
    "purchasePrice": 18.009479,
    "stock": 2,
    "category": "Cafés",
    "sku": "SKU-3340",
    "barcode": "3340",
    "imageUrl": "http://almoune.fr/img/p/4/3/7/9/4379.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3344",
    "name": "Couscous moyen DARI 1kg",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-3344",
    "barcode": "3344",
    "imageUrl": "http://almoune.fr/img/p/4/5/1/4/4514.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3345",
    "name": "Couscous Fin DARI 500 gr",
    "price": 1.5,
    "purchasePrice": 1.421801,
    "stock": 18,
    "category": "Accueil",
    "sku": "SKU-3345",
    "barcode": "3345",
    "imageUrl": "http://almoune.fr/img/p/4/5/1/3/4513.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3346",
    "name": "Charbon de Bois de Noix de Coco en Cubes COCO ROYAL 1kg",
    "price": 7.49,
    "purchasePrice": 6.241667,
    "stock": 0,
    "category": "Autres",
    "sku": "SKU-3346",
    "barcode": "3346",
    "imageUrl": "http://almoune.fr/img/p/4/4/3/3/4433.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3349",
    "name": "Feuilles de vigne jeunes & tendres Paliria 400g",
    "price": 4,
    "purchasePrice": 3.791469,
    "stock": -4,
    "category": "Accueil",
    "sku": "SKU-3349",
    "barcode": "3349",
    "imageUrl": "http://almoune.fr/img/p/4/4/8/4/4484.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3355",
    "name": "Amande en poudre 400 gr",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-3355",
    "barcode": "3355",
    "imageUrl": "http://almoune.fr/img/p/4/4/7/9/4479.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3361",
    "name": "Concombre sauvage marinés Déan Gourmet 600 gr",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 11,
    "category": "Légumes Marinés",
    "sku": "SKU-3361",
    "barcode": "3361",
    "imageUrl": "http://almoune.fr/img/p/4/4/3/9/4439.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3362",
    "name": "Sirop d'Abricot Kamardine Kassatly Chtaura 600ml",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 7,
    "category": "Boissons",
    "sku": "SKU-3362",
    "barcode": "3362",
    "imageUrl": "http://almoune.fr/img/p/4/4/7/5/4475.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3363",
    "name": "Sherbet à la Réglisse Meyan Kökü Ramzy 150g",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 7,
    "category": "Boissons",
    "sku": "SKU-3363",
    "barcode": "3363",
    "imageUrl": "http://almoune.fr/img/p/4/4/7/7/4477.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3367",
    "name": "Boisson en Poudre Instantanée Fraise Aruba 500g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 5,
    "category": "Boissons",
    "sku": "SKU-3367",
    "barcode": "3367",
    "imageUrl": "http://almoune.fr/img/p/4/3/5/0/4350.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3373",
    "name": "Poulet Al RAI 340gr",
    "price": 2.55,
    "purchasePrice": 2.417062,
    "stock": 17,
    "category": "Conserves",
    "sku": "SKU-3373",
    "barcode": "3373",
    "imageUrl": "http://almoune.fr/img/p/4/3/6/9/4369.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3374",
    "name": "Poulet Al TAGHZIAH 200gr",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 5,
    "category": "Conserves",
    "sku": "SKU-3374",
    "barcode": "3374",
    "imageUrl": "http://almoune.fr/img/p/4/3/7/0/4370.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3375",
    "name": "Riz Daawat 5kg",
    "price": 13.85,
    "purchasePrice": 13.127962,
    "stock": 24,
    "category": "Accueil",
    "sku": "SKU-3375",
    "barcode": "3375",
    "imageUrl": "http://almoune.fr/img/p/4/2/8/9/4289.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3377",
    "name": "Poulet Goût Bœuf Al Taghziah Halal 340g",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 12,
    "category": "Conserves",
    "sku": "SKU-3377",
    "barcode": "3377",
    "imageUrl": "http://almoune.fr/img/p/4/3/7/3/4373.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3378",
    "name": "Luncheon Meat Poulet Goût Bœuf Al Taghziah Halal 200g",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 4,
    "category": "Conserves",
    "sku": "SKU-3378",
    "barcode": "3378",
    "imageUrl": "http://almoune.fr/img/p/4/3/7/2/4372.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3379",
    "name": "Poulet Al taghziah 340gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-3379",
    "barcode": "3379",
    "imageUrl": "http://almoune.fr/img/p/4/3/6/7/4367.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3380",
    "name": "Boisson en Poudre Instantanée Fruits Rouges Aruba 500g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-3380",
    "barcode": "3380",
    "imageUrl": "http://almoune.fr/img/p/4/3/4/7/4347.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3381",
    "name": "Boisson en Poudre Instantanée Ananas Aruba 500g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-3381",
    "barcode": "3381",
    "imageUrl": "http://almoune.fr/img/p/4/3/4/8/4348.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3382",
    "name": "Boisson en Poudre Instantanée Mangue Aruba 500g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3382",
    "barcode": "3382",
    "imageUrl": "http://almoune.fr/img/p/4/3/4/9/4349.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3386",
    "name": "Sardines à l'Huile et au Piment Tayba Halal 125g",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 5,
    "category": "Conserves",
    "sku": "SKU-3386",
    "barcode": "3386",
    "imageUrl": "http://almoune.fr/img/p/4/3/7/4/4374.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3387",
    "name": "Navet Al RAi 660gr",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-3387",
    "barcode": "3387",
    "imageUrl": "http://almoune.fr/img/p/4/3/2/2/4322.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3388",
    "name": "Thé Noir Earl Grey 110 Sachets Ahmed Tea 220g",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-3388",
    "barcode": "3388",
    "imageUrl": "http://almoune.fr/img/p/4/3/5/4/4354.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3389",
    "name": "Thé Noir Earl Grey Feuille Entière Ahmed Tea 500g",
    "price": 10.55,
    "purchasePrice": 10,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-3389",
    "barcode": "3389",
    "imageUrl": "http://almoune.fr/img/p/4/3/5/1/4351.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3390",
    "name": "Concentré de Tomate Chtoura Garden 650g",
    "price": 4.5,
    "purchasePrice": 4.265403,
    "stock": 6,
    "category": "Condiments",
    "sku": "SKU-3390",
    "barcode": "3390",
    "imageUrl": "http://almoune.fr/img/p/4/4/5/5/4455.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3391",
    "name": "Aubergine grillé Al RAI 660gr",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3391",
    "barcode": "3391",
    "imageUrl": "http://almoune.fr/img/p/4/3/5/5/4355.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3392",
    "name": "Riz Basmati Sella Extra Long Daawat 1kg",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-3392",
    "barcode": "3392",
    "imageUrl": "http://almoune.fr/img/p/4/3/9/5/4395.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3393",
    "name": "Sauce Pimentée Forte Hot Chili Sauce Boustan 176ml",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 12,
    "category": "Épices",
    "sku": "SKU-3393",
    "barcode": "3393",
    "imageUrl": "http://almoune.fr/img/p/4/3/5/8/4358.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3394",
    "name": "Sauce Pimentée Forte Hot Chili Sauce Boustan 88ml",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 14,
    "category": "Accueil",
    "sku": "SKU-3394",
    "barcode": "3394",
    "imageUrl": "http://almoune.fr/img/p/4/3/5/7/4357.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3410",
    "name": "Amandes Blanchies Bâtonnets O'Régal 500g",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 13,
    "category": "Accueil",
    "sku": "SKU-3410",
    "barcode": "3410",
    "imageUrl": "http://almoune.fr/img/p/4/5/0/3/4503.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3415",
    "name": "Zaatar Premium Naturel 500gr BOULOS",
    "price": 10.95,
    "purchasePrice": 10.379147,
    "stock": 31,
    "category": "Accueil",
    "sku": "SKU-3415",
    "barcode": "3415",
    "imageUrl": "http://almoune.fr/img/p/4/2/8/6/4286.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3416",
    "name": "Pistaches d'Iran crues décortiquées - O'Regal 500gr",
    "price": 19.9,
    "purchasePrice": 18.862559,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-3416",
    "barcode": "3416",
    "imageUrl": "http://almoune.fr/img/p/4/2/8/7/4287.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3420",
    "name": "Cannelle Moulue Gardenia Grain d'Or 50g",
    "price": 1.82,
    "purchasePrice": 1.725118,
    "stock": 6,
    "category": "Épices",
    "sku": "SKU-3420",
    "barcode": "3420",
    "imageUrl": "http://almoune.fr/img/p/4/3/6/3/4363.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3424",
    "name": "Coriandre Moulue Gardenia Grain d'Or 50g",
    "price": 1.82,
    "purchasePrice": 1.725118,
    "stock": 2,
    "category": "Epices",
    "sku": "SKU-3424",
    "barcode": "3424",
    "imageUrl": "http://almoune.fr/img/p/4/3/6/4/4364.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3425",
    "name": "Poivre Blanc Moulu Gardenia Grain d'Or 50g",
    "price": 2.2,
    "purchasePrice": 2.085308,
    "stock": 3,
    "category": "Épices",
    "sku": "SKU-3425",
    "barcode": "3425",
    "imageUrl": "http://almoune.fr/img/p/4/3/6/6/4366.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3426",
    "name": "Bicarbonate de Soude Gardenia 100g",
    "price": 1.82,
    "purchasePrice": 1.725118,
    "stock": 4,
    "category": "Accueil",
    "sku": "SKU-3426",
    "barcode": "3426",
    "imageUrl": "http://almoune.fr/img/p/4/4/7/2/4472.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3433",
    "name": "Puck fromage à huile 300 gr",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 33,
    "category": "Accueil",
    "sku": "SKU-3433",
    "barcode": "3433",
    "imageUrl": "http://almoune.fr/img/p/4/3/1/6/4316.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3437",
    "name": "Cerelac 12 à 36 mois 16 Services",
    "price": 6,
    "purchasePrice": 5.687204,
    "stock": 8,
    "category": "Apéritifs et pain",
    "sku": "SKU-3437",
    "barcode": "3437",
    "imageUrl": "http://almoune.fr/img/p/4/3/1/7/4317.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3439",
    "name": "Mélasse de grenade Boulos 500ml",
    "price": 5.5,
    "purchasePrice": 5.21327,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3439",
    "barcode": "3439",
    "imageUrl": "http://almoune.fr/img/p/4/3/2/1/4321.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3440",
    "name": "Chips Kettle Cooked Sel Marin Master",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": 11,
    "category": "Apéritifs et pain",
    "sku": "SKU-3440",
    "barcode": "3440",
    "imageUrl": "http://almoune.fr/img/p/4/3/8/3/4383.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3441",
    "name": "Cannelle en Bâtonnets Gardenia 50g",
    "price": 1.65,
    "purchasePrice": 1.563981,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-3441",
    "barcode": "3441",
    "imageUrl": "http://almoune.fr/img/p/4/4/7/1/4471.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3444",
    "name": "Sel Rose de l'Himalaya Naturel Kaalar 450g",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 6,
    "category": "Condiments",
    "sku": "SKU-3444",
    "barcode": "3444",
    "imageUrl": "http://almoune.fr/img/p/4/3/9/9/4399.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3445",
    "name": "Mélasse de grenade Habo 1kg",
    "price": 4.95,
    "purchasePrice": 4.691943,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-3445",
    "barcode": "3445",
    "imageUrl": "http://almoune.fr/img/p/4/3/4/6/4346.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3446",
    "name": "Fèves Sèches Entières AZ Distribution 900g",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 21,
    "category": "Accueil",
    "sku": "SKU-3446",
    "barcode": "3446",
    "imageUrl": "http://almoune.fr/img/p/4/4/0/1/4401.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3447",
    "name": "Melase grenade Déan 25 cL",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 9,
    "category": "Accueil",
    "sku": "SKU-3447",
    "barcode": "3447",
    "imageUrl": "http://almoune.fr/img/p/4/3/1/9/4319.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3449",
    "name": "zaatar kasih",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-3449",
    "barcode": "3449",
    "imageUrl": "http://almoune.fr/img/p/4/3/1/8/4318.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3468",
    "name": "Graines de Tournesol Piment & Citron Vert Krikita 200g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 16,
    "category": "Accueil",
    "sku": "SKU-3468",
    "barcode": "3468",
    "imageUrl": "http://almoune.fr/img/p/4/3/3/8/4338.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3469",
    "name": "Graines de Tournesol Sel & Vinaigre Krikita 200g",
    "price": 3.5,
    "purchasePrice": 3.317536,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-3469",
    "barcode": "3469",
    "imageUrl": "http://almoune.fr/img/p/4/3/4/1/4341.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3470",
    "name": "Fiesta sipcy Krikita 225gr",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": -1,
    "category": "Accueil",
    "sku": "SKU-3470",
    "barcode": "3470",
    "imageUrl": "http://almoune.fr/img/p/4/3/2/3/4323.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3472",
    "name": "Amidon de Maïs DOMO 300g",
    "price": 2.5,
    "purchasePrice": 2.369668,
    "stock": 9,
    "category": "Gâteaux - Biscuits orientaux",
    "sku": "SKU-3472",
    "barcode": "3472",
    "imageUrl": "http://almoune.fr/img/p/4/4/6/5/4465.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3473",
    "name": "Arôme de Rose Al Wadi 300ml",
    "price": 2.15,
    "purchasePrice": 2.037915,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-3473",
    "barcode": "3473",
    "imageUrl": "http://almoune.fr/img/p/4/4/6/7/4467.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3474",
    "name": "Mélasse de grenade durra 500gr",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 16,
    "category": "Accueil",
    "sku": "SKU-3474",
    "barcode": "3474",
    "imageUrl": "http://almoune.fr/img/p/4/3/7/7/4377.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3478",
    "name": "Mélasse de datte boulos 800gr",
    "price": 8.5,
    "purchasePrice": 8.056872,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-3478",
    "barcode": "3478",
    "imageUrl": "http://almoune.fr/img/p/4/4/9/9/4499.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3480",
    "name": "Feuilles de Vigne Farcies au Riz (Dolmas) Paliria 280g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-3480",
    "barcode": "3480",
    "imageUrl": "http://almoune.fr/img/p/4/4/0/5/4405.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3481",
    "name": "Mini Feuilles de Vigne Farcies au Riz (Dolmas) Paliria 2000g",
    "price": 17.5,
    "purchasePrice": 16.587678,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-3481",
    "barcode": "3481",
    "imageUrl": "http://almoune.fr/img/p/4/4/4/5/4445.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3482",
    "name": "Lentille Gardenia 907g",
    "price": 3.25,
    "purchasePrice": 3.080569,
    "stock": -10,
    "category": "Accueil",
    "sku": "SKU-3482",
    "barcode": "3482",
    "imageUrl": "http://almoune.fr/img/p/4/3/1/2/4312.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3483",
    "name": "Hummus kasih 4",
    "price": 5.99,
    "purchasePrice": 5.677725,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-3483",
    "barcode": "3483",
    "imageUrl": "http://almoune.fr/img/p/4/4/0/3/4403.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3484",
    "name": "Maamoul Hamdan 450gr",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 20,
    "category": "Accueil",
    "sku": "SKU-3484",
    "barcode": "3484",
    "imageUrl": "http://almoune.fr/img/p/4/3/1/1/4311.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3485",
    "name": "Riz Basmati Blanc Ambré XXL Abu Kass 4.5kg",
    "price": 14.5,
    "purchasePrice": 13.744076,
    "stock": 2,
    "category": "Accueil",
    "sku": "SKU-3485",
    "barcode": "3485",
    "imageUrl": "http://almoune.fr/img/p/4/5/1/0/4510.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3486",
    "name": "Poivron vert farcie 400gr FINEMEZE",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 20,
    "category": "Accueil",
    "sku": "SKU-3486",
    "barcode": "3486",
    "imageUrl": "http://almoune.fr/img/p/4/3/0/7/4307.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3487",
    "name": "Chou Farcie 400gr FINEMEZE",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-3487",
    "barcode": "3487",
    "imageUrl": "http://almoune.fr/img/p/4/3/0/8/4308.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3488",
    "name": "Vermicelles Kaalar 150g",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 58,
    "category": "Légumineuses et grains",
    "sku": "SKU-3488",
    "barcode": "3488",
    "imageUrl": "http://almoune.fr/img/p/4/4/0/4/4404.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3489",
    "name": "chamsine maamoul date",
    "price": 8.5,
    "purchasePrice": 8.056872,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3489",
    "barcode": "3489",
    "imageUrl": "http://almoune.fr/img/p/4/3/1/5/4315.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3494",
    "name": "Ghee Végétal El Nakhletein 1,5 kg",
    "price": 14.95,
    "purchasePrice": 14.170616,
    "stock": 2,
    "category": "Beurre clarifié - Smen - Ghee",
    "sku": "SKU-3494",
    "barcode": "3494",
    "imageUrl": "http://almoune.fr/img/p/4/4/1/6/4416.jpg",
    "price_per_kg": 14.95
  },
  {
    "id": "csv-3495",
    "name": "Aubergine farcie au riz et aux herbes 400 GR",
    "price": 2.99,
    "purchasePrice": 2.834123,
    "stock": 7,
    "category": "Accueil",
    "sku": "SKU-3495",
    "barcode": "3495",
    "imageUrl": "http://almoune.fr/img/p/4/3/0/9/4309.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3496",
    "name": "Bonbon Jelly Sweets",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 15,
    "category": "Accueil",
    "sku": "SKU-3496",
    "barcode": "3496",
    "imageUrl": "http://almoune.fr/img/p/4/2/9/1/4291.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3497",
    "name": "Bonbon Marsh Mallow 65gr",
    "price": 1.69,
    "purchasePrice": 1.601896,
    "stock": 22,
    "category": "Accueil",
    "sku": "SKU-3497",
    "barcode": "3497",
    "imageUrl": "http://almoune.fr/img/p/4/3/0/2/4302.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3498",
    "name": "Bonbon Marsh Mallow 65 gr",
    "price": 1.69,
    "purchasePrice": 1.601896,
    "stock": 25,
    "category": "Accueil",
    "sku": "SKU-3498",
    "barcode": "3498",
    "imageUrl": "http://almoune.fr/img/p/4/3/0/3/4303.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3499",
    "name": "Bonbons Gélifiés Halal aux Fruits 90 g",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 24,
    "category": "Accueil",
    "sku": "SKU-3499",
    "barcode": "3499",
    "imageUrl": "http://almoune.fr/img/p/4/2/9/7/4297.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3500",
    "name": "Bonbon jelly vert 80g",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 24,
    "category": "Accueil",
    "sku": "SKU-3500",
    "barcode": "3500",
    "imageUrl": "http://almoune.fr/img/p/4/2/9/8/4298.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3501",
    "name": "Bonbons Gélifiés Halal aux Fruits",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 22,
    "category": "Accueil",
    "sku": "SKU-3501",
    "barcode": "3501",
    "imageUrl": "http://almoune.fr/img/p/4/2/9/9/4299.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3502",
    "name": "Bonbon Cola 80gr Jelly sweets al kheir",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 23,
    "category": "Accueil",
    "sku": "SKU-3502",
    "barcode": "3502",
    "imageUrl": "http://almoune.fr/img/p/4/3/0/0/4300.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3506",
    "name": "Chips de Pomme de Terre Saveur Chili Piquant Master 145g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 14,
    "category": "Accueil",
    "sku": "SKU-3506",
    "barcode": "3506",
    "imageUrl": "http://almoune.fr/img/p/4/3/8/6/4386.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3507",
    "name": "Tortilla Chips au Goût Oignon Caramélisé Sitos Master",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-3507",
    "barcode": "3507",
    "imageUrl": "http://almoune.fr/img/p/4/3/8/5/4385.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3509",
    "name": "Chips de Pommes de Terre Saveur Barbecue Master",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 15,
    "category": "Accueil",
    "sku": "SKU-3509",
    "barcode": "3509",
    "imageUrl": "http://almoune.fr/img/p/4/3/8/1/4381.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3510",
    "name": "Chips Buffies Ketchup Master Soufflés de Maïs Libanais",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": -2,
    "category": "Accueil",
    "sku": "SKU-3510",
    "barcode": "3510",
    "imageUrl": "http://almoune.fr/img/p/4/3/8/4/4384.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3511",
    "name": "Penne Paprika master 60gr",
    "price": 2.89,
    "purchasePrice": 2.739336,
    "stock": 1,
    "category": "Accueil",
    "sku": "SKU-3511",
    "barcode": "3511",
    "imageUrl": "http://almoune.fr/img/p/4/4/9/6/4496.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3512",
    "name": "ICE FREE Pastèque 275ml",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 91,
    "category": "Accueil",
    "sku": "SKU-3512",
    "barcode": "3512",
    "imageUrl": "http://almoune.fr/img/p/4/3/3/2/4332.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3513",
    "name": "ICE FREE TAMARIN 275ml",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 108,
    "category": "Accueil",
    "sku": "SKU-3513",
    "barcode": "3513",
    "imageUrl": "http://almoune.fr/img/p/4/3/3/3/4333.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3515",
    "name": "ICE FREE citron menthe275ml",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 95,
    "category": "Accueil",
    "sku": "SKU-3515",
    "barcode": "3515",
    "imageUrl": "http://almoune.fr/img/p/4/3/3/0/4330.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3516",
    "name": "ICE FREE Tropical blue 275ml",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 112,
    "category": "Accueil",
    "sku": "SKU-3516",
    "barcode": "3516",
    "imageUrl": "http://almoune.fr/img/p/4/3/3/5/4335.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3517",
    "name": "ICE FREE citron 275ml",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 67,
    "category": "Accueil",
    "sku": "SKU-3517",
    "barcode": "3517",
    "imageUrl": "http://almoune.fr/img/p/4/3/3/1/4331.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3518",
    "name": "ICE FREE grenade 275ml",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 114,
    "category": "Accueil",
    "sku": "SKU-3518",
    "barcode": "3518",
    "imageUrl": "http://almoune.fr/img/p/4/3/3/4/4334.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3523",
    "name": "Confiture d'orange et Eau de fleurs d'oranger 250 GR",
    "price": 7.5,
    "purchasePrice": 7.109005,
    "stock": 12,
    "category": "Accueil",
    "sku": "SKU-3523",
    "barcode": "3523",
    "imageUrl": "http://almoune.fr/img/p/4/3/3/7/4337.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3524",
    "name": "ICE FREE Pomme  275ml",
    "price": 1.99,
    "purchasePrice": 1.886256,
    "stock": 228,
    "category": "Accueil",
    "sku": "SKU-3524",
    "barcode": "3524",
    "imageUrl": "http://almoune.fr/img/p/4/3/3/6/4336.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3527",
    "name": "Mélange de Fruits Secs Castania 300g",
    "price": 10.55,
    "purchasePrice": 10,
    "stock": 11,
    "category": "Apéritifs et pain",
    "sku": "SKU-3527",
    "barcode": "3527",
    "imageUrl": "http://almoune.fr/img/p/4/4/1/3/4413.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3528",
    "name": "Ahmad Thé Special Blend 500 gr",
    "price": 8.49,
    "purchasePrice": 8.047393,
    "stock": 46,
    "category": "Accueil",
    "sku": "SKU-3528",
    "barcode": "3528",
    "imageUrl": "http://almoune.fr/img/p/4/3/5/6/4356.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3529",
    "name": "Boisson Énergétique Gazeuse ASSED Force de Lion 250ml",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 24,
    "category": "Boissons",
    "sku": "SKU-3529",
    "barcode": "3529",
    "imageUrl": "http://almoune.fr/img/p/4/3/5/9/4359.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3530",
    "name": "Boisson Énergétique Pêche ASSED Force de Lion 250ml",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 40,
    "category": "Boissons",
    "sku": "SKU-3530",
    "barcode": "3530",
    "imageUrl": "http://almoune.fr/img/p/4/3/6/0/4360.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3531",
    "name": "Boisson Énergétique Vanille ASSED Force de Lion 250ml",
    "price": 1,
    "purchasePrice": 0.947867,
    "stock": 34,
    "category": "Accueil",
    "sku": "SKU-3531",
    "barcode": "3531",
    "imageUrl": "http://almoune.fr/img/p/4/3/6/1/4361.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3533",
    "name": "Bœuf Al Raii 340 gr",
    "price": 2.55,
    "purchasePrice": 2.417062,
    "stock": 6,
    "category": "Accueil",
    "sku": "SKU-3533",
    "barcode": "3533",
    "imageUrl": "http://almoune.fr/img/p/4/3/6/8/4368.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3536",
    "name": "SIROP DE JALLAB AL-RABIH 500ml",
    "price": 6.75,
    "purchasePrice": 6.398104,
    "stock": -2,
    "category": "Sirops concentrés",
    "sku": "SKU-3536",
    "barcode": "3536",
    "imageUrl": "http://almoune.fr/img/p/4/3/7/6/4376.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3537",
    "name": "Sardines à la Sauce Tomate Tayba Halal 125g",
    "price": 1.25,
    "purchasePrice": 1.184834,
    "stock": 39,
    "category": "Accueil",
    "sku": "SKU-3537",
    "barcode": "3537",
    "imageUrl": "http://almoune.fr/img/p/4/3/7/8/4378.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3538",
    "name": "Purée de Piments Rouges avec Graines (Shatta) Al Durra 600g",
    "price": 5.75,
    "purchasePrice": 5.450237,
    "stock": 0,
    "category": "Épices",
    "sku": "SKU-3538",
    "barcode": "3538",
    "imageUrl": "http://almoune.fr/img/p/4/4/0/6/4406.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3540",
    "name": "Chips Buffies Pizza Master 60g",
    "price": 3.49,
    "purchasePrice": 3.308057,
    "stock": 4,
    "category": "Chips et apéritifs",
    "sku": "SKU-3540",
    "barcode": "3540",
    "imageUrl": "http://almoune.fr/img/p/4/3/9/2/4392.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3542",
    "name": "Aubergines Pelées Grillées Al-Raii 1kg",
    "price": 5.59,
    "purchasePrice": 5.298578,
    "stock": 10,
    "category": "Accueil",
    "sku": "SKU-3542",
    "barcode": "3542",
    "imageUrl": "http://almoune.fr/img/p/4/5/0/7/4507.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3543",
    "name": "Chips de Pommes de Terre saveur de sel et vinaigre master 145g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 13,
    "category": "Chips et apéritifs",
    "sku": "SKU-3543",
    "barcode": "3543",
    "imageUrl": "http://almoune.fr/img/p/4/4/0/9/4409.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3544",
    "name": "Mélange de Fruits Secs sans Sel Al Kazzi 450g",
    "price": 12.5,
    "purchasePrice": 11.848341,
    "stock": 7,
    "category": "Apéritifs et pain",
    "sku": "SKU-3544",
    "barcode": "3544",
    "imageUrl": "http://almoune.fr/img/p/4/4/1/4/4414.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3545",
    "name": "Piment JALAPENO AL-RAII",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 5,
    "category": "Accueil",
    "sku": "SKU-3545",
    "barcode": "3545",
    "imageUrl": "http://almoune.fr/img/p/4/5/0/8/4508.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3547",
    "name": "Gaufrettes au Citron Konafetto Roshen 216g",
    "price": 1.75,
    "purchasePrice": 1.658768,
    "stock": 7,
    "category": "Gourmandises",
    "sku": "SKU-3547",
    "barcode": "3547",
    "imageUrl": "http://almoune.fr/img/p/4/4/5/0/4450.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3549",
    "name": "Maïs Doux en Grains Roslen 400g",
    "price": 0.89,
    "purchasePrice": 0.843602,
    "stock": 20,
    "category": "Aliments et Laitiers",
    "sku": "SKU-3549",
    "barcode": "3549",
    "imageUrl": "http://almoune.fr/img/p/4/4/8/1/4481.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3550",
    "name": "Blé Complet en Grains en Vrac 900g",
    "price": 2.25,
    "purchasePrice": 2.132701,
    "stock": 11,
    "category": "Accueil",
    "sku": "SKU-3550",
    "barcode": "3550",
    "imageUrl": "http://almoune.fr/img/p/4/4/6/9/4469.jpg",
    "price_per_kg": 2.25
  },
  {
    "id": "csv-3553",
    "name": "Mélange d'Épices Tandoori Espig 100g",
    "price": 1.95,
    "purchasePrice": 1.848341,
    "stock": 10,
    "category": "Condiments",
    "sku": "SKU-3553",
    "barcode": "3553",
    "imageUrl": "http://almoune.fr/img/p/4/4/7/8/4478.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3558",
    "name": "Miel De Cèdre Bcharré L'Atelier Du Miel 450g",
    "price": 24,
    "purchasePrice": 22.748815,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-3558",
    "barcode": "3558",
    "imageUrl": "http://almoune.fr/img/p/4/4/9/8/4498.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-3562",
    "name": "Harissa 760gr",
    "price": 6.5,
    "purchasePrice": 6.161137,
    "stock": 3,
    "category": "Accueil",
    "sku": "SKU-3562",
    "barcode": "3562",
    "imageUrl": "http://almoune.fr/img/p/4/5/0/1/4501.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-100",
    "name": "Barazek de qualité supérieure 500g bowabet dimashq",
    "price": 14.99,
    "purchasePrice": 14.208531,
    "stock": -32,
    "category": "Gourmandises",
    "sku": "SKU-100",
    "barcode": "100",
    "imageUrl": "http://almoune.fr/img/p/2/1/7/7/2177.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-203",
    "name": "Olives vertes libanaises de Koura - vrac 500 g",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 85,
    "category": "Accueil",
    "sku": "SKU-203",
    "barcode": "203",
    "imageUrl": "http://almoune.fr/img/p/2/3/4/9/2349.jpg",
    "price_per_kg": 3.99
  },
  {
    "id": "csv-268",
    "name": "Savon d'Alep 200g",
    "price": 2.5,
    "purchasePrice": 2.083333,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-268",
    "barcode": "268",
    "imageUrl": "http://almoune.fr/img/p/2/0/8/5/2085.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-297",
    "name": "Mastic 2g",
    "price": 0.99,
    "purchasePrice": 0.938389,
    "stock": -5,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-297",
    "barcode": "297",
    "imageUrl": "http://almoune.fr/img/p/3/6/8/8/3688.jpg",
    "price_per_kg": 0.99
  },
  {
    "id": "csv-464",
    "name": "Fromage de brebis et de chèvre dur 250g",
    "price": 4.6,
    "purchasePrice": 4.598,
    "stock": 0,
    "category": "Fromages libanais",
    "sku": "SKU-464",
    "barcode": "464",
    "imageUrl": "http://almoune.fr/img/p/2/0/9/0/2090.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-470",
    "name": "Savon naturel parfumé au laurier et à l'huile de Nigelle 125gr",
    "price": 1.5,
    "purchasePrice": 1.25,
    "stock": 0,
    "category": "Autres",
    "sku": "SKU-470",
    "barcode": "470",
    "imageUrl": "http://almoune.fr/img/p/3/6/8/4/3684.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-614",
    "name": "Abricots secs - Meyva 225g",
    "price": 1.99,
    "purchasePrice": 4.028436,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-614",
    "barcode": "614",
    "imageUrl": "http://almoune.fr/img/p/2/3/6/4/2364.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-663",
    "name": "Bamias à l'huile - Paliria 280g",
    "price": 3.75,
    "purchasePrice": 3.554502,
    "stock": 25,
    "category": "Accueil",
    "sku": "SKU-663",
    "barcode": "663",
    "imageUrl": "http://almoune.fr/img/p/3/1/2/6/3126.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-854",
    "name": "Semoule Extra Grosse 1kg",
    "price": 2.35,
    "purchasePrice": 2.227488,
    "stock": 0,
    "category": "Ingrédients de pâtisserie",
    "sku": "SKU-854",
    "barcode": "854",
    "imageUrl": "http://almoune.fr/img/p/3/6/9/0/3690.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-946",
    "name": "Haricots coco roses 1kg",
    "price": 3.65,
    "purchasePrice": 3.459716,
    "stock": -1,
    "category": "Légumineuses",
    "sku": "SKU-946",
    "barcode": "946",
    "imageUrl": "http://almoune.fr/img/p/3/7/0/0/3700.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1268",
    "name": "Dattes Namazi sous vide 1 kg",
    "price": 3.99,
    "purchasePrice": 3.781991,
    "stock": 2,
    "category": "Gourmandises",
    "sku": "SKU-1268",
    "barcode": "1268",
    "imageUrl": "http://almoune.fr/img/p/3/7/0/2/3702.jpg",
    "price_per_kg": 3.99
  },
  {
    "id": "csv-1278",
    "name": "Baklava frais du Liban en vrac 500gr.",
    "price": 12.75,
    "purchasePrice": 12.085308,
    "stock": -9,
    "category": "Baklava",
    "sku": "SKU-1278",
    "barcode": "1278",
    "imageUrl": "http://almoune.fr/img/p/3/5/2/1/3521.jpg",
    "price_per_kg": 12.75
  },
  {
    "id": "csv-1537",
    "name": "Haricots Géants en saumure Paliria 2kg",
    "price": 14.99,
    "purchasePrice": 14.208531,
    "stock": -37,
    "category": "Conserves",
    "sku": "SKU-1537",
    "barcode": "1537",
    "imageUrl": "http://almoune.fr/img/p/3/4/1/8/3418.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1580",
    "name": "Haricots Géants Blancs à la sauce tomate 280 gr",
    "price": 2.75,
    "purchasePrice": 2.606635,
    "stock": 0,
    "category": "Accueil",
    "sku": "SKU-1580",
    "barcode": "1580",
    "imageUrl": "http://almoune.fr/img/p/3/4/2/0/3420.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1592",
    "name": "Namoura fabriqués au Liban en vrac 6 pièces ≈ 330 gr",
    "price": 4.99,
    "purchasePrice": 4.729858,
    "stock": 0,
    "category": "Gourmandises",
    "sku": "SKU-1592",
    "barcode": "1592",
    "imageUrl": "http://almoune.fr/img/p/3/5/6/3/3563.jpg",
    "price_per_kg": 4.99
  },
  {
    "id": "csv-1625",
    "name": "Assabeh cajou fabriqués au Liban 1.5 kg",
    "price": 34.9,
    "purchasePrice": 33.080569,
    "stock": 20,
    "category": "Accueil",
    "sku": "SKU-1625",
    "barcode": "1625",
    "imageUrl": "http://almoune.fr/img/p/3/4/7/4/3474.jpg",
    "price_per_kg": 34.9
  },
  {
    "id": "csv-1633",
    "name": "Bokaj cajou fabriqués au Liban en vrac 12 pièces ≈ 240 gr",
    "price": 5.99,
    "purchasePrice": 5.677725,
    "stock": 9,
    "category": "Gourmandises",
    "sku": "SKU-1633",
    "barcode": "1633",
    "imageUrl": "http://almoune.fr/img/p/3/4/6/3/3463.jpg",
    "price_per_kg": 5.99
  },
  {
    "id": "csv-1649",
    "name": "Brochettes plates pour kafta ou kebab",
    "price": 2.99,
    "purchasePrice": 2.491667,
    "stock": 38,
    "category": "Autres",
    "sku": "SKU-1649",
    "barcode": "1649",
    "imageUrl": "http://almoune.fr/img/p/3/5/0/7/3507.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1964",
    "name": "Truffes du désert (Qama) Durra 400g",
    "price": 22.5,
    "purchasePrice": 21.327014,
    "stock": 8,
    "category": "Accueil",
    "sku": "SKU-1964",
    "barcode": "1964",
    "imageUrl": "http://almoune.fr/img/p/4/4/2/0/4420.jpg",
    "price_per_kg": null
  },
  {
    "id": "csv-1117",
    "name": "Moule à falafel",
    "price": 3.5,
    "purchasePrice": 2.916667,
    "stock": 0,
    "category": "Autres",
    "sku": "SKU-1117",
    "barcode": "1117",
    "imageUrl": "http://almoune.fr/img/p/2/7/1/6/2716.jpg",
    "price_per_kg": null
  }
];

const STORAGE_KEY = "almoune_admin_catalog_v3";

export const getCatalog = () => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored) {
    try {
      return JSON.parse(stored);
    } catch (e) {
      console.error("Erreur lecture catalogue", e);
    }
  }
  return defaultCatalog;
};

export const saveCatalog = (catalogData) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(catalogData));
};

export const isWeightedProduct = (product) => {
  if (!product) return false;
  if (product.price_per_kg !== undefined && product.price_per_kg !== null) return true;
  if (product.isWeighted) return true;
  return false;
};

export const getDefaultCartAmountForProduct = (product) => {
  return isWeightedProduct(product) ? 0 : 1;
};

export const getWeightStepKg = (product) => {
  return 0.1;
};

export const formatProductAmount = (product, quantity) => {
  if (isWeightedProduct(product)) {
    return `${Number(quantity).toFixed(3)} kg`;
  }
  return `${quantity} x`;
};

export const loadCatalog = async () => {
  return getCatalog();
};

export const formatAdminPrice = (price) => {
  return `${Number(price || 0).toFixed(2)} EUR`;
};

export const LOW_STOCK_THRESHOLD = 5;

export const getProductPriceLabel = (product) => {
  return isWeightedProduct(product) ? "Prix/kg" : "Prix/unité";
};

export const deliveryRules = [
  { min: 79, max: Infinity, cost: 3.90 },
  { min: 49, max: 79, cost: 6.90 },
  { min: 0, max: 49, cost: Infinity }
];

export const loadCategories = async () => {
  const catalog = getCatalog();
  const cats = new Set();
  catalog.forEach(p => { 
    if (p.category) {
      if (Array.isArray(p.category)) p.category.forEach(c => cats.add(c));
      else cats.add(p.category);
    }
  });
  return Array.from(cats);
};

export const loadVariantsForProduct = async (productId) => {
  return [];
};

// --- Stubs added for MyAccountAddress.jsx imports ---

export const saveCategory = async (category) => {
  const catalog = getCatalog();
  // Category is just a string field on products; saving a "category" means ensuring it exists.
  // No-op for now — categories are derived from products.
  return category;
};

export const deleteCategory = async (categoryName) => {
  // Categories are derived from products; deleting one requires renaming/removing from products.
  // No-op for now.
  return true;
};

export const saveProductVariant = async (variant) => {
  const catalog = getCatalog();
  const updated = catalog.map((p) =>
    p.id === variant.productId ? { ...p, ...variant } : p
  );
  saveCatalog(updated);
  return variant;
};

export const deleteProductVariant = async (variantId) => {
  // Variants are not stored separately yet; no-op.
  return true;
};

export const generateInternalBarcode = () => {
  const catalog = getCatalog();
  const maxBarcode = catalog.reduce((max, p) => {
    const num = parseInt(p.barcode, 10);
    return !isNaN(num) && num > max ? num : max;
  }, 0);
  return String(maxBarcode + 1);
};

export const importPrestashopProductCsv = async (csvText) => {
  // Placeholder: parse CSV and return array of product objects.
  // Real implementation would parse PrestaShop CSV format.
  console.warn("importPrestashopProductCsv: not yet implemented");
  return [];
};

export const updateProductPrices = async (productId, updates) => {
  // updates = { purchasePrice?, price? }
  // Load catalog, find product, merge updates, save
  const catalog = getCatalog();
  const idx = catalog.findIndex(p => p.id === productId);
  if (idx === -1) return catalog;
  catalog[idx] = { ...catalog[idx], ...updates };
  await saveCatalog(catalog);
  return catalog;
};
